/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  CleoClinicRatatoskrProviderApplicationSettingsSkeletonJSON: { input: any; output: any };
  CleoClinicalParameterValueSkeletonJSON: { input: any; output: any };
  CleoProfileMetadataSkeletonJSON: { input: any; output: any };
  CleoRuleParserSettingsSkeletonJSON: { input: any; output: any };
  CleoSubmissionCommentContentSkeletonJSON: { input: any; output: any };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any };
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any };
  EinsteinProfilesGroupRulesetArraySkeletonJSON: { input: any; output: any };
  EinsteinProfilesGroupRulesetSkeletonJSON: { input: any; output: any };
  EinsteinRecurringFrequenciesSkeletonJSON: { input: any; output: any };
  FaradayOrderMetadataSkeletonJSON: { input: any; output: any };
  FaradayPatientMetadataSkeletonJSON: { input: any; output: any };
  FileFieldType: { input: any; output: any };
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any };
  HeimdallApplicationInputSkeletonJSON: { input: any; output: any };
  HeimdallProviderInputSkeletonJSON: { input: any; output: any };
  HospitalProfileSettingsSkeletonJSON: { input: any; output: any };
  RatatoskrDeliveryMetadataSkeletonJSON: { input: any; output: any };
  RatatoskrDeviceMetadataSkeletonJSON: { input: any; output: any };
  RatatoskrMessageSkeletonJSON: { input: any; output: any };
  RatatoskrMessageTemplateSkeletonJSON: { input: any; output: any };
  ScalpelFilterSettingsSkeletonJSON: { input: any; output: any };
  SkeletonAnySkeletonJSON: { input: any; output: any };
  StitchLinkMetadataSkeletonJSON: { input: any; output: any };
  StitchLinkPermissionSkeletonJSON: { input: any; output: any };
  StitchRequestSettingsSkeletonJSON: { input: any; output: any };
  StitchResponseHeadersSkeletonJSON: { input: any; output: any };
};

export enum AdminOrderBy {
  CreatedOn = 'CREATED_ON',
  Department = 'DEPARTMENT',
  Designation = 'DESIGNATION',
  Name = 'NAME',
  Status = 'STATUS',
}

export enum AdministratorOperationType {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE',
}

export enum AdministratorOrderBy {
  AccountType = 'ACCOUNT_TYPE',
  Name = 'NAME',
  Status = 'STATUS',
}

export enum BroadcastOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
  ScheduledFor = 'SCHEDULED_FOR',
  Status = 'STATUS',
}

/** Object type for `CaesarEvent`. */
export type CaesarEvent = ScalpelNode & {
  __typename?: 'CaesarEvent';
  /** Date/Time this event was completed from the provider perspective. */
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time this event was created from the provider perspective. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** End date/time of this event (In provider's timezone). */
  endOn: Scalars['DateTime']['output'];
  /** Type of this event. */
  eventType?: Maybe<CaesarEventType>;
  /** This is the global ID constructed from the base64 encoding of `CaesarEvent:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Metadata for the event. Usually populated by the provider. It is validated against <a href="https://skeleton.staging.botmd.io/docs/caesar-eventmetadata-generated.html" target="_blank">caesar/EventMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Human-readable name for the event. */
  name: Scalars['String']['output'];
  /** Date/Time this event was pending for schedule from the provider perspective. */
  pendingOn?: Maybe<Scalars['DateTime']['output']>;
  /** Event type from provider. */
  providerEventType: Scalars['String']['output'];
  /** List of reminders that will be synced to Kronos. It is validated against <a href="https://skeleton.staging.botmd.io/docs/caesar-eventreminders-generated.html" target="_blank">caesar/EventReminders.schema</a>. */
  reminders?: Maybe<Scalars['GenericScalar']['output']>;
  /** If this event was rescheduled, the previous event that was rescheduled from. */
  rescheduledFrom?: Maybe<CaesarEvent>;
  /** Start date/time of this event (In provider's timezone). */
  startOn: Scalars['DateTime']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CaesarEventConnection = {
  __typename?: 'CaesarEventConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaesarEventEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CaesarEvent` and its cursor. */
export type CaesarEventEdge = {
  __typename?: 'CaesarEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaesarEvent>;
};

/** Object type for `CaesarEventType`. */
export type CaesarEventType = ScalpelNode & {
  __typename?: 'CaesarEventType';
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Type of this event. */
  events: CaesarEventConnection;
  /** This is the global ID constructed from the base64 encoding of `CaesarEventType:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Supplementary information about the event type. It is validated against <a href="https://skeleton.staging.botmd.io/docs/-generated.html" target="_blank"></a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** The name of this event type. */
  name: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Object type for `CaesarEventType`. */
export type CaesarEventTypeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum CancerType {
  BladderCancer = 'BLADDER_CANCER',
  BreastCancer = 'BREAST_CANCER',
  ColorectalCancer = 'COLORECTAL_CANCER',
  EndometrialCancer = 'ENDOMETRIAL_CANCER',
  HeadAndNeckCancer = 'HEAD_AND_NECK_CANCER',
  Leukaemia = 'LEUKAEMIA',
  LiverCancer = 'LIVER_CANCER',
  LungCancer = 'LUNG_CANCER',
  Lymphoma = 'LYMPHOMA',
  MerkelCellCancer = 'MERKEL_CELL_CANCER',
  MulticentricCastlemansDisease = 'MULTICENTRIC_CASTLEMANS_DISEASE',
  MultipleMyeloma = 'MULTIPLE_MYELOMA',
  MyeloproliferativeNeoplasms = 'MYELOPROLIFERATIVE_NEOPLASMS',
  Neuroendocrine = 'NEUROENDOCRINE',
  Others = 'OTHERS',
  OvarianCancer = 'OVARIAN_CANCER',
  PancreaticCancer = 'PANCREATIC_CANCER',
  ProstateCancer = 'PROSTATE_CANCER',
  RenalCancer = 'RENAL_CANCER',
  Sarcoma = 'SARCOMA',
  SkinCancer = 'SKIN_CANCER',
  ThoracicCancer = 'THORACIC_CANCER',
  ThyroidCancer = 'THYROID_CANCER',
  TumourAgnostic = 'TUMOUR_AGNOSTIC',
  UpperGastrointestinalCancer = 'UPPER_GASTROINTESTINAL_CANCER',
}

/** An enumeration. */
export enum Category {
  AccountUpdate = 'ACCOUNT_UPDATE',
  AlertUpdate = 'ALERT_UPDATE',
  AppointmentUpdate = 'APPOINTMENT_UPDATE',
  AutoReply = 'AUTO_REPLY',
  IssueResolution = 'ISSUE_RESOLUTION',
  Marketing = 'MARKETING',
  Otp = 'OTP',
  PaymentUpdate = 'PAYMENT_UPDATE',
  PersonalFinanceUpdate = 'PERSONAL_FINANCE_UPDATE',
  ReservationUpdate = 'RESERVATION_UPDATE',
  ShippingUpdate = 'SHIPPING_UPDATE',
  TicketUpdate = 'TICKET_UPDATE',
  Transactional = 'TRANSACTIONAL',
  TransportationUpdate = 'TRANSPORTATION_UPDATE',
  Utility = 'UTILITY',
}

export enum ChatMessageType {
  Incoming = 'INCOMING',
  IsSorry = 'IS_SORRY',
  Outgoing = 'OUTGOING',
}

export type ChemocalcUserVariableInput = {
  /** Variable name. */
  name: Scalars['String']['input'];
  /** Variable value. For `file` types, this can be either a Stitch `upload_id` or HTTPS URL. */
  value: Scalars['String']['input'];
};

export type ChernobylVariableInput = {
  /** Variable name. */
  name: Scalars['String']['input'];
  /** Variable value. */
  value: Scalars['String']['input'];
};

/** Object type for `CleoAlertRule`. */
export type CleoAlertRule = ScalpelNode & {
  __typename?: 'CleoAlertRule';
  /** This is the global ID constructed from the base64 encoding of `CleoAlertRule:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** This alert rule applies to all patient-form in the clinic by default. */
  isForClinic: Scalars['Boolean']['output'];
  /** The level determines the response to the alert. */
  level?: Maybe<CleoAlertRuleLevelChoices>;
  /** Alert name */
  name: Scalars['String']['output'];
  /** The import path for this instantiable object. */
  parserImportPath: CleoAlertRuleParserImportPathChoices;
  /** Settings for parser. It will be validated against `cleo/RuleParserSettings.schema`. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-ruleparsersettings-generated.html" target="_blank">cleo/RuleParserSettings.schema</a>. */
  parserSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoAlertRuleConnection = {
  __typename?: 'CleoAlertRuleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoAlertRuleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoAlertRule` and its cursor. */
export type CleoAlertRuleEdge = {
  __typename?: 'CleoAlertRuleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoAlertRule>;
};

/** An enumeration. */
export enum CleoAlertRuleLevelChoices {
  /** Critical */
  Critical = 'CRITICAL',
  /** Informational */
  Informational = 'INFORMATIONAL',
  /** Warning */
  Warning = 'WARNING',
}

/** An enumeration. */
export enum CleoAlertRuleLevelForMutation {
  /** Critical */
  Critical = 'CRITICAL',
  /** Informational */
  Informational = 'INFORMATIONAL',
  /** Warning */
  Warning = 'WARNING',
}

/** An enumeration. */
export enum CleoAlertRuleParserImportPathChoices {
  /** Min-Max Rule Parser (Deprecated; Use Simple Rule Parser instead) */
  CleoRuleParsersMinmaxMinmaxparser = 'CLEO_RULE_PARSERS_MINMAX_MINMAXPARSER',
  /** Missing Submission */
  CleoRuleParsersMissingSubmissionMissingsubmissionruleparser = 'CLEO_RULE_PARSERS_MISSING_SUBMISSION_MISSINGSUBMISSIONRULEPARSER',
  /** Simple Rule Parser */
  CleoRuleParsersSimpleSimpleparser = 'CLEO_RULE_PARSERS_SIMPLE_SIMPLEPARSER',
}

/** An enumeration. */
export enum CleoAlertRuleParserImportPathForMutation {
  /** Min-Max Rule Parser (Deprecated; Use Simple Rule Parser instead) */
  CleoRuleParsersMinmaxMinmaxparser = 'CLEO_RULE_PARSERS_MINMAX_MINMAXPARSER',
  /** Missing Submission */
  CleoRuleParsersMissingSubmissionMissingsubmissionruleparser = 'CLEO_RULE_PARSERS_MISSING_SUBMISSION_MISSINGSUBMISSIONRULEPARSER',
  /** Simple Rule Parser */
  CleoRuleParsersSimpleSimpleparser = 'CLEO_RULE_PARSERS_SIMPLE_SIMPLEPARSER',
}

/** This is a related model input type for `CleoAlertRule`. */
export type CleoAlertRuleRelatedModelInput = {
  /** Global ID for referencing `CleoAlertRule`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoAlertRule`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoClinic`. */
export type CleoClinic = ScalpelNode & {
  __typename?: 'CleoClinic';
  /** Table settings for configuring the look and feel of "Active Patients forms" table. */
  activePatientFormsTableSettings: Scalars['GenericScalar']['output'];
  /** Table settings for configuring the look and feel of "Active Patients" table. */
  activePatientListTableSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Table settings for configuring the look and feel of "All Patients" table. */
  allPatientFormsTableSettings: Scalars['GenericScalar']['output'];
  /** Billing settings for this clinic. */
  billingSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** The clinic's assigned caregiver role. */
  caregiverRole?: Maybe<CleoRole>;
  /** Clinic group associated with this clinic. */
  clinicGroup: CleoClinicGroup;
  /** Count of clinicians belong to this clinic. */
  clinicianCount?: Maybe<Scalars['Int']['output']>;
  /** The communication methods supported by this clinic. `INBOUND` is excluded. */
  communicationMethods: Array<CleoCommunicationMethod>;
  /** Default phone country code of this clinic. */
  countryCode: CleoClinicCountryCodeChoices;
  /** Table settings for configuring the look and feel of "Discharged Patients forms" table. */
  dischargedPatientFormsTableSettings: Scalars['GenericScalar']['output'];
  /** Table settings for configuring the look and feel of "Discharged Patients" table. */
  dischargedPatientListTableSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Clinic domain/sub-domain when accessing via the web. */
  domain: Scalars['String']['output'];
  /** Clinic logo. Defaults to clinic group logo if not specified. */
  effectiveLogo: Scalars['String']['output'];
  /** The enrollment form associated with the clinic. */
  enrollmentForm?: Maybe<CleoMonitoringForm>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinic:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Billing logic based on clinic or clinic group. Default is `False`. */
  isClinicBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Whether clinic is using v3 logic. Default is `False`. */
  isV3?: Maybe<Scalars['Boolean']['output']>;
  /** Default language of this clinic. */
  language: CleoClinicLanguageChoices;
  /** Clinic logo which will be displayed on dashboard. Defaults to clinic group logo if not set. */
  logo: Scalars['FileFieldType']['output'];
  /** The Moneta provider-applications used by this clinic. */
  monetaProviderApplications: Array<CleoClinicMonetaProviderApplication>;
  /** Clinic name. */
  name: Scalars['String']['output'];
  /** Table settings for configuring the look and feel of "Non-compliant Patients" table. */
  nonCompliantPatientFormsTableSettings: Scalars['GenericScalar']['output'];
  /** Charts settings for displaying individual patient's charts. Charts will be displayed in the same order as this array of settings. */
  patientChartsSettings: Scalars['GenericScalar']['output'];
  /** Table settings for configuring the look and feel of the submissions table within an individual patient's view. */
  patientSubmissionsTableSettings: Scalars['GenericScalar']['output'];
  /** Clinic settings. This field is exposed to Frontend. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicsettings-generated.html" target="_blank">cleo/ClinicSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Default timezone of this clinic. */
  timezone: CleoClinicTimezoneChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Table settings for configuring the look and feel of "Patients with Unresolved Alerts" table. */
  unresolvedAlertsPatientFormsTableSettings: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoClinicCalendar`. */
export type CleoClinicCalendar = ScalpelNode & {
  __typename?: 'CleoClinicCalendar';
  /** URL to access the calendar from provider. */
  calendarUrl: Scalars['String']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Event type supported by this calendar. */
  eventTypes?: Maybe<Array<CleoClinicCalendarEventType>>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicCalendar:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Supplementary information about the calendar. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-cliniccalendarmetadata-generated.html" target="_blank">cleo/ClinicCalendarMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** The name of this calendar from Cleo' perspective. */
  name: Scalars['String']['output'];
  /** List of reminders attached to this calendar. */
  reminders: Array<CleoReminder>;
  /** List of template_sets attached to this calendar. */
  templateSets: Array<CleoMessageTemplateSet>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicCalendarConnection = {
  __typename?: 'CleoClinicCalendarConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicCalendarEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicCalendar` and its cursor. */
export type CleoClinicCalendarEdge = {
  __typename?: 'CleoClinicCalendarEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicCalendar>;
};

/** List of event type that belongs to clinic calendar. */
export type CleoClinicCalendarEventType = ScalpelNode & {
  __typename?: 'CleoClinicCalendarEventType';
  /** Clinic calendar this mapping is for. */
  clinicCalendar: CleoClinicCalendar;
  /** Effective URL to schedule for this event type from provider. */
  effectiveEventUrl?: Maybe<Scalars['String']['output']>;
  /** Event type this mapping is for. */
  eventType: CaesarEventType;
  /** URL to schedule for this event type from provider. */
  eventUrl: Scalars['String']['output'];
  /** `CleoClinicCalendarEventType` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type CleoClinicCalendarEventTypeConnection = {
  __typename?: 'CleoClinicCalendarEventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicCalendarEventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicCalendarEventType` and its cursor. */
export type CleoClinicCalendarEventTypeEdge = {
  __typename?: 'CleoClinicCalendarEventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicCalendarEventType>;
};

export type CleoClinicConnection = {
  __typename?: 'CleoClinicConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CleoClinicCountryCodeChoices {
  /** Colombia (CO) */
  Co = 'CO',
  /** United Kingdom (GB) */
  Gb = 'GB',
  /** Indonesia (ID) */
  Id = 'ID',
  /** India (IN) */
  In = 'IN',
  /** Japan (JP) */
  Jp = 'JP',
  /** Mexico (MX) */
  Mx = 'MX',
  /** Malaysia (MY) */
  My = 'MY',
  /** Philippines (PH) */
  Ph = 'PH',
  /** Singapore (SG) */
  Sg = 'SG',
  /** Thailand (TH) */
  Th = 'TH',
  /** United States of America (US) */
  Us = 'US',
}

/** An enumeration. */
export enum CleoClinicCountryCodeForMutation {
  /** Colombia (CO) */
  Co = 'CO',
  /** United Kingdom (GB) */
  Gb = 'GB',
  /** Indonesia (ID) */
  Id = 'ID',
  /** India (IN) */
  In = 'IN',
  /** Japan (JP) */
  Jp = 'JP',
  /** Mexico (MX) */
  Mx = 'MX',
  /** Malaysia (MY) */
  My = 'MY',
  /** Philippines (PH) */
  Ph = 'PH',
  /** Singapore (SG) */
  Sg = 'SG',
  /** Thailand (TH) */
  Th = 'TH',
  /** United States of America (US) */
  Us = 'US',
}

/** A Relay edge containing a `CleoClinic` and its cursor. */
export type CleoClinicEdge = {
  __typename?: 'CleoClinicEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinic>;
};

/** Object type for `CleoClinicFilter`. */
export type CleoClinicFilter = ScalpelNode & {
  __typename?: 'CleoClinicFilter';
  /** Description of the filter. */
  description: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoClinicFilter:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Filter name. */
  name: Scalars['String']['output'];
  /** Filter settings including its schedule and options. It is validated against <a href="https://skeleton.staging.botmd.io/docs/scalpel-filtersettings-generated.html" target="_blank">scalpel/FilterSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicFilterConnection = {
  __typename?: 'CleoClinicFilterConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicFilterEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicFilter` and its cursor. */
export type CleoClinicFilterEdge = {
  __typename?: 'CleoClinicFilterEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicFilter>;
};

/** This is a related model input type for `CleoClinicFilter`. */
export type CleoClinicFilterRelatedModelInput = {
  /** Global ID for referencing `CleoClinicFilter`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoClinicFilter`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoClinicGroup`. */
export type CleoClinicGroup = ScalpelNode & {
  __typename?: 'CleoClinicGroup';
  /** Billing settings for this clinic. */
  billingSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Count of clinicians belong to this clinic group. */
  clinicianCount?: Maybe<Scalars['Int']['output']>;
  /** Clinics belong to this clinic group. */
  clinics?: Maybe<Array<CleoClinicPublicSettings>>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Clinic group domain/sub-domain. */
  domain: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoClinicGroup:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinic group logo which will be displayed on dashboard. */
  logo: Scalars['FileFieldType']['output'];
  /** Clinic group name. */
  name: Scalars['String']['output'];
  /** Clinic group settings. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicgroupsettings-generated.html" target="_blank">cleo/ClinicGroupSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Default timezone of this clinic group. */
  timezone: CleoClinicGroupTimezoneChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicGroupConnection = {
  __typename?: 'CleoClinicGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicGroup` and its cursor. */
export type CleoClinicGroupEdge = {
  __typename?: 'CleoClinicGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicGroup>;
};

/** This is a related model input type for `CleoClinicGroup`. */
export type CleoClinicGroupRelatedModelInput = {
  /** Global ID for referencing `CleoClinicGroup`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoClinicGroup`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CleoClinicGroupTimezoneChoices {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar es Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North Dakota/New Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port of Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho Chi Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** CET */
  Cet = 'CET',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** CST6CDT */
  Cst6Cdt = 'CST6CDT',
  /** Cuba */
  Cuba = 'CUBA',
  /** EET */
  Eet = 'EET',
  /** Egypt */
  Egypt = 'EGYPT',
  /** Eire */
  Eire = 'EIRE',
  /** EST */
  Est = 'EST',
  /** EST5EDT */
  Est5Edt = 'EST5EDT',
  /** Etc/GMT */
  EtcGmt = 'ETC_GMT',
  /** Etc/GMT0 */
  EtcGmt0 = 'ETC_GMT0',
  /** Etc/GMT-0 */
  EtcGmt_0 = 'ETC_GMT_0',
  /** Etc/GMT+0 */
  EtcGmt_0_408 = 'ETC_GMT_0_408',
  /** Etc/GMT-1 */
  EtcGmt_1 = 'ETC_GMT_1',
  /** Etc/GMT+1 */
  EtcGmt_1_409 = 'ETC_GMT_1_409',
  /** Etc/GMT-2 */
  EtcGmt_2 = 'ETC_GMT_2',
  /** Etc/GMT+2 */
  EtcGmt_2_413 = 'ETC_GMT_2_413',
  /** Etc/GMT-3 */
  EtcGmt_3 = 'ETC_GMT_3',
  /** Etc/GMT+3 */
  EtcGmt_3_414 = 'ETC_GMT_3_414',
  /** Etc/GMT-4 */
  EtcGmt_4 = 'ETC_GMT_4',
  /** Etc/GMT+4 */
  EtcGmt_4_415 = 'ETC_GMT_4_415',
  /** Etc/GMT-5 */
  EtcGmt_5 = 'ETC_GMT_5',
  /** Etc/GMT+5 */
  EtcGmt_5_416 = 'ETC_GMT_5_416',
  /** Etc/GMT-6 */
  EtcGmt_6 = 'ETC_GMT_6',
  /** Etc/GMT+6 */
  EtcGmt_6_417 = 'ETC_GMT_6_417',
  /** Etc/GMT-7 */
  EtcGmt_7 = 'ETC_GMT_7',
  /** Etc/GMT+7 */
  EtcGmt_7_418 = 'ETC_GMT_7_418',
  /** Etc/GMT-8 */
  EtcGmt_8 = 'ETC_GMT_8',
  /** Etc/GMT+8 */
  EtcGmt_8_419 = 'ETC_GMT_8_419',
  /** Etc/GMT-9 */
  EtcGmt_9 = 'ETC_GMT_9',
  /** Etc/GMT+9 */
  EtcGmt_9_420 = 'ETC_GMT_9_420',
  /** Etc/GMT-10 */
  EtcGmt_10 = 'ETC_GMT_10',
  /** Etc/GMT+10 */
  EtcGmt_10_410 = 'ETC_GMT_10_410',
  /** Etc/GMT-11 */
  EtcGmt_11 = 'ETC_GMT_11',
  /** Etc/GMT+11 */
  EtcGmt_11_411 = 'ETC_GMT_11_411',
  /** Etc/GMT-12 */
  EtcGmt_12 = 'ETC_GMT_12',
  /** Etc/GMT+12 */
  EtcGmt_12_412 = 'ETC_GMT_12_412',
  /** Etc/GMT-13 */
  EtcGmt_13 = 'ETC_GMT_13',
  /** Etc/GMT-14 */
  EtcGmt_14 = 'ETC_GMT_14',
  /** Etc/Greenwich */
  EtcGreenwich = 'ETC_GREENWICH',
  /** Etc/UCT */
  EtcUct = 'ETC_UCT',
  /** Etc/Universal */
  EtcUniversal = 'ETC_UNIVERSAL',
  /** Etc/UTC */
  EtcUtc = 'ETC_UTC',
  /** Etc/Zulu */
  EtcZulu = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle of Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** GB */
  Gb = 'GB',
  /** GB-Eire */
  GbEire = 'GB_EIRE',
  /** GMT */
  Gmt = 'GMT',
  /** GMT0 */
  Gmt0 = 'GMT0',
  /** GMT-0 */
  Gmt_0 = 'GMT_0',
  /** GMT+0 */
  Gmt_0_495 = 'GMT_0_495',
  /** Greenwich */
  Greenwich = 'GREENWICH',
  /** Hongkong */
  Hongkong = 'HONGKONG',
  /** HST */
  Hst = 'HST',
  /** Iceland */
  Iceland = 'ICELAND',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Iran */
  Iran = 'IRAN',
  /** Israel */
  Israel = 'ISRAEL',
  /** Jamaica */
  Jamaica = 'JAMAICA',
  /** Japan */
  Japan = 'JAPAN',
  /** Kwajalein */
  Kwajalein = 'KWAJALEIN',
  /** Libya */
  Libya = 'LIBYA',
  /** localtime */
  Localtime = 'LOCALTIME',
  /** MET */
  Met = 'MET',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** MST */
  Mst = 'MST',
  /** MST7MDT */
  Mst7Mdt = 'MST7MDT',
  /** Navajo */
  Navajo = 'NAVAJO',
  /** NZ */
  Nz = 'NZ',
  /** NZ-CHAT */
  NzChat = 'NZ_CHAT',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** Poland */
  Poland = 'POLAND',
  /** Portugal */
  Portugal = 'PORTUGAL',
  /** PRC */
  Prc = 'PRC',
  /** PST8PDT */
  Pst8Pdt = 'PST8PDT',
  /** ROC */
  Roc = 'ROC',
  /** ROK */
  Rok = 'ROK',
  /** Singapore */
  Singapore = 'SINGAPORE',
  /** Turkey */
  Turkey = 'TURKEY',
  /** UCT */
  Uct = 'UCT',
  /** Universal */
  Universal = 'UNIVERSAL',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA',
  /** UTC */
  Utc = 'UTC',
  /** WET */
  Wet = 'WET',
  /** W-SU */
  WSu = 'W_SU',
  /** Zulu */
  Zulu = 'ZULU',
}

/** An enumeration. */
export enum CleoClinicGroupTimezoneForMutation {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar es Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North Dakota/New Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port of Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho Chi Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** CET */
  Cet = 'CET',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** CST6CDT */
  Cst6Cdt = 'CST6CDT',
  /** Cuba */
  Cuba = 'CUBA',
  /** EET */
  Eet = 'EET',
  /** Egypt */
  Egypt = 'EGYPT',
  /** Eire */
  Eire = 'EIRE',
  /** EST */
  Est = 'EST',
  /** EST5EDT */
  Est5Edt = 'EST5EDT',
  /** Etc/GMT */
  EtcGmt = 'ETC_GMT',
  /** Etc/GMT0 */
  EtcGmt0 = 'ETC_GMT0',
  /** Etc/GMT-0 */
  EtcGmt_0 = 'ETC_GMT_0',
  /** Etc/GMT+0 */
  EtcGmt_0_408 = 'ETC_GMT_0_408',
  /** Etc/GMT-1 */
  EtcGmt_1 = 'ETC_GMT_1',
  /** Etc/GMT+1 */
  EtcGmt_1_409 = 'ETC_GMT_1_409',
  /** Etc/GMT-2 */
  EtcGmt_2 = 'ETC_GMT_2',
  /** Etc/GMT+2 */
  EtcGmt_2_413 = 'ETC_GMT_2_413',
  /** Etc/GMT-3 */
  EtcGmt_3 = 'ETC_GMT_3',
  /** Etc/GMT+3 */
  EtcGmt_3_414 = 'ETC_GMT_3_414',
  /** Etc/GMT-4 */
  EtcGmt_4 = 'ETC_GMT_4',
  /** Etc/GMT+4 */
  EtcGmt_4_415 = 'ETC_GMT_4_415',
  /** Etc/GMT-5 */
  EtcGmt_5 = 'ETC_GMT_5',
  /** Etc/GMT+5 */
  EtcGmt_5_416 = 'ETC_GMT_5_416',
  /** Etc/GMT-6 */
  EtcGmt_6 = 'ETC_GMT_6',
  /** Etc/GMT+6 */
  EtcGmt_6_417 = 'ETC_GMT_6_417',
  /** Etc/GMT-7 */
  EtcGmt_7 = 'ETC_GMT_7',
  /** Etc/GMT+7 */
  EtcGmt_7_418 = 'ETC_GMT_7_418',
  /** Etc/GMT-8 */
  EtcGmt_8 = 'ETC_GMT_8',
  /** Etc/GMT+8 */
  EtcGmt_8_419 = 'ETC_GMT_8_419',
  /** Etc/GMT-9 */
  EtcGmt_9 = 'ETC_GMT_9',
  /** Etc/GMT+9 */
  EtcGmt_9_420 = 'ETC_GMT_9_420',
  /** Etc/GMT-10 */
  EtcGmt_10 = 'ETC_GMT_10',
  /** Etc/GMT+10 */
  EtcGmt_10_410 = 'ETC_GMT_10_410',
  /** Etc/GMT-11 */
  EtcGmt_11 = 'ETC_GMT_11',
  /** Etc/GMT+11 */
  EtcGmt_11_411 = 'ETC_GMT_11_411',
  /** Etc/GMT-12 */
  EtcGmt_12 = 'ETC_GMT_12',
  /** Etc/GMT+12 */
  EtcGmt_12_412 = 'ETC_GMT_12_412',
  /** Etc/GMT-13 */
  EtcGmt_13 = 'ETC_GMT_13',
  /** Etc/GMT-14 */
  EtcGmt_14 = 'ETC_GMT_14',
  /** Etc/Greenwich */
  EtcGreenwich = 'ETC_GREENWICH',
  /** Etc/UCT */
  EtcUct = 'ETC_UCT',
  /** Etc/Universal */
  EtcUniversal = 'ETC_UNIVERSAL',
  /** Etc/UTC */
  EtcUtc = 'ETC_UTC',
  /** Etc/Zulu */
  EtcZulu = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle of Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** GB */
  Gb = 'GB',
  /** GB-Eire */
  GbEire = 'GB_EIRE',
  /** GMT */
  Gmt = 'GMT',
  /** GMT0 */
  Gmt0 = 'GMT0',
  /** GMT-0 */
  Gmt_0 = 'GMT_0',
  /** GMT+0 */
  Gmt_0_495 = 'GMT_0_495',
  /** Greenwich */
  Greenwich = 'GREENWICH',
  /** Hongkong */
  Hongkong = 'HONGKONG',
  /** HST */
  Hst = 'HST',
  /** Iceland */
  Iceland = 'ICELAND',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Iran */
  Iran = 'IRAN',
  /** Israel */
  Israel = 'ISRAEL',
  /** Jamaica */
  Jamaica = 'JAMAICA',
  /** Japan */
  Japan = 'JAPAN',
  /** Kwajalein */
  Kwajalein = 'KWAJALEIN',
  /** Libya */
  Libya = 'LIBYA',
  /** localtime */
  Localtime = 'LOCALTIME',
  /** MET */
  Met = 'MET',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** MST */
  Mst = 'MST',
  /** MST7MDT */
  Mst7Mdt = 'MST7MDT',
  /** Navajo */
  Navajo = 'NAVAJO',
  /** NZ */
  Nz = 'NZ',
  /** NZ-CHAT */
  NzChat = 'NZ_CHAT',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** Poland */
  Poland = 'POLAND',
  /** Portugal */
  Portugal = 'PORTUGAL',
  /** PRC */
  Prc = 'PRC',
  /** PST8PDT */
  Pst8Pdt = 'PST8PDT',
  /** ROC */
  Roc = 'ROC',
  /** ROK */
  Rok = 'ROK',
  /** Singapore */
  Singapore = 'SINGAPORE',
  /** Turkey */
  Turkey = 'TURKEY',
  /** UCT */
  Uct = 'UCT',
  /** Universal */
  Universal = 'UNIVERSAL',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA',
  /** UTC */
  Utc = 'UTC',
  /** WET */
  Wet = 'WET',
  /** W-SU */
  WSu = 'W_SU',
  /** Zulu */
  Zulu = 'ZULU',
}

/** An enumeration. */
export enum CleoClinicLanguageChoices {
  /** Bengali */
  Bn = 'BN',
  /** English */
  En = 'EN',
  /** Spanish; Castilian */
  Es = 'ES',
  /** Hindi */
  Hi = 'HI',
  /** Indonesian */
  Id = 'ID',
  /** Japanese */
  Ja = 'JA',
  /** Malay */
  Ms = 'MS',
  /** Tamil */
  Ta = 'TA',
  /** Thai */
  Th = 'TH',
  /** Tagalog */
  Tl = 'TL',
  /** Chinese */
  Zh = 'ZH',
}

/** An enumeration. */
export enum CleoClinicLanguageForMutation {
  /** Bengali */
  Bn = 'BN',
  /** English */
  En = 'EN',
  /** Spanish; Castilian */
  Es = 'ES',
  /** Hindi */
  Hi = 'HI',
  /** Indonesian */
  Id = 'ID',
  /** Japanese */
  Ja = 'JA',
  /** Malay */
  Ms = 'MS',
  /** Tamil */
  Ta = 'TA',
  /** Thai */
  Th = 'TH',
  /** Tagalog */
  Tl = 'TL',
  /** Chinese */
  Zh = 'ZH',
}

/** Object type for `CleoClinicMonetaProviderApplication`. */
export type CleoClinicMonetaProviderApplication = ScalpelNode & {
  __typename?: 'CleoClinicMonetaProviderApplication';
  /** The `name` if set, otherwise, it will default to the "`payment_method` via `provider_name`". */
  effectiveName: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoClinicMonetaProviderApplication:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The human readable name of this payment provider. If left empty, it will default to `provider_application_name`. */
  name: Scalars['String']['output'];
  /** Moneta provider application this clinic will use. */
  providerApplication: MonetaProviderApplication;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Object type for `CleoClinicProduct`. */
export type CleoClinicProduct = ScalpelNode & {
  __typename?: 'CleoClinicProduct';
  /** The decimal amount of the cost. */
  cost: Scalars['Decimal']['output'];
  costCurrency: CleoClinicProductCostCurrencyChoices;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicProduct:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the clinic product active? */
  isActivated: Scalars['Boolean']['output'];
  /** Clinic product metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicproductmetadata-generated.html" target="_blank">cleo/ClinicProductMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** The name of this product. */
  name: Scalars['String']['output'];
  /** The pretty representation of the cost. */
  prettyCost: Scalars['String']['output'];
  /** List of Moneta provider-application that support the currency for this clinic product. */
  supportedClinicMonetaProviderApplications: Array<CleoClinicMonetaProviderApplication>;
  /** List of template_sets attached to this calendar. */
  templateSets: Array<CleoMessageTemplateSet>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicProductConnection = {
  __typename?: 'CleoClinicProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CleoClinicProductCostCurrencyChoices {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR',
}

/** An enumeration. */
export enum CleoClinicProductCostCurrencyForMutation {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR',
}

/** A Relay edge containing a `CleoClinicProduct` and its cursor. */
export type CleoClinicProductEdge = {
  __typename?: 'CleoClinicProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicProduct>;
};

/** Object type for `CleoClinicProgram`. */
export type CleoClinicProgram = ScalpelNode & {
  __typename?: 'CleoClinicProgram';
  /** The CPMFs attached to this clinic program. */
  clinicProgramMonitoringFormsets: Array<CleoClinicProgramMonitoringFormset>;
  /** The clinical parameters attached to this clinic program. */
  clinicalParameters: Array<CleoClinicalParameter>;
  /** Merlin administrator who created the clinic program. */
  createdBy?: Maybe<MerlinAdministrator>;
  /** Date/Time this program was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicProgram:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Program name. */
  name: Scalars['String']['output'];
  /** Count of patients who enrolled into the program */
  patientCount?: Maybe<CleoClinicProgramPatientCount>;
  /** The reminder attached to this form. (Deprecated) */
  reminder?: Maybe<CleoReminder>;
  /** The reminders attached to this form. */
  reminders: Array<CleoReminder>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicProgramConnection = {
  __typename?: 'CleoClinicProgramConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicProgramEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicProgram` and its cursor. */
export type CleoClinicProgramEdge = {
  __typename?: 'CleoClinicProgramEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicProgram>;
};

/** Object type for `CleoClinicProgramMonitoringFormset`. */
export type CleoClinicProgramMonitoringFormset = ScalpelNode & {
  __typename?: 'CleoClinicProgramMonitoringFormset';
  /** The alert rules attached to this clinic program monitoring formsets. */
  alertRules: Array<CleoAlertRule>;
  /** ClinicProgram this mapping is for. */
  clinicProgram: CleoClinicProgram;
  /** The clinical parameters attached to this clinic program monitoring formsets. */
  clinicalParameters: Array<CleoClinicalParameter>;
  /** The reminders that are in effect for this clinic program monitoring formsets. Can be cpmf level or monitoring-formset level. */
  effectiveReminders: Array<CleoReminder>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicProgramMonitoringFormset:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** MonitoringFormset this mapping is for. */
  monitoringFormset: CleoMonitoringFormset;
  /** The reminders attached to this clinic program monitoring formsets. */
  reminders: Array<CleoReminder>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoClinicProgramMonitoringFormsetConnection = {
  __typename?: 'CleoClinicProgramMonitoringFormsetConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicProgramMonitoringFormsetEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicProgramMonitoringFormset` and its cursor. */
export type CleoClinicProgramMonitoringFormsetEdge = {
  __typename?: 'CleoClinicProgramMonitoringFormsetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicProgramMonitoringFormset>;
};

/** The count of patients who enrolled into the program. */
export type CleoClinicProgramPatientCount = ScalpelNode & {
  __typename?: 'CleoClinicProgramPatientCount';
  /** The number of activated patients. */
  activatedPatients: Scalars['Int']['output'];
  /** The number of deactivated patients. */
  deactivatedPatients: Scalars['Int']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The total number of patients. */
  totalPatients: Scalars['Int']['output'];
};

/** Clinic public settings. */
export type CleoClinicPublicSettings = ScalpelNode & {
  __typename?: 'CleoClinicPublicSettings';
  /** Allowed login methods for this clinic. */
  allowedLoginMethods: Array<Scalars['String']['output']>;
  /** [ISO 3166 alpha-2](https://www.iban.com/country-codes) country code for this clinic. This is used for various presentation purposes when the user's geographical location cannot be inferred. */
  countryCode: Scalars['String']['output'];
  /** Domain. */
  domain: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) language code for this clinic. Defaults to `en`. */
  language: Scalars['String']['output'];
  /** Logo URL. */
  logo: Scalars['String']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Describes how the patient should be verified when accessing their own dashboard. If `patient_dashboard_verification` is not set or `verification_fields` is empty, it means no verification is necessary. */
  patientDashboardVerification?: Maybe<Scalars['GenericScalar']['output']>;
  /** Default [timezone](https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) to assume for patients, clinicians in this clinic. Defaults to `UTC`. */
  timezone: Scalars['String']['output'];
  /** Unique identifier. */
  uid?: Maybe<Scalars['String']['output']>;
};

/** Object type for `CleoClinicRatatoskrProviderApplication`. */
export type CleoClinicRatatoskrProviderApplication = ScalpelNode & {
  __typename?: 'CleoClinicRatatoskrProviderApplication';
  /** Clinic associated with this Ratatoskr provider application. */
  clinic: CleoClinic;
  /** Use this Ratatoskr provider application for communication. */
  communicationMethod: CleoClinicRatatoskrProviderApplicationCommunicationMethodChoices;
  /** Date/Time this ratatoskr provider application set was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Order of fallback Ratatoskr provider applications. Lower number means higher priority. */
  fallbackOrder?: Maybe<Scalars['Int']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicRatatoskrProviderApplication:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Ratatoskr provider application this clinic will use. */
  providerApplication: RatatoskrProviderApplication;
  /** Settings for this Ratatoskr provider application. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicratatoskrproviderapplicationsettings-generated.html" target="_blank">cleo/ClinicRatatoskrProviderApplicationSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum CleoClinicRatatoskrProviderApplicationCommunicationMethodChoices {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

/** An enumeration. */
export enum CleoClinicRatatoskrProviderApplicationCommunicationMethodForMutation {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

export type CleoClinicRatatoskrProviderApplicationConnection = {
  __typename?: 'CleoClinicRatatoskrProviderApplicationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicRatatoskrProviderApplicationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoClinicRatatoskrProviderApplication` and its cursor. */
export type CleoClinicRatatoskrProviderApplicationEdge = {
  __typename?: 'CleoClinicRatatoskrProviderApplicationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicRatatoskrProviderApplication>;
};

/** This is a related model input type for `CleoClinic`. */
export type CleoClinicRelatedModelInput = {
  /** Global ID for referencing `CleoClinic`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoClinic`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CleoClinicTimezoneChoices {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar es Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North Dakota/New Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port of Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho Chi Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** CET */
  Cet = 'CET',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** CST6CDT */
  Cst6Cdt = 'CST6CDT',
  /** Cuba */
  Cuba = 'CUBA',
  /** EET */
  Eet = 'EET',
  /** Egypt */
  Egypt = 'EGYPT',
  /** Eire */
  Eire = 'EIRE',
  /** EST */
  Est = 'EST',
  /** EST5EDT */
  Est5Edt = 'EST5EDT',
  /** Etc/GMT */
  EtcGmt = 'ETC_GMT',
  /** Etc/GMT0 */
  EtcGmt0 = 'ETC_GMT0',
  /** Etc/GMT-0 */
  EtcGmt_0 = 'ETC_GMT_0',
  /** Etc/GMT+0 */
  EtcGmt_0_408 = 'ETC_GMT_0_408',
  /** Etc/GMT-1 */
  EtcGmt_1 = 'ETC_GMT_1',
  /** Etc/GMT+1 */
  EtcGmt_1_409 = 'ETC_GMT_1_409',
  /** Etc/GMT-2 */
  EtcGmt_2 = 'ETC_GMT_2',
  /** Etc/GMT+2 */
  EtcGmt_2_413 = 'ETC_GMT_2_413',
  /** Etc/GMT-3 */
  EtcGmt_3 = 'ETC_GMT_3',
  /** Etc/GMT+3 */
  EtcGmt_3_414 = 'ETC_GMT_3_414',
  /** Etc/GMT-4 */
  EtcGmt_4 = 'ETC_GMT_4',
  /** Etc/GMT+4 */
  EtcGmt_4_415 = 'ETC_GMT_4_415',
  /** Etc/GMT-5 */
  EtcGmt_5 = 'ETC_GMT_5',
  /** Etc/GMT+5 */
  EtcGmt_5_416 = 'ETC_GMT_5_416',
  /** Etc/GMT-6 */
  EtcGmt_6 = 'ETC_GMT_6',
  /** Etc/GMT+6 */
  EtcGmt_6_417 = 'ETC_GMT_6_417',
  /** Etc/GMT-7 */
  EtcGmt_7 = 'ETC_GMT_7',
  /** Etc/GMT+7 */
  EtcGmt_7_418 = 'ETC_GMT_7_418',
  /** Etc/GMT-8 */
  EtcGmt_8 = 'ETC_GMT_8',
  /** Etc/GMT+8 */
  EtcGmt_8_419 = 'ETC_GMT_8_419',
  /** Etc/GMT-9 */
  EtcGmt_9 = 'ETC_GMT_9',
  /** Etc/GMT+9 */
  EtcGmt_9_420 = 'ETC_GMT_9_420',
  /** Etc/GMT-10 */
  EtcGmt_10 = 'ETC_GMT_10',
  /** Etc/GMT+10 */
  EtcGmt_10_410 = 'ETC_GMT_10_410',
  /** Etc/GMT-11 */
  EtcGmt_11 = 'ETC_GMT_11',
  /** Etc/GMT+11 */
  EtcGmt_11_411 = 'ETC_GMT_11_411',
  /** Etc/GMT-12 */
  EtcGmt_12 = 'ETC_GMT_12',
  /** Etc/GMT+12 */
  EtcGmt_12_412 = 'ETC_GMT_12_412',
  /** Etc/GMT-13 */
  EtcGmt_13 = 'ETC_GMT_13',
  /** Etc/GMT-14 */
  EtcGmt_14 = 'ETC_GMT_14',
  /** Etc/Greenwich */
  EtcGreenwich = 'ETC_GREENWICH',
  /** Etc/UCT */
  EtcUct = 'ETC_UCT',
  /** Etc/Universal */
  EtcUniversal = 'ETC_UNIVERSAL',
  /** Etc/UTC */
  EtcUtc = 'ETC_UTC',
  /** Etc/Zulu */
  EtcZulu = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle of Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** GB */
  Gb = 'GB',
  /** GB-Eire */
  GbEire = 'GB_EIRE',
  /** GMT */
  Gmt = 'GMT',
  /** GMT0 */
  Gmt0 = 'GMT0',
  /** GMT-0 */
  Gmt_0 = 'GMT_0',
  /** GMT+0 */
  Gmt_0_495 = 'GMT_0_495',
  /** Greenwich */
  Greenwich = 'GREENWICH',
  /** Hongkong */
  Hongkong = 'HONGKONG',
  /** HST */
  Hst = 'HST',
  /** Iceland */
  Iceland = 'ICELAND',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Iran */
  Iran = 'IRAN',
  /** Israel */
  Israel = 'ISRAEL',
  /** Jamaica */
  Jamaica = 'JAMAICA',
  /** Japan */
  Japan = 'JAPAN',
  /** Kwajalein */
  Kwajalein = 'KWAJALEIN',
  /** Libya */
  Libya = 'LIBYA',
  /** localtime */
  Localtime = 'LOCALTIME',
  /** MET */
  Met = 'MET',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** MST */
  Mst = 'MST',
  /** MST7MDT */
  Mst7Mdt = 'MST7MDT',
  /** Navajo */
  Navajo = 'NAVAJO',
  /** NZ */
  Nz = 'NZ',
  /** NZ-CHAT */
  NzChat = 'NZ_CHAT',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** Poland */
  Poland = 'POLAND',
  /** Portugal */
  Portugal = 'PORTUGAL',
  /** PRC */
  Prc = 'PRC',
  /** PST8PDT */
  Pst8Pdt = 'PST8PDT',
  /** ROC */
  Roc = 'ROC',
  /** ROK */
  Rok = 'ROK',
  /** Singapore */
  Singapore = 'SINGAPORE',
  /** Turkey */
  Turkey = 'TURKEY',
  /** UCT */
  Uct = 'UCT',
  /** Universal */
  Universal = 'UNIVERSAL',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA',
  /** UTC */
  Utc = 'UTC',
  /** WET */
  Wet = 'WET',
  /** W-SU */
  WSu = 'W_SU',
  /** Zulu */
  Zulu = 'ZULU',
}

/** An enumeration. */
export enum CleoClinicTimezoneForMutation {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar es Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North Dakota/New Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port of Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho Chi Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** CET */
  Cet = 'CET',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** CST6CDT */
  Cst6Cdt = 'CST6CDT',
  /** Cuba */
  Cuba = 'CUBA',
  /** EET */
  Eet = 'EET',
  /** Egypt */
  Egypt = 'EGYPT',
  /** Eire */
  Eire = 'EIRE',
  /** EST */
  Est = 'EST',
  /** EST5EDT */
  Est5Edt = 'EST5EDT',
  /** Etc/GMT */
  EtcGmt = 'ETC_GMT',
  /** Etc/GMT0 */
  EtcGmt0 = 'ETC_GMT0',
  /** Etc/GMT-0 */
  EtcGmt_0 = 'ETC_GMT_0',
  /** Etc/GMT+0 */
  EtcGmt_0_408 = 'ETC_GMT_0_408',
  /** Etc/GMT-1 */
  EtcGmt_1 = 'ETC_GMT_1',
  /** Etc/GMT+1 */
  EtcGmt_1_409 = 'ETC_GMT_1_409',
  /** Etc/GMT-2 */
  EtcGmt_2 = 'ETC_GMT_2',
  /** Etc/GMT+2 */
  EtcGmt_2_413 = 'ETC_GMT_2_413',
  /** Etc/GMT-3 */
  EtcGmt_3 = 'ETC_GMT_3',
  /** Etc/GMT+3 */
  EtcGmt_3_414 = 'ETC_GMT_3_414',
  /** Etc/GMT-4 */
  EtcGmt_4 = 'ETC_GMT_4',
  /** Etc/GMT+4 */
  EtcGmt_4_415 = 'ETC_GMT_4_415',
  /** Etc/GMT-5 */
  EtcGmt_5 = 'ETC_GMT_5',
  /** Etc/GMT+5 */
  EtcGmt_5_416 = 'ETC_GMT_5_416',
  /** Etc/GMT-6 */
  EtcGmt_6 = 'ETC_GMT_6',
  /** Etc/GMT+6 */
  EtcGmt_6_417 = 'ETC_GMT_6_417',
  /** Etc/GMT-7 */
  EtcGmt_7 = 'ETC_GMT_7',
  /** Etc/GMT+7 */
  EtcGmt_7_418 = 'ETC_GMT_7_418',
  /** Etc/GMT-8 */
  EtcGmt_8 = 'ETC_GMT_8',
  /** Etc/GMT+8 */
  EtcGmt_8_419 = 'ETC_GMT_8_419',
  /** Etc/GMT-9 */
  EtcGmt_9 = 'ETC_GMT_9',
  /** Etc/GMT+9 */
  EtcGmt_9_420 = 'ETC_GMT_9_420',
  /** Etc/GMT-10 */
  EtcGmt_10 = 'ETC_GMT_10',
  /** Etc/GMT+10 */
  EtcGmt_10_410 = 'ETC_GMT_10_410',
  /** Etc/GMT-11 */
  EtcGmt_11 = 'ETC_GMT_11',
  /** Etc/GMT+11 */
  EtcGmt_11_411 = 'ETC_GMT_11_411',
  /** Etc/GMT-12 */
  EtcGmt_12 = 'ETC_GMT_12',
  /** Etc/GMT+12 */
  EtcGmt_12_412 = 'ETC_GMT_12_412',
  /** Etc/GMT-13 */
  EtcGmt_13 = 'ETC_GMT_13',
  /** Etc/GMT-14 */
  EtcGmt_14 = 'ETC_GMT_14',
  /** Etc/Greenwich */
  EtcGreenwich = 'ETC_GREENWICH',
  /** Etc/UCT */
  EtcUct = 'ETC_UCT',
  /** Etc/Universal */
  EtcUniversal = 'ETC_UNIVERSAL',
  /** Etc/UTC */
  EtcUtc = 'ETC_UTC',
  /** Etc/Zulu */
  EtcZulu = 'ETC_ZULU',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle of Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** GB */
  Gb = 'GB',
  /** GB-Eire */
  GbEire = 'GB_EIRE',
  /** GMT */
  Gmt = 'GMT',
  /** GMT0 */
  Gmt0 = 'GMT0',
  /** GMT-0 */
  Gmt_0 = 'GMT_0',
  /** GMT+0 */
  Gmt_0_495 = 'GMT_0_495',
  /** Greenwich */
  Greenwich = 'GREENWICH',
  /** Hongkong */
  Hongkong = 'HONGKONG',
  /** HST */
  Hst = 'HST',
  /** Iceland */
  Iceland = 'ICELAND',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Iran */
  Iran = 'IRAN',
  /** Israel */
  Israel = 'ISRAEL',
  /** Jamaica */
  Jamaica = 'JAMAICA',
  /** Japan */
  Japan = 'JAPAN',
  /** Kwajalein */
  Kwajalein = 'KWAJALEIN',
  /** Libya */
  Libya = 'LIBYA',
  /** localtime */
  Localtime = 'LOCALTIME',
  /** MET */
  Met = 'MET',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** MST */
  Mst = 'MST',
  /** MST7MDT */
  Mst7Mdt = 'MST7MDT',
  /** Navajo */
  Navajo = 'NAVAJO',
  /** NZ */
  Nz = 'NZ',
  /** NZ-CHAT */
  NzChat = 'NZ_CHAT',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** Poland */
  Poland = 'POLAND',
  /** Portugal */
  Portugal = 'PORTUGAL',
  /** PRC */
  Prc = 'PRC',
  /** PST8PDT */
  Pst8Pdt = 'PST8PDT',
  /** ROC */
  Roc = 'ROC',
  /** ROK */
  Rok = 'ROK',
  /** Singapore */
  Singapore = 'SINGAPORE',
  /** Turkey */
  Turkey = 'TURKEY',
  /** UCT */
  Uct = 'UCT',
  /** Universal */
  Universal = 'UNIVERSAL',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA',
  /** UTC */
  Utc = 'UTC',
  /** WET */
  Wet = 'WET',
  /** W-SU */
  WSu = 'W_SU',
  /** Zulu */
  Zulu = 'ZULU',
}

/** Object type for `CleoClinicalParameter`. */
export type CleoClinicalParameter = ScalpelNode & {
  __typename?: 'CleoClinicalParameter';
  /** DSL filter key for this clinical parameter */
  dslFilterKeys?: Maybe<Array<Maybe<CleoClinicalParameterDslFilterKey>>>;
  /** This is used for grouping parameters together, e.g., "Blood Pressure" is a group for Systolic/Diastolic. Defaults to the parameter name. */
  groupName: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoClinicalParameter:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical parameter name. */
  name: Scalars['String']['output'];
  /** Name of parameter including group name if applicable. */
  nameWithGroup: Scalars['String']['output'];
  /** For numerical clinical parameters, this is used to control the precision for display purposes. */
  numberPrecision?: Maybe<Scalars['Int']['output']>;
  /** Possible value for the clinical paramter. */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** An arbitrary order of preference for display purposes. */
  sortOrder: Scalars['Int']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Unit for this clinical parameter. Only applies to NUMBER value types. */
  unit: Scalars['String']['output'];
  /** If `true`, this clinicial parameter will be available for creation by clinician in the Patient-Event metadata modal. */
  usedForPatientEventMetadataEntry?: Maybe<Scalars['Boolean']['output']>;
  /** If `true`, this clinicial parameter will be available for creation by clinician in the Patient-Form metadata modal. */
  usedForPatientFormMetadataEntry?: Maybe<Scalars['Boolean']['output']>;
  /** If `true`, this clinicial parameter will be available for creation by clinician in the Patient metadata modal. */
  usedForPatientMetadataEntry?: Maybe<Scalars['Boolean']['output']>;
  /** If `true`, this clinicial parameter will be available for creation by clinician in the Patient-Program-Form metadata modal. */
  usedForPatientProgramFormMetadataEntry?: Maybe<Scalars['Boolean']['output']>;
  /** If `true`, this clinicial parameter will be available for creation by clinician in the Patient-Program metadata modal. */
  usedForPatientProgramMetadataEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Parameter specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes clinic, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

export type CleoClinicalParameterConnection = {
  __typename?: 'CleoClinicalParameterConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicalParameterEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Key for DSL filter pair */
export type CleoClinicalParameterDslFilterKey = ScalpelNode & {
  __typename?: 'CleoClinicalParameterDSLFilterKey';
  /** Key in dsl to filter for parameter name */
  clinicalParameterNameFilterKey: Scalars['String']['output'];
  /** Key in dsl to filter for parameter value */
  clinicalParameterValueFilterKey: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** A Relay edge containing a `CleoClinicalParameter` and its cursor. */
export type CleoClinicalParameterEdge = {
  __typename?: 'CleoClinicalParameterEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinicalParameter>;
};

/** This is a related model input type for `CleoClinicalParameter`. */
export type CleoClinicalParameterRelatedModelInput = {
  /** Global ID for referencing `CleoClinicalParameter`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoClinicalParameter`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CleoClinicalParameterValueTypeChoices {
  /** Boolean */
  Boolean = 'BOOLEAN',
  /** Date-Time */
  Datetime = 'DATETIME',
  /** File */
  File = 'FILE',
  /** Number */
  Number = 'NUMBER',
  /** String */
  String = 'STRING',
  /** String Array */
  StringArray = 'STRING_ARRAY',
  /** Time */
  Time = 'TIME',
}

/** An enumeration. */
export enum CleoClinicalParameterValueTypeForMutation {
  /** Boolean */
  Boolean = 'BOOLEAN',
  /** Date-Time */
  Datetime = 'DATETIME',
  /** File */
  File = 'FILE',
  /** Number */
  Number = 'NUMBER',
  /** String */
  String = 'STRING',
  /** String Array */
  StringArray = 'STRING_ARRAY',
  /** Time */
  Time = 'TIME',
}

/** Object type for `CleoClinician`. */
export type CleoClinician = ScalpelNode & {
  __typename?: 'CleoClinician';
  /** The avatar for the clinician. Defaults to `avatar_blue_male`. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Caregiver relations to this clinician. */
  caregiverRelations?: Maybe<Array<CleoClinicianPatientFormRelation>>;
  /** Clinic which this profile belongs to. */
  clinic: CleoClinic;
  /** Method of contacting the clinician/patient. */
  communicationMethod: CleoClinicianCommunicationMethodChoices;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Designation. */
  designation: Scalars['String']['output'];
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoClinician:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Invitation QR code for clinician to link non-phone-based provider's device. */
  invitationQrcode?: Maybe<Scalars['String']['output']>;
  /** Invitation URL for clinician to link non-phone-based provider's device. */
  invitationUrl?: Maybe<Scalars['String']['output']>;
  /** Is the clinician activated? */
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the clinician a caregiver? */
  isCaregiver?: Maybe<Scalars['Boolean']['output']>;
  /** The language for the clinician. Defaults to clinic language if not set for clinician. Can be `null` when there is no clinic language set. */
  language?: Maybe<Scalars['String']['output']>;
  /** Supplementary information about the clinician/Patient. (Deprecated for Patient, use `metadata_entries` instead) It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-profilemetadata-generated.html" target="_blank">cleo/ProfileMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Full name of the user. */
  name: Scalars['String']['output'];
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone: Scalars['String']['output'];
  /** Profile photo. */
  profilePhoto: Scalars['FileFieldType']['output'];
  /** Ratatoskr devices for this clinician. */
  ratatoskrDevices: Array<CleoClinicianRatatoskrDevice>;
  /** Role that will apply to this clinician. Defaults to view only for all clinic objects. */
  role?: Maybe<CleoRole>;
  /** Stitch invitation URL for clinician to link non-phone-based provider's device. */
  stitchInvitationUrl?: Maybe<Scalars['String']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum CleoClinicianCommunicationMethodChoices {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

/** An enumeration. */
export enum CleoClinicianCommunicationMethodForMutation {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

export type CleoClinicianConnection = {
  __typename?: 'CleoClinicianConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoClinicianEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoClinicianConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoClinicianConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoClinicianConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Clinician designations. */
export type CleoClinicianDesignation = ScalpelNode & {
  __typename?: 'CleoClinicianDesignation';
  /** Designations in the clinic. */
  designation: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** A Relay edge containing a `CleoClinician` and its cursor. */
export type CleoClinicianEdge = {
  __typename?: 'CleoClinicianEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoClinician>;
};

/** Object type for `CleoClinicianPatientFormRelation`. */
export type CleoClinicianPatientFormRelation = ScalpelNode & {
  __typename?: 'CleoClinicianPatientFormRelation';
  /** This is the global ID constructed from the base64 encoding of `CleoClinicianPatientFormRelation:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Patient-Form associated with the clinician. */
  patientForm: CleoPatientForm;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Set clinician-patientform relations in one go. (DEPRECATED) */
export type CleoClinicianPatientFormRelationsUpdate = {
  __typename?: 'CleoClinicianPatientFormRelationsUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Patient-form whose relations were updated.(DEPRECATED) */
  patientForm?: Maybe<CleoPatientForm>;
};

export type CleoClinicianPatientFormRelationsUpdateInput = {
  /** Clinician UIDs for clinician alertees.(DEPRECATED) */
  alerteeUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician UIDs for caregivers.(DEPRECATED) */
  caregiverUids?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinician UIDs for clinicians in-charge.(DEPRECATED) */
  icUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient form UID.(DEPRECATED) */
  patientFormUid: Scalars['String']['input'];
};

/** Set clinician-patient relations in one go. */
export type CleoClinicianPatientRelationsUpdate = {
  __typename?: 'CleoClinicianPatientRelationsUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Patient-form whose relations were updated. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Patient-program-form whose relations were updated. */
  patientProgramForm?: Maybe<CleoPatientProgramForm>;
};

export type CleoClinicianPatientRelationsUpdateInput = {
  /** Clinician UIDs for clinician alertees. */
  alerteeUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician UIDs for caregivers. */
  caregiverUids?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinician UIDs for clinicians in-charge. */
  icUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient form UID. */
  patientFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient program form UID. */
  patientProgramFormUid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoClinicianRatatoskrDevice`. */
export type CleoClinicianRatatoskrDevice = ScalpelNode & {
  __typename?: 'CleoClinicianRatatoskrDevice';
  /** The communication method associated with this device. Can be `null` if the ClinicRatatoskrProviderApplication is removed or invalid. */
  communicationMethod?: Maybe<Scalars['String']['output']>;
  /** Ratatoskr device associated with this profile. */
  device: RatatoskrDevice;
  /** This is the global ID constructed from the base64 encoding of `CleoClinicianRatatoskrDevice:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Reassign all of clinician A's patient-relations to clinician B. */
export type CleoClinicianReassignment = {
  __typename?: 'CleoClinicianReassignment';
  /** Patient-forms that were reassigned. */
  affectedPatientForms?: Maybe<Array<CleoPatientForm>>;
  /** Patient-program-forms that were reassigned. */
  affectedPatientProgramForms?: Maybe<Array<CleoPatientProgramForm>>;
  /** No. of alertee relations that were reassigned. */
  alerteeRelationCount?: Maybe<Scalars['Int']['output']>;
  /** No. of caregiver relations that were reassigned. */
  caregiverRelationCount?: Maybe<Scalars['Int']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** No. of IC relations that were reassigned. */
  icRelationCount?: Maybe<Scalars['Int']['output']>;
};

export type CleoClinicianReassignmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinician A UID. */
  clinicianAUid: Scalars['String']['input'];
  /** Clinician B UID. */
  clinicianBUid: Scalars['String']['input'];
};

/** GQL type representation with human readable label for `CommunicationMethod` enum. */
export type CleoCommunicationMethod = ScalpelNode & {
  __typename?: 'CleoCommunicationMethod';
  /** This is the fallback order of the communication method. */
  fallbackOrder?: Maybe<Scalars['Int']['output']>;
  /** This is the GQL expected value (usually uppercase). */
  gql: CommunicationMethod;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** This is the human readable label (usually title case). */
  label: Scalars['String']['output'];
  /** This is the value stored in the database (usually lowercase). */
  value: Scalars['String']['output'];
};

export type CleoDeliveriesConnection = {
  __typename?: 'CleoDeliveriesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoDeliveriesEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoDeliveriesConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoDeliveriesConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoDeliveriesConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay edge containing a `CleoDeliveries` and its cursor. */
export type CleoDeliveriesEdge = {
  __typename?: 'CleoDeliveriesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoDelivery>;
};

/** Similar to Ratatoskr deliveries but customized for Cleo. */
export type CleoDelivery = ScalpelNode & {
  __typename?: 'CleoDelivery';
  /** Communication method this message template is for. */
  communicationMethod: CleoMessageTemplateCommunicationMethodChoices;
  /** Date/time the delivery was sent/received. */
  createdOn: Scalars['DateTime']['output'];
  /** Describes the type of the message according to Cleo delivery metadata. */
  deliveryBy: Scalars['String']['output'];
  /** Direction of the delivery. */
  direction?: Maybe<Direction>;
  /** Delivery's error message if any. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Delivery message content (including substitution). */
  message: Scalars['GenericScalar']['output'];
  /** Delivery message content (without substitution). */
  messageWithoutSubstitution: Scalars['GenericScalar']['output'];
  /** Delivery metadata. */
  metadata: Scalars['GenericScalar']['output'];
  /** Patient-event relevant to this delivery. */
  patientEvent?: Maybe<CleoPatientEvent>;
  /** Patient-form relevant to this delivery. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Patient-program relevant to this delivery. */
  patientProgram?: Maybe<CleoPatientProgram>;
  /** Patient-program-form relevant to this delivery. */
  patientProgramForm?: Maybe<CleoPatientProgramForm>;
  /** Delivery primary key. **Frontend should never use this field directly**. */
  pk: Scalars['String']['output'];
  /** Recipient of the delivery. */
  recipient: CleoDeliveryProfile;
  /** Sender of the delivery. */
  sender: CleoDeliveryProfile;
  /** Delivery status. */
  status?: Maybe<Scalars['String']['output']>;
  /** Delivery UID. */
  uid: Scalars['String']['output'];
};

/** Count of Ratatoskr deliveries but customized for Cleo. */
export type CleoDeliveryCount = ScalpelNode & {
  __typename?: 'CleoDeliveryCount';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Total Count ratatoskr deliveries. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Profile on either end of a delivery. */
export type CleoDeliveryProfile = ScalpelNode & {
  __typename?: 'CleoDeliveryProfile';
  /** Clinician who sent/received the delivery. */
  clinician?: Maybe<CleoClinician>;
  /** Recipient device when sender/recipient is the end-user. */
  device?: Maybe<RatatoskrDevice>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if the sender/recipient is bot. */
  isBot: Scalars['Boolean']['output'];
  /** Patient who sent/recieved the delivery. */
  patient?: Maybe<CleoPatient>;
};

/** Describes an exportable format for `PatientForm`s and `Submission`s. */
export type CleoExportableFormat = ScalpelNode & {
  __typename?: 'CleoExportableFormat';
  /** Is email allowed for the export of this document format. Defaults to `false`. */
  allowEmail: Scalars['Boolean']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Human readable label to display to the user. */
  label: Scalars['String']['output'];
  /** Output format key for use in `exportByUrl` field. */
  outputFormat: ExportOutputFormat;
};

/** For integration with third party */
export type CleoExternalApi = ScalpelNode & {
  __typename?: 'CleoExternalAPI';
  /** Total number of activated patients. */
  activatedPatientCount?: Maybe<Scalars['Int']['output']>;
  /** Clinicians in clinic. */
  clinicians?: Maybe<Array<CleoExternalClinician>>;
  /** Clinics in clinic group. */
  clinics?: Maybe<Array<CleoExternalClinic>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Message template sets in clinic. */
  messageTemplateSets?: Maybe<Array<CleoExternalMessageTemplateSet>>;
  /** Total number of patients. */
  patientCount?: Maybe<Scalars['Int']['output']>;
  /** Reminders in clinic. */
  reminders?: Maybe<Array<CleoExternalReminder>>;
};

/** Clinic for external integration. */
export type CleoExternalClinic = ScalpelNode & {
  __typename?: 'CleoExternalClinic';
  /** Clinic's domain */
  domain: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinic's name */
  name: Scalars['String']['output'];
  /** Clinic's uid */
  uid: Scalars['String']['output'];
};

/** Clinical parameter for external integration. */
export type CleoExternalClinicalParameter = ScalpelNode & {
  __typename?: 'CleoExternalClinicalParameter';
  /** Clinical paramter's clinic */
  clinic: CleoExternalClinic;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical parameter's name */
  name: Scalars['String']['output'];
  /** Clinical parameter's uid */
  uid: Scalars['String']['output'];
  valueType: ExternalClinicalParameterValueType;
};

export type CleoExternalClinicalParametersConnection = {
  __typename?: 'CleoExternalClinicalParametersConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoExternalClinicalParametersEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoExternalClinicalParameters` and its cursor. */
export type CleoExternalClinicalParametersEdge = {
  __typename?: 'CleoExternalClinicalParametersEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoExternalClinicalParameter>;
};

/** Clinician in clinic. */
export type CleoExternalClinician = ScalpelNode & {
  __typename?: 'CleoExternalClinician';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinician's name */
  name: Scalars['String']['output'];
  /** Clinician's uid */
  uid: Scalars['String']['output'];
};

/** Message teamplate set in clinic. */
export type CleoExternalMessageTemplateSet = ScalpelNode & {
  __typename?: 'CleoExternalMessageTemplateSet';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Message template set's name */
  name: Scalars['String']['output'];
  /** Message template set's purpose */
  purpose: Scalars['String']['output'];
  /** Message template set's uid */
  uid: Scalars['String']['output'];
};

/** Patient for external integration. */
export type CleoExternalPatient = ScalpelNode & {
  __typename?: 'CleoExternalPatient';
  /** Patient's clinic */
  clinic: CleoExternalClinic;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Patient's identifier */
  identifier: Scalars['String']['output'];
  /** Patient's metadata */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Patient's name */
  name: Scalars['String']['output'];
  /** Patient's phone */
  phone: Scalars['String']['output'];
  /** Programs that patient is enrolled into. */
  programs?: Maybe<Array<CleoExternalPatientForm>>;
  /** Patient's uid */
  uid: Scalars['String']['output'];
};

/** Patient program for external integration. */
export type CleoExternalPatientForm = ScalpelNode & {
  __typename?: 'CleoExternalPatientForm';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Patient program's metadata */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Patient program's name */
  name: Scalars['String']['output'];
  /** Patient program's uid */
  uid: Scalars['String']['output'];
};

/** Update or insert patient into clinic. */
export type CleoExternalPatientMutation = {
  __typename?: 'CleoExternalPatientMutation';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated patient */
  patient: CleoExternalPatient;
};

export type CleoExternalPatientMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Patient's identifier */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Patient's metadata */
  metadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Patient's name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Patient's phone */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** To sync all patient in clinics with same identifier */
  syncAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient's uid */
  uid: Scalars['String']['input'];
};

export type CleoExternalPatientsConnection = {
  __typename?: 'CleoExternalPatientsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoExternalPatientsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoExternalPatients` and its cursor. */
export type CleoExternalPatientsEdge = {
  __typename?: 'CleoExternalPatientsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoExternalPatient>;
};

/** Reminder in clinic. */
export type CleoExternalReminder = ScalpelNode & {
  __typename?: 'CleoExternalReminder';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Reminder's name */
  name: Scalars['String']['output'];
  /** Reminder's uid */
  uid: Scalars['String']['output'];
};

/** List of clinic that a given JWT can login to. */
export type CleoLoginableClinics = ScalpelNode & {
  __typename?: 'CleoLoginableClinics';
  /** List of clinics that a given JWT can login to. */
  clinics: Array<CleoClinicPublicSettings>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** List of clinic that belongs to Maxicare. */
export type CleoMaxicare = ScalpelNode & {
  __typename?: 'CleoMaxicare';
  /** Clinics belong to this clinic group. */
  clinics?: Maybe<Array<CleoClinicPublicSettings>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Object type for `CleoMessageTemplate`. */
export type CleoMessageTemplate = ScalpelNode & {
  __typename?: 'CleoMessageTemplate';
  /** Communication method this message template is for. */
  communicationMethod: CleoMessageTemplateCommunicationMethodChoices;
  /** Statuses of message template. */
  errors?: Maybe<Array<MessageTemplateError>>;
  /** This is the global ID constructed from the base64 encoding of `CleoMessageTemplate:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Language of this message template. */
  language?: Maybe<CleoMessageTemplateLanguageChoices>;
  /** Template set associated with this message template. */
  messageTemplateSet: CleoMessageTemplateSet;
  /** List of messages. */
  messages?: Maybe<Array<Scalars['GenericScalar']['output']>>;
  /** Message template set UID. */
  templateSetUid: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** List of WhatsApp templates. */
  whatsappTemplates?: Maybe<Array<RatatoskrWhatsAppTemplate>>;
};

/** An enumeration. */
export enum CleoMessageTemplateCommunicationMethodChoices {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

/** An enumeration. */
export enum CleoMessageTemplateCommunicationMethodForMutation {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

export type CleoMessageTemplateConnection = {
  __typename?: 'CleoMessageTemplateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoMessageTemplateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Deliver message template to patients. */
export type CleoMessageTemplateDeliverToPatient = {
  __typename?: 'CleoMessageTemplateDeliverToPatient';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the message template deliveries. */
  results?: Maybe<Array<CleoMessageTemplateDeliveryResult>>;
};

/** Asynchronously deliver message template to patients. */
export type CleoMessageTemplateDeliverToPatientAsync = {
  __typename?: 'CleoMessageTemplateDeliverToPatientAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the message template deliveries. */
  results?: Maybe<Array<CleoMessageTemplateDeliveryResult>>;
};

export type CleoMessageTemplateDeliverToPatientAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic program for the patients. */
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient UIDs to be excluded from receiving message template. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only deliver to enrolled patient-forms when `true`, discharged patient-forms when `false`, all applicable patient-forms by default (`null`). */
  isEnrolledMonitoringForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Message template set UID. */
  messageTemplateSetUid?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring form for the patients. */
  monitoringFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring formset for the patients. */
  monitoringFormsetUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient event UID. */
  patientEventUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Event UIDs to receive message template. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Send messages by applying filter for patients in clinic. This will apply to all patients in clinic regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Patient form UIDs. */
  patientFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient group UIDs. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UID of patient program to be attached to message template. */
  patientProgramFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Program Form UIDs to receive message template. */
  patientProgramFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient program UID. */
  patientProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Program UIDs. */
  patientProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient UIDs. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of user variables. */
  userVariables?: InputMaybe<Array<UserVariableInput>>;
};

export type CleoMessageTemplateDeliverToPatientInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic program for the patients. */
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient UIDs to be excluded from receiving message template. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only deliver to enrolled patient-forms when `true`, discharged patient-forms when `false`, all applicable patient-forms by default (`null`). */
  isEnrolledMonitoringForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Message template set UID. */
  messageTemplateSetUid: Scalars['String']['input'];
  /** Monitoring form for the patients. */
  monitoringFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring formset for the patients. */
  monitoringFormsetUid?: InputMaybe<Scalars['String']['input']>;
  /** UID of patient event to be attached to message template. */
  patientEventUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Event UIDs to receive message template. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Send messages by applying filter for patients in clinic. This will apply to all patients in clinic regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Patient form UIDs to receive message template. */
  patientFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient group UIDs to receive message template. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UID of patient program to be attached to message template. */
  patientProgramFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Program Form UIDs to receive message template. */
  patientProgramFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UID of patient program to be attached to message template. */
  patientProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** Patient Program UIDs to receive message template. */
  patientProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient UIDs to receive message template. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of user variables. */
  userVariables?: InputMaybe<Array<UserVariableInput>>;
};

/** Results of delivering messages to patient (form). */
export type CleoMessageTemplateDeliveryResult = ScalpelNode & {
  __typename?: 'CleoMessageTemplateDeliveryResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** If deliveries were created, this will be `true`. Note that a `true` value does not guarantee that the messages were actually recieved by the patient. */
  isDelivered: Scalars['Boolean']['output'];
  /** Message template that was delivered. If `null`, a message template was't used or it wasn't found. */
  messageTemplate?: Maybe<CleoMessageTemplate>;
  /** Patient the message template was delivered to. */
  patient: CleoPatient;
  /** Patient event the message template was delivered to. */
  patientEvent?: Maybe<CleoPatientEvent>;
  /** Patient form the message template was delivered to. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Patient program the message template was delivered to. */
  patientProgram?: Maybe<CleoPatientProgram>;
  /** Patient program form the message template was delivered to. */
  patientProgramForm?: Maybe<CleoPatientProgramForm>;
};

/** A Relay edge containing a `CleoMessageTemplate` and its cursor. */
export type CleoMessageTemplateEdge = {
  __typename?: 'CleoMessageTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoMessageTemplate>;
};

/** An enumeration. */
export enum CleoMessageTemplateLanguageChoices {
  /** Bengali */
  Bn = 'BN',
  /** English */
  En = 'EN',
  /** Spanish; Castilian */
  Es = 'ES',
  /** Hindi */
  Hi = 'HI',
  /** Indonesian */
  Id = 'ID',
  /** Japanese */
  Ja = 'JA',
  /** Malay */
  Ms = 'MS',
  /** Tamil */
  Ta = 'TA',
  /** Thai */
  Th = 'TH',
  /** Tagalog */
  Tl = 'TL',
  /** Chinese */
  Zh = 'ZH',
}

/** An enumeration. */
export enum CleoMessageTemplateLanguageForMutation {
  /** Bengali */
  Bn = 'BN',
  /** English */
  En = 'EN',
  /** Spanish; Castilian */
  Es = 'ES',
  /** Hindi */
  Hi = 'HI',
  /** Indonesian */
  Id = 'ID',
  /** Japanese */
  Ja = 'JA',
  /** Malay */
  Ms = 'MS',
  /** Tamil */
  Ta = 'TA',
  /** Thai */
  Th = 'TH',
  /** Tagalog */
  Tl = 'TL',
  /** Chinese */
  Zh = 'ZH',
}

/** Object type for `CleoMessageTemplateSet`. */
export type CleoMessageTemplateSet = ScalpelNode & {
  __typename?: 'CleoMessageTemplateSet';
  /** Clinic associated with this message. */
  clinic: CleoClinic;
  /** This is the global ID constructed from the base64 encoding of `CleoMessageTemplateSet:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Descriptive name of this message template set. Should be unique within the clinic. */
  name: Scalars['String']['output'];
  /** Purpose of this message template set. */
  purpose: CleoMessageTemplateSetPurposeChoices;
  /** Whether message templates in this set require access to patient-event. */
  requirePatientEvent: Scalars['Boolean']['output'];
  /** Whether message templates in this set require access to patient-forms. */
  requirePatientForm: Scalars['Boolean']['output'];
  /** Whether message templates in this set require access to patient-programs. */
  requirePatientProgram: Scalars['Boolean']['output'];
  /** Whether message templates in this set require access to patient-program-forms. */
  requirePatientProgramForm: Scalars['Boolean']['output'];
  /** The message templates in this set. */
  templates: Array<CleoMessageTemplate>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** List of variables that a user can specify on the frontend. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-messagetemplatesetuservariables-generated.html" target="_blank">cleo/MessageTemplateSetUserVariables.schema</a>. */
  userVariables?: Maybe<Scalars['GenericScalar']['output']>;
};

export type CleoMessageTemplateSetConnection = {
  __typename?: 'CleoMessageTemplateSetConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoMessageTemplateSetEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoMessageTemplateSet` and its cursor. */
export type CleoMessageTemplateSetEdge = {
  __typename?: 'CleoMessageTemplateSetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoMessageTemplateSet>;
};

/** An enumeration. */
export enum CleoMessageTemplateSetPurposeChoices {
  /** Abnormal Submission */
  AbnormalSubmission = 'ABNORMAL_SUBMISSION',
  /** Alert (Abnormal Submission) */
  AlertAbnormalSubmission = 'ALERT_ABNORMAL_SUBMISSION',
  /** Alert (Missing Submission) */
  AlertMissingSubmission = 'ALERT_MISSING_SUBMISSION',
  /** Discharge */
  Discharge = 'DISCHARGE',
  /** Enrollment */
  Enrollment = 'ENROLLMENT',
  /** Event Canceled (IC) */
  EventCanceledIc = 'EVENT_CANCELED_IC',
  /** Event Canceled (Patient) */
  EventCanceledPatient = 'EVENT_CANCELED_PATIENT',
  /** Event Confirmed (IC) */
  EventConfirmedIc = 'EVENT_CONFIRMED_IC',
  /** Event Confirmed (Patient) */
  EventConfirmedPatient = 'EVENT_CONFIRMED_PATIENT',
  /** Event Created (IC) */
  EventCreatedIc = 'EVENT_CREATED_IC',
  /** Event Created (Patient) */
  EventCreatedPatient = 'EVENT_CREATED_PATIENT',
  /** Event Not Confirmed (IC) */
  EventNotConfirmedIc = 'EVENT_NOT_CONFIRMED_IC',
  /** Event Not Confirmed (Patient) */
  EventNotConfirmedPatient = 'EVENT_NOT_CONFIRMED_PATIENT',
  /** Event Rescheduled (IC) */
  EventRescheduledIc = 'EVENT_RESCHEDULED_IC',
  /** Event Rescheduled (Patient) */
  EventRescheduledPatient = 'EVENT_RESCHEDULED_PATIENT',
  /** Greeting */
  Greeting = 'GREETING',
  /** JarvisV2 Disclaimer */
  Jarvisv2Disclaimer = 'JARVISV2_DISCLAIMER',
  /** New submission comment */
  NewSubmissionComment = 'NEW_SUBMISSION_COMMENT',
  /** Normal Submission */
  NormalSubmission = 'NORMAL_SUBMISSION',
  /** Patient event list */
  PatientEventList = 'PATIENT_EVENT_LIST',
  /** Patient event null */
  PatientEventNull = 'PATIENT_EVENT_NULL',
  /** Patient not enrolled */
  PatientNotEnrolled = 'PATIENT_NOT_ENROLLED',
  /** Payment Received */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** Payment Refunded */
  PaymentRefunded = 'PAYMENT_REFUNDED',
  /** Payment Requested */
  PaymentRequested = 'PAYMENT_REQUESTED',
  /** Payment Request Canceled */
  PaymentRequestCanceled = 'PAYMENT_REQUEST_CANCELED',
  /** Reminder */
  Reminder = 'REMINDER',
  /** Scheduling Reminder */
  SchedulingReminder = 'SCHEDULING_REMINDER',
  /** Sorry */
  Sorry = 'SORRY',
  /** Update metadata entry */
  UpdateMetadataEntry = 'UPDATE_METADATA_ENTRY',
  /** Update Phone */
  UpdatePhone = 'UPDATE_PHONE',
  /** User Defined */
  UserDefined = 'USER_DEFINED',
}

/** An enumeration. */
export enum CleoMessageTemplateSetPurposeForMutation {
  /** Abnormal Submission */
  AbnormalSubmission = 'ABNORMAL_SUBMISSION',
  /** Alert (Abnormal Submission) */
  AlertAbnormalSubmission = 'ALERT_ABNORMAL_SUBMISSION',
  /** Alert (Missing Submission) */
  AlertMissingSubmission = 'ALERT_MISSING_SUBMISSION',
  /** Discharge */
  Discharge = 'DISCHARGE',
  /** Enrollment */
  Enrollment = 'ENROLLMENT',
  /** Event Canceled (IC) */
  EventCanceledIc = 'EVENT_CANCELED_IC',
  /** Event Canceled (Patient) */
  EventCanceledPatient = 'EVENT_CANCELED_PATIENT',
  /** Event Confirmed (IC) */
  EventConfirmedIc = 'EVENT_CONFIRMED_IC',
  /** Event Confirmed (Patient) */
  EventConfirmedPatient = 'EVENT_CONFIRMED_PATIENT',
  /** Event Created (IC) */
  EventCreatedIc = 'EVENT_CREATED_IC',
  /** Event Created (Patient) */
  EventCreatedPatient = 'EVENT_CREATED_PATIENT',
  /** Event Not Confirmed (IC) */
  EventNotConfirmedIc = 'EVENT_NOT_CONFIRMED_IC',
  /** Event Not Confirmed (Patient) */
  EventNotConfirmedPatient = 'EVENT_NOT_CONFIRMED_PATIENT',
  /** Event Rescheduled (IC) */
  EventRescheduledIc = 'EVENT_RESCHEDULED_IC',
  /** Event Rescheduled (Patient) */
  EventRescheduledPatient = 'EVENT_RESCHEDULED_PATIENT',
  /** Greeting */
  Greeting = 'GREETING',
  /** JarvisV2 Disclaimer */
  Jarvisv2Disclaimer = 'JARVISV2_DISCLAIMER',
  /** New submission comment */
  NewSubmissionComment = 'NEW_SUBMISSION_COMMENT',
  /** Normal Submission */
  NormalSubmission = 'NORMAL_SUBMISSION',
  /** Patient event list */
  PatientEventList = 'PATIENT_EVENT_LIST',
  /** Patient event null */
  PatientEventNull = 'PATIENT_EVENT_NULL',
  /** Patient not enrolled */
  PatientNotEnrolled = 'PATIENT_NOT_ENROLLED',
  /** Payment Received */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** Payment Refunded */
  PaymentRefunded = 'PAYMENT_REFUNDED',
  /** Payment Requested */
  PaymentRequested = 'PAYMENT_REQUESTED',
  /** Payment Request Canceled */
  PaymentRequestCanceled = 'PAYMENT_REQUEST_CANCELED',
  /** Reminder */
  Reminder = 'REMINDER',
  /** Scheduling Reminder */
  SchedulingReminder = 'SCHEDULING_REMINDER',
  /** Sorry */
  Sorry = 'SORRY',
  /** Update metadata entry */
  UpdateMetadataEntry = 'UPDATE_METADATA_ENTRY',
  /** Update Phone */
  UpdatePhone = 'UPDATE_PHONE',
  /** User Defined */
  UserDefined = 'USER_DEFINED',
}

/** This is a related model input type for `CleoMessageTemplateSet`. */
export type CleoMessageTemplateSetRelatedModelInput = {
  /** Global ID for referencing `CleoMessageTemplateSet`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoMessageTemplateSet`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoMonitoringForm`. */
export type CleoMonitoringForm = ScalpelNode & {
  __typename?: 'CleoMonitoringForm';
  /** The clinical parameters attached to this form. (DEPRECATED) */
  clinicalParameters: Array<CleoClinicalParameter>;
  /** The effective name of this monitoring form. Will default to name of monitoring formset. */
  effectiveName: Scalars['String']['output'];
  /** The effective settings of this monitoring form. Will merge with settings of monitoring formset. */
  effectiveSettings: Scalars['GenericScalar']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoMonitoringForm:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is enrollment form? */
  isEnrollmentForm: Scalars['Boolean']['output'];
  /** Monitoring form language. Defaults to clinic language if not set. */
  language: Scalars['String']['output'];
  /** Monitoring formset it is part of. */
  monitoringFormset: CleoMonitoringFormset;
  /** Monitoring form name. Defaults to the monitoring formset name. */
  name: Scalars['String']['output'];
  /** Number of patient form with submission */
  patientFormCount: Scalars['Int']['output'];
  /** Number of patient form with submission */
  patientFormWithSubmissionCount: Scalars['Int']['output'];
  /** Number of patient form without submission */
  patientFormWithoutSubmissionCount: Scalars['Int']['output'];
  /** Monitoring form instance settings, e.g., `language`, etc. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-monitoringformsettings-generated.html" target="_blank">cleo/MonitoringFormSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** The URL to this form. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Object type for `CleoMonitoringFormset`. */
export type CleoMonitoringFormset = ScalpelNode & {
  __typename?: 'CleoMonitoringFormset';
  /** The alert rule attached to this form. (Deprecated) */
  alertRule?: Maybe<CleoAlertRule>;
  /** The alert rules attached to this form. */
  alertRules: Array<CleoAlertRule>;
  /** Clinic that owns this formset. */
  clinic: CleoClinic;
  /** The clinical parameters attached to this form. */
  clinicalParameters: Array<CleoClinicalParameter>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoMonitoringFormset:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this is an enrollment form. */
  isEnrollmentForm: Scalars['Boolean']['output'];
  /** The monitoring forms attached to this form. */
  monitoringForms: Array<CleoMonitoringForm>;
  /** Monitoring formset name. */
  name: Scalars['String']['output'];
  /** MonitoringFormset this mapping is for. */
  programMonitoringFormsets: CleoClinicProgramMonitoringFormsetConnection;
  /** The reminder attached to this form. (Deprecated) */
  reminder?: Maybe<CleoReminder>;
  /** The reminders attached to this form. */
  reminders: Array<CleoReminder>;
  /** Monitoring form settings. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-monitoringformsettings-generated.html" target="_blank">cleo/MonitoringFormSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Object type for `CleoMonitoringFormset`. */
export type CleoMonitoringFormsetProgramMonitoringFormsetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CleoMonitoringFormsetConnection = {
  __typename?: 'CleoMonitoringFormsetConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoMonitoringFormsetEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoMonitoringFormset` and its cursor. */
export type CleoMonitoringFormsetEdge = {
  __typename?: 'CleoMonitoringFormsetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoMonitoringFormset>;
};

/** This is a related model input type for `CleoMonitoringFormset`. */
export type CleoMonitoringFormsetRelatedModelInput = {
  /** Global ID for referencing `CleoMonitoringFormset`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoMonitoringFormset`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Various numerical statistics for a given patient's analytics. */
export type CleoParameterStatistic = ScalpelNode & {
  __typename?: 'CleoParameterStatistic';
  /** Average of aggregated values. Returns `null` for non-numerical values. */
  average?: Maybe<Scalars['Float']['output']>;
  /** Clinical parameter. */
  clinicalParameter: CleoClinicalParameter;
  /** Number of aggregated values. Returns `null` for non-numerical values. */
  count: Scalars['Int']['output'];
  /** List of `extractedForDisplay` values. */
  extractedForDisplays: Array<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Maximum of aggregated values. Returns `null` for non-numerical values. */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum of aggregated values. Returns `null` for non-numerical values. */
  min?: Maybe<Scalars['Float']['output']>;
  /** List of actual numerical values. Returns `null` for non-numerical values. */
  numbers?: Maybe<Array<Scalars['Float']['output']>>;
  /** List of actual string values. Returns `null` for non-string values. */
  strings?: Maybe<Array<Scalars['String']['output']>>;
  /** List of submission datetimes. */
  submissionTimes: Array<Scalars['DateTime']['output']>;
  /** List of actual value objects. */
  values: Array<Scalars['GenericScalar']['output']>;
  /** Parameter specific submission value variables for substitution in templates. This will be an object with `name => [extractedForDisplay]!`. */
  variables: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoPatient`. */
export type CleoPatient = ScalpelNode & {
  __typename?: 'CleoPatient';
  /** The patient age based on date of birth. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Clinicians that receive alerts for this patient. */
  alertees: Array<CleoClinician>;
  /** Caregivers for this patient. */
  caregivers: Array<CleoClinician>;
  /** Clinic which this profile belongs to. */
  clinic: CleoClinic;
  /** Method of contacting the clinician/patient. */
  communicationMethod: CleoPatientCommunicationMethodChoices;
  /** The communication methods supported by this clinic. */
  communicationMethods: Array<CleoPatientCommunicationMethod>;
  /** Date/Time this object was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Date of birth of the patient. Can be left empty. If time is not available, we assume it is 12:00 (noon) local time of the patient. This field is always stored in UTC. */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Monitoring forms the patient is discharged from. */
  dischargedMonitoringForms: Array<CleoMonitoringForm>;
  /** Effective reminder with kronos task details. */
  effectiveReminderTasks: Array<CleoReminderTask>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: Maybe<Scalars['String']['output']>;
  /** Monitoring forms the patient is enrolled in. */
  enrolledMonitoringForms: Array<CleoMonitoringForm>;
  /** Gender of the patient. Can be left empty. */
  gender?: Maybe<CleoPatientGenderChoices>;
  /** Clinicans that are in-charge of this patient. */
  ics: Array<CleoClinician>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatient:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the user within the clinic. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  identifier: Scalars['String']['output'];
  /** Invitation QR code for patient to link non-phone-based provider's device. */
  invitationQrcode?: Maybe<Scalars['String']['output']>;
  /** Invitation URL for patient to link non-phone-based provider's device. */
  invitationUrl?: Maybe<Scalars['String']['output']>;
  /** Is the patient activated? */
  isActivated: Scalars['Boolean']['output'];
  /** Is device belongs to patient's communication method created? */
  isDeviceCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Is device belongs to patient's communication method subscribed? */
  isDeviceSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** Did patient follow us for non-phone based provider. */
  isFollower?: Maybe<Scalars['Boolean']['output']>;
  /** The patient language based on enrollment metadata. Defaults to clinic language if not specified. */
  language: Scalars['String']['output'];
  /** Date of birth of patient in local time (based on clinic TZ). */
  localDateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Metadata entries for this patient. */
  metadataEntries: Array<CleoPatientMetadataEntry>;
  /** Full name of the user. */
  name: Scalars['String']['output'];
  /** The corresponding patient. */
  patientEvents: CleoPatientEventConnection;
  /** Patient enrolled in this form. */
  patientForms: CleoPatientFormConnection;
  /** Patient programs for this patient. */
  patientPrograms: Array<CleoPatientProgram>;
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone: Scalars['String']['output'];
  /** Ratatoskr devices for this patient. */
  ratatoskrDevices: Array<CleoPatientRatatoskrDevice>;
  /** Stitch invitation URL for patient to link non-phone-based provider's device. */
  stitchInvitationUrl?: Maybe<Scalars['String']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoPatient`. */
export type CleoPatientPatientEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendar_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EventType_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_PendingOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientShowed?: InputMaybe<Scalars['Boolean']['input']>;
  patientShowedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Object type for `CleoPatient`. */
export type CleoPatientPatientFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  monitoringForm_MonitoringFormset_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  monitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Return aggregated submission values for a patient/partient-form. */
export type CleoPatientChart = ScalpelNode & {
  __typename?: 'CleoPatientChart';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Statistics for each parameter. */
  statistics?: Maybe<Array<CleoParameterStatistic>>;
};

/** GQL type representation with human readable label for `CommunicationMethod` enum. */
export type CleoPatientCommunicationMethod = ScalpelNode & {
  __typename?: 'CleoPatientCommunicationMethod';
  /** This is the fallback order of the communication method. */
  fallbackOrder?: Maybe<Scalars['Int']['output']>;
  /** This is the GQL expected value (usually uppercase). */
  gql: CommunicationMethod;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Invitation QR code for patient to link non-phone-based provider's device. */
  invitationQrcode?: Maybe<Scalars['String']['output']>;
  /** Invitation URL for patient to link non-phone-based provider's device. */
  invitationUrl?: Maybe<Scalars['String']['output']>;
  /** Is device belongs to patient's communication method created? */
  isDeviceCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Is device belongs to patient's communication method subscribed? */
  isDeviceSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** Did patient follow us for non-phone based provider. */
  isFollower?: Maybe<Scalars['Boolean']['output']>;
  /** This is the human readable label (usually title case). */
  label: Scalars['String']['output'];
  /** Ratatoskr device in channel for this patient. */
  ratatoskrDevice?: Maybe<CleoPatientRatatoskrDevice>;
  /** This is the value stored in the database (usually lowercase). */
  value: Scalars['String']['output'];
};

/** An enumeration. */
export enum CleoPatientCommunicationMethodChoices {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

/** An enumeration. */
export enum CleoPatientCommunicationMethodForMutation {
  /** Any */
  Any = 'ANY',
  /** Bot MD */
  Botmd = 'BOTMD',
  /** Email */
  Email = 'EMAIL',
  /** Line */
  Line = 'LINE',
  /** Messenger */
  Messenger = 'MESSENGER',
  /** SMS */
  Sms = 'SMS',
  /** Telegram */
  Telegram = 'TELEGRAM',
  /** Viber */
  Viber = 'VIBER',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

export type CleoPatientConnection = {
  __typename?: 'CleoPatientConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientEdge>>;
  /** A total count of patients that has an active patient form. */
  enrolledPatientCount?: Maybe<Scalars['Int']['output']>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Generate delayed Stitch link for email of import template as a password protected Zip attachment. */
  importTemplateByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of import template. */
  importTemplateByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  importTemplateFormats?: Maybe<Array<CleoExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoPatientConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoPatientConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoPatientConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CleoPatientConnectionImportTemplateByEmailArgs = {
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  importTemplateFormat: ExportOutputFormat;
};

export type CleoPatientConnectionImportTemplateByUrlArgs = {
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  importTemplateFormat: ExportOutputFormat;
};

/** Total count of patients. */
export type CleoPatientCount = ScalpelNode & {
  __typename?: 'CleoPatientCount';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Total count of patients. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoPatient` and its cursor. */
export type CleoPatientEdge = {
  __typename?: 'CleoPatientEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatient>;
};

/** Object type for `CleoPatientEvent`. */
export type CleoPatientEvent = ScalpelNode & {
  __typename?: 'CleoPatientEvent';
  /** The corresponding clinic calendar. */
  calendar: CleoClinicCalendar;
  /** Event Cancel URL */
  cancelUrl?: Maybe<Scalars['String']['output']>;
  /** Date/Time this event marks as confirmed. */
  confirmedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time this patient event was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Effective reminder with kronos task details. */
  effectiveReminderTasks: Array<CleoReminderTask>;
  /** End date/time of this event. */
  endOn?: Maybe<Scalars['DateTime']['output']>;
  /** The corresponding Caesar event. */
  event: CaesarEvent;
  /** Logs of this PatientEvent. */
  eventLogs: Array<CleoPatientEventLog>;
  /** Event URL */
  eventUrl?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientEvent:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the event has been canceled. */
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the event has been confirmed. */
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the event has been confirmed. */
  isPatientShowed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the event is pending for confirmation. */
  isPending?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the event is slated to start in the future. */
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  /** Metadata that is associated with the patient-event. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-patienteventmetadata-generated.html" target="_blank">cleo/PatientEventMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Metadata entries for this patient form. */
  metadataEntries: Array<CleoPatientEventMetadataEntry>;
  /** The corresponding patient. */
  patient: CleoPatient;
  /** Date/Time this event marks as showed. */
  patientShowedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Date/time of this event in pending state. */
  pendingOn?: Maybe<Scalars['DateTime']['output']>;
  /** Event Reschedule URL */
  rescheduleUrl?: Maybe<Scalars['String']['output']>;
  /** Start date/time of this event. */
  startOn?: Maybe<Scalars['DateTime']['output']>;
  /** Status of this event */
  status?: Maybe<Scalars['String']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Patient-event specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates. */
  variablesAll: Scalars['GenericScalar']['output'];
};

export type CleoPatientEventConnection = {
  __typename?: 'CleoPatientEventConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientEventEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Total count of patient-events. */
export type CleoPatientEventCount = ScalpelNode & {
  __typename?: 'CleoPatientEventCount';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Total count of patient-events. */
  totalCount: Scalars['Int']['output'];
};

/** Cancellation of patient events. */
export type CleoPatientEventDelete = {
  __typename?: 'CleoPatientEventDelete';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of cancelled patient events */
  results?: Maybe<Array<CleoPatientEvent>>;
};

/** Asynchronously cancel patient events. */
export type CleoPatientEventDeleteAsync = {
  __typename?: 'CleoPatientEventDeleteAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of cancelled patient events */
  results?: Maybe<Array<CleoPatientEvent>>;
};

export type CleoPatientEventDeleteAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Bulk update by applying filter for patient event in clinic. This will apply to all patient event in clinic regardless of pagination. */
  patientEventFilter?: InputMaybe<PatientEventFilter>;
  /** Patient Event UIDs. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CleoPatientEventDeleteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Bulk update by applying filter for patient event in clinic. This will apply to all patient event in clinic regardless of pagination. */
  patientEventFilter?: InputMaybe<PatientEventFilter>;
  /** Patient Event UIDs. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A Relay edge containing a `CleoPatientEvent` and its cursor. */
export type CleoPatientEventEdge = {
  __typename?: 'CleoPatientEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientEvent>;
};

/** Log for patient event */
export type CleoPatientEventLog = ScalpelNode & {
  __typename?: 'CleoPatientEventLog';
  /** Clinician who perform the action */
  clinician?: Maybe<CleoClinician>;
  /** Datetime of the log. */
  datetime: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinician who perform the action */
  patient?: Maybe<CleoPatient>;
  /** Event status from provider */
  status: PatientEventStatus;
};

/** Object type for `CleoPatientEventMetadataEntry`. */
export type CleoPatientEventMetadataEntry = ScalpelNode & {
  __typename?: 'CleoPatientEventMetadataEntry';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientEventMetadataEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** This is a related model input type for `CleoPatientEvent`. */
export type CleoPatientEventRelatedModelInput = {
  /** Global ID for referencing `CleoPatientEvent`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoPatientEvent`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Update of patient events. */
export type CleoPatientEventUpdate = {
  __typename?: 'CleoPatientEventUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of updated patient events */
  results?: Maybe<Array<CleoPatientEvent>>;
};

/** Asynchronously update patient events. */
export type CleoPatientEventUpdateAsync = {
  __typename?: 'CleoPatientEventUpdateAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of cancelled patient events */
  results?: Maybe<Array<CleoPatientEvent>>;
};

export type CleoPatientEventUpdateAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Event confirmation. */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bulk update by applying filter for patient event in clinic. This will apply to all patient event in clinic regardless of pagination. */
  patientEventFilter?: InputMaybe<PatientEventFilter>;
  /** Patient Event UIDs. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Did patient show for the event. */
  patientShowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CleoPatientEventUpdateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Event confirmation. */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bulk update by applying filter for patient event in clinic. This will apply to all patient event in clinic regardless of pagination. */
  patientEventFilter?: InputMaybe<PatientEventFilter>;
  /** Patient Event UIDs. */
  patientEventUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Did patient show for the event. */
  patientShowed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Object type for `CleoPatientForm`. */
export type CleoPatientForm = ScalpelNode & {
  __typename?: 'CleoPatientForm';
  /** The alert rules that are attached to this patient-form. */
  alertRules: Array<CleoAlertRule>;
  /** Clinicians that receive alerts for this patient form. */
  alertees: Array<CleoClinician>;
  /** Caregivers for this patient form. */
  caregivers: Array<CleoClinician>;
  /** Date of enrollment of this patient. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Do not alert this patient regardless. */
  doNotAlert: Scalars['Boolean']['output'];
  /** Do not remind this patient regardless. */
  doNotRemind: Scalars['Boolean']['output'];
  /** The alert rules that are in effect for this patient. Can be clinic level or patient-form level. */
  effectiveAlertRules: Array<CleoAlertRule>;
  /** Effective reminder with kronos task details. */
  effectiveReminderTasks: Array<CleoReminderTask>;
  /** The reminders that are in effect for this patient. Can be clinic level or patient-form level. */
  effectiveReminders: Array<CleoReminder>;
  /** Clinicans that are in-charge of this patient form. */
  ics: Array<CleoClinician>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientForm:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the patient-form activated? */
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-form deactivated? */
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-form or patient discharged (i.e., deactivated)? */
  isDischarged?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-form and patient enrolled (i.e., activated)? */
  isEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** Is enrollment form? */
  isEnrollmentForm: Scalars['Boolean']['output'];
  /** The patient language based on enrollment metadata. Defaults to clinic language if not specified. */
  language: Scalars['String']['output'];
  /** The last submission for this patient-form. */
  lastSubmission?: Maybe<CleoSubmission>;
  /** DateTime of patient form's last submission. */
  lastSubmittedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Metadata entries for this patient form. */
  metadataEntries: Array<CleoPatientFormMetadataEntry>;
  /** The monitoring form associated with the patient. */
  monitoringForm: CleoMonitoringForm;
  /** Patient enrolled in this form. */
  patient: CleoPatient;
  /** The reminders that are attached to this patient-form. */
  reminders: Array<CleoReminder>;
  /** List of taggable entities for this patient-form. Only the first 20 results will be returned. Entities will be similar to the schema used in `cleo/SubmissionCommentContent.schema` and will include a `name` field for convenience). */
  taggableEntities: Array<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Patient-form specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoPatientForm`. */
export type CleoPatientFormTaggableEntitiesArgs = {
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type CleoPatientFormConnection = {
  __typename?: 'CleoPatientFormConnection';
  /** A total count of patients that has active patient_form. */
  activePatientCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientFormEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of patients in patient_forms query. */
  patientCount?: Maybe<Scalars['Int']['output']>;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoPatientFormConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoPatientFormConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoPatientFormConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Total count of patient forms. */
export type CleoPatientFormCount = ScalpelNode & {
  __typename?: 'CleoPatientFormCount';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Total count of patient forms. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoPatientForm` and its cursor. */
export type CleoPatientFormEdge = {
  __typename?: 'CleoPatientFormEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientForm>;
};

/** Enroll or discharge a patient-form. This operation will update the patient-form `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
export type CleoPatientFormEnrollDischarge = {
  __typename?: 'CleoPatientFormEnrollDischarge';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the enroll/discharge operation. */
  results?: Maybe<Array<CleoPatientFormEnrollDischargeResult>>;
};

/** Asynchronously enroll or discharge a patient-form. This operation will update the patient-form `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
export type CleoPatientFormEnrollDischargeAsync = {
  __typename?: 'CleoPatientFormEnrollDischargeAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the enroll/discharge operation. */
  results?: Maybe<Array<CleoPatientFormEnrollDischargeResult>>;
};

export type CleoPatientFormEnrollDischargeAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinician alertees UIDs to attach to patient-form for `ENROLL` operation. */
  clinicianAlertees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician ICs UIDs to attach to patient-form for `ENROLL` operation. */
  clinicianIcs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When a patient is discharged from all the forms (i.e., `monitoring_form_uid` and `monitoring_formset_uid` are `null`), we deactivate the patient as well. Defaults to `false`. */
  deactivatePatient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monitoring form UID. */
  monitoringFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring formset UID. This should only be used with `DISCHARGE` operations. */
  monitoringFormsetUid?: InputMaybe<Scalars['String']['input']>;
  /** The enrollment/discharge operation. */
  operation?: InputMaybe<PatientFormOperation>;
  /** Enroll/Discharge by applying filter for patients in clinic. This will apply all patients regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Patient-form UID. */
  patientFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient group UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patients in the group will be discharged from all their enrolled forms. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patient will be discharged from all their enrolled forms. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reminder UIDs to attach to patient-form for `ENROLL` operation. */
  reminders?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CleoPatientFormEnrollDischargeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinician alertees UIDs to attach to patient-form for `ENROLL` operation. */
  clinicianAlertees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician ICs UIDs to attach to patient-form for `ENROLL` operation. */
  clinicianIcs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When a patient is discharged from all the forms (i.e., `monitoring_form_uid` and `monitoring_formset_uid` are `null`), we deactivate the patient as well. Defaults to `false`. */
  deactivatePatient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monitoring form UID. */
  monitoringFormUid?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring formset UID. This should only be used with `DISCHARGE` operations. */
  monitoringFormsetUid?: InputMaybe<Scalars['String']['input']>;
  /** The enrollment/discharge operation. */
  operation: PatientFormOperation;
  /** Enroll/Discharge by applying filter for patients in clinic. This will apply all patients regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Patient-form UID. */
  patientFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient group UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patients in the group will be discharged from all their enrolled forms. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patient will be discharged from all their enrolled forms. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reminder UIDs to attach to patient-form for `ENROLL` operation. */
  reminders?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of the patient form enrollment/discharge. */
export type CleoPatientFormEnrollDischargeResult = ScalpelNode & {
  __typename?: 'CleoPatientFormEnrollDischargeResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the patient-form was previously enrolled. */
  isPreviouslyEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** Patient-form which was enrolled or discharged. */
  patientForm: CleoPatientForm;
};

/** Object type for `CleoPatientFormMetadataEntry`. */
export type CleoPatientFormMetadataEntry = ScalpelNode & {
  __typename?: 'CleoPatientFormMetadataEntry';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientFormMetadataEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** This is a related model input type for `CleoPatientForm`. */
export type CleoPatientFormRelatedModelInput = {
  /** Global ID for referencing `CleoPatientForm`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoPatientForm`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CleoPatientGenderChoices {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M',
}

/** An enumeration. */
export enum CleoPatientGenderForMutation {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M',
}

/** Object type for `CleoPatientGroup`. */
export type CleoPatientGroup = ScalpelNode & {
  __typename?: 'CleoPatientGroup';
  /** Clinician who created this patient group. */
  createdBy?: Maybe<CleoClinician>;
  /** Date/Time this entry was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Description of the group. */
  description: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoPatientGroup:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** This is an all patients group. */
  isAllPatients: Scalars['Boolean']['output'];
  /** Whether this patient group is a fixed list of patients. */
  isFixed: Scalars['Boolean']['output'];
  /** This is a system group which cannot be delete by user. */
  isSystemGroup: Scalars['Boolean']['output'];
  /** Monitoring formsets associated with this patient group. */
  monitoringFormsets: Array<CleoMonitoringFormset>;
  /** Name of the group. */
  name: Scalars['String']['output'];
  /** A total count of patients that belong to this group. */
  patientCount: Scalars['Int']['output'];
  /** Patients that are part of this patient group. */
  patients: CleoPatientConnection;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Patient-group specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates. */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoPatientGroup`. */
export type CleoPatientGroupPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communicationMethod_In?: InputMaybe<Array<InputMaybe<CleoPatientCommunicationMethodChoices>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender_In?: InputMaybe<Array<InputMaybe<CleoPatientGenderChoices>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientForms_ClinicianRelations_Clinician_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientForms_MonitoringForm_MonitoringFormset_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  patientForms_MonitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientPrograms_PatientProgramForms_ClinicianRelations_Clinician_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  phone?: InputMaybe<Scalars['String']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CleoPatientGroupConnection = {
  __typename?: 'CleoPatientGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoPatientGroup` and its cursor. */
export type CleoPatientGroupEdge = {
  __typename?: 'CleoPatientGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientGroup>;
};

/** Synchronous import of patient forms via CSV or Excel. Do not use this when there are more than 500 entries. (DEPRECATED) */
export type CleoPatientImport = {
  __typename?: 'CleoPatientImport';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of enrollment (when preview is `false`). */
  importResults?: Maybe<Array<CleoPatientImportActualResult>>;
  /** Results of preview. */
  previewResults?: Maybe<CleoPatientImportPreviewResult>;
};

/** Individual result entry of patient import. */
export type CleoPatientImportActualResult = ScalpelNode & {
  __typename?: 'CleoPatientImportActualResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this a new patient (excluding deactivated patients)? */
  isNewPatient: Scalars['Boolean']['output'];
  /** Is this a new patient-form (excluding discharged patient-form)? */
  isNewPatientForm?: Maybe<Scalars['Boolean']['output']>;
  /** Is this a new patient-program (excluding discharged patient-program)? */
  isNewPatientProgram?: Maybe<Scalars['Boolean']['output']>;
  /** Imported patient. */
  patient: CleoPatient;
  /** Enrolled patient-form. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Enrolled patient-form. */
  patientProgram?: Maybe<CleoPatientProgram>;
  /** Corresponding row number in the CSV file. */
  rowNo: Scalars['Int']['output'];
};

/** Asynchronously import of patient forms via CSV or Excel. */
export type CleoPatientImportAsync = {
  __typename?: 'CleoPatientImportAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of enrollment (when preview is `false`). This is only available when the AsyncJob status is `SUCCESS`. */
  importResults?: Maybe<Array<CleoPatientImportActualResult>>;
  /** Results of preview. This is only available when the AsyncJob status is `SUCCESS`. */
  previewResults?: Maybe<CleoPatientImportPreviewResult>;
};

export type CleoPatientImportAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Contents of CSV for import. */
  csvContent?: InputMaybe<Scalars['String']['input']>;
  /** Used as defaults when values are not present in the CSV. */
  defaults?: InputMaybe<PatientImportAdditionalInput>;
  /** Whether to trigger the delivery of enrollment messsage. Can be `null` (default), `true` (always send), or `false` (never ever send). Default: Enrollment messages are only sent to new or re-activated patient forms. */
  forceDeliverMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Used as overrides to complement values in the CSV. */
  overrides?: InputMaybe<PatientImportAdditionalInput>;
  /** Whether to run through the CSV file in preview mode. Defaults to `true`. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Upload ID returned by `stitchCreateUploadUrl`. The file should have been uploaded when this mutation is called. */
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type CleoPatientImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Contents of CSV for import. */
  csvContent?: InputMaybe<Scalars['String']['input']>;
  /** Used as defaults when values are not present in the CSV. */
  defaults?: InputMaybe<PatientImportAdditionalInput>;
  /** Whether to trigger the delivery of enrollment messsage. Can be `null` (default), `true` (always send), or `false` (never ever send). Default: Enrollment messages are only sent to new or re-activated patient forms. */
  forceDeliverMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Used as overrides to complement values in the CSV. */
  overrides?: InputMaybe<PatientImportAdditionalInput>;
  /** Whether to run through the CSV file in preview mode. Defaults to `true`. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Upload ID returned by `stitchCreateUploadUrl`. The file should have been uploaded when this mutation is called. */
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

/** Results of import in preview mode. */
export type CleoPatientImportPreviewResult = ScalpelNode & {
  __typename?: 'CleoPatientImportPreviewResult';
  /** Duplicate entries. */
  duplicateEntries: Array<CleoPatientImportPreviewResultEntry>;
  /** Entries with errors during enrollment. */
  errorEntries: Array<CleoPatientImportPreviewResultEntry>;
  /** Already enrolled entries. */
  existingEntries: Array<CleoPatientImportPreviewResultEntry>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** New enrollment entries. */
  newEntries: Array<CleoPatientImportPreviewResultEntry>;
};

/** Individual preview result entry. */
export type CleoPatientImportPreviewResultEntry = ScalpelNode & {
  __typename?: 'CleoPatientImportPreviewResultEntry';
  /** Clinic programs being enrolled. */
  clinicPrograms?: Maybe<Array<CleoClinicProgram>>;
  /** Clinician alertees attached to patient-form. */
  clinicianAlertees: Array<CleoClinician>;
  /** Clinicians ICs attached to patient-form. */
  clinicianIcs: Array<CleoClinician>;
  /** Method of contacting the clinician/patient. */
  communicationMethod: CleoPatientCommunicationMethodChoices;
  /** Patient date of birth. */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Patient email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The error message if there was an error processing this row. */
  errors: Array<Scalars['String']['output']>;
  /** If patient already exists. */
  existingPatient?: Maybe<CleoPatient>;
  /** Gender of the patient. Can be left empty. */
  gender?: Maybe<CleoPatientGenderChoices>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Patient identifier. */
  identifier: Scalars['String']['output'];
  /** If patient is activated. */
  isPatientActivated?: Maybe<Scalars['Boolean']['output']>;
  /** If all patient form is activated */
  isPatientFormActivated?: Maybe<Scalars['Boolean']['output']>;
  /** If all patient program is activated */
  isPatientProgramActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Monitoring forms being enrolled. */
  monitoringForms: Array<CleoMonitoringForm>;
  /** Patient name. */
  name: Scalars['String']['output'];
  /** Patient phone. */
  phone: Scalars['String']['output'];
  /** Corresponding row number in the CSV file. */
  rowNo: Scalars['Int']['output'];
};

/** Object type for `CleoPatientMetadataEntry`. */
export type CleoPatientMetadataEntry = ScalpelNode & {
  __typename?: 'CleoPatientMetadataEntry';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientMetadataEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoPatientPayment`. */
export type CleoPatientPayment = ScalpelNode & {
  __typename?: 'CleoPatientPayment';
  /** The clinic product the patient is paying for. */
  clinicProduct?: Maybe<CleoClinicProduct>;
  /** The clinician who created this payment. */
  createdBy: CleoClinician;
  /** Date/Time this entry was created. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoPatientPayment:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Metadata that is associated with the patient-payment. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-patientpaymentmetadata-generated.html" target="_blank">cleo/PatientPaymentMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** The corresponding patient. */
  patient: CleoPatient;
  /** The corresponding Moneta payment. */
  payment: MonetaPayment;
  /** Purpose of this payment. */
  purpose: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Patient-payment specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates. */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Cancel a patient payment. */
export type CleoPatientPaymentCancelRequest = {
  __typename?: 'CleoPatientPaymentCancelRequest';
  /** The canceled patient payment instance. */
  cleoPatientPayment: CleoPatientPayment;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CleoPatientPaymentCancelRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The patient payment UID to cancel. */
  patientPaymentUid: Scalars['String']['input'];
};

export type CleoPatientPaymentConnection = {
  __typename?: 'CleoPatientPaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientPaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Create a patient payment. */
export type CleoPatientPaymentCreate = {
  __typename?: 'CleoPatientPaymentCreate';
  /** The created patient payment instance. */
  cleoPatientPayment: CleoPatientPayment;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The URL to redirect the user to for the payment request. */
  paymentRequestUrl?: Maybe<Scalars['String']['output']>;
};

export type CleoPatientPaymentCreateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The clinic Moneta Provider-Application UID to use for this payment. */
  clinicMonetaProviderApplicationUid: Scalars['String']['input'];
  /** The clinic product UID if paying for a product. */
  clinicProductUid?: InputMaybe<Scalars['String']['input']>;
  /** The patient UID. */
  patientUid: Scalars['String']['input'];
  /** For custom payment requests. */
  paymentAmount?: InputMaybe<PaymentAmountInput>;
  paymentMethod: PaymentMethod;
  /** The purpose of this payment. */
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay edge containing a `CleoPatientPayment` and its cursor. */
export type CleoPatientPaymentEdge = {
  __typename?: 'CleoPatientPaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientPayment>;
};

/** Refund a patient payment. */
export type CleoPatientPaymentRefund = {
  __typename?: 'CleoPatientPaymentRefund';
  /** The canceled patient payment instance. */
  cleoPatientPayment: CleoPatientPayment;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CleoPatientPaymentRefundInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The patient payment UID to refund. */
  patientPaymentUid: Scalars['String']['input'];
};

/** Object type for `CleoPatientProgram`. */
export type CleoPatientProgram = ScalpelNode & {
  __typename?: 'CleoPatientProgram';
  /** The clinic program own by patient. */
  clinicProgram: CleoClinicProgram;
  /** Date of enrollment of this patient. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Do not remind this patient regardless. */
  doNotRemind: Scalars['Boolean']['output'];
  /** Effective reminder with kronos task details. */
  effectiveReminderTasks: Array<CleoReminderTask>;
  /** The reminders that are in effect for this patient. Can be clinic level, program-level or patient-program level. */
  effectiveReminders: Array<CleoReminder>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientProgram:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the patient-program activated? */
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program deactivated? */
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program or patient discharged (i.e., deactivated)? */
  isDischarged?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program and patient enrolled (i.e., activated)? */
  isEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** Metadata entries for this patient program. */
  metadataEntries: Array<CleoPatientProgramMetadataEntry>;
  /** The monitoring form associated with the patient. */
  monitoringFormset: CleoMonitoringFormset;
  /** Patient enrolled in this program. */
  patient: CleoPatient;
  /** Patient-program-forms attached to this patient-program. */
  patientProgramForms: Array<CleoPatientProgramForm>;
  /** The name of the program. */
  programName: Scalars['String']['output'];
  /** The reminders that are attached to this patient-program. */
  reminders: Array<CleoReminder>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Patient-program specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes patient programs, clinic programs, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

export type CleoPatientProgramConnection = {
  __typename?: 'CleoPatientProgramConnection';
  /** A total count of patients that has active patient_programs. */
  activePatientCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientProgramEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of patients in patient_programs query. */
  patientCount?: Maybe<Scalars['Int']['output']>;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoPatientProgramConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoPatientProgramConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoPatientProgramConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay edge containing a `CleoPatientProgram` and its cursor. */
export type CleoPatientProgramEdge = {
  __typename?: 'CleoPatientProgramEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientProgram>;
};

/** Enroll or discharge a patient-program. This operation will update the patient-program `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
export type CleoPatientProgramEnrollDischarge = {
  __typename?: 'CleoPatientProgramEnrollDischarge';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the enroll/discharge operation. */
  results?: Maybe<Array<CleoPatientProgramEnrollDischargeResult>>;
};

/** Asynchronously enroll or discharge a patient-program. This operation will update the patient-program `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
export type CleoPatientProgramEnrollDischargeAsync = {
  __typename?: 'CleoPatientProgramEnrollDischargeAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results of the enroll/discharge operation. */
  results?: Maybe<Array<CleoPatientProgramEnrollDischargeResult>>;
};

export type CleoPatientProgramEnrollDischargeAsyncInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic program UID.(Deprecated) */
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** List of clinic programs for patient to ENROLL or DISCHARGE. If operation is DISCHARGE and `clinic_program_uids` are `null`, the patient will be discharged from all their enrolled programs. */
  clinicProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician alertees UIDs to attach to patient-program-form for `ENROLL` operation. */
  clinicianAlertees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician ICs UIDs to attach to patient-program-form for `ENROLL` operation. */
  clinicianIcs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When a patient is discharged from all the programs, we deactivate the patient as well. Defaults to `false`. */
  deactivatePatient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient UIDs to be excluded from enroll/discharge. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The enrollment/discharge operation. */
  operation?: InputMaybe<PatientProgramOperation>;
  /** Enroll/Discharge by applying filter for patients in clinic. This will apply all patients regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** List of patient group UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patients in the group will be discharged from all their enrolled programs. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient-program UID. */
  patientProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs. If `clinic_program_uids` are `null`, the patient will be discharged from all their enrolled programs. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reminder UIDs to attach to patient-program for `ENROLL` operation. */
  reminders?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CleoPatientProgramEnrollDischargeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic program UID.(Deprecated) */
  clinicProgramUid?: InputMaybe<Scalars['String']['input']>;
  /** List of clinic programs for patient to ENROLL or DISCHARGE. If operation is DISCHARGE and `clinic_program_uids` are `null`, the patient will be discharged from all their enrolled programs. */
  clinicProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician alertees UIDs to attach to patient-program-form for `ENROLL` operation. */
  clinicianAlertees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician ICs UIDs to attach to patient-program-form for `ENROLL` operation. */
  clinicianIcs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When a patient is discharged from all the programs, we deactivate the patient as well. Defaults to `false`. */
  deactivatePatient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient UIDs to be excluded from enroll/discharge. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The enrollment/discharge operation. */
  operation: PatientProgramOperation;
  /** Enroll/Discharge by applying filter for patients in clinic. This will apply all patients regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** List of patient group UIDs. If `monitoring_form_uid` and `monitoring_formset_uid` are `null`, the patients in the group will be discharged from all their enrolled programs. */
  patientGroupUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Patient-program UID. */
  patientProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs. If `clinic_program_uid` are `null`, the patient will be discharged from all their enrolled programs. */
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reminder UIDs to attach to patient-program for `ENROLL` operation. */
  reminders?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of the patient program enrollment/discharge. */
export type CleoPatientProgramEnrollDischargeResult = ScalpelNode & {
  __typename?: 'CleoPatientProgramEnrollDischargeResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the patient-program was previously enrolled. */
  isPreviouslyEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** Patient-program which was enrolled or discharged. */
  patientProgram: CleoPatientProgram;
};

/** Object type for `CleoPatientProgramForm`. */
export type CleoPatientProgramForm = ScalpelNode & {
  __typename?: 'CleoPatientProgramForm';
  /** The alert rules that are attached to this patient-program-form. */
  alertRules: Array<CleoAlertRule>;
  /** Clinicians that receive alerts for this patient program form. */
  alertees: Array<CleoClinician>;
  /** Caregivers for this patient program form. */
  caregivers: Array<CleoClinician>;
  /** The clinic program associated with the patient. */
  clinicProgram: CleoClinicProgram;
  /** The clinic program monitoring formset associated with the patient. */
  clinicProgramMonitoringFormset: CleoClinicProgramMonitoringFormset;
  /** Date of enrollment of this patient. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Do not alert this patient regardless. */
  doNotAlert: Scalars['Boolean']['output'];
  /** Do not remind this patient regardless. */
  doNotRemind: Scalars['Boolean']['output'];
  /** The alert rules that are in effect for this patient. Can be clinic level or patient-program-form level. */
  effectiveAlertRules: Array<CleoAlertRule>;
  /** The URL to the monitoring form that is in effect for this patient. */
  effectiveMonitoringFormUrl?: Maybe<Scalars['String']['output']>;
  /** Effective reminder with kronos task details. */
  effectiveReminderTasks: Array<CleoReminderTask>;
  /** The reminders that are in effect for this patient. Can be clinic level, program-form-level or patient-program-form level. */
  effectiveReminders: Array<CleoReminder>;
  /** Clinicans that are in-charge of this patient program form. */
  ics: Array<CleoClinician>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientProgramForm:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the patient-program-form activated? */
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program-form deactivated? */
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program-form or patient discharged (i.e., deactivated)? */
  isDischarged?: Maybe<Scalars['Boolean']['output']>;
  /** Is the patient-program-form and patient enrolled (i.e., activated)? */
  isEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** The last submission for this patient-program-form. */
  lastSubmission?: Maybe<CleoSubmission>;
  /** DateTime of patient-program-form's last submission. */
  lastSubmittedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Metadata entries for this patient-program-form. */
  metadataEntries: Array<CleoPatientProgramFormMetadataEntry>;
  /** The monitoring form-onform pair. */
  monitoringForm: CleoMonitoringForm;
  /** Patient-Program this mapping is for. */
  patientProgram: CleoPatientProgram;
  /** The reminders that are attached to this patient-program-form. */
  reminders: Array<CleoReminder>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoPatientProgramFormConnection = {
  __typename?: 'CleoPatientProgramFormConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientProgramFormEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoPatientProgramFormConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoPatientProgramFormConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoPatientProgramFormConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay edge containing a `CleoPatientProgramForm` and its cursor. */
export type CleoPatientProgramFormEdge = {
  __typename?: 'CleoPatientProgramFormEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientProgramForm>;
};

/** Object type for `CleoPatientProgramFormMetadataEntry`. */
export type CleoPatientProgramFormMetadataEntry = ScalpelNode & {
  __typename?: 'CleoPatientProgramFormMetadataEntry';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientProgramFormMetadataEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient program forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** This is a related model input type for `CleoPatientProgramForm`. */
export type CleoPatientProgramFormRelatedModelInput = {
  /** Global ID for referencing `CleoPatientProgramForm`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoPatientProgramForm`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoPatientProgramMetadataEntry`. */
export type CleoPatientProgramMetadataEntry = ScalpelNode & {
  __typename?: 'CleoPatientProgramMetadataEntry';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientProgramMetadataEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** This is a related model input type for `CleoPatientProgram`. */
export type CleoPatientProgramRelatedModelInput = {
  /** Global ID for referencing `CleoPatientProgram`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoPatientProgram`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoPatientRatatoskrDevice`. */
export type CleoPatientRatatoskrDevice = ScalpelNode & {
  __typename?: 'CleoPatientRatatoskrDevice';
  /** The communication method associated with this device. Can be `null` if the ClinicRatatoskrProviderApplication is removed or invalid. */
  communicationMethod?: Maybe<Scalars['String']['output']>;
  /** Ratatoskr device associated with this profile. */
  device: RatatoskrDevice;
  /** This is the global ID constructed from the base64 encoding of `CleoPatientRatatoskrDevice:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** This is a related model input type for `CleoPatient`. */
export type CleoPatientRelatedModelInput = {
  /** Global ID for referencing `CleoPatient`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoPatient`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Reminder with kronos task that is attached to patient */
export type CleoPatientReminderTask = ScalpelNode & {
  __typename?: 'CleoPatientReminderTask';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Patient-event attached to reminder. */
  patientEvent?: Maybe<CleoPatientEvent>;
  /** Patient-form attached to reminder. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Patient-program attached to reminder. */
  patientProgram?: Maybe<CleoPatientProgram>;
  /** Patient-program-form attached to reminder. */
  patientProgramForm?: Maybe<CleoPatientProgramForm>;
  /** Reminder with kronos task */
  reminderTask: CleoReminderTask;
};

export type CleoPatientReminderTasksConnection = {
  __typename?: 'CleoPatientReminderTasksConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoPatientReminderTasksEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoPatientReminderTasks` and its cursor. */
export type CleoPatientReminderTasksEdge = {
  __typename?: 'CleoPatientReminderTasksEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoPatientReminderTask>;
};

/** Get a permanent session from a temporary session during login. */
export type CleoPermanentSession = ScalpelNode & {
  __typename?: 'CleoPermanentSession';
  /** Session is assigned to this clinician UID. */
  clinicianUid?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Session is assigned to this patient UID. */
  patientUid?: Maybe<Scalars['String']['output']>;
  /** The authorized permanent session. */
  session: HeimdallSession;
};

/** Object type for `CleoReminder`. */
export type CleoReminder = ScalpelNode & {
  __typename?: 'CleoReminder';
  /** Clinic which uses this reminder. */
  clinic: CleoClinic;
  /** Merlin administrator who created the reminder. */
  createdBy?: Maybe<MerlinAdministrator>;
  /** Date/Time this reminder was created. */
  createdOn: Scalars['DateTime']['output'];
  /** The human readable description of the reminder schedule. */
  description: Scalars['String']['output'];
  /** Effective name of reminder. */
  effectiveName?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoReminder:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** This reminder applies to all patient-form in the clinic by default. */
  isForClinic: Scalars['Boolean']['output'];
  /** Message template set attached to reminder. */
  messageTemplateSet?: Maybe<CleoMessageTemplateSet>;
  /** Reminder name. */
  name: Scalars['String']['output'];
  /** Reminders attached to this ClinicProgram-MonitoringFormset. */
  programMonitoringFormsets: CleoClinicProgramMonitoringFormsetConnection;
  /** Reminder settings including its schedule and options. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-remindersettings-generated.html" target="_blank">cleo/ReminderSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Reminder specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates. */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Object type for `CleoReminder`. */
export type CleoReminderProgramMonitoringFormsetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CleoReminderConnection = {
  __typename?: 'CleoReminderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoReminderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoReminder` and its cursor. */
export type CleoReminderEdge = {
  __typename?: 'CleoReminderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoReminder>;
};

/** Object type for `CleoReminderEvent`. */
export type CleoReminderEvent = ScalpelNode & {
  __typename?: 'CleoReminderEvent';
  /** Date/Time this event was created. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoReminderEvent:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Submission object associated with the reminder. */
  submission?: Maybe<CleoSubmission>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** This is a related model input type for `CleoReminder`. */
export type CleoReminderRelatedModelInput = {
  /** Global ID for referencing `CleoReminder`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoReminder`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Patient reminder with kronos task information */
export type CleoReminderTask = ScalpelNode & {
  __typename?: 'CleoReminderTask';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Message template set attached to reminder. */
  messageTemplateSet?: Maybe<CleoMessageTemplateSet>;
  /** Reminder attached to patient form. */
  reminder: CleoReminder;
  /** kronos task attached to reminder. */
  task?: Maybe<KronosTask>;
};

/** Object type for `CleoRole`. */
export type CleoRole = ScalpelNode & {
  __typename?: 'CleoRole';
  /** This is the global ID constructed from the base64 encoding of `CleoRole:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Descriptive name of this clinic role. Should be unique within the clinic. */
  name: Scalars['String']['output'];
  /** Permissions associated with this role. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-rolepermission-generated.html" target="_blank">cleo/RolePermission.schema</a>. */
  permissions?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type CleoRoleConnection = {
  __typename?: 'CleoRoleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoRoleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoRole` and its cursor. */
export type CleoRoleEdge = {
  __typename?: 'CleoRoleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoRole>;
};

/** This is a related model input type for `CleoRole`. */
export type CleoRoleRelatedModelInput = {
  /** Global ID for referencing `CleoRole`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoRole`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoSubmission`. */
export type CleoSubmission = ScalpelNode & {
  __typename?: 'CleoSubmission';
  /** List of submitted comments. */
  comments: Array<CleoSubmissionComment>;
  /** Date/Time this submission was created. */
  createdOn: Scalars['DateTime']['output'];
  /** The clinician who mark the object as hidden. */
  hiddenBy?: Maybe<CleoClinician>;
  /** Date/Time this object was hidden. */
  hiddenOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoSubmission:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if all triggered alerts are resolved or there are no triggered alerts. */
  isAlertsResolved?: Maybe<Scalars['Boolean']['output']>;
  /** True if there is at least 1 alert triggered. */
  isAlertsTriggered?: Maybe<Scalars['Boolean']['output']>;
  /** When this submission is seen by the patient. */
  lastSeenByPatientOn?: Maybe<Scalars['DateTime']['output']>;
  /** When this submission was last seen by the profile. This is agnostic between clinician and patients. */
  lastSeenOn?: Maybe<Scalars['DateTime']['output']>;
  /** List of clinicians and when they last saw this submission. */
  lastSeens: Array<CleoSubmissionLastSeen>;
  /** Submission for this particular Patient and form. */
  patientForm?: Maybe<CleoPatientForm>;
  /** Submission for this particular patient-program-form. */
  patientProgramForm?: Maybe<CleoPatientProgramForm>;
  /** DateTime of submission. */
  submittedOn: Scalars['DateTime']['output'];
  /** List of all `TriggeredAlert` objects for this submission. */
  triggeredAlerts?: Maybe<Array<CleoTriggeredAlert>>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** List of submitted values. */
  values: Array<CleoSubmissionValue>;
  /** Submission specific variables for substitution in templates. */
  variables?: Maybe<Scalars['GenericScalar']['output']>;
  /** All variables for substitution in templates (i.e., includes patient forms, monitoring forms, patients, etc). */
  variablesAll?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Object type for `CleoSubmission`. */
export type CleoSubmissionValuesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Object type for `CleoSubmissionComment`. */
export type CleoSubmissionComment = ScalpelNode & {
  __typename?: 'CleoSubmissionComment';
  /** Clinician who posted this comment. If null, the author is assumed to be the patient. */
  clinician?: Maybe<CleoClinician>;
  /** String value of the content. This is V1. */
  content: Scalars['String']['output'];
  /** JSON object for comments based on `cleo/SubmissionCommentContent.schema`. This is V2. */
  contentV2: Scalars['GenericScalar']['output'];
  /** Date/Time this comment was created. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoSubmissionComment:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the current profile (i.e., patient or clinician) has seen this comment. */
  isSeen: Scalars['Boolean']['output'];
  /** List of clinicians who have seen this comment. */
  seenByClinicians: Array<CleoClinician>;
  /** Submission associated with this comment. */
  submission: CleoSubmission;
  /** List of clinicians who are tagged in this comment. */
  taggedClinicians: Array<CleoClinician>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Who will be able to see this comment. */
  visibleTo?: Maybe<CleoSubmissionCommentVisibleToChoices>;
};

export type CleoSubmissionCommentConnection = {
  __typename?: 'CleoSubmissionCommentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoSubmissionCommentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoSubmissionComment` and its cursor. */
export type CleoSubmissionCommentEdge = {
  __typename?: 'CleoSubmissionCommentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoSubmissionComment>;
};

/** This is a related model input type for `CleoSubmissionComment`. */
export type CleoSubmissionCommentRelatedModelInput = {
  /** Global ID for referencing `CleoSubmissionComment`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoSubmissionComment`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CleoSubmissionCommentVisibleToChoices {
  /** Everybody */
  Everybody = 'EVERYBODY',
  /** ICs and Alertees */
  IcsAndAlertees = 'ICS_AND_ALERTEES',
}

/** An enumeration. */
export enum CleoSubmissionCommentVisibleToForMutation {
  /** Everybody */
  Everybody = 'EVERYBODY',
  /** ICs and Alertees */
  IcsAndAlertees = 'ICS_AND_ALERTEES',
}

export type CleoSubmissionConnection = {
  __typename?: 'CleoSubmissionConnection';
  /** A total count of patients that has active patient_form with submissions. */
  activePatientCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CleoSubmissionEdge>>;
  /** Generate delayed Stitch link for email of document as a password protected Zip attachment. */
  exportByEmail: Scalars['String']['output'];
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<CleoExportableFormat>>;
  /**
   * Generate delayed Stitch link for email of exported CSV as a password protected Zip attachment. (DEPRECATED)
   * @deprecated Use `exportByEmail` instead.
   */
  exportedCsvEmail: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported CSV. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedCsvUrl: Scalars['String']['output'];
  /**
   * Generate delayed Stitch link for downloading of exported printable HTML. (DEPRECATED)
   * @deprecated Use `exportByUrl` instead.
   */
  exportedHtmlUrl: Scalars['String']['output'];
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of patients in submissions query. */
  patientCount?: Maybe<Scalars['Int']['output']>;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type CleoSubmissionConnectionExportByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outputFormat: ExportOutputFormat;
};

export type CleoSubmissionConnectionExportByUrlArgs = {
  outputFormat: ExportOutputFormat;
};

export type CleoSubmissionConnectionExportedCsvEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** Total count of submissions. */
export type CleoSubmissionCount = ScalpelNode & {
  __typename?: 'CleoSubmissionCount';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Total count of submissions. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CleoSubmission` and its cursor. */
export type CleoSubmissionEdge = {
  __typename?: 'CleoSubmissionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CleoSubmission>;
};

/** Mark the submission as hidden. */
export type CleoSubmissionHide = {
  __typename?: 'CleoSubmissionHide';
  /** Return the updated `CleoSubmission` after update. */
  cleoSubmission: CleoSubmission;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CleoSubmissionHideInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Mark the submission as hidden. */
  uid: Scalars['String']['input'];
};

/** Object type for `CleoSubmissionLastSeen`. */
export type CleoSubmissionLastSeen = ScalpelNode & {
  __typename?: 'CleoSubmissionLastSeen';
  /** Clinician who last saw the submission. */
  clinician: CleoClinician;
  /** This is the global ID constructed from the base64 encoding of `CleoSubmissionLastSeen:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Date/Time this submission was last seen. */
  seenOn: Scalars['DateTime']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Update the submission last seen status for current profile (i.e., clinician/patient). */
export type CleoSubmissionLastSeenUpdate = {
  __typename?: 'CleoSubmissionLastSeenUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the last seen datetime for the profile. */
  lastSeenOn: Scalars['DateTime']['output'];
};

/** Update submission last seen status for all submissions accessible by the current profile (i.e., clinician/patient). */
export type CleoSubmissionLastSeenUpdateAll = {
  __typename?: 'CleoSubmissionLastSeenUpdateAll';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of submission UIDs affected. */
  submissionUids: Array<Scalars['String']['output']>;
};

export type CleoSubmissionLastSeenUpdateAllInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CleoSubmissionLastSeenUpdateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Submission associated with this last seen time. */
  submissionUid: Scalars['String']['input'];
};

/** This is a related model input type for `CleoSubmission`. */
export type CleoSubmissionRelatedModelInput = {
  /** Global ID for referencing `CleoSubmission`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `CleoSubmission`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `CleoSubmissionValue`. */
export type CleoSubmissionValue = ScalpelNode & {
  __typename?: 'CleoSubmissionValue';
  /** Extracted scalar value instead of a value object. This field will be `null` if we are unable to obtain the extracted value. */
  extracted?: Maybe<Scalars['GenericScalar']['output']>;
  /** Extracted scalar value as a string for display. This includes number formatting for precision and string array concatenation. This field will be `null` if we are unable to obtain the extracted value. */
  extractedForDisplay?: Maybe<Scalars['String']['output']>;
  /** Extracted scalar value including a unit for numerical types. Note that this is built on `extractedForDisplay`. This field will be `null` if we are unable to obtain the extracted value. */
  extractedWithUnit?: Maybe<Scalars['String']['output']>;
  /** The clinician who mark the object as hidden. */
  hiddenBy?: Maybe<CleoClinician>;
  /** Date/Time this object was hidden. */
  hiddenOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `CleoSubmissionValue:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this submission value triggered an alert. */
  isAlertsTriggered: Scalars['Boolean']['output'];
  /** Clinical Parameter associated with this value. */
  parameter: CleoClinicalParameter;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
  /** Type of the clinical parameter. */
  valueType: CleoClinicalParameterValueTypeChoices;
  /** Submission value specific variables for substitution in templates. */
  variables: Scalars['GenericScalar']['output'];
  /** All variables for substitution in templates (i.e., includes submission, patient forms, monitoring forms, patients, etc). */
  variablesAll: Scalars['GenericScalar']['output'];
};

/** Mark the submission value as hidden. */
export type CleoSubmissionValueHide = {
  __typename?: 'CleoSubmissionValueHide';
  /** Return the updated `CleoSubmissionValue` after update. */
  cleoSubmissionValue: CleoSubmissionValue;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CleoSubmissionValueHideInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Mark the submission value as hidden. */
  uid: Scalars['String']['input'];
};

/** Object type for `CleoTriggeredAlert`. */
export type CleoTriggeredAlert = ScalpelNode & {
  __typename?: 'CleoTriggeredAlert';
  /** Reasons for triggered alert. */
  alertReasons?: Maybe<Array<CleoTriggeredAlertReason>>;
  /** When this alert got triggered. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `CleoTriggeredAlert:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the triggered alert resolved. */
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  /** Reminder event which triggered this alert. */
  reminderEvent?: Maybe<CleoReminderEvent>;
  /** DateTime which the alert is resolved. Convenience attribute. */
  resolvedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Resolving comment for the triggered alert. */
  resolvingComment?: Maybe<CleoSubmissionComment>;
  /** Which rule triggered this alert. */
  rule: CleoAlertRule;
  /** Submission which triggered this alert. */
  submission?: Maybe<CleoSubmission>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Reason for triggered alert. */
export type CleoTriggeredAlertReason = ScalpelNode & {
  __typename?: 'CleoTriggeredAlertReason';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The human readable description of the reason for triggered alert. */
  reason: Scalars['String']['output'];
  /** The submission value attached to this alert. */
  submissionValue?: Maybe<CleoSubmissionValue>;
};

/** Create a resolving comment for all unresolved `TriggeredAlert`s where the active clinician is an IC. */
export type CleoTriggeredAlertsResolveAll = {
  __typename?: 'CleoTriggeredAlertsResolveAll';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of triggered alerts affected. */
  resolvedTriggeredAlerts: Array<CleoTriggeredAlert>;
  /** Number of triggered alerts that got resolved. */
  resolvedTriggeredAlertsCount?: Maybe<Scalars['Int']['output']>;
};

export type CleoTriggeredAlertsResolveAllInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resolving comment for the triggered alert. It will be validated against [`cleo/SubmissionCommentContent.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  resolvingCommentContent?: InputMaybe<Scalars['CleoSubmissionCommentContentSkeletonJSON']['input']>;
};

export enum ClinicGroupOrderBy {
  Domain = 'DOMAIN',
  Name = 'NAME',
}

export type ClinicProgramImport = {
  /** Description to override for clinic program. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name to override for clinic program. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UID of the clinic program. */
  uid: Scalars['String']['input'];
};

export enum ClinicianAvartar {
  AvatarBlueFemale = 'AVATAR_BLUE_FEMALE',
  AvatarBlueMale = 'AVATAR_BLUE_MALE',
  AvatarGreyFemale = 'AVATAR_GREY_FEMALE',
  AvatarGreyMale = 'AVATAR_GREY_MALE',
  AvatarPinkFemale = 'AVATAR_PINK_FEMALE',
  AvatarPinkMale = 'AVATAR_PINK_MALE',
  AvatarYellowFemale = 'AVATAR_YELLOW_FEMALE',
  AvatarYellowMale = 'AVATAR_YELLOW_MALE',
}

export enum ClinicianOrderBy {
  CommunicationMethod = 'COMMUNICATION_METHOD',
  Designation = 'DESIGNATION',
  Name = 'NAME',
  RoleName = 'ROLE_NAME',
  Status = 'STATUS',
}

/** An enumeration. */
export enum CommunicationMethod {
  Any = 'ANY',
  Botmd = 'BOTMD',
  Email = 'EMAIL',
  Line = 'LINE',
  Messenger = 'MESSENGER',
  Sms = 'SMS',
  Telegram = 'TELEGRAM',
  Viber = 'VIBER',
  Whatsapp = 'WHATSAPP',
}

/** Result of create mutation. */
export type CreateCleoAlertRule = {
  __typename?: 'CreateCleoAlertRule';
  /** Return the created `CleoAlertRule` after mutation. */
  cleoAlertRule: CleoAlertRule;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoAlertRuleInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This alert rule applies to all patient-form in the clinic by default. (Required if creating new `CleoAlertRule`) */
  isForClinic: Scalars['Boolean']['input'];
  /** The level determines the response to the alert. */
  level?: InputMaybe<CleoAlertRuleLevelForMutation>;
  /** Alert name (Required if creating new `CleoAlertRule`) */
  name: Scalars['String']['input'];
  /** The import path for this instantiable object. (Required if creating new `CleoAlertRule`) */
  parserImportPath: CleoAlertRuleParserImportPathForMutation;
  /** Settings for parser. It will be validated against `cleo/RuleParserSettings.schema`. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-ruleparsersettings-generated.html" target="_blank">cleo/RuleParserSettings.schema</a>. It will be validated against [`cleo/RuleParserSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  parserSettings?: InputMaybe<Scalars['CleoRuleParserSettingsSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoClinic = {
  __typename?: 'CreateCleoClinic';
  /** Return the created `CleoClinic` after mutation. */
  cleoClinic: CleoClinic;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Result of create mutation. */
export type CreateCleoClinicFilter = {
  __typename?: 'CreateCleoClinicFilter';
  /** Return the created `CleoClinicFilter` after mutation. */
  cleoClinicFilter: CleoClinicFilter;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicFilterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the filter. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter name. (Required if creating new `CleoClinicFilter`) */
  name: Scalars['String']['input'];
  /** Filter settings including its schedule and options. It is validated against <a href="https://skeleton.staging.botmd.io/docs/scalpel-filtersettings-generated.html" target="_blank">scalpel/FilterSettings.schema</a>. (Required if creating new `CleoClinicFilter`) It will be validated against [`scalpel/FilterSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  settings: Scalars['ScalpelFilterSettingsSkeletonJSON']['input'];
};

/** Result of create mutation. */
export type CreateCleoClinicGroup = {
  __typename?: 'CreateCleoClinicGroup';
  /** Return the created `CleoClinicGroup` after mutation. */
  cleoClinicGroup: CleoClinicGroup;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic group domain/sub-domain. (Required if creating new `CleoClinicGroup`) */
  domain: Scalars['String']['input'];
  /** Clinic group logo which will be displayed on dashboard. (Required if creating new `CleoClinicGroup`) (Supports either S3 or data URI) */
  logo: Scalars['String']['input'];
  /** Clinic group name. (Required if creating new `CleoClinicGroup`) */
  name: Scalars['String']['input'];
  /** Default timezone of this clinic group. (Required if creating new `CleoClinicGroup`) */
  timezone: CleoClinicGroupTimezoneForMutation;
};

export type CreateCleoClinicInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicGroup`. */
  clinicGroup?: InputMaybe<CleoClinicGroupRelatedModelInput>;
  /** Default phone country code of this clinic. (Required if creating new `CleoClinic`) */
  countryCode: CleoClinicCountryCodeForMutation;
  /** Clinic domain/sub-domain when accessing via the web. (Required if creating new `CleoClinic`) */
  domain: Scalars['String']['input'];
  /** Default language of this clinic. (Required if creating new `CleoClinic`) */
  language: CleoClinicLanguageForMutation;
  /** Clinic logo which will be displayed on dashboard. Defaults to clinic group logo if not set. (Supports either S3 or data URI) */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Clinic name. (Required if creating new `CleoClinic`) */
  name: Scalars['String']['input'];
  /** Default timezone of this clinic. (Required if creating new `CleoClinic`) */
  timezone: CleoClinicTimezoneForMutation;
};

/** Result of create mutation. */
export type CreateCleoClinicProduct = {
  __typename?: 'CreateCleoClinicProduct';
  /** Return the created `CleoClinicProduct` after mutation. */
  cleoClinicProduct: CleoClinicProduct;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicProductInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost of the product. (Required if creating new `CleoClinicProduct`) */
  cost: Scalars['Decimal']['input'];
  /**  (Required if creating new `CleoClinicProduct`) */
  costCurrency: CleoClinicProductCostCurrencyForMutation;
  /** The name of this product. (Required if creating new `CleoClinicProduct`) */
  name: Scalars['String']['input'];
};

/** Result of create mutation. */
export type CreateCleoClinicRatatoskrProviderApplication = {
  __typename?: 'CreateCleoClinicRatatoskrProviderApplication';
  /** Return the created `CleoClinicRatatoskrProviderApplication` after mutation. */
  cleoClinicRatatoskrProviderApplication: CleoClinicRatatoskrProviderApplication;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicRatatoskrProviderApplicationInput = {
  /** Application's settings to setup ratatoskr provider application. */
  applicationSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** Use this Ratatoskr provider application for communication. (Required if creating new `CleoClinicRatatoskrProviderApplication`) */
  communicationMethod: CleoClinicRatatoskrProviderApplicationCommunicationMethodForMutation;
  /** Order of fallback Ratatoskr provider applications. Lower number means higher priority. */
  fallbackOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Set the value for `ForeignKey` to `RatatoskrProviderApplication`. */
  providerApplication?: InputMaybe<RatatoskrProviderApplicationRelatedModelInput>;
  /** Import path of the provider. */
  providerImportPath?: InputMaybe<Scalars['String']['input']>;
  /** Provider's settings to setup ratatoskr provider application. */
  providerSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Settings for this Ratatoskr provider application. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicratatoskrproviderapplicationsettings-generated.html" target="_blank">cleo/ClinicRatatoskrProviderApplicationSettings.schema</a>. It will be validated against [`cleo/ClinicRatatoskrProviderApplicationSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  settings?: InputMaybe<Scalars['CleoClinicRatatoskrProviderApplicationSettingsSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoClinicalParameter = {
  __typename?: 'CreateCleoClinicalParameter';
  /** Return the created `CleoClinicalParameter` after mutation. */
  cleoClinicalParameter: CleoClinicalParameter;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicalParameterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This is used for grouping parameters together, e.g., "Blood Pressure" is a group for Systolic/Diastolic. Defaults to the parameter name. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter name. (Required if creating new `CleoClinicalParameter`) */
  name: Scalars['String']['input'];
  /** Type of the clinical parameter. (Required if creating new `CleoClinicalParameter`) */
  valueType: CleoClinicalParameterValueTypeForMutation;
};

/** Result of create mutation. */
export type CreateCleoClinician = {
  __typename?: 'CreateCleoClinician';
  /** Return the created `CleoClinician` after mutation. */
  cleoClinician: CleoClinician;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoClinicianInput = {
  /** Avatar for clinicians. */
  avatar?: InputMaybe<ClinicianAvartar>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Method of contacting the clinician/patient. (Required if creating new `CleoClinician`) */
  communicationMethod: CleoClinicianCommunicationMethodForMutation;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Designation. (Required if creating new `CleoClinician`) */
  designation: Scalars['String']['input'];
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Supplementary information about the clinician/Patient. (Deprecated for Patient, use `metadata_entries` instead) It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-profilemetadata-generated.html" target="_blank">cleo/ProfileMetadata.schema</a>. It will be validated against [`cleo/ProfileMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['CleoProfileMetadataSkeletonJSON']['input']>;
  /** Full name of the user. (Required if creating new `CleoClinician`) */
  name: Scalars['String']['input'];
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoClinician`) */
  phone: Scalars['String']['input'];
  /** Profile photo. (Supports either S3 or data URI) */
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoRole`. */
  role?: InputMaybe<CleoRoleRelatedModelInput>;
};

/** Result of create mutation. */
export type CreateCleoMessageTemplate = {
  __typename?: 'CreateCleoMessageTemplate';
  /** Return the created `CleoMessageTemplate` after mutation. */
  cleoMessageTemplate: CleoMessageTemplate;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoMessageTemplateInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Communication method this message template is for. (Required if creating new `CleoMessageTemplate`) */
  communicationMethod: CleoMessageTemplateCommunicationMethodForMutation;
  /** Language of this message template. */
  language?: InputMaybe<CleoMessageTemplateLanguageForMutation>;
  /** Set the value for `ForeignKey` to `CleoMessageTemplateSet`. */
  messageTemplateSet?: InputMaybe<CleoMessageTemplateSetRelatedModelInput>;
  /** The message template to use for delivery. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `CleoMessageTemplate`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  template: Scalars['RatatoskrMessageTemplateSkeletonJSON']['input'];
};

/** Result of create mutation. */
export type CreateCleoMessageTemplateSet = {
  __typename?: 'CreateCleoMessageTemplateSet';
  /** Return the created `CleoMessageTemplateSet` after mutation. */
  cleoMessageTemplateSet: CleoMessageTemplateSet;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoMessageTemplateSetInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** Descriptive name of this message template set. Should be unique within the clinic. (Required if creating new `CleoMessageTemplateSet`) */
  name: Scalars['String']['input'];
  /** Purpose of this message template set. (Required if creating new `CleoMessageTemplateSet`) */
  purpose: CleoMessageTemplateSetPurposeForMutation;
  /** Whether message templates in this set require access to patient-event. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientEvent: Scalars['Boolean']['input'];
  /** Whether message templates in this set require access to patient-forms. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientForm: Scalars['Boolean']['input'];
  /** Whether message templates in this set require access to patient-programs. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientProgram: Scalars['Boolean']['input'];
  /** Whether message templates in this set require access to patient-program-forms. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientProgramForm: Scalars['Boolean']['input'];
};

/** Result of create mutation. */
export type CreateCleoPatient = {
  __typename?: 'CreateCleoPatient';
  /** Return the created `CleoPatient` after mutation. */
  cleoPatient: CleoPatient;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Result of create mutation. */
export type CreateCleoPatientEventMetadataEntry = {
  __typename?: 'CreateCleoPatientEventMetadataEntry';
  /** Return the created `CleoPatientEventMetadataEntry` after mutation. */
  cleoPatientEventMetadataEntry: CleoPatientEventMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientEventMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientEvent`. */
  patientEvent?: InputMaybe<CleoPatientEventRelatedModelInput>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoPatientFormMetadataEntry = {
  __typename?: 'CreateCleoPatientFormMetadataEntry';
  /** Return the created `CleoPatientFormMetadataEntry` after mutation. */
  cleoPatientFormMetadataEntry: CleoPatientFormMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientFormMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientForm`. */
  patientForm?: InputMaybe<CleoPatientFormRelatedModelInput>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoPatientGroup = {
  __typename?: 'CreateCleoPatientGroup';
  /** Return the created `CleoPatientGroup` after mutation. */
  cleoPatientGroup: CleoPatientGroup;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientGroupInput = {
  /** List of patient group UIDs to add patients from. */
  addFromPatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs to add to this patient group. */
  addPatients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicFilter`. */
  clinicFilter?: InputMaybe<CleoClinicFilterRelatedModelInput>;
  /** Description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Patient UIDs to be excluded from adding into patient group. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter patients fulfill conditin of this filter. It is validated against <a href="https://skeleton.staging.botmd.io/docs/scalpel-filtersettings-generated.html" target="_blank">scalpel/FilterSettings.schema</a>. It will be validated against [`scalpel/FilterSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  filterSettings?: InputMaybe<Scalars['ScalpelFilterSettingsSkeletonJSON']['input']>;
  /** Set the values for `ManyToManyField` to `CleoMonitoringFormset`. */
  monitoringFormsets?: InputMaybe<Array<InputMaybe<CleoMonitoringFormsetRelatedModelInput>>>;
  /** Name of the group. (Required if creating new `CleoPatientGroup`) */
  name: Scalars['String']['input'];
  /** Filter for patients in clinic. This will apply to all patients in clinic regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Set the values for `ManyToManyField` to `CleoPatient`. */
  patients?: InputMaybe<Array<InputMaybe<CleoPatientRelatedModelInput>>>;
  /** Remove patient from group based on patient filter. This flag only applicable in update operation. */
  removeByPatientFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of patient UIDs to remove from this patient group. */
  removePatients?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCleoPatientInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Method of contacting the clinician/patient. (Required if creating new `CleoPatient`) */
  communicationMethod: CleoPatientCommunicationMethodForMutation;
  /** Date of birth of the patient. Can be left empty. If time is not available, we assume it is 12:00 (noon) local time of the patient. This field is always stored in UTC. */
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the patient. Can be left empty. */
  gender?: InputMaybe<CleoPatientGenderForMutation>;
  /** Unique identifier for the user within the clinic. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoPatient`) */
  identifier: Scalars['String']['input'];
  /** Full name of the user. (Required if creating new `CleoPatient`) */
  name: Scalars['String']['input'];
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoPatient`) */
  phone: Scalars['String']['input'];
};

/** Result of create mutation. */
export type CreateCleoPatientMetadataEntry = {
  __typename?: 'CreateCleoPatientMetadataEntry';
  /** Return the created `CleoPatientMetadataEntry` after mutation. */
  cleoPatientMetadataEntry: CleoPatientMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatient`. */
  patient?: InputMaybe<CleoPatientRelatedModelInput>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoPatientProgramFormMetadataEntry = {
  __typename?: 'CreateCleoPatientProgramFormMetadataEntry';
  /** Return the created `CleoPatientProgramFormMetadataEntry` after mutation. */
  cleoPatientProgramFormMetadataEntry: CleoPatientProgramFormMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientProgramFormMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientProgramForm`. */
  patientProgramForm?: InputMaybe<CleoPatientProgramFormRelatedModelInput>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoPatientProgramMetadataEntry = {
  __typename?: 'CreateCleoPatientProgramMetadataEntry';
  /** Return the created `CleoPatientProgramMetadataEntry` after mutation. */
  cleoPatientProgramMetadataEntry: CleoPatientProgramMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoPatientProgramMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientProgram`. */
  patientProgram?: InputMaybe<CleoPatientProgramRelatedModelInput>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateCleoReminder = {
  __typename?: 'CreateCleoReminder';
  /** Return the created `CleoReminder` after mutation. */
  cleoReminder: CleoReminder;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** This reminder applies to all patient-form in the clinic by default. (Required if creating new `CleoReminder`) */
  isForClinic: Scalars['Boolean']['input'];
  /** Reminder name. (Required if creating new `CleoReminder`) */
  name: Scalars['String']['input'];
  /** Reminder settings including its schedule and options. This field is overriden to be nullable. */
  settings?: InputMaybe<Scalars['GenericScalar']['input']>;
};

/** Result of create mutation. */
export type CreateCleoSubmissionComment = {
  __typename?: 'CreateCleoSubmissionComment';
  /** Return the created `CleoSubmissionComment` after mutation. */
  cleoSubmissionComment: CleoSubmissionComment;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCleoSubmissionCommentInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SubmissionComment content. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-submissioncommentcontent-generated.html" target="_blank">cleo/SubmissionCommentContent.schema</a>. (Required if creating new `CleoSubmissionComment`) It will be validated against [`cleo/SubmissionCommentContent.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  content: Scalars['CleoSubmissionCommentContentSkeletonJSON']['input'];
  /** Set the value for `ForeignKey` to `CleoSubmission`. */
  submission?: InputMaybe<CleoSubmissionRelatedModelInput>;
  /** Who will be able to see this comment. */
  visibleTo?: InputMaybe<CleoSubmissionCommentVisibleToForMutation>;
};

/** Result of create mutation. */
export type CreateEinsteinAdministrator = {
  __typename?: 'CreateEinsteinAdministrator';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinAdministrator` after mutation. */
  einsteinAdministrator: EinsteinAdministrator;
};

export type CreateEinsteinAdministratorInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Department UID of the administrator. */
  departmentUid?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  departments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Designation UID of the administrator. */
  designationUid?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  divisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Email of the administrator. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Administrator first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** True if the admin is a super-admin. False for department admins, or other cases as to be defined. */
  isSuper?: InputMaybe<Scalars['Boolean']['input']>;
  /** Administrator last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the administrator. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateEinsteinBroadcast = {
  __typename?: 'CreateEinsteinBroadcast';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinBroadcast` after mutation. */
  einsteinBroadcast: EinsteinBroadcast;
};

export type CreateEinsteinBroadcastInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Broadcast should only run before this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Messages to be broadcasted. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `EinsteinBroadcast`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messages: Scalars['RatatoskrMessageTemplateSkeletonJSON']['input'];
  /** Broadcast name. (Required if creating new `EinsteinBroadcast`) */
  name: Scalars['String']['input'];
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Rulesets to select profiles to send the messages to. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-profilesgrouprulesetarray-generated.html" target="_blank">einstein/ProfilesGroupRulesetArray.schema</a>. It will be validated against [`einstein/ProfilesGroupRulesetArray.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  profilesGroupRulesets?: InputMaybe<Scalars['EinsteinProfilesGroupRulesetArraySkeletonJSON']['input']>;
  /** Recurring frequencies this broadcast is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. It will be validated against [`einstein/RecurringFrequencies.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  recurringFrequencies?: InputMaybe<Scalars['EinsteinRecurringFrequenciesSkeletonJSON']['input']>;
  /** Date/Time this broadcast is scheduled to be sent. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  /** Broadcast should only run after this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Status of the broadcast. (Required if creating new `EinsteinBroadcast`) */
  status: EinsteinBroadcastStatusForMutation;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of create mutation. */
export type CreateEinsteinChernobylEntry = {
  __typename?: 'CreateEinsteinChernobylEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinChernobylEntry` after mutation. */
  einsteinChernobylEntry: EinsteinChernobylEntry;
};

export type CreateEinsteinChernobylEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the Einstein Chernobyl DataSource to create the entry. */
  dataSourceUid?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** For convenient CUD of the data source entry variables. This is a _set_ operation meaning any variables not in this set will be deleted from the entry. If `null`, no changes will be done to the existing variables. */
  variablesSet?: InputMaybe<Array<ChernobylVariableInput>>;
};

/** Result of create mutation. */
export type CreateEinsteinDialogueEntry = {
  __typename?: 'CreateEinsteinDialogueEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinDialogueEntry` after mutation. */
  einsteinDialogueEntry: EinsteinDialogueEntry;
};

export type CreateEinsteinDialogueEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Messages that will be returned as a response. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `EinsteinDialogueEntry`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messages: Scalars['RatatoskrMessageTemplateSkeletonJSON']['input'];
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Title of this dialogue. (Required if creating new `EinsteinDialogueEntry`) */
  title: Scalars['String']['input'];
  /** Array of trigger entities. */
  triggersSet?: InputMaybe<Array<InputMaybe<Array<EntityInput>>>>;
};

/** Result of create mutation. */
export type CreateEinsteinDocumentEntry = {
  __typename?: 'CreateEinsteinDocumentEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinDocumentEntry` after mutation. */
  einsteinDocumentEntry: EinsteinDocumentEntry;
};

export type CreateEinsteinDocumentEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `EinsteinDataSource`. */
  dataSource?: InputMaybe<EinsteinDataSourceRelatedModelInput>;
  /** DataSource UID when creating a DocumentEntry. */
  dataSourceUid?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** (DEPRECATED) Department UID when creating or updating a DocumentEntry */
  departmentUid?: InputMaybe<Scalars['String']['input']>;
  /** An identifier which uniquely identifies this file in the source. (Required if creating new `EinsteinDocumentEntry`) */
  fileId: Scalars['String']['input'];
  /** The name/path of this file for display. Depending on the nature of the data source, this may be a hierarchical path. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of this file. Defaults to `application/octet-stream` if unable to guess from `filename`. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Title of this document. This is usually provided by the user (or automatically inferred). */
  title?: InputMaybe<Scalars['String']['input']>;
  /** For convenient CUD of the data source entry variables. This is a _set_ operation meaning any variables not in this set will be deleted from the entry. If `null`, no changes will be done to the existing variables. */
  variablesSet?: InputMaybe<Array<DocumentVariableInput>>;
  /** The URL to web version of the file on the data source if available. */
  webUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateEinsteinProfilesGroup = {
  __typename?: 'CreateEinsteinProfilesGroup';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `EinsteinProfilesGroup` after mutation. */
  einsteinProfilesGroup: EinsteinProfilesGroup;
};

export type CreateEinsteinProfilesGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Group description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Group name. (Required if creating new `EinsteinProfilesGroup`) */
  name: Scalars['String']['input'];
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Ruleset for profiles to send the message to. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-profilesgroupruleset-generated.html" target="_blank">einstein/ProfilesGroupRuleset.schema</a>. It will be validated against [`einstein/ProfilesGroupRuleset.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  ruleset?: InputMaybe<Scalars['EinsteinProfilesGroupRulesetSkeletonJSON']['input']>;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of create mutation. */
export type CreateFaradayOrder = {
  __typename?: 'CreateFaradayOrder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `FaradayOrder` after mutation. */
  faradayOrder: FaradayOrder;
};

/** Result of create mutation. */
export type CreateFaradayOrderDraft = {
  __typename?: 'CreateFaradayOrderDraft';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `FaradayOrderDraft` after mutation. */
  faradayOrderDraft: FaradayOrderDraft;
};

export type CreateFaradayOrderDraftInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Draft detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. It will be validated against [`skeleton/Any.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  draft?: InputMaybe<Scalars['SkeletonAnySkeletonJSON']['input']>;
};

/** Result of create mutation. */
export type CreateFaradayOrderExam = {
  __typename?: 'CreateFaradayOrderExam';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `FaradayOrderExam` after mutation. */
  faradayOrderExam: FaradayOrderExam;
};

export type CreateFaradayOrderExamInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `FaradayExam`. */
  exam?: InputMaybe<FaradayExamRelatedModelInput>;
  /** exam comments, attention radiologist etc. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. It will be validated against [`faraday/OrderMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayOrderMetadataSkeletonJSON']['input']>;
  /** Set the value for `ForeignKey` to `FaradayOrder`. */
  order?: InputMaybe<FaradayOrderRelatedModelInput>;
  /** Metadata for order. This will overwrite existing order metadata. */
  orderMetadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Set the value for `ForeignKey` to `FaradayRoom`. */
  room?: InputMaybe<FaradayRoomRelatedModelInput>;
  /** Time this exam order is scheduled for. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateFaradayOrderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the doctor to create an order for. */
  doctorUid?: InputMaybe<Scalars['String']['input']>;
  /** Order detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. It will be validated against [`faraday/OrderMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayOrderMetadataSkeletonJSON']['input']>;
  /** List of OrderExams to bulk create during object creation. */
  orderExams?: InputMaybe<Array<OrderExamInput>>;
  /** UID of the patient to create an order for. */
  patientUid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateFaradayPatientProfile = {
  __typename?: 'CreateFaradayPatientProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `FaradayPatientProfile` after mutation. */
  faradayPatientProfile: FaradayPatientProfile;
};

export type CreateFaradayPatientProfileInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comments for this patient. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Patient date of birth */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** UIDs for doctor who in-charge of this patient. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User's first name. (Required if creating new `FaradayPatientProfile`) */
  firstName: Scalars['String']['input'];
  /** Patient gender. */
  gender?: InputMaybe<FaradayPatientProfileGenderForMutation>;
  /** Is this patient claustrophobic? (Required if creating new `FaradayPatientProfile`) */
  isClaustrophobic: Scalars['Boolean']['input'];
  /** User's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Patient metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-patientmetadata-generated.html" target="_blank">faraday/PatientMetadata.schema</a>. It will be validated against [`faraday/PatientMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayPatientMetadataSkeletonJSON']['input']>;
  /** Patient MRN in Parkway UCMI. */
  mrnNo?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted patient national ID (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  nationalId?: InputMaybe<Scalars['String']['input']>;
  /** Nationality for this patient. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateFaradayStaffProfile = {
  __typename?: 'CreateFaradayStaffProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `FaradayStaffProfile` after mutation. */
  faradayStaffProfile: FaradayStaffProfile;
};

export type CreateFaradayStaffProfileInput = {
  /** Account type of the staff (Required if creating new `FaradayStaffProfile`) */
  accountType: FaradayStaffProfileAccountTypeForMutation;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Staff designation */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs for AdminDoctorRelationship. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Encrypted and HMAC email for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User's first name. (Required if creating new `FaradayStaffProfile`) */
  firstName: Scalars['String']['input'];
  /** User's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Staff's MCR No. */
  mcrNo?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Staff's Physician ID. */
  physicianId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalBanner = {
  __typename?: 'CreateHospitalBanner';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalBanner` after mutation. */
  hospitalBanner: HospitalBanner;
};

export type CreateHospitalBannerInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Banner should only run before this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Banner should only run after this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** The HTML content of the banner. Max 60 characters (exclude the HTML tags). (Required if creating new `HospitalBanner`) */
  text: Scalars['String']['input'];
};

/** Result of create mutation. */
export type CreateHospitalDepartment = {
  __typename?: 'CreateHospitalDepartment';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalDepartment` after mutation. */
  hospitalDepartment: HospitalDepartment;
};

export type CreateHospitalDepartmentInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**  (Required if creating new `HospitalDepartment`) */
  name: Scalars['String']['input'];
  /** Name of Department to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalDesignation = {
  __typename?: 'CreateHospitalDesignation';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalDesignation` after mutation. */
  hospitalDesignation: HospitalDesignation;
};

export type CreateHospitalDesignationInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**  (Required if creating new `HospitalDesignation`) */
  name: Scalars['String']['input'];
  /** Name of Designation to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalDirectoryProfile = {
  __typename?: 'CreateHospitalDirectoryProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalDirectoryProfile` after mutation. */
  hospitalDirectoryProfile: HospitalDirectoryProfile;
};

export type CreateHospitalDirectoryProfileInput = {
  /** If specified, this profile will be activated after the set date. */
  activateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If specified, this profile will be deactivated after the set date. Mechanics of deactivation follow that of `deactivated_on`. */
  deactivateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** If specified, this profile will be deactivated. However, the user will still be able to log in if they are present in the hospital's API. Note that this option should be left blank if user `is_blacklisted`. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** User Department UID */
  department?: InputMaybe<Scalars['String']['input']>;
  /** User Designation UID */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** Email of user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Profile first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Profile last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of user */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalDivision = {
  __typename?: 'CreateHospitalDivision';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalDivision` after mutation. */
  hospitalDivision: HospitalDivision;
};

export type CreateHospitalDivisionInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToOneRel` to `HospitalDepartment`. */
  departments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /**  (Required if creating new `HospitalDivision`) */
  name: Scalars['String']['input'];
  /** UID of Division to move displaced admins and departments to on deletion. */
  replaceUid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalFavourite = {
  __typename?: 'CreateHospitalFavourite';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalFavourite` after mutation. */
  hospitalFavourite: HospitalFavourite;
};

export type CreateHospitalFavouriteInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this favourite. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Content type of the Favourite. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Favourite key. (Required if creating new `HospitalFavourite`) */
  key: Scalars['String']['input'];
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Subtitle of the Favourite. */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Title of the Favourite. (Required if creating new `HospitalFavourite`) */
  title: Scalars['String']['input'];
  /** URL the favourite links to. (Required if creating new `HospitalFavourite`) */
  url: Scalars['String']['input'];
};

/** Result of create mutation. */
export type CreateHospitalMoodLog = {
  __typename?: 'CreateHospitalMoodLog';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalMoodLog` after mutation. */
  hospitalMoodLog: HospitalMoodLog;
};

export type CreateHospitalMoodLogInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The mood rating. 1 for unhappiest, 5 for happiest. (Required if creating new `HospitalMoodLog`) */
  rating: Scalars['Int']['input'];
};

/** Result of create mutation. */
export type CreateHospitalMoodLogReminder = {
  __typename?: 'CreateHospitalMoodLogReminder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalMoodLogReminder` after mutation. */
  hospitalMoodLogReminder: HospitalMoodLogReminder;
};

export type CreateHospitalMoodLogReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Reminder should only run before this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Recurring frequencies this reminder is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. It will be validated against [`einstein/RecurringFrequencies.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  recurringFrequencies?: InputMaybe<Scalars['EinsteinRecurringFrequenciesSkeletonJSON']['input']>;
  /** Reminder should only run after this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Result of create mutation. */
export type CreateHospitalQueryFeedback = {
  __typename?: 'CreateHospitalQueryFeedback';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the created `HospitalQueryFeedback` after mutation. */
  hospitalQueryFeedback: HospitalQueryFeedback;
};

export type CreateHospitalQueryFeedbackInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** True if positive, False if negative (Required if creating new `HospitalQueryFeedback`) */
  isPositive: Scalars['Boolean']['input'];
  /** UID of the query message for feedback */
  messageUid?: InputMaybe<Scalars['String']['input']>;
  /** Text feedback written by user */
  userFeedback?: InputMaybe<Scalars['String']['input']>;
};

export enum CreationStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

/** An enumeration. */
export enum DataSourceEntrySyncStatus {
  Ignore = 'IGNORE',
  LatestAvailable = 'LATEST_AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  Outdated = 'OUTDATED',
}

/** An enumeration. */
export enum DelayedStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED',
  Ready = 'READY',
}

/** Result of delete mutation. */
export type DeleteCleoAlertRule = {
  __typename?: 'DeleteCleoAlertRule';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoAlertRuleInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinic = {
  __typename?: 'DeleteCleoClinic';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

/** Result of delete mutation. */
export type DeleteCleoClinicFilter = {
  __typename?: 'DeleteCleoClinicFilter';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicFilterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicGroup = {
  __typename?: 'DeleteCleoClinicGroup';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCleoClinicInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicProduct = {
  __typename?: 'DeleteCleoClinicProduct';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicProductInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicProgram = {
  __typename?: 'DeleteCleoClinicProgram';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicProgramInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicProgramMonitoringFormset = {
  __typename?: 'DeleteCleoClinicProgramMonitoringFormset';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicProgramMonitoringFormsetInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicRatatoskrProviderApplication = {
  __typename?: 'DeleteCleoClinicRatatoskrProviderApplication';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicRatatoskrProviderApplicationInput = {
  /** Application's settings to setup ratatoskr provider application. */
  applicationSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Import path of the provider. */
  providerImportPath?: InputMaybe<Scalars['String']['input']>;
  /** Provider's settings to setup ratatoskr provider application. */
  providerSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinicalParameter = {
  __typename?: 'DeleteCleoClinicalParameter';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicalParameterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoClinician = {
  __typename?: 'DeleteCleoClinician';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoClinicianInput = {
  /** Avatar for clinicians. */
  avatar?: InputMaybe<ClinicianAvartar>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoMessageTemplate = {
  __typename?: 'DeleteCleoMessageTemplate';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoMessageTemplateInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoMessageTemplateSet = {
  __typename?: 'DeleteCleoMessageTemplateSet';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoMessageTemplateSetInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoPatient = {
  __typename?: 'DeleteCleoPatient';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

/** Result of delete mutation. */
export type DeleteCleoPatientGroup = {
  __typename?: 'DeleteCleoPatientGroup';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoPatientGroupInput = {
  /** List of patient group UIDs to add patients from. */
  addFromPatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs to add to this patient group. */
  addPatients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Patient UIDs to be excluded from adding into patient group. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for patients in clinic. This will apply to all patients in clinic regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Remove patient from group based on patient filter. This flag only applicable in update operation. */
  removeByPatientFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of patient UIDs to remove from this patient group. */
  removePatients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCleoPatientInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteCleoReminder = {
  __typename?: 'DeleteCleoReminder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteCleoReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reminder settings including its schedule and options. This field is overriden to be nullable. */
  settings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteEinsteinBroadcast = {
  __typename?: 'DeleteEinsteinBroadcast';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteEinsteinBroadcastInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of delete mutation. */
export type DeleteEinsteinProfilesGroup = {
  __typename?: 'DeleteEinsteinProfilesGroup';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteEinsteinProfilesGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of delete mutation. */
export type DeleteFaradayOrder = {
  __typename?: 'DeleteFaradayOrder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

/** Result of delete mutation. */
export type DeleteFaradayOrderDraft = {
  __typename?: 'DeleteFaradayOrderDraft';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteFaradayOrderDraftInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteFaradayOrderExam = {
  __typename?: 'DeleteFaradayOrderExam';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteFaradayOrderExamInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metadata for order. This will overwrite existing order metadata. */
  orderMetadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteFaradayOrderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the doctor to create an order for. */
  doctorUid?: InputMaybe<Scalars['String']['input']>;
  /** List of OrderExams to bulk create during object creation. */
  orderExams?: InputMaybe<Array<OrderExamInput>>;
  /** UID of the patient to create an order for. */
  patientUid?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteFaradayPatientProfile = {
  __typename?: 'DeleteFaradayPatientProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteFaradayPatientProfileInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comments for this patient. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** UIDs for doctor who in-charge of this patient. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Nationality for this patient. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteFaradayStaffProfile = {
  __typename?: 'DeleteFaradayStaffProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteFaradayStaffProfileInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs for AdminDoctorRelationship. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Staff's MCR No. */
  mcrNo?: InputMaybe<Scalars['String']['input']>;
  /** Staff's Physician ID. */
  physicianId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalBanner = {
  __typename?: 'DeleteHospitalBanner';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalBannerInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalDepartment = {
  __typename?: 'DeleteHospitalDepartment';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalDepartmentInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of Department to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalDesignation = {
  __typename?: 'DeleteHospitalDesignation';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalDesignationInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of Designation to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID representing the Designation. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalDirectoryProfile = {
  __typename?: 'DeleteHospitalDirectoryProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalDirectoryProfileInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Department UID */
  department?: InputMaybe<Scalars['String']['input']>;
  /** User Designation UID */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** Email of user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalDivision = {
  __typename?: 'DeleteHospitalDivision';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalDivisionInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of Division to move displaced admins and departments to on deletion. */
  replaceUid?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID representing the Division. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalFavourite = {
  __typename?: 'DeleteHospitalFavourite';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalFavouriteInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteHospitalMoodLogReminder = {
  __typename?: 'DeleteHospitalMoodLogReminder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteHospitalMoodLogReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of delete mutation. */
export type DeleteMerlinAdministrator = {
  __typename?: 'DeleteMerlinAdministrator';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the deleted `DeleteMutationResult` after mutation. */
  deleteMutationResult: DeleteMutationResult;
};

export type DeleteMerlinAdministratorInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a delete mutation. */
export type DeleteMutationResult = Node & {
  __typename?: 'DeleteMutationResult';
  /** Number of instances deleted. This includes related models. */
  count: Scalars['Int']['output'];
  /** ID of the object being deleted; a random string if model has no UID. */
  id: Scalars['ID']['output'];
  /** UID of the object being deleted, if applicable. */
  uid?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryOrderBy {
  CreatedOn = 'CREATED_ON',
  Direction = 'DIRECTION',
}

export enum DepartmentOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
}

export enum DesignationOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
}

export enum DialogueEntryOrderBy {
  CreatedOn = 'CREATED_ON',
  UpdatedOn = 'UPDATED_ON',
}

/** An enumeration. */
export enum Direction {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING',
}

export enum DirectoryProfileOperationType {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE',
  ResendActivationEmail = 'RESEND_ACTIVATION_EMAIL',
}

export enum DirectoryProfileOrderBy {
  ActivateAfter = 'activateAfter',
  CreatedOn = 'createdOn',
  DeactivateAfter = 'deactivateAfter',
  DeactivatedOn = 'deactivatedOn',
  Department = 'department',
  Designation = 'designation',
  FirstName = 'firstName',
  LastName = 'lastName',
}

export enum DivisionOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
}

/** All Documents provided with this input will be updated per this set of (fixed) inputs */
export type DocumentBulkFixedInput = {
  /** Overwrite ACL for all documents. Empty list if no action */
  aclDnf?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Deactivate all documents. False if you want to reactivate, null or do not provide if no action */
  deactivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Department UID to transfer all documents to. */
  departmentUid?: InputMaybe<Scalars['String']['input']>;
  /** Trigger Jarvis sync */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sync status for this document */
  syncStatus?: InputMaybe<Scalars['String']['input']>;
};

/** All Documents to be updated are filtered using this set of inputs */
export type DocumentFilter = {
  /** Filter based on ACL fragments. */
  aclDnfOr?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on Data Source's key value */
  dataSource_Key_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on Data Source's module */
  dataSource_Modules_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on Data Source's UID */
  dataSource_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on document's deactivated on. */
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on Department Name. */
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on the document's MIME type */
  mimeType_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on documents not having department owner. */
  ownerDepartments_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on Owner Departments */
  ownerDepartments_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on documents not having division owner. */
  ownerDivisions_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on Owner Divisions */
  ownerDivisions_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Input search per the regular DocumentEntry GQL list endpoint. */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Sync Status */
  syncStatus?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Synced On time */
  syncedOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of UIDs to filter by. Use either this OR the other filters */
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentVariableInput = {
  /** Variable name. */
  name: Scalars['String']['input'];
  /** Variable value. */
  value: Scalars['String']['input'];
};

/** Object type for `EinsteinAdministrator`. */
export type EinsteinAdministrator = ScalpelNode & {
  __typename?: 'EinsteinAdministrator';
  /** `Super Admin` if no department, `Admin` if has department */
  accountType?: Maybe<Scalars['String']['output']>;
  /** Number of broadcasts belonging to this administrator */
  broadcastCount?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<EinsteinAdministrator>;
  /** Date/Time this object was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Administrator department. */
  department?: Maybe<HospitalDepartment>;
  /** Departments this admin is a department admin of. */
  departments?: Maybe<Array<HospitalDepartment>>;
  /** Administrator designation. */
  designation?: Maybe<HospitalDesignation>;
  /** Divisions this admin is a division admin of. */
  divisions?: Maybe<Array<HospitalDivision>>;
  /** Administrator first name. */
  firstName: Scalars['String']['output'];
  /** Administrator full name based on merging first and last name. */
  fullName: Scalars['String']['output'];
  /** Hospital this user belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `EinsteinAdministrator:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of identifiable informations such phone number, email */
  identifiableInformations: Array<GovernessIdentifiableInformation>;
  /** Administrator is active. */
  isActivated: Scalars['Boolean']['output'];
  /** Administrator is inactive. */
  isDeactivated: Scalars['Boolean']['output'];
  /** True if the admin is a super-admin. False for department admins, or other cases as to be defined. */
  isSuper: Scalars['Boolean']['output'];
  /** Administrator last name. */
  lastName: Scalars['String']['output'];
  /** Administrator profile picture. */
  picture: Scalars['FileFieldType']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this administrator was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

/** Perform bulk operation on Administrators. */
export type EinsteinAdministratorBulkOperation = {
  __typename?: 'EinsteinAdministratorBulkOperation';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of Administrators updated. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EinsteinAdministratorBulkOperationInput = {
  /** Administrator UIDs to operate on. */
  allUids: Array<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Op Type to perform. Can be `ACTIVATE` or `DEACTIVATE`. */
  opType: AdministratorOperationType;
};

export type EinsteinAdministratorConnection = {
  __typename?: 'EinsteinAdministratorConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinAdministratorEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type EinsteinAdministratorConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `EinsteinAdministrator` and its cursor. */
export type EinsteinAdministratorEdge = {
  __typename?: 'EinsteinAdministratorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinAdministrator>;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcast = ScalpelNode & {
  __typename?: 'EinsteinBroadcast';
  /** Administrator who created this broadcast. */
  createdBy: EinsteinAdministrator;
  /** Date/Time this broadcast was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Profile devices where the broadcast has been delivered to. */
  deliveredProfileDevices: HospitalProfileDeviceConnection;
  /** Profile devices where the broadcast has been delivered to. */
  deliveredProfiles: HospitalProfileConnection;
  /** Broadcast should only run before this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  endOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `EinsteinBroadcast:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Messages to be broadcasted. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. */
  messages?: Maybe<Scalars['GenericScalar']['output']>;
  /** List of messages but with all URLs resolved to publicly accessible secure ones (i.e., with expiry). */
  messagesWithSecureUrl: Array<Scalars['GenericScalar']['output']>;
  /** Broadcast name. */
  name: Scalars['String']['output'];
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** Recurring frequencies this broadcast is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. */
  recurringFrequencies?: Maybe<Scalars['GenericScalar']['output']>;
  /** The ruleset for this broadcast. */
  rulesets: Array<EinsteinProfilesGroupRuleset>;
  /** Date/Time this broadcast is scheduled to be sent. */
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  /** Broadcast should only run after this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  startOn?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the broadcast. */
  status: EinsteinBroadcastStatusChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** (DEPRECATED) ProfileDevices where the broadcast was delivered to. */
  undeliveredProfiles: HospitalProfileConnection;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcastDeliveredProfileDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcastDeliveredProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcastOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcastOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinBroadcast`. */
export type EinsteinBroadcastUndeliveredProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EinsteinBroadcastConnection = {
  __typename?: 'EinsteinBroadcastConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinBroadcastEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinBroadcast` and its cursor. */
export type EinsteinBroadcastEdge = {
  __typename?: 'EinsteinBroadcastEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinBroadcast>;
};

/** An enumeration. */
export enum EinsteinBroadcastStatusChoices {
  /** Cancelled ❌ */
  Cancelled = 'CANCELLED',
  /** Completed 🚀 */
  Completed = 'COMPLETED',
  /** Draft 🖊️ */
  Draft = 'DRAFT',
  /** Failed ☠️ */
  Failed = 'FAILED',
  /** In Progress 🏗️ */
  InProgress = 'IN_PROGRESS',
  /** Scheduled ⏳ */
  Scheduled = 'SCHEDULED',
  /** Sending ✉️ */
  Sending = 'SENDING',
}

/** An enumeration. */
export enum EinsteinBroadcastStatusForMutation {
  /** Cancelled ❌ */
  Cancelled = 'CANCELLED',
  /** Completed 🚀 */
  Completed = 'COMPLETED',
  /** Draft 🖊️ */
  Draft = 'DRAFT',
  /** Failed ☠️ */
  Failed = 'FAILED',
  /** In Progress 🏗️ */
  InProgress = 'IN_PROGRESS',
  /** Scheduled ⏳ */
  Scheduled = 'SCHEDULED',
  /** Sending ✉️ */
  Sending = 'SENDING',
}

/** Object type for `EinsteinChernobylEntry`. */
export type EinsteinChernobylEntry = ScalpelNode & {
  __typename?: 'EinsteinChernobylEntry';
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time this entry was created. */
  createdOn: Scalars['DateTime']['output'];
  /** The data source this entry is synced from. */
  dataSource: EinsteinDataSource;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `EinsteinChernobylEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the data source entry is active. */
  isActivated: Scalars['Boolean']['output'];
  /** Whether the data source entry is inactive. */
  isDeactivated: Scalars['Boolean']['output'];
  /** Jarvis ACL object for this data source. */
  jarvisAclForDataSource: Scalars['GenericScalar']['output'];
  /** Jarvis ACL object for this module. */
  jarvisAclForModule: Scalars['GenericScalar']['output'];
  /** Sync status of this entry. */
  syncStatus: DataSourceEntrySyncStatus;
  /** Date/Time the `data_source` synced this entry due to creation or changes (see deactivated_on for deletion time). `None` means this entry hasn't been synced yet. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Tags associated with this data source entry. This is used for access control by Jarvis. It will override `tags` in its parent data source. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this entry was modified. */
  updatedOn: Scalars['DateTime']['output'];
  /** Variables associated with this entry. */
  variables: Scalars['GenericScalar']['output'];
};

/** Object type for `EinsteinChernobylEntry`. */
export type EinsteinChernobylEntryJarvisAclForDataSourceArgs = {
  dataSourceUid: Scalars['String']['input'];
};

/** Object type for `EinsteinChernobylEntry`. */
export type EinsteinChernobylEntryJarvisAclForModuleArgs = {
  moduleUid: Scalars['String']['input'];
};

export type EinsteinChernobylEntryConnection = {
  __typename?: 'EinsteinChernobylEntryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinChernobylEntryEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Generate delayed Stitch link for downloading of exported CSV [DEPRECATE]. */
  exportedCsvUrl?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type EinsteinChernobylEntryConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `EinsteinChernobylEntry` and its cursor. */
export type EinsteinChernobylEntryEdge = {
  __typename?: 'EinsteinChernobylEntryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinChernobylEntry>;
};

/** Object type for `EinsteinDataSource`. */
export type EinsteinDataSource = ScalpelNode & {
  __typename?: 'EinsteinDataSource';
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Athena will set this to `synced_version` with it does a successful sync. */
  athenaSyncedVersion?: Maybe<Scalars['String']['output']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital associated with this data source. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `EinsteinDataSource:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the data source is active. */
  isActivated: Scalars['Boolean']['output'];
  /** Whether the data source is inactive. */
  isDeactivated: Scalars['Boolean']['output'];
  /** Jarvis ACL object for this module. */
  jarvisAclForModule: Scalars['GenericScalar']['output'];
  /** Unique key for this instantiable model. */
  key: Scalars['String']['output'];
  /** Data source settings that are available for frontend consumption. */
  nonSecretSettings: Scalars['GenericScalar']['output'];
  /** Human readable name of the data source import path. */
  providerName: Scalars['String']['output'];
  /** Human readable name of the data source import path. */
  providerSettingsKey: Scalars['String']['output'];
  /** Error message if the sync failed. */
  syncError: Scalars['String']['output'];
  /** Metadata of the sync. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. */
  syncMetadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Mode of the current sync. */
  syncMode?: Maybe<EinsteinDataSourceSyncModeChoices>;
  /** Date/Time the sync started. */
  syncStartedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the current sync. */
  syncStatus?: Maybe<EinsteinDataSourceSyncStatusChoices>;
  /** Date/Time the sync ended. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Version may be set to optimize Jarvis syncing (eg. use hash of ingestor content). */
  syncedVersion?: Maybe<Scalars['String']['output']>;
  /** Tags associated with this data source. This is used for access control by Jarvis. It will override `tags` in its parent module. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this data source was updated. */
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** Object type for `EinsteinDataSource`. */
export type EinsteinDataSourceJarvisAclForModuleArgs = {
  moduleUid: Scalars['String']['input'];
};

export type EinsteinDataSourceConnection = {
  __typename?: 'EinsteinDataSourceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinDataSourceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinDataSource` and its cursor. */
export type EinsteinDataSourceEdge = {
  __typename?: 'EinsteinDataSourceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinDataSource>;
};

/** This is a related model input type for `EinsteinDataSource`. */
export type EinsteinDataSourceRelatedModelInput = {
  /** Global ID for referencing `EinsteinDataSource`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `EinsteinDataSource`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum EinsteinDataSourceSyncModeChoices {
  /** Add */
  Add = 'ADD',
  /** Na */
  Na = 'NA',
  /** Sync */
  Sync = 'SYNC',
}

/** An enumeration. */
export enum EinsteinDataSourceSyncStatusChoices {
  /** Failed */
  Failed = 'FAILED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Na */
  Na = 'NA',
  /** Success */
  Success = 'SUCCESS',
}

/** DialogueEntry model. */
export type EinsteinDialogueEntry = ScalpelNode & {
  __typename?: 'EinsteinDialogueEntry';
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Administrator who created this dialogue. */
  createdBy?: Maybe<EinsteinAdministrator>;
  /** Date/Time this entry was created. */
  createdOn: Scalars['DateTime']['output'];
  /** The data source this entry is synced from. */
  dataSource: EinsteinDataSource;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `EinsteinDialogueEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Jarvis ACL object for this data source. */
  jarvisAclForDataSource: Scalars['GenericScalar']['output'];
  /** Jarvis ACL object for this module. */
  jarvisAclForModule: Scalars['GenericScalar']['output'];
  /** Messages that will be returned as a response. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. */
  messages?: Maybe<Scalars['GenericScalar']['output']>;
  /** List of messages but with all URLs resolved to publicly accessible secure ones. */
  messagesWithSecureUrl: Array<Scalars['GenericScalar']['output']>;
  /** Additional status field (eg. ignore used by jarvis for syncing) */
  status: Scalars['String']['output'];
  /** Date/Time the `data_source` synced this entry due to creation or changes (see deactivated_on for deletion time). `None` means this entry hasn't been synced yet. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Tags associated with this data source entry. This is used for access control by Jarvis. It will override `tags` in its parent data source. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** Title of this dialogue. */
  title: Scalars['String']['output'];
  /** Triggers for this dialogue. */
  triggers: EinsteinDialogueTriggerConnection;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this entry was modified. */
  updatedOn: Scalars['DateTime']['output'];
};

/** DialogueEntry model. */
export type EinsteinDialogueEntryJarvisAclForDataSourceArgs = {
  dataSourceUid: Scalars['String']['input'];
};

/** DialogueEntry model. */
export type EinsteinDialogueEntryJarvisAclForModuleArgs = {
  moduleUid: Scalars['String']['input'];
};

/** DialogueEntry model. */
export type EinsteinDialogueEntryTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EinsteinDialogueEntryConnection = {
  __typename?: 'EinsteinDialogueEntryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinDialogueEntryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinDialogueEntry` and its cursor. */
export type EinsteinDialogueEntryEdge = {
  __typename?: 'EinsteinDialogueEntryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinDialogueEntry>;
};

/** DialogueTrigger model. */
export type EinsteinDialogueTrigger = ScalpelNode & {
  __typename?: 'EinsteinDialogueTrigger';
  /** Array of entities that make up a trigger. It is validated against <a href="https://skeleton.staging.botmd.io/docs/eliza-dialoguetriggerentities-generated.html" target="_blank">eliza/DialogueTriggerEntities.schema</a>. */
  entities?: Maybe<Scalars['GenericScalar']['output']>;
  /** This is the global ID constructed from the base64 encoding of `EinsteinDialogueTrigger:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type EinsteinDialogueTriggerConnection = {
  __typename?: 'EinsteinDialogueTriggerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinDialogueTriggerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinDialogueTrigger` and its cursor. */
export type EinsteinDialogueTriggerEdge = {
  __typename?: 'EinsteinDialogueTriggerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinDialogueTrigger>;
};

/** Object type for `EinsteinDocumentEntry`. */
export type EinsteinDocumentEntry = ScalpelNode & {
  __typename?: 'EinsteinDocumentEntry';
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time this entry was created. */
  createdOn: Scalars['DateTime']['output'];
  /** The data source this entry is synced from. */
  dataSource: EinsteinDataSource;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Department that this DocumentEntry belongs to. */
  department?: Maybe<HospitalDepartment>;
  /** Title of entry inferred from `title`, `filename`, or `file_id`. */
  effectiveTitle: Scalars['String']['output'];
  /** An identifier which uniquely identifies this file in the source. */
  fileId: Scalars['String']['output'];
  /** The name/path of this file for display. Depending on the nature of the data source, this may be a hierarchical path. */
  filename: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `EinsteinDocumentEntry:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the data source entry is active. */
  isActivated: Scalars['Boolean']['output'];
  /** Whether the data source entry is inactive. */
  isDeactivated: Scalars['Boolean']['output'];
  /** Jarvis ACL object for this data source. */
  jarvisAclForDataSource: Scalars['GenericScalar']['output'];
  /** Jarvis ACL object for this module. */
  jarvisAclForModule: Scalars['GenericScalar']['output'];
  /** MIME type of this file. Defaults to `application/octet-stream` if unable to guess from `filename`. */
  mimeType: Scalars['String']['output'];
  /** The original file from the data source in any format. Used for archival purposes. */
  originalFile: Scalars['FileFieldType']['output'];
  /** Stitch URL to Original File file (if available). */
  originalFileStitchUrl?: Maybe<Scalars['String']['output']>;
  /** Storage URI to the original file (if available). */
  originalFileUri?: Maybe<Scalars['String']['output']>;
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** The original file converted to PDF format. */
  pdfFile: Scalars['FileFieldType']['output'];
  /** Stitch URL to PDF file (if available). */
  pdfFileStitchUrl?: Maybe<Scalars['String']['output']>;
  /** Storage URI to PDF file (if available). */
  pdfFileUri?: Maybe<Scalars['String']['output']>;
  /** Sync status of this entry. */
  syncStatus: DataSourceEntrySyncStatus;
  /** Date/Time the `data_source` synced this entry due to creation or changes (see deactivated_on for deletion time). `None` means this entry hasn't been synced yet. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Tags associated with this data source entry. This is used for access control by Jarvis. It will override `tags` in its parent data source. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** Title of this document. This is usually provided by the user (or automatically inferred). */
  title: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this entry was modified. */
  updatedOn: Scalars['DateTime']['output'];
  /** Variables associated with this entry. */
  variables: Scalars['GenericScalar']['output'];
  /** The URL to web version of the file on the data source if available. */
  webUrl: Scalars['String']['output'];
};

/** Object type for `EinsteinDocumentEntry`. */
export type EinsteinDocumentEntryJarvisAclForDataSourceArgs = {
  dataSourceUid: Scalars['String']['input'];
};

/** Object type for `EinsteinDocumentEntry`. */
export type EinsteinDocumentEntryJarvisAclForModuleArgs = {
  moduleUid: Scalars['String']['input'];
};

/** Object type for `EinsteinDocumentEntry`. */
export type EinsteinDocumentEntryOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinDocumentEntry`. */
export type EinsteinDocumentEntryOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Perform an update a set of documents filtered by the provided input filters */
export type EinsteinDocumentEntryBulkOperation = {
  __typename?: 'EinsteinDocumentEntryBulkOperation';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of Documents updated. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EinsteinDocumentEntryBulkOperationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input for Document Entry bulk update. Documents in this action will be updated per the provided input fields. */
  fields: DocumentBulkFixedInput;
  /** Filters for Document Entry bulk update. Documents to be updated are determined by the filters in this input. */
  filters?: InputMaybe<DocumentFilter>;
};

export type EinsteinDocumentEntryConnection = {
  __typename?: 'EinsteinDocumentEntryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinDocumentEntryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinDocumentEntry` and its cursor. */
export type EinsteinDocumentEntryEdge = {
  __typename?: 'EinsteinDocumentEntryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinDocumentEntry>;
};

/** Export User Chat Messages. */
export type EinsteinExportChatMessages = ScalpelNode & {
  __typename?: 'EinsteinExportChatMessages';
  /** URL to download the exported messages. */
  exportedCsvUrl: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type EinsteinExportChatMessagessConnection = {
  __typename?: 'EinsteinExportChatMessagessConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinExportChatMessagessEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinExportChatMessagess` and its cursor. */
export type EinsteinExportChatMessagessEdge = {
  __typename?: 'EinsteinExportChatMessagessEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinExportChatMessages>;
};

export enum EinsteinExportOutputFormat {
  Csv = 'CSV',
  Template = 'TEMPLATE',
  Xlsx = 'XLSX',
}

/** Does a full einstein module sync of data sources and jarvis sync. */
export type EinsteinJarvisSyncModule = {
  __typename?: 'EinsteinJarvisSyncModule';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Einstein Module UID scheduled for Jarvis sync. */
  moduleUid?: Maybe<Scalars['String']['output']>;
};

export type EinsteinJarvisSyncModuleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Einstein Module UID. */
  moduleUid: Scalars['String']['input'];
};

/** Logo of the hospital to use in the app. */
export type EinsteinLogo = ScalpelNode & {
  __typename?: 'EinsteinLogo';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** URL of the logo. */
  url: Scalars['String']['output'];
};

/** Object type for `EinsteinMetricSnapshot`. */
export type EinsteinMetricSnapshot = ScalpelNode & {
  __typename?: 'EinsteinMetricSnapshot';
  /** Represents the last second of the metric time window. */
  endOn: Scalars['DateTime']['output'];
  /** Hospital associated with this snapshot. */
  hospital: Hospital;
  /** `EinsteinMetricSnapshot` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Type of the snapshot (e.g. daily_querying, daily_active). */
  key: EinsteinMetricSnapshotKeyChoices;
  /** Represents the first second of the metric time window. */
  startOn: Scalars['DateTime']['output'];
  /** Value associated with this snapshot. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-metricsnapshotvalue-generated.html" target="_blank">einstein/MetricSnapshotValue.schema</a>. */
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

export type EinsteinMetricSnapshotConnection = {
  __typename?: 'EinsteinMetricSnapshotConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinMetricSnapshotEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type EinsteinMetricSnapshotConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `EinsteinMetricSnapshot` and its cursor. */
export type EinsteinMetricSnapshotEdge = {
  __typename?: 'EinsteinMetricSnapshotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinMetricSnapshot>;
};

/** An enumeration. */
export enum EinsteinMetricSnapshotKeyChoices {
  /** Daily Active */
  DailyActive = 'DAILY_ACTIVE',
  /** Daily Active By Department */
  DailyActiveByDepartment = 'DAILY_ACTIVE_BY_DEPARTMENT',
  /** Daily Active By Designation */
  DailyActiveByDesignation = 'DAILY_ACTIVE_BY_DESIGNATION',
  /** Daily Querying */
  DailyQuerying = 'DAILY_QUERYING',
  /** Daily Querying By Department */
  DailyQueryingDepartment = 'DAILY_QUERYING_DEPARTMENT',
  /** Daily Querying By Designation */
  DailyQueryingDesignation = 'DAILY_QUERYING_DESIGNATION',
  /** Daily Signed In */
  DailySignedIn = 'DAILY_SIGNED_IN',
  /** Daily Signed In By Department */
  DailySignedInDepartment = 'DAILY_SIGNED_IN_DEPARTMENT',
  /** Daily Signed In By Designation */
  DailySignedInDesignation = 'DAILY_SIGNED_IN_DESIGNATION',
  /** Total Daily Queries */
  DailyTotalQueries = 'DAILY_TOTAL_QUERIES',
  /** Total Daily Queries by Department */
  DailyTotalQueriesDepartment = 'DAILY_TOTAL_QUERIES_DEPARTMENT',
  /** Total Daily Queries by Designation */
  DailyTotalQueriesDesignation = 'DAILY_TOTAL_QUERIES_DESIGNATION',
  /** Active Users by Department (last 7 days) */
  Last_7DaysActiveDepartment = 'LAST_7_DAYS_ACTIVE_DEPARTMENT',
  /** Active Users by Designation (last 7 days) */
  Last_7DaysActiveDesignation = 'LAST_7_DAYS_ACTIVE_DESIGNATION',
  /** Documents Viewed Last 7 Days */
  Last_7DaysDocumentsViewed = 'LAST_7_DAYS_DOCUMENTS_VIEWED',
  /** Documents Viewed Last 7 Days by Department */
  Last_7DaysDocumentsViewedDepartment = 'LAST_7_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  /** Documents Viewed Last 7 Days by Designation */
  Last_7DaysDocumentsViewedDesignation = 'LAST_7_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  /** Querying Users by Department (last 7 days) */
  Last_7DaysQueryingDepartment = 'LAST_7_DAYS_QUERYING_DEPARTMENT',
  /** Querying Users by Designation (last 7 days) */
  Last_7DaysQueryingDesignation = 'LAST_7_DAYS_QUERYING_DESIGNATION',
  /** Query Content Type (last 7 days) */
  Last_7DaysQueryContentType = 'LAST_7_DAYS_QUERY_CONTENT_TYPE',
  /** Query Content Type By Department (last 7 days) */
  Last_7DaysQueryContentTypeDepartment = 'LAST_7_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  /** Query Content Type By Designation (last 7 days) */
  Last_7DaysQueryContentTypeDesignation = 'LAST_7_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  /** Signed in Users by Department (last 7 days) */
  Last_7DaysSignedInDepartment = 'LAST_7_DAYS_SIGNED_IN_DEPARTMENT',
  /** Signed in Users by Designation (last 7 days) */
  Last_7DaysSignedInDesignation = 'LAST_7_DAYS_SIGNED_IN_DESIGNATION',
  /** Active Users by Department (last 30 days) */
  Last_30DaysActiveDepartment = 'LAST_30_DAYS_ACTIVE_DEPARTMENT',
  /** Active Users by Designation (last 30 days) */
  Last_30DaysActiveDesignation = 'LAST_30_DAYS_ACTIVE_DESIGNATION',
  /** Documents Viewed Last 30 Days */
  Last_30DaysDocumentsViewed = 'LAST_30_DAYS_DOCUMENTS_VIEWED',
  /** Documents Viewed Last 30 Days by Department */
  Last_30DaysDocumentsViewedDepartment = 'LAST_30_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  /** Documents Viewed Last 30 Days by Designation */
  Last_30DaysDocumentsViewedDesignation = 'LAST_30_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  /** Querying Users by Department (last 30 days) */
  Last_30DaysQueryingDepartment = 'LAST_30_DAYS_QUERYING_DEPARTMENT',
  /** Querying Users by Designation (last 30 days) */
  Last_30DaysQueryingDesignation = 'LAST_30_DAYS_QUERYING_DESIGNATION',
  /** Query Content Type (last 30 days) */
  Last_30DaysQueryContentType = 'LAST_30_DAYS_QUERY_CONTENT_TYPE',
  /** Query Content Type By Department (last 30 days) */
  Last_30DaysQueryContentTypeDepartment = 'LAST_30_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  /** Query Content Type By Designation (last 30 days) */
  Last_30DaysQueryContentTypeDesignation = 'LAST_30_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  /** Signed in Users by Department (last 30 days) */
  Last_30DaysSignedInDepartment = 'LAST_30_DAYS_SIGNED_IN_DEPARTMENT',
  /** Signed in Users by Designation (last 30 days) */
  Last_30DaysSignedInDesignation = 'LAST_30_DAYS_SIGNED_IN_DESIGNATION',
  /** Active Users by Department (last 60 days) */
  Last_60DaysActiveDepartment = 'LAST_60_DAYS_ACTIVE_DEPARTMENT',
  /** Active Users by Designation (last 60 days) */
  Last_60DaysActiveDesignation = 'LAST_60_DAYS_ACTIVE_DESIGNATION',
  /** Documents Viewed Last 60 Days */
  Last_60DaysDocumentsViewed = 'LAST_60_DAYS_DOCUMENTS_VIEWED',
  /** Documents Viewed Last 60 Days by Department */
  Last_60DaysDocumentsViewedDepartment = 'LAST_60_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  /** Documents Viewed Last 60 Days by Designation */
  Last_60DaysDocumentsViewedDesignation = 'LAST_60_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  /** Querying Users by Department (last 60 days) */
  Last_60DaysQueryingDepartment = 'LAST_60_DAYS_QUERYING_DEPARTMENT',
  /** Querying Users by Designation (last 60 days) */
  Last_60DaysQueryingDesignation = 'LAST_60_DAYS_QUERYING_DESIGNATION',
  /** Query Content Type (last 60 days) */
  Last_60DaysQueryContentType = 'LAST_60_DAYS_QUERY_CONTENT_TYPE',
  /** Query Content Type By Department (last 60 days) */
  Last_60DaysQueryContentTypeDepartment = 'LAST_60_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  /** Query Content Type By Designation (last 60 days) */
  Last_60DaysQueryContentTypeDesignation = 'LAST_60_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  /** Signed in Users by Department (last 60 days) */
  Last_60DaysSignedInDepartment = 'LAST_60_DAYS_SIGNED_IN_DEPARTMENT',
  /** Signed in Users by Designation (last 60 days) */
  Last_60DaysSignedInDesignation = 'LAST_60_DAYS_SIGNED_IN_DESIGNATION',
  /** Active Users by Department (last 90 days) */
  Last_90DaysActiveDepartment = 'LAST_90_DAYS_ACTIVE_DEPARTMENT',
  /** Active Users by Designation (last 90 days) */
  Last_90DaysActiveDesignation = 'LAST_90_DAYS_ACTIVE_DESIGNATION',
  /** Documents Viewed Last 90 Days */
  Last_90DaysDocumentsViewed = 'LAST_90_DAYS_DOCUMENTS_VIEWED',
  /** Documents Viewed Last 90 Days by Department */
  Last_90DaysDocumentsViewedDepartment = 'LAST_90_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  /** Documents Viewed Last 90 Days by Designation */
  Last_90DaysDocumentsViewedDesignation = 'LAST_90_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  /** Querying Users by Department (last 90 days) */
  Last_90DaysQueryingDepartment = 'LAST_90_DAYS_QUERYING_DEPARTMENT',
  /** Querying Users by Designation (last 90 days) */
  Last_90DaysQueryingDesignation = 'LAST_90_DAYS_QUERYING_DESIGNATION',
  /** Query Content Type (last 90 days) */
  Last_90DaysQueryContentType = 'LAST_90_DAYS_QUERY_CONTENT_TYPE',
  /** Query Content Type By Department (last 90 days) */
  Last_90DaysQueryContentTypeDepartment = 'LAST_90_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  /** Query Content Type By Designation (last 90 days) */
  Last_90DaysQueryContentTypeDesignation = 'LAST_90_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  /** Signed in Users by Department (last 90 days) */
  Last_90DaysSignedInDepartment = 'LAST_90_DAYS_SIGNED_IN_DEPARTMENT',
  /** Signed in Users by Designation (last 90 days) */
  Last_90DaysSignedInDesignation = 'LAST_90_DAYS_SIGNED_IN_DESIGNATION',
  /** Active Users by Department (last 365 days) */
  Last_365DaysActiveDepartment = 'LAST_365_DAYS_ACTIVE_DEPARTMENT',
  /** Active Users by Designation (last 365 days) */
  Last_365DaysActiveDesignation = 'LAST_365_DAYS_ACTIVE_DESIGNATION',
  /** Documents Viewed Last 365 Days */
  Last_365DaysDocumentsViewed = 'LAST_365_DAYS_DOCUMENTS_VIEWED',
  /** Documents Viewed Last 365 Days by Department */
  Last_365DaysDocumentsViewedDepartment = 'LAST_365_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  /** Documents Viewed Last 365 Days by Designation */
  Last_365DaysDocumentsViewedDesignation = 'LAST_365_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  /** Querying Users by Department (last 365 days) */
  Last_365DaysQueryingDepartment = 'LAST_365_DAYS_QUERYING_DEPARTMENT',
  /** Querying Users by Designation (last 365 days) */
  Last_365DaysQueryingDesignation = 'LAST_365_DAYS_QUERYING_DESIGNATION',
  /** Query Content Type (last 365 days) */
  Last_365DaysQueryContentType = 'LAST_365_DAYS_QUERY_CONTENT_TYPE',
  /** Query Content Type By Department (last 365 days) */
  Last_365DaysQueryContentTypeDepartment = 'LAST_365_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  /** Query Content Type By Designation (last 365 days) */
  Last_365DaysQueryContentTypeDesignation = 'LAST_365_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  /** Signed in Users by Department (last 365 days) */
  Last_365DaysSignedInDepartment = 'LAST_365_DAYS_SIGNED_IN_DEPARTMENT',
  /** Signed in Users by Designation (last 365 days) */
  Last_365DaysSignedInDesignation = 'LAST_365_DAYS_SIGNED_IN_DESIGNATION',
  /** Weekly Active */
  WeeklyActive = 'WEEKLY_ACTIVE',
  /** Weekly Active By Department */
  WeeklyActiveByDepartment = 'WEEKLY_ACTIVE_BY_DEPARTMENT',
  /** Weekly Active By Designation */
  WeeklyActiveByDesignation = 'WEEKLY_ACTIVE_BY_DESIGNATION',
  /** Weekly Querying */
  WeeklyQuerying = 'WEEKLY_QUERYING',
  /** Weekly Querying By Department */
  WeeklyQueryingDepartment = 'WEEKLY_QUERYING_DEPARTMENT',
  /** Weekly Querying By Designation */
  WeeklyQueryingDesignation = 'WEEKLY_QUERYING_DESIGNATION',
  /** Weekly Signed In */
  WeeklySignedIn = 'WEEKLY_SIGNED_IN',
  /** Weekly Signed In By Department */
  WeeklySignedInDepartment = 'WEEKLY_SIGNED_IN_DEPARTMENT',
  /** Weekly Signed In By Designation */
  WeeklySignedInDesignation = 'WEEKLY_SIGNED_IN_DESIGNATION',
}

/** Object type for `EinsteinModule`. */
export type EinsteinModule = ScalpelNode & {
  __typename?: 'EinsteinModule';
  /** List of ACLs in DNF format (OR of ANDs) that applies to this module */
  aclDnf?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time this module was created. */
  createdOn: Scalars['DateTime']['output'];
  /** List of data sources associated with this module. */
  dataSources: Array<EinsteinDataSource>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital associated with this module. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `EinsteinModule:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Jarvis ACL object for this module. */
  jarvisAcl: Scalars['GenericScalar']['output'];
  /** The module name used for display. */
  name: Scalars['String']['output'];
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** All departments have access to this module */
  ownerDepartmentsAll: Scalars['Boolean']['output'];
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** All divisions have access to this module */
  ownerDivisionsAll: Scalars['Boolean']['output'];
  /** Settings associated with this module. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-modulesettings-generated.html" target="_blank">einstein/ModuleSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Tags associated with this module. This is used for access control by Jarvis. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this module was updated. */
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Flag indicating if this module should be viewable by default to Einstein admins. */
  visible: Scalars['Boolean']['output'];
};

/** Object type for `EinsteinModule`. */
export type EinsteinModuleOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinModule`. */
export type EinsteinModuleOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EinsteinModuleConnection = {
  __typename?: 'EinsteinModuleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinModuleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinModule` and its cursor. */
export type EinsteinModuleEdge = {
  __typename?: 'EinsteinModuleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinModule>;
};

/** Filter options for frontend when displaying directory profiles. */
export type EinsteinProfileFilterOptions = ScalpelNode & {
  __typename?: 'EinsteinProfileFilterOptions';
  /** List of departments for filtering. (DEPRECATED) */
  departments?: Maybe<Array<Scalars['String']['output']>>;
  /** List of designations for filtering. (DEPRECATED) */
  designations?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of profile status for filtering. (DEPRECATED) */
  profileStatuses?: Maybe<Array<Scalars['String']['output']>>;
};

/** Object type for `EinsteinProfilesGroup`. */
export type EinsteinProfilesGroup = ScalpelNode & {
  __typename?: 'EinsteinProfilesGroup';
  /** Administrator that created this group. */
  createdBy: EinsteinAdministrator;
  /** Date/Time this profile group was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Group description. */
  description: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `EinsteinProfilesGroup:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Group name. */
  name: Scalars['String']['output'];
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** The ruleset. */
  ruleset: EinsteinProfilesGroupRuleset;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this profile group was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

/** Object type for `EinsteinProfilesGroup`. */
export type EinsteinProfilesGroupOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinProfilesGroup`. */
export type EinsteinProfilesGroupOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EinsteinProfilesGroupConnection = {
  __typename?: 'EinsteinProfilesGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinProfilesGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinProfilesGroup` and its cursor. */
export type EinsteinProfilesGroupEdge = {
  __typename?: 'EinsteinProfilesGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinProfilesGroup>;
};

/** A convenience GQL wrapper type for the ruleset JSON object. */
export type EinsteinProfilesGroupRuleset = ScalpelNode & {
  __typename?: 'EinsteinProfilesGroupRuleset';
  /** All directory profiles that are part of this ruleset. Both active and inactive directory profiles are returned here. */
  allProfiles: HospitalDirectoryProfileConnection;
  /** Generate delayed Stitch link for downloading of exported CSV of directory profiles in this profiles group ruleset. */
  allProfilesCsvUrl: Scalars['String']['output'];
  /** Auto-generated description of this ruleset. */
  defaultDescription?: Maybe<Scalars['String']['output']>;
  /** Description of this ruleset. For `ProfilesGroup`, this will be the `description` on the `ProfilesGroup`. */
  description?: Maybe<Scalars['String']['output']>;
  /** List of directory profiles specified in this ruleset (via `directory_profile_uids`). */
  directoryProfiles: Array<HospitalDirectoryProfile>;
  /** Effective description of this ruleset (`description` or `default_description`). */
  effectiveDescription?: Maybe<Scalars['String']['output']>;
  /** Effective profiles that are part of this ruleset. Only active users with active devices are returned here. */
  effectiveProfiles: HospitalProfileConnection;
  /** Filters for dyanamic ruleset. */
  filters?: Maybe<Scalars['GenericScalar']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if this profiles are generated from this ruleset dynamically. */
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  /** Name of this ruleset. For `ProfilesGroup`, this will be the `name` of the `ProfilesGroup`. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of hospital profiles specified in this ruleset (via `profile_uids`). */
  profiles: Array<HospitalProfile>;
  /** Serialized ruleset as an JSON object (not string) suitable for using directly in Broadcast. */
  serialized: Scalars['GenericScalar']['output'];
  /** UID this ruleset is derived from. */
  uid?: Maybe<Scalars['String']['output']>;
};

/** A convenience GQL wrapper type for the ruleset JSON object. */
export type EinsteinProfilesGroupRulesetAllProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A convenience GQL wrapper type for the ruleset JSON object. */
export type EinsteinProfilesGroupRulesetEffectiveProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcast = ScalpelNode & {
  __typename?: 'EinsteinSentBroadcast';
  /** Administrator who created this broadcast. */
  createdBy: EinsteinAdministrator;
  /** Profile devices where the broadcast has been delivered to. */
  deliveredProfileDevices: HospitalProfileDeviceConnection;
  /** Profile devices where the broadcast has been delivered to. */
  deliveredProfiles: HospitalProfileConnection;
  /** This is the global ID constructed from the base64 encoding of `EinsteinSentBroadcast:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Messages to be broadcasted. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. */
  messages?: Maybe<Scalars['GenericScalar']['output']>;
  /** List of messages but with all URLs resolved to publicly accessible secure ones (i.e., with expiry). */
  messagesWithSecureUrl: Array<Scalars['GenericScalar']['output']>;
  /** Broadcast name. */
  name: Scalars['String']['output'];
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** The ruleset for this broadcast. */
  rulesets: Array<EinsteinProfilesGroupRuleset>;
  /** Broadcast which spawned this SentBroadcast instance. */
  sendingBroadcast: EinsteinBroadcastConnection;
  /** Date/Time this broadcast was sent. */
  sentOn: Scalars['DateTime']['output'];
  /** Status of the broadcast. */
  status: EinsteinSentBroadcastStatusChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Profile devices where the broadcast has not been delivered to. */
  undeliveredProfiles: HospitalProfileConnection;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastDeliveredProfileDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastDeliveredProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastSendingBroadcastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Object type for `EinsteinSentBroadcast`. */
export type EinsteinSentBroadcastUndeliveredProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EinsteinSentBroadcastConnection = {
  __typename?: 'EinsteinSentBroadcastConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinSentBroadcastEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinSentBroadcast` and its cursor. */
export type EinsteinSentBroadcastEdge = {
  __typename?: 'EinsteinSentBroadcastEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinSentBroadcast>;
};

/** An enumeration. */
export enum EinsteinSentBroadcastStatusChoices {
  /** Cancelled ❌ */
  Cancelled = 'CANCELLED',
  /** Completed 🚀 */
  Completed = 'COMPLETED',
  /** Failed ☠️ */
  Failed = 'FAILED',
  /** Ready👍 */
  Ready = 'READY',
  /** Sending ✉️ */
  Sending = 'SENDING',
}

/** Einstein settings for frontend to display. */
export type EinsteinSettings = ScalpelNode & {
  __typename?: 'EinsteinSettings';
  /** Admin Contact Fields required for this hospital. */
  adminContactFields?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Logo of the hospital to use in the app. */
  logo?: Maybe<EinsteinLogo>;
  /** Filter options for frontend when displaying Hospital profiles. (TO DEPRECATE?) */
  profileFilterOptions?: Maybe<EinsteinProfileFilterOptions>;
  /** User Contact Fields required for this hospital. */
  userContactFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Welcome menu to display to the user. */
  welcomeMessage?: Maybe<EinsteinWelcomeMessage>;
};

/** Update Einstein and Hospital related settings. */
export type EinsteinSettingsUpdate = {
  __typename?: 'EinsteinSettingsUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Einstein settings for frontend to display. */
  settings?: Maybe<EinsteinSettings>;
};

export type EinsteinSettingsUpdateInput = {
  /** Admin Contact Fields required for this hospital. */
  adminContactFields?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Logo of the hospital to use in the app. */
  logo?: InputMaybe<LogoInput>;
  /** User Contact Fields required for this hospital. */
  userContactFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Welcome menu to display to the user. */
  welcomeMessage?: InputMaybe<WelcomeMessageInput>;
};

/** Sync a tabular data to a chernobyl data source. */
export type EinsteinSyncChernobylDataSource = {
  __typename?: 'EinsteinSyncChernobylDataSource';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The DataSource Model */
  dataSource?: Maybe<EinsteinDataSource>;
};

export type EinsteinSyncChernobylDataSourceInput = {
  /** Excel sheet names to use for the data source. */
  activeSheets?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the Einstein Chernobyl DataSource to sync. */
  dataSourceUid: Scalars['String']['input'];
  /** Storage file ID of the data source excel file. */
  fileId: Scalars['String']['input'];
  /** Flag to preview changes instead of writing to database. */
  preview: Scalars['Boolean']['input'];
  /** Syncs Jarvis if True and preview is False. */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sync a user data source excel template file. */
export type EinsteinSyncExcelUserDataSource = {
  __typename?: 'EinsteinSyncExcelUserDataSource';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userDataSource?: Maybe<EinsteinUserDataSource>;
};

export type EinsteinSyncExcelUserDataSourceInput = {
  /** Excel sheet names to use for the user data source (ignored for `TEMPLATE`). */
  activeSheets?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Storage file ID of the user data source excel template file. */
  fileId: Scalars['String']['input'];
  /** Input file format, only supports `template` and `xlsx (defaults to xlsx)`. */
  inputFormat?: InputMaybe<EinsteinExportOutputFormat>;
  /** Flag to preview changes instead of writing to database. */
  preview: Scalars['Boolean']['input'];
  /** Mode of the sync (SYNC does CRUD, ADD only does create/update without delete). */
  syncMode: SyncMode;
};

/** Update `DataSourceEntry` related fields. */
export type EinsteinUpdateDataSourceEntry = {
  __typename?: 'EinsteinUpdateDataSourceEntry';
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: Maybe<Scalars['DateTime']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** UID of the DataSourceEntry. */
  dataSourceEntryUid?: Maybe<Scalars['String']['output']>;
  /** UIDs of the DataSourceEntries for bulk update. */
  dataSourceEntryUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Date/Time the `data_source` synced this entry due to creation or changes (see deactivated_on for deletion time). `None` means this entry hasn't been synced yet. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type EinsteinUpdateDataSourceEntryInput = {
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the DataSourceEntry. */
  dataSourceEntryUid?: InputMaybe<Scalars['String']['input']>;
  /** UIDs of the DataSourceEntries for bulk update. */
  dataSourceEntryUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Date/Time the `data_source` synced this entry due to creation or changes (see deactivated_on for deletion time). `None` means this entry hasn't been synced yet. */
  syncedOn?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Upload resources to an `EinsteinModule` private storage. */
export type EinsteinUploadModuleResource = {
  __typename?: 'EinsteinUploadModuleResource';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Stitch URL of the resouce in the module private storage. */
  url: Scalars['String']['output'];
};

export type EinsteinUploadModuleResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the file name in storage, uses a random name otherwise. This will overwrite any file with a similar name. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Specifies additional path for the file inside the parent (organization/module/file_path). */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** Einstein Module UID. */
  moduleUid: Scalars['String']['input'];
  /** Source URL of the resource to store in private storage. */
  sourceUrl: Scalars['String']['input'];
};

/** UserDataSource containing the status and metadata of the sync. */
export type EinsteinUserDataSource = ScalpelNode & {
  __typename?: 'EinsteinUserDataSource';
  /** Error message if the sync failed. */
  error: Scalars['String']['output'];
  /** Hospital associated with this sync status. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `EinsteinUserDataSource:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Unique key for this instantiable model. */
  key: Scalars['String']['output'];
  /** Metadata of the sync. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time the sync started. */
  startedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Mode of the current sync. */
  syncMode?: Maybe<EinsteinUserDataSourceSyncModeChoices>;
  /** Status of the current sync. */
  syncStatus?: Maybe<EinsteinUserDataSourceSyncStatusChoices>;
  /** Date/Time the sync ended. */
  syncedOn?: Maybe<Scalars['DateTime']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type EinsteinUserDataSourceConnection = {
  __typename?: 'EinsteinUserDataSourceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EinsteinUserDataSourceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `EinsteinUserDataSource` and its cursor. */
export type EinsteinUserDataSourceEdge = {
  __typename?: 'EinsteinUserDataSourceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EinsteinUserDataSource>;
};

/** An enumeration. */
export enum EinsteinUserDataSourceSyncModeChoices {
  /** Add */
  Add = 'ADD',
  /** Sync */
  Sync = 'SYNC',
}

/** An enumeration. */
export enum EinsteinUserDataSourceSyncStatusChoices {
  /** Failed */
  Failed = 'FAILED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Success */
  Success = 'SUCCESS',
}

/** Welcome menu to display to the user. */
export type EinsteinWelcomeMessage = ScalpelNode & {
  __typename?: 'EinsteinWelcomeMessage';
  /** Buttons of the welcome menu. */
  buttons?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Text of the welcome menu. */
  text?: Maybe<Scalars['String']['output']>;
};

export type EntityInput = {
  /** Determines if the phrases are required or optional. */
  isRequired: Scalars['Boolean']['input'];
  /** Array of phrases which are synonyms of each other. */
  phrases: Array<Scalars['String']['input']>;
};

export enum ExamOrderBy {
  Name = 'NAME',
  ProcedureCode = 'PROCEDURE_CODE',
}

export enum ExportOutputFormat {
  Csv = 'CSV',
  Html = 'HTML',
  MohCdmpExcel = 'MOH_CDMP_EXCEL',
  Pdf = 'PDF',
  Xlsx = 'XLSX',
}

export enum ExternalClinicalParameterValueType {
  Boolean = 'BOOLEAN',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  String = 'STRING',
}

/** Additional field */
export type FaradayAdditionalField = ScalpelNode & {
  __typename?: 'FaradayAdditionalField';
  /** Default value of field */
  default?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Key of the field. */
  key: Scalars['String']['output'];
  /** Name of field */
  name: Scalars['String']['output'];
  /** Type of field */
  type: Scalars['String']['output'];
};

/** Template for additional fields. */
export type FaradayAdditionalFieldTemplate = ScalpelNode & {
  __typename?: 'FaradayAdditionalFieldTemplate';
  /** Categories of additional fields */
  categories: Array<FaradayAditionalFieldCategory>;
  /** Description of tmemplate */
  description?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Key of the template. */
  key: Scalars['String']['output'];
  /** Name of the template. */
  name: Scalars['String']['output'];
};

/** Category for additional fields. */
export type FaradayAditionalFieldCategory = ScalpelNode & {
  __typename?: 'FaradayAditionalFieldCategory';
  /** Description of category */
  description?: Maybe<Scalars['String']['output']>;
  /** Additional fields */
  fields: Array<FaradayAdditionalField>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Key of the category. */
  key: Scalars['String']['output'];
  /** Name of category */
  name: Scalars['String']['output'];
};

/** Object type for `FaradayAdminDoctorRelationship`. */
export type FaradayAdminDoctorRelationship = ScalpelNode & {
  __typename?: 'FaradayAdminDoctorRelationship';
  /** Staff associated with the doctor. */
  admin: FaradayStaffProfile;
  /** Doctor associated with the staff. */
  doctor: FaradayStaffProfile;
  /** `FaradayAdminDoctorRelationship` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaradayAdminDoctorRelationshipConnection = {
  __typename?: 'FaradayAdminDoctorRelationshipConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayAdminDoctorRelationshipEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayAdminDoctorRelationship` and its cursor. */
export type FaradayAdminDoctorRelationshipEdge = {
  __typename?: 'FaradayAdminDoctorRelationshipEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayAdminDoctorRelationship>;
};

/** Set admin-doctor relationships in one go. */
export type FaradayAdminDoctorRelationshipsUpdate = {
  __typename?: 'FaradayAdminDoctorRelationshipsUpdate';
  /** Admin doctor relationships being updated */
  adminDoctorRelationships: Array<FaradayAdminDoctorRelationship>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type FaradayAdminDoctorRelationshipsUpdateInput = {
  /** Admin UID. */
  adminUid: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs */
  doctorUids: Array<Scalars['String']['input']>;
};

/** Available slots for booking. */
export type FaradayAvailability = ScalpelNode & {
  __typename?: 'FaradayAvailability';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Results of available slots for booking. */
  results?: Maybe<Array<FaradayAvailabilityResult>>;
};

/** Asynchronously retrieve available slots for booking. */
export type FaradayAvailabilityAsync = ScalpelNode & {
  __typename?: 'FaradayAvailabilityAsync';
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Results of available slots for booking. */
  results?: Maybe<Array<FaradayAvailabilityResult>>;
};

/** Results of available slots for booking. */
export type FaradayAvailabilityResult = ScalpelNode & {
  __typename?: 'FaradayAvailabilityResult';
  /** Exam details. */
  exam: FaradayExam;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Room that can conduct the exam. */
  room: FaradayRoom;
  /** Slots for booking */
  slots?: Maybe<Array<FaradayAvailabilitySlot>>;
};

/** Available slot for booking. */
export type FaradayAvailabilitySlot = ScalpelNode & {
  __typename?: 'FaradayAvailabilitySlot';
  /** Date of the slot */
  date: Scalars['Date']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Time available for booking in format (start_time, end_time) */
  times: Array<Maybe<Array<Scalars['String']['output']>>>;
};

/** Bulk create staff profiles. */
export type FaradayBulkCreateStaffProfile = {
  __typename?: 'FaradayBulkCreateStaffProfile';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of status for staff creation */
  creationStatus: Array<FaradayStaffProfileCreationStatus>;
  /** Number of profiles that have error. */
  errorCount: Scalars['Int']['output'];
  /** Status of creation */
  status: CreationStatus;
  /** Number of profiles created. */
  totalCount: Scalars['Int']['output'];
};

export type FaradayBulkCreateStaffProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of staff profile inputs. */
  staffProfiles: Array<StaffProfileInput>;
};

/** Catalogues for Parkway Hospital. */
export type FaradayCatalogue = ScalpelNode & {
  __typename?: 'FaradayCatalogue';
  /** Catalogue entry for Parkway Hospital */
  document: EinsteinDocumentEntry;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaradayCataloguesConnection = {
  __typename?: 'FaradayCataloguesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayCataloguesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayCatalogues` and its cursor. */
export type FaradayCataloguesEdge = {
  __typename?: 'FaradayCataloguesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayCatalogue>;
};

/** Object type for `FaradayClinic`. */
export type FaradayClinic = ScalpelNode & {
  __typename?: 'FaradayClinic';
  /** Clinic address */
  address: Scalars['String']['output'];
  /** Clinic domain/sub-domain */
  domain: Scalars['String']['output'];
  /** Unique code for clinic */
  hciCode: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayClinic:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Clinic name */
  name: Scalars['String']['output'];
  /** Clinic phone number */
  phone: Scalars['String']['output'];
  /** Staffs belong to this clinic. */
  staffs: Array<FaradayStaffProfile>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayClinicConnection = {
  __typename?: 'FaradayClinicConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayClinicEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayClinic` and its cursor. */
export type FaradayClinicEdge = {
  __typename?: 'FaradayClinicEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayClinic>;
};

/** Object type for `FaradayExam`. */
export type FaradayExam = ScalpelNode & {
  __typename?: 'FaradayExam';
  /** Additional field templates for this exam */
  additionalFieldTemplates?: Maybe<Array<FaradayAdditionalFieldTemplate>>;
  /** Disclaimer messages for this exam */
  disclaimerMessages?: Maybe<Array<Scalars['String']['output']>>;
  /** Duration of the exam (in seconds). */
  duration: Scalars['Int']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayExam:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this exam retired? (Retired exams are not available for new bookings) */
  isRetired: Scalars['Boolean']['output'];
  /** Exam metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-exammetadata-generated.html" target="_blank">faraday/ExamMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Modality of exam */
  modality: FaradayModality;
  /** Procedure of exam. */
  name: Scalars['String']['output'];
  /** Procedure code of exam. */
  procedureCode: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Exam that is available for booking. */
export type FaradayExamAvailability = ScalpelNode & {
  __typename?: 'FaradayExamAvailability';
  /** Exam details. */
  exam: FaradayExam;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaradayExamConnection = {
  __typename?: 'FaradayExamConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayExamEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayExam` and its cursor. */
export type FaradayExamEdge = {
  __typename?: 'FaradayExamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayExam>;
};

/** This is a related model input type for `FaradayExam`. */
export type FaradayExamRelatedModelInput = {
  /** Global ID for referencing `FaradayExam`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `FaradayExam`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `FaradayFacility`. */
export type FaradayFacility = ScalpelNode & {
  __typename?: 'FaradayFacility';
  /** Disclaimer messages for this facility */
  disclaimerMessages?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the global ID constructed from the base64 encoding of `FaradayFacility:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Facility metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-facilitymetadata-generated.html" target="_blank">faraday/FacilityMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Facility Name */
  name: Scalars['String']['output'];
  /** Rooms belong to this facility. */
  rooms: Array<FaradayRoom>;
  /** Facility code in parkway database AKA external id. */
  shortCode: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Facility that is capable of conducting list of exams. */
export type FaradayFacilityAvailability = ScalpelNode & {
  __typename?: 'FaradayFacilityAvailability';
  /** Exams that is conductable in facility. */
  exams: Array<FaradayExam>;
  /** Facility details. */
  facility: FaradayFacility;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaradayFacilityConnection = {
  __typename?: 'FaradayFacilityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayFacilityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayFacility` and its cursor. */
export type FaradayFacilityEdge = {
  __typename?: 'FaradayFacilityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayFacility>;
};

/** Object type for `FaradayMessageTemplate`. */
export type FaradayMessageTemplate = ScalpelNode & {
  __typename?: 'FaradayMessageTemplate';
  /** This is the global ID constructed from the base64 encoding of `FaradayMessageTemplate:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Descriptive name of this message template set. Should be unique within the clinic. */
  name: Scalars['String']['output'];
  /** The message template to use for delivery. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. */
  template?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** List of variables that a user can specify on the frontend. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-messagetemplateuservariables-generated.html" target="_blank">faraday/MessageTemplateUserVariables.schema</a>. */
  userVariables?: Maybe<Scalars['GenericScalar']['output']>;
};

export type FaradayMessageTemplateConnection = {
  __typename?: 'FaradayMessageTemplateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayMessageTemplateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Deliver message template to patients. */
export type FaradayMessageTemplateDeliverToPatient = {
  __typename?: 'FaradayMessageTemplateDeliverToPatient';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results for message template deliveries. */
  results: Array<FaradayMessageTemplateDeliveryResult>;
};

export type FaradayMessageTemplateDeliverToPatientInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message template UID. */
  messageTemplateUid: Scalars['String']['input'];
  /** Order UID. */
  orderUid: Scalars['String']['input'];
  /** Patient profile UID. */
  patientProfileUid: Scalars['String']['input'];
  /** List of user variables. */
  userVariables?: InputMaybe<Array<FaradayUserVariableInput>>;
};

/** Result of message template delivery */
export type FaradayMessageTemplateDeliveryResult = ScalpelNode & {
  __typename?: 'FaradayMessageTemplateDeliveryResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** If deliveries were created, this will be `true`. Note that a `true` value does not guarantee that the messages were actually received by the patient. */
  isDelivered: Scalars['Boolean']['output'];
  /** Message template that was delivered. If `null`, a message template was't used or it wasn't found. */
  messageTemplate?: Maybe<FaradayMessageTemplate>;
  /** Patient the message template was delivered to. */
  patientProfile: FaradayPatientProfile;
};

/** A Relay edge containing a `FaradayMessageTemplate` and its cursor. */
export type FaradayMessageTemplateEdge = {
  __typename?: 'FaradayMessageTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayMessageTemplate>;
};

/** Object type for `FaradayModality`. */
export type FaradayModality = ScalpelNode & {
  __typename?: 'FaradayModality';
  /** This is the global ID constructed from the base64 encoding of `FaradayModality:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of modality */
  name: Scalars['String']['output'];
  /** Short name of modality */
  shortName: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayModalityConnection = {
  __typename?: 'FaradayModalityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayModalityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayModality` and its cursor. */
export type FaradayModalityEdge = {
  __typename?: 'FaradayModalityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayModality>;
};

/** Object type for `FaradayOrder`. */
export type FaradayOrder = ScalpelNode & {
  __typename?: 'FaradayOrder';
  /** Staff who create this order. */
  createdBy: FaradayStaffProfile;
  /** Doctor who own this order. */
  createdFor: FaradayStaffProfile;
  /** Order creation time. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayOrder:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this order exam is editable. */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Latest order pdf generated for this order */
  lastPdfForm?: Maybe<FaradayOrderPdf>;
  /** Order detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Exams belong to this order. */
  orderExams: Array<FaradayOrderExam>;
  /** Patient profile */
  patient: FaradayPatientProfile;
  /** PDFs generated for this order. */
  pdfForms: Array<FaradayOrderPdf>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Order modification time. */
  updatedOn: Scalars['DateTime']['output'];
};

export type FaradayOrderConnection = {
  __typename?: 'FaradayOrderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayOrderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Object type for `FaradayOrderDraft`. */
export type FaradayOrderDraft = ScalpelNode & {
  __typename?: 'FaradayOrderDraft';
  /** Staff Profile. */
  createdBy: FaradayStaffProfile;
  /** Draft creation time. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Draft detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. */
  draft?: Maybe<Scalars['GenericScalar']['output']>;
  /** This is the global ID constructed from the base64 encoding of `FaradayOrderDraft:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Draft modification time. */
  updatedOn: Scalars['DateTime']['output'];
};

export type FaradayOrderDraftConnection = {
  __typename?: 'FaradayOrderDraftConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayOrderDraftEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayOrderDraft` and its cursor. */
export type FaradayOrderDraftEdge = {
  __typename?: 'FaradayOrderDraftEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayOrderDraft>;
};

/** A Relay edge containing a `FaradayOrder` and its cursor. */
export type FaradayOrderEdge = {
  __typename?: 'FaradayOrderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayOrder>;
};

/** Exam within order */
export type FaradayOrderExam = ScalpelNode & {
  __typename?: 'FaradayOrderExam';
  /** Accession number of order exam. */
  accessionNo: Scalars['String']['output'];
  /** Order creation time. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Duration of the OrderExam (in seconds). */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Error message for the order exam. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Log for this order exam */
  eventLogs?: Maybe<Array<FaradayOrderExamLog>>;
  /** Exam of this order. */
  exam: FaradayExam;
  /** This is the global ID constructed from the base64 encoding of `FaradayOrderExam:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Datetime image was ready on. */
  imageReadyOn?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this order exam is editable. */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Last event log of this order exam */
  lastEventLog?: Maybe<FaradayOrderExamLog>;
  /** The last datetime of the reminder that was sent for this exam order. */
  lastRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  /** exam comments, attention radiologist etc. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Order detailed info */
  order: FaradayOrder;
  /** Datetime report was ready on. */
  reportReadyOn?: Maybe<Scalars['DateTime']['output']>;
  /** Room of this order. */
  room: FaradayRoom;
  /** Time this exam order is scheduled for. */
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  /** Status of exam in order. */
  status: FaradayOrderExamStatusChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Order modification time. */
  updatedOn: Scalars['DateTime']['output'];
  /** Vue Motion URL */
  vueMotionUrl?: Maybe<Scalars['String']['output']>;
};

export type FaradayOrderExamConnection = {
  __typename?: 'FaradayOrderExamConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayOrderExamEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayOrderExam` and its cursor. */
export type FaradayOrderExamEdge = {
  __typename?: 'FaradayOrderExamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayOrderExam>;
};

/** Object type for `FaradayOrderExamLog`. */
export type FaradayOrderExamLog = ScalpelNode & {
  __typename?: 'FaradayOrderExamLog';
  /** `FaradayOrderExamLog` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this action is performed by BotMD. */
  isBotmd: Scalars['Boolean']['output'];
  /** Whether this action is performed by BotMD. */
  isPhilips: Scalars['Boolean']['output'];
  /** metadata for event log. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-orderexamlog-generated.html" target="_blank">faraday/OrderExamLog.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Event log of this order. */
  order?: Maybe<FaradayOrder>;
  /** Event log of this order exam. */
  orderExam?: Maybe<FaradayOrderExam>;
  /** Time this exam order exam is scheduled for. */
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  /** Staff that updated the status. */
  staffProfile?: Maybe<FaradayStaffProfile>;
  /** The status of the instance. */
  status: FaradayOrderExamLogStatusChoices;
  /** Date/Time the instance status was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum FaradayOrderExamLogStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Error */
  Error = 'ERROR',
  /** Error cancel */
  ErrorCancel = 'ERROR_CANCEL',
  /** Error reschedule */
  ErrorReschedule = 'ERROR_RESCHEDULE',
  /** Error schedule */
  ErrorSchedule = 'ERROR_SCHEDULE',
  /** Image ready */
  ImageReady = 'IMAGE_READY',
  /** Modified */
  Modified = 'MODIFIED',
  /** Notified Patient */
  NotifiedPatient = 'NOTIFIED_PATIENT',
  /** Notified Staff */
  NotifiedStaff = 'NOTIFIED_STAFF',
  /** Order Pdf Uploaded */
  OrderPdfUploaded = 'ORDER_PDF_UPLOADED',
  /** Order Pdf Upload error */
  OrderPdfUploadError = 'ORDER_PDF_UPLOAD_ERROR',
  /** Pending cancel */
  PendingCancel = 'PENDING_CANCEL',
  /** Pending reschedule */
  PendingReschedule = 'PENDING_RESCHEDULE',
  /** Pending schedule */
  PendingSchedule = 'PENDING_SCHEDULE',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Report ready */
  ReportReady = 'REPORT_READY',
  /** Rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** RIS cancelled */
  RisCancelled = 'RIS_CANCELLED',
  /** RIS Modified */
  RisModified = 'RIS_MODIFIED',
  /** RIS rescheduled */
  RisRescheduled = 'RIS_RESCHEDULED',
  /** RIS scheduled */
  RisScheduled = 'RIS_SCHEDULED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
}

/** An enumeration. */
export enum FaradayOrderExamStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Error */
  Error = 'ERROR',
  /** Error cancel */
  ErrorCancel = 'ERROR_CANCEL',
  /** Error reschedule */
  ErrorReschedule = 'ERROR_RESCHEDULE',
  /** Error schedule */
  ErrorSchedule = 'ERROR_SCHEDULE',
  /** Image ready */
  ImageReady = 'IMAGE_READY',
  /** Modified */
  Modified = 'MODIFIED',
  /** Notified Patient */
  NotifiedPatient = 'NOTIFIED_PATIENT',
  /** Notified Staff */
  NotifiedStaff = 'NOTIFIED_STAFF',
  /** Order Pdf Uploaded */
  OrderPdfUploaded = 'ORDER_PDF_UPLOADED',
  /** Order Pdf Upload error */
  OrderPdfUploadError = 'ORDER_PDF_UPLOAD_ERROR',
  /** Pending cancel */
  PendingCancel = 'PENDING_CANCEL',
  /** Pending reschedule */
  PendingReschedule = 'PENDING_RESCHEDULE',
  /** Pending schedule */
  PendingSchedule = 'PENDING_SCHEDULE',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Report ready */
  ReportReady = 'REPORT_READY',
  /** Rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** RIS cancelled */
  RisCancelled = 'RIS_CANCELLED',
  /** RIS Modified */
  RisModified = 'RIS_MODIFIED',
  /** RIS rescheduled */
  RisRescheduled = 'RIS_RESCHEDULED',
  /** RIS scheduled */
  RisScheduled = 'RIS_SCHEDULED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
}

/** Object type for `FaradayOrderPDF`. */
export type FaradayOrderPdf = ScalpelNode & {
  __typename?: 'FaradayOrderPDF';
  /** Staff who create the pdf. */
  createdBy: FaradayStaffProfile;
  /** Order creation time. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayOrderPDF:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Order which generate the PDF form */
  order: FaradayOrder;
  /** Path to PDF order form. */
  pdfForm: Scalars['FileFieldType']['output'];
  /** Path to PDF masked order form. */
  pdfFormMasked: Scalars['FileFieldType']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayOrderPdfConnection = {
  __typename?: 'FaradayOrderPDFConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayOrderPdfEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayOrderPDF` and its cursor. */
export type FaradayOrderPdfEdge = {
  __typename?: 'FaradayOrderPDFEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayOrderPdf>;
};

/** This is a related model input type for `FaradayOrder`. */
export type FaradayOrderRelatedModelInput = {
  /** Global ID for referencing `FaradayOrder`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `FaradayOrder`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `FaradayParkwayOrder`. */
export type FaradayParkwayOrder = ScalpelNode & {
  __typename?: 'FaradayParkwayOrder';
  /** Accession number of order. */
  accessionNo: Scalars['String']['output'];
  /** Exam of order. */
  exam: Scalars['String']['output'];
  /** Facility of this order. */
  facility?: Maybe<FaradayFacility>;
  /** This is the global ID constructed from the base64 encoding of `FaradayParkwayOrder:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Modality of this order. */
  modality: FaradayModality;
  /** Patient's first name. */
  patientFirstName: Scalars['String']['output'];
  /** Full name of the user */
  patientFullName: Scalars['String']['output'];
  /** Patient's last name. */
  patientLastName: Scalars['String']['output'];
  /** Patient's mrn no. */
  patientMrnNo: Scalars['String']['output'];
  /** Procedure code of order. */
  procedureCode: Scalars['String']['output'];
  /** Referring doctor of this order. */
  referringDoctor?: Maybe<FaradayParkwayStaff>;
  /** Room of order. */
  room: Scalars['String']['output'];
  /** Time this order is scheduled for. */
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  /** Status of exam in order. */
  status: FaradayParkwayOrderStatusChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Vue Motion URL */
  vueMotionUrl?: Maybe<Scalars['String']['output']>;
};

export type FaradayParkwayOrderConnection = {
  __typename?: 'FaradayParkwayOrderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayParkwayOrderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayParkwayOrder` and its cursor. */
export type FaradayParkwayOrderEdge = {
  __typename?: 'FaradayParkwayOrderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayParkwayOrder>;
};

/** An enumeration. */
export enum FaradayParkwayOrderStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Error */
  Error = 'ERROR',
  /** Error cancel */
  ErrorCancel = 'ERROR_CANCEL',
  /** Error reschedule */
  ErrorReschedule = 'ERROR_RESCHEDULE',
  /** Error schedule */
  ErrorSchedule = 'ERROR_SCHEDULE',
  /** Image ready */
  ImageReady = 'IMAGE_READY',
  /** Modified */
  Modified = 'MODIFIED',
  /** Notified Patient */
  NotifiedPatient = 'NOTIFIED_PATIENT',
  /** Notified Staff */
  NotifiedStaff = 'NOTIFIED_STAFF',
  /** Order Pdf Uploaded */
  OrderPdfUploaded = 'ORDER_PDF_UPLOADED',
  /** Order Pdf Upload error */
  OrderPdfUploadError = 'ORDER_PDF_UPLOAD_ERROR',
  /** Pending cancel */
  PendingCancel = 'PENDING_CANCEL',
  /** Pending reschedule */
  PendingReschedule = 'PENDING_RESCHEDULE',
  /** Pending schedule */
  PendingSchedule = 'PENDING_SCHEDULE',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Report ready */
  ReportReady = 'REPORT_READY',
  /** Rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** RIS cancelled */
  RisCancelled = 'RIS_CANCELLED',
  /** RIS Modified */
  RisModified = 'RIS_MODIFIED',
  /** RIS rescheduled */
  RisRescheduled = 'RIS_RESCHEDULED',
  /** RIS scheduled */
  RisScheduled = 'RIS_SCHEDULED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
}

/** Object type for `FaradayParkwayStaff`. */
export type FaradayParkwayStaff = ScalpelNode & {
  __typename?: 'FaradayParkwayStaff';
  /** Parkway patient first name. */
  firstName: Scalars['String']['output'];
  /** Full name of the user */
  fullName: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayParkwayStaff:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Parkway patient last name. */
  lastName: Scalars['String']['output'];
  /** Doctor MCR */
  mcrNo: Scalars['String']['output'];
  /** Parkway Staff metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-parkwaystaffmetadata-generated.html" target="_blank">faraday/ParkwayStaffMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Physician ID */
  physicianId: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayParkwayStaffConnection = {
  __typename?: 'FaradayParkwayStaffConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayParkwayStaffEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayParkwayStaff` and its cursor. */
export type FaradayParkwayStaffEdge = {
  __typename?: 'FaradayParkwayStaffEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayParkwayStaff>;
};

/** Update patient doctor relationships. */
export type FaradayPatientDoctorRelationshipsUpdate = {
  __typename?: 'FaradayPatientDoctorRelationshipsUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated patient profile */
  patient: FaradayPatientProfile;
};

export type FaradayPatientDoctorRelationshipsUpdateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs */
  doctorUids: Array<Scalars['String']['input']>;
  /** Patient UID. */
  patientUid: Scalars['String']['input'];
};

/** Object type for `FaradayPatientProfile`. */
export type FaradayPatientProfile = ScalpelNode & {
  __typename?: 'FaradayPatientProfile';
  /** Clinic which this patient belongs to. */
  clinic: FaradayClinic;
  /** Comments on this patient. */
  comments: Scalars['String']['output'];
  /** Patient date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Doctors in-charge for the patient. */
  doctors: Array<FaradayStaffProfile>;
  /** Encrypted and HMAC email for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: Maybe<Scalars['String']['output']>;
  /** User's first name. */
  firstName: Scalars['String']['output'];
  /** Full name of this patient. */
  fullName: Scalars['String']['output'];
  /** Gender of patient. */
  gender?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `FaradayPatientProfile:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this patient claustrophobic? */
  isClaustrophobic: Scalars['Boolean']['output'];
  /** User's last name. */
  lastName: Scalars['String']['output'];
  /** Last order of patient. */
  lastOrder?: Maybe<FaradayOrder>;
  /** Patient metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-patientmetadata-generated.html" target="_blank">faraday/PatientMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Patient MRN in Parkway UCMI. */
  mrnNo: Scalars['String']['output'];
  /** Encrypted patient national ID (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  nationalId: Scalars['String']['output'];
  /** Nationality of this patient. */
  nationality?: Maybe<Scalars['String']['output']>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: Maybe<Scalars['String']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayPatientProfileConnection = {
  __typename?: 'FaradayPatientProfileConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayPatientProfileEdge>>;
  /** Generate delayed Stitch link for download or for email of document as a password protected Zip attachment. */
  export?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type FaradayPatientProfileConnectionExportArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

/** A Relay edge containing a `FaradayPatientProfile` and its cursor. */
export type FaradayPatientProfileEdge = {
  __typename?: 'FaradayPatientProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayPatientProfile>;
};

/** An enumeration. */
export enum FaradayPatientProfileGenderForMutation {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M',
}

/** Price lists for Parkway Hospital. */
export type FaradayPriceList = ScalpelNode & {
  __typename?: 'FaradayPriceList';
  /** Price list for Parkway Hospital */
  entry: EinsteinChernobylEntry;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaradayPriceListsConnection = {
  __typename?: 'FaradayPriceListsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayPriceListsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayPriceLists` and its cursor. */
export type FaradayPriceListsEdge = {
  __typename?: 'FaradayPriceListsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayPriceList>;
};

/** Register a `Device` to an existing `StaffProfile`. */
export type FaradayRegisterDevice = {
  __typename?: 'FaradayRegisterDevice';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Ratatoskr device created/obtained for this StaffProfile. */
  device?: Maybe<RatatoskrDevice>;
  /** The StaffProfile registered. */
  staffProfile?: Maybe<FaradayStaffProfile>;
};

export type FaradayRegisterDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device metadata to supplement the provider metadata. It will be validated against [`ratatoskr/DeviceMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  deviceMetadata?: InputMaybe<Scalars['RatatoskrDeviceMetadataSkeletonJSON']['input']>;
  /** Ratatoskr Provider Application UID to register this device under. */
  providerApplication: Scalars['String']['input'];
  /** Register/Create a Pusher device to the `StaffProfile`. */
  pusher: StaffDevicePusherInput;
};

/** Object type for `FaradayRoom`. */
export type FaradayRoom = ScalpelNode & {
  __typename?: 'FaradayRoom';
  /** AE title of the room. */
  aeTitle: Scalars['String']['output'];
  /** Exams belong to this room */
  exams: Array<FaradayExam>;
  /** Room facility id */
  facility: FaradayFacility;
  /** This is the global ID constructed from the base64 encoding of `FaradayRoom:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Room metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-roommetadata-generated.html" target="_blank">faraday/RoomMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Modality Id */
  modality: FaradayModality;
  /** Name of room. */
  name: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayRoomConnection = {
  __typename?: 'FaradayRoomConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayRoomEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayRoom` and its cursor. */
export type FaradayRoomEdge = {
  __typename?: 'FaradayRoomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayRoom>;
};

/** This is a related model input type for `FaradayRoom`. */
export type FaradayRoomRelatedModelInput = {
  /** Global ID for referencing `FaradayRoom`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `FaradayRoom`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `FaradayStaffFavoriteExam`. */
export type FaradayStaffFavoriteExam = ScalpelNode & {
  __typename?: 'FaradayStaffFavoriteExam';
  /** Exam ID */
  exam: FaradayExam;
  /** `FaradayStaffFavoriteExam` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Staff profile ID */
  staff: FaradayStaffProfile;
};

/** Favorite an exam for staff. */
export type FaradayStaffFavoriteExamsUpdate = {
  __typename?: 'FaradayStaffFavoriteExamsUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Exams that are favorited by staff. */
  favoriteExams: Array<FaradayStaffFavoriteExam>;
};

export type FaradayStaffFavoriteExamsUpdateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of exam UIDs */
  examUids: Array<Scalars['String']['input']>;
};

/**
 * A model for storing data of users, maps to `USER` table in parkway database.
 *     The data is not mapped one to one with the parkway database.
 */
export type FaradayStaffProfile = ScalpelNode & {
  __typename?: 'FaradayStaffProfile';
  /** Account type of the staff */
  accountType: FaradayStaffProfileAccountTypeChoices;
  /** Staff's admin doctor relationships */
  adminDoctorRelationships: Array<FaradayAdminDoctorRelationship>;
  /** Clinic which this staff belongs to. */
  clinic: FaradayClinic;
  /** Date/Time this profile-device was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Staff designation */
  designation: Scalars['String']['output'];
  /** Encrypted and HMAC email for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: Maybe<Scalars['String']['output']>;
  /** Staff's favorite exam */
  favoriteExams: Array<FaradayExam>;
  /** User's first name. */
  firstName: Scalars['String']['output'];
  /** Full name of the user */
  fullName: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `FaradayStaffProfile:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** User's last name. */
  lastName: Scalars['String']['output'];
  /** Staff's MCR No. */
  mcrNo?: Maybe<Scalars['String']['output']>;
  /** Staff's draft for order */
  orderDrafts: Array<FaradayOrderDraft>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Staff's physician id */
  physicianId?: Maybe<Scalars['String']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Staff's web device. */
  webDevices?: Maybe<Array<FaradayStaffProfileRatatoskrDevice>>;
};

/** An enumeration. */
export enum FaradayStaffProfileAccountTypeChoices {
  /** Admin */
  Admin = 'ADMIN',
  /** Doctor */
  Doctor = 'DOCTOR',
  /** Super Admin */
  Superadmin = 'SUPERADMIN',
}

/** An enumeration. */
export enum FaradayStaffProfileAccountTypeForMutation {
  /** Admin */
  Admin = 'ADMIN',
  /** Doctor */
  Doctor = 'DOCTOR',
  /** Super Admin */
  Superadmin = 'SUPERADMIN',
}

export type FaradayStaffProfileConnection = {
  __typename?: 'FaradayStaffProfileConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayStaffProfileEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** Status of staff creation */
export type FaradayStaffProfileCreationStatus = ScalpelNode & {
  __typename?: 'FaradayStaffProfileCreationStatus';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** More details for status of creation. */
  info?: Maybe<Scalars['String']['output']>;
  /** status of creation. */
  status: CreationStatus;
};

/** A Relay edge containing a `FaradayStaffProfile` and its cursor. */
export type FaradayStaffProfileEdge = {
  __typename?: 'FaradayStaffProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayStaffProfile>;
};

/** Object type for `FaradayStaffProfileRatatoskrDevice`. */
export type FaradayStaffProfileRatatoskrDevice = ScalpelNode & {
  __typename?: 'FaradayStaffProfileRatatoskrDevice';
  /** Date/Time this profile-device was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Ratatoskr device associated with this profile. */
  device: RatatoskrDevice;
  /** This is the global ID constructed from the base64 encoding of `FaradayStaffProfileRatatoskrDevice:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Staff profile associated with this device. */
  staffProfile: FaradayStaffProfile;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type FaradayStaffProfileRatatoskrDeviceConnection = {
  __typename?: 'FaradayStaffProfileRatatoskrDeviceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaradayStaffProfileRatatoskrDeviceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FaradayStaffProfileRatatoskrDevice` and its cursor. */
export type FaradayStaffProfileRatatoskrDeviceEdge = {
  __typename?: 'FaradayStaffProfileRatatoskrDeviceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaradayStaffProfileRatatoskrDevice>;
};

export type FaradayUserVariableInput = {
  /** Variable name. */
  name: Scalars['String']['input'];
  /** Variable value. For `file` types, this can be either a Stitch `upload_id` or HTTPS URL. */
  value: Scalars['String']['input'];
};

export enum FavouriteOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Subtitle = 'SUBTITLE',
  Title = 'TITLE',
  Url = 'URL',
}

/** Send a Slack notification via Ford CI bot user. This GQL is only available in SG staging. */
export type FordCiSlackNotification = {
  __typename?: 'FordCiSlackNotification';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the message was sent successfully. */
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type FordCiSlackNotificationInput = {
  /** Slack channel to send the message to. Defaults to `engineering`. */
  channel?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Gitlab username of user who triggered the job. Usually equivalent to `$GITLAB_USER_LOGIN`. */
  gitlabUserLogin?: InputMaybe<Scalars['String']['input']>;
  /** Message to send. Can be markdown format. */
  message: Scalars['String']['input'];
};

/** Object type for `GovernessIdentifiableInformation`. */
export type GovernessIdentifiableInformation = ScalpelNode & {
  __typename?: 'GovernessIdentifiableInformation';
  /** Date/Time this object was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Original value of the `IdentifiableInformation` (Value is encrypted with AES-256.) */
  encryptedValue?: Maybe<Scalars['String']['output']>;
  /** `GovernessIdentifiableInformation` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Type of information, e.g., phone, whatsapp, etc */
  type: GovernessIdentifiableInformationTypeChoices;
  value: Scalars['String']['output'];
};

/** An enumeration. */
export enum GovernessIdentifiableInformationTypeChoices {
  /** E-mail */
  Email = 'EMAIL',
  /** Phone */
  Phone = 'PHONE',
  /** WhatsApp */
  Whatsapp = 'WHATSAPP',
}

/** Object type for `GovernessOrganization`. */
export type GovernessOrganization = ScalpelNode & {
  __typename?: 'GovernessOrganization';
  /** Organization's [ISO 3166-1 alpha-2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements). */
  country?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `GovernessOrganization:<key>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Key for the organization. */
  key: Scalars['String']['output'];
  /** Language of organization. */
  language: Scalars['String']['output'];
  /** Organization full name. */
  name: Scalars['String']['output'];
  /** Organization short name. */
  shortName: Scalars['String']['output'];
  /** Timezone of organization. */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Object type for `GovernessUser`. */
export type GovernessUser = ScalpelNode & {
  __typename?: 'GovernessUser';
  /** This is the global ID constructed from the base64 encoding of `GovernessUser:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Obtain a session and user instance through the Heimdall authorization flow. */
export type HeimdallAuthorizationFlow = {
  __typename?: 'HeimdallAuthorizationFlow';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** URL to redirect to after authentication. This URL will include the session token. */
  redirectTo?: Maybe<Scalars['String']['output']>;
  /** The authorized session. */
  session?: Maybe<HeimdallSession>;
};

export type HeimdallAuthorizationFlowInput = {
  /** An `Application` specific set of inputs to use for verifying the user. It will be validated against [`heimdall/ApplicationInput.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  applicationInput?: InputMaybe<Scalars['HeimdallApplicationInputSkeletonJSON']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID or name of Heimdall `ProviderApplication` to use for authorization flow. */
  providerApplicationUid: Scalars['String']['input'];
  /** A `Provider` specific set of inputs to use for verifying the user. It will be validated against [`heimdall/ProviderInput.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  providerInput: Scalars['HeimdallProviderInputSkeletonJSON']['input'];
  /** URL to redirect to after authentication. This field will be verified on the backend. */
  redirectTo?: InputMaybe<Scalars['String']['input']>;
};

/** Retrieves the discovery settings based on the URL. */
export type HeimdallDiscovery = ScalpelNode & {
  __typename?: 'HeimdallDiscovery';
  /** The relevant settings for Care application. */
  care?: Maybe<Scalars['GenericScalar']['output']>;
  /** The relevant settings for heimdall application. */
  heimdall?: Maybe<Scalars['GenericScalar']['output']>;
  /** The relevant settings for Hippocrates application. */
  hippocrates?: Maybe<Scalars['GenericScalar']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The relevant settings for Login application. */
  login?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Logout a session. */
export type HeimdallLogout = {
  __typename?: 'HeimdallLogout';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Result of operation. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HeimdallLogoutInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** A single mutation for requesting OTP token and verifying it. */
export type HeimdallOtpFlow = {
  __typename?: 'HeimdallOtpFlow';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** `True` if an OTP was sent. */
  otpSent: Scalars['Boolean']['output'];
  /** If OTP is verified, this token can be used in `heimdallAuthorizationFlow`. */
  token?: Maybe<Scalars['String']['output']>;
};

export type HeimdallOtpFlowInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifiable information type. */
  iiType: IdentifiableInformationTypeWithUid;
  /** The identifiable information value. */
  iiValue: Scalars['String']['input'];
  /** OTP for verification. If not specified, an OTP will be sent to the `ii_type`/`ii_value`. */
  otp?: InputMaybe<Scalars['String']['input']>;
  /** UID of Heimdall `ProviderApplication` containing an `OTPProvider`. */
  providerApplicationUid: Scalars['String']['input'];
};

/** Heimdall `ProviderApplication`s are used by user/client to work the necessary authentication flow. */
export type HeimdallProviderApplication = ScalpelNode & {
  __typename?: 'HeimdallProviderApplication';
  /** This is the global ID constructed from the base64 encoding of `HeimdallProviderApplication:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The import path for this instantiable object. */
  providerImportPath: HeimdallProviderApplicationProviderImportPathChoices;
  /** Provider-Application specific settings that are accessible by frontend. *Secret settings should not be stored here!* It is validated against <a href="https://skeleton.staging.botmd.io/docs/heimdall-providerapplicationsettings-generated.html" target="_blank">heimdall/ProviderApplicationSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Frontend should use this field to retrieve required information. */
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum HeimdallProviderApplicationProviderImportPathChoices {
  /** Cleo API Heimdall Provider */
  CleoApplicationsHeimdallApiCleoapiheimdallprovider = 'CLEO_APPLICATIONS_HEIMDALL_API_CLEOAPIHEIMDALLPROVIDER',
  /** Cleo Clinician (Session) */
  CleoApplicationsHeimdallDefaultCleocliniciansessionexchangeprovider = 'CLEO_APPLICATIONS_HEIMDALL_DEFAULT_CLEOCLINICIANSESSIONEXCHANGEPROVIDER',
  /** Cleo Profile (JWT) */
  CleoApplicationsHeimdallDefaultCleoprofilejwtprovider = 'CLEO_APPLICATIONS_HEIMDALL_DEFAULT_CLEOPROFILEJWTPROVIDER',
  /** Maxicare Heimdall Provider */
  CleoApplicationsHeimdallMaxicareMaxicareheimdallprovider = 'CLEO_APPLICATIONS_HEIMDALL_MAXICARE_MAXICAREHEIMDALLPROVIDER',
  /** Maxicare Mock Heimdall Provider */
  CleoApplicationsHeimdallMaxicareMaxicaremockheimdallprovider = 'CLEO_APPLICATIONS_HEIMDALL_MAXICARE_MAXICAREMOCKHEIMDALLPROVIDER',
  /** Einstein Administrator (Session) */
  EinsteinApplicationsHeimdallEinsteinadministratorsessionexchangeprovider = 'EINSTEIN_APPLICATIONS_HEIMDALL_EINSTEINADMINISTRATORSESSIONEXCHANGEPROVIDER',
  /** Faraday Provider (Session) */
  FaradayApplicationsHeimdallFaradaystaffsessionexchangeprovider = 'FARADAY_APPLICATIONS_HEIMDALL_FARADAYSTAFFSESSIONEXCHANGEPROVIDER',
  /** Auth0 Provider */
  HeimdallProvidersAuth0Auth0Provider = 'HEIMDALL_PROVIDERS_AUTH0_AUTH0PROVIDER',
  /** Azure AD Provider */
  HeimdallProvidersAzureAzureadprovider = 'HEIMDALL_PROVIDERS_AZURE_AZUREADPROVIDER',
  /** Dummy Provider */
  HeimdallProvidersBaseDummyprovider = 'HEIMDALL_PROVIDERS_BASE_DUMMYPROVIDER',
  /** Identifiable Information Test Provider */
  HeimdallProvidersIiTestIdentifiableinformationtestprovider = 'HEIMDALL_PROVIDERS_II_TEST_IDENTIFIABLEINFORMATIONTESTPROVIDER',
  /** Internal Service Provider */
  HeimdallProvidersInternalServiceInternalserviceprovider = 'HEIMDALL_PROVIDERS_INTERNAL_SERVICE_INTERNALSERVICEPROVIDER',
  /** NoopProvider */
  HeimdallProvidersNoopNoopprovider = 'HEIMDALL_PROVIDERS_NOOP_NOOPPROVIDER',
  /** Heimdall OTP Provider */
  HeimdallProvidersOtpOtpprovider = 'HEIMDALL_PROVIDERS_OTP_OTPPROVIDER',
  /** Public Service Provider */
  HeimdallProvidersPublicServicePublicserviceprovider = 'HEIMDALL_PROVIDERS_PUBLIC_SERVICE_PUBLICSERVICEPROVIDER',
  /** QR Code Provider */
  HeimdallProvidersQrcodeQrcodeprovider = 'HEIMDALL_PROVIDERS_QRCODE_QRCODEPROVIDER',
  /** SGID Provider */
  HeimdallProvidersSgidSgidprovider = 'HEIMDALL_PROVIDERS_SGID_SGIDPROVIDER',
  /** SGID Provider(Chemocalc) */
  HospitalApplicationsHeimdallChemocalcChemocalcheimdallprovider = 'HOSPITAL_APPLICATIONS_HEIMDALL_CHEMOCALC_CHEMOCALCHEIMDALLPROVIDER',
  /** Hospital Profile (Session) */
  HospitalApplicationsHeimdallDefaultHospitalsessionexchangeprovider = 'HOSPITAL_APPLICATIONS_HEIMDALL_DEFAULT_HOSPITALSESSIONEXCHANGEPROVIDER',
}

/** View information related to this request. */
export type HeimdallRequestLog = ScalpelNode & {
  __typename?: 'HeimdallRequestLog';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The UID of this request. */
  uid: Scalars['String']['output'];
};

/** Retrieve user info from SGID. */
export type HeimdallSgidUserInfo = ScalpelNode & {
  __typename?: 'HeimdallSGIDUserInfo';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** User info retieved from SGID */
  userInfo?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Heimdall `Session`s are one-time-issued immutable tokens with metadata issued to authorized users. */
export type HeimdallSession = ScalpelNode & {
  __typename?: 'HeimdallSession';
  /** Date/time when this session expires. */
  expiresOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `HeimdallSession:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** A list of scopes that are associated with this session. It is validated against <a href="https://skeleton.staging.botmd.io/docs/heimdall-sessionscopes-generated.html" target="_blank">heimdall/SessionScopes.schema</a>. */
  scopes?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** User who currently owns this session. When null, it is considered an anonymous session. */
  user?: Maybe<GovernessUser>;
};

/** Object type for `Hospital`. */
export type Hospital = ScalpelNode & {
  __typename?: 'Hospital';
  /** Assistants available on this hospital */
  assistants?: Maybe<Scalars['GenericScalar']['output']>;
  /** URL to the JSON containing autocomplete entries. This will be a temporary URL issued by S3/GCS. */
  autocompleteEntriesUrl?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Hospital:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Settings for logic. It will be validated against `hospital/LogicSettings.schema`. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-logicsettings-generated.html" target="_blank">hospital/LogicSettings.schema</a>. */
  logicSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Hospital full name. */
  name: Scalars['String']['output'];
  /** Hospital belongs to this organization. */
  organization: GovernessOrganization;
  /** Hospital organization key. Convenience for `settings["organization_key"]`. */
  organizationKey?: Maybe<Scalars['String']['output']>;
  /** Settings for this hospital. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-settings-generated.html" target="_blank">hospital/Settings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Hospital short name. */
  shortName: Scalars['String']['output'];
  /** Tags associated with this object. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Version used for determining any settings changes, may be used for reloading resources and invalidating caches. */
  version: Scalars['String']['output'];
};

/** Active banner for this hospital. */
export type HospitalActiveBanner = ScalpelNode & {
  __typename?: 'HospitalActiveBanner';
  endOn?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  startOn?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** Get autocomplete queries via AirTable. (DEPRECATED) */
export type HospitalAutoComplete = {
  __typename?: 'HospitalAutoComplete';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of autocomplete entries. */
  entries: Array<Maybe<HospitalAutoCompleteEntry>>;
};

/** An autocomplete query entry. */
export type HospitalAutoCompleteEntry = ScalpelNode & {
  __typename?: 'HospitalAutoCompleteEntry';
  /** Frequency of the query. (DEPRECATED) */
  frequency?: Maybe<Scalars['Int']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The query. */
  query: Scalars['String']['output'];
  /** List of restricted organizations for the query. (DEPRECATED) */
  restrictedOrganizations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique airtable record ID. (DEPRECATED) */
  uid?: Maybe<Scalars['String']['output']>;
};

export type HospitalAutoCompleteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Minimum frequency. Default: 5 */
  minFrequency?: InputMaybe<Scalars['Int']['input']>;
  /** The type of query to get from Airtable. Options are: `User Queries` (default), `Onboarding`, `Suggested`. */
  queryType?: InputMaybe<Scalars['String']['input']>;
};

/** All banners for all hospitals. */
export type HospitalBanner = ScalpelNode & {
  __typename?: 'HospitalBanner';
  /** The creator of this banner */
  createdBy?: Maybe<EinsteinAdministrator>;
  /** The date and time when this banner was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Banner should only run before this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  endOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital this banner belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalBanner:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Banner should only run after this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  startOn?: Maybe<Scalars['DateTime']['output']>;
  /** The HTML content of the banner. Max 60 characters (exclude the HTML tags). */
  text: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type HospitalBannerConnection = {
  __typename?: 'HospitalBannerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalBannerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalBanner` and its cursor. */
export type HospitalBannerEdge = {
  __typename?: 'HospitalBannerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalBanner>;
};

/** Broadcast message to a list of users via Bot MD. */
export type HospitalBroadcastMessages = {
  __typename?: 'HospitalBroadcastMessages';
  /** The posted deliveries/messages. */
  broadcastResults: Array<HospitalBroadcastResult>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type HospitalBroadcastMessagesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message to broadcast. */
  messages: Array<Scalars['RatatoskrMessageSkeletonJSON']['input']>;
  /** Metadata to add to the delivery object. It will be validated against [`ratatoskr/DeliveryMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['RatatoskrDeliveryMetadataSkeletonJSON']['input']>;
  /** List of profiles to broadcast message to. */
  profiles: Array<IdentifiableInformationInput>;
};

/** Result of a broadcast. */
export type HospitalBroadcastResult = ScalpelNode & {
  __typename?: 'HospitalBroadcastResult';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The messages delivered. */
  messages?: Maybe<Array<HospitalMessage>>;
  /** The hospital profile delivered to. */
  profile: HospitalProfile;
  /** Dummy value to ignore results of this object. */
  void?: Maybe<Scalars['String']['output']>;
};

/** Retrieve information from MTSOC for chemocalc. */
export type HospitalChemocalc = ScalpelNode & {
  __typename?: 'HospitalChemocalc';
  /** Results from chernobyl chemocalc */
  chemocalcResults?: Maybe<Scalars['GenericScalar']['output']>;
  /** Final out of pocket cost for patient */
  finalCost?: Maybe<Scalars['GenericScalar']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Subsidy result from insurance */
  insuranceSubsidy?: Maybe<Scalars['GenericScalar']['output']>;
  /** Subsidy result from MTSOC */
  subsidy?: Maybe<Scalars['GenericScalar']['output']>;
};

/** Deliver message template to user. */
export type HospitalChemocalcMessageTemplateDeliver = {
  __typename?: 'HospitalChemocalcMessageTemplateDeliver';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results for message template deliveries. */
  results: Array<HospitalChemocalcMessageTemplateDeliveryResult>;
};

export type HospitalChemocalcMessageTemplateDeliverInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address to receive the message. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Message template UID. */
  messageTemplateUid: Scalars['String']['input'];
  /** Phone number to receive the Whatsapp message. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** List of user variables. */
  userVariables: Array<ChemocalcUserVariableInput>;
};

/** Result of message template delivery */
export type HospitalChemocalcMessageTemplateDeliveryResult = ScalpelNode & {
  __typename?: 'HospitalChemocalcMessageTemplateDeliveryResult';
  /** Email address to receive the message. */
  email?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** If deliveries were created, this will be `true`. Note that a `true` value does not guarantee that the messages were actually received by the patient. */
  isDelivered: Scalars['Boolean']['output'];
  /** Message template that was delivered. */
  messageTemplateUid: Scalars['String']['output'];
  /** Phone number to receive the Whatsapp message. */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Deliver message template to user. */
export type HospitalChemocalcReportDeliver = {
  __typename?: 'HospitalChemocalcReportDeliver';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Results for message template deliveries. */
  results: Array<HospitalChemocalcMessageTemplateDeliveryResult>;
};

export type HospitalChemocalcReportDeliverInput = {
  /** Cancer classification of patient. */
  cancerType: CancerType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Doctor to receive the report. */
  doctorUid?: InputMaybe<Scalars['String']['input']>;
  /** Drug indication for chemocalc. */
  drugIndications?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Email to receive the report. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID or HE Code for facility. */
  healthcareFacility: MtsocFacilityCode;
  /** Height of patient in cm. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** List of regimen selected by user */
  regimens: Array<InputMaybe<RegimenItemInput>>;
  /** Clinics belong to this clinic group. */
  schemaCodes: Array<InputMaybe<MtsocSchemaCode>>;
  /** Subsidy status of patient */
  subsidyStatus: SubsidyStatus;
  /** Weight of patient in kg. */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** To export chemocalc report. */
export type HospitalChemocalcReportExport = {
  __typename?: 'HospitalChemocalcReportExport';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** URL for download chemocost report. */
  reportUrl?: Maybe<Scalars['String']['output']>;
};

export type HospitalChemocalcReportExportInput = {
  /** Cancer classification of patient. */
  cancerType: CancerType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Doctor to receive the report. */
  doctorUid?: InputMaybe<Scalars['String']['input']>;
  /** Drug indication for chemocalc. */
  drugIndications?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Organization ID or HE Code for facility. */
  healthcareFacility: MtsocFacilityCode;
  /** Height of patient in cm. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** List of regimen selected by user */
  regimens: Array<InputMaybe<RegimenItemInput>>;
  /** Clinics belong to this clinic group. */
  schemaCodes: Array<InputMaybe<MtsocSchemaCode>>;
  /** Subsidy status of patient */
  subsidyStatus: SubsidyStatus;
  /** Weight of patient in kg. */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** Departments for this hospital. */
export type HospitalDepartment = ScalpelNode & {
  __typename?: 'HospitalDepartment';
  /** Einstein Admin who created this Favourite. */
  createdBy?: Maybe<EinsteinAdministrator>;
  createdOn: Scalars['DateTime']['output'];
  /** Division this department belongs to. Can be empty. */
  division?: Maybe<HospitalDivision>;
  /** Number of Einstein documents with ACLs referencing this department */
  documentAclCount?: Maybe<Scalars['Int']['output']>;
  /** Number of Documents owned by this department */
  documentCount?: Maybe<Scalars['Int']['output']>;
  /** Number of favourites with ACLs referencing this department */
  favouriteCount?: Maybe<Scalars['Int']['output']>;
  /** This is the global ID constructed from the base64 encoding of `HospitalDepartment:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  updatedOn: Scalars['DateTime']['output'];
  /** Number of users in this department */
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type HospitalDepartmentConnection = {
  __typename?: 'HospitalDepartmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalDepartmentEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type HospitalDepartmentConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `HospitalDepartment` and its cursor. */
export type HospitalDepartmentEdge = {
  __typename?: 'HospitalDepartmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalDepartment>;
};

/** This is a related model input type for `HospitalDepartment`. */
export type HospitalDepartmentRelatedModelInput = {
  /** Global ID for referencing `HospitalDepartment`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `HospitalDepartment`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Designations for this hospital. */
export type HospitalDesignation = ScalpelNode & {
  __typename?: 'HospitalDesignation';
  /** Einstein Admin who created this Favourite. */
  createdBy?: Maybe<EinsteinAdministrator>;
  createdOn: Scalars['DateTime']['output'];
  /** Number of Einstein documents with ACLs referencing this department */
  documentAclCount?: Maybe<Scalars['Int']['output']>;
  /** Number of favourites with ACLs referencing this department */
  favouriteCount?: Maybe<Scalars['Int']['output']>;
  /** This is the global ID constructed from the base64 encoding of `HospitalDesignation:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Unique ID representing the Designation. */
  uid: Scalars['String']['output'];
  updatedOn: Scalars['DateTime']['output'];
  /** Number of users in this department */
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type HospitalDesignationConnection = {
  __typename?: 'HospitalDesignationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalDesignationEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type HospitalDesignationConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `HospitalDesignation` and its cursor. */
export type HospitalDesignationEdge = {
  __typename?: 'HospitalDesignationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalDesignation>;
};

/** DirectoryProfile for user to sign-in into hospital apps. */
export type HospitalDirectoryProfile = ScalpelNode & {
  __typename?: 'HospitalDirectoryProfile';
  /** If specified, this profile will be activated after the set date. */
  activateAfter?: Maybe<Scalars['DateTime']['output']>;
  /** Date/Time this profile was created. */
  createdOn: Scalars['DateTime']['output'];
  /** If specified, this profile will be deactivated after the set date. Mechanics of deactivation follow that of `deactivated_on`. */
  deactivateAfter?: Maybe<Scalars['DateTime']['output']>;
  /** If specified, this profile will be deactivated. However, the user will still be able to log in if they are present in the hospital's API. Note that this option should be left blank if user `is_blacklisted`. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Department this profile belongs to */
  department: Scalars['String']['output'];
  /** Department V2 Object. Null means empty Department. */
  departmentFk?: Maybe<HospitalDepartment>;
  /** Designation this profile belongs to */
  designation: Scalars['String']['output'];
  /** Profile first name. */
  firstName: Scalars['String']['output'];
  /** Full name. */
  fullName: Scalars['String']['output'];
  /** Hospital this user belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalDirectoryProfile:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of identifiable informations such phone number, email, whatsapp. */
  identifiableInformations: Array<GovernessIdentifiableInformation>;
  /** Profile last name. */
  lastName: Scalars['String']['output'];
  /** Activation status of profile. */
  status: ProfileActivationStatus;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this profile was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

/** Perform bulk operation on Directory Profiles. */
export type HospitalDirectoryProfileBulkOperation = {
  __typename?: 'HospitalDirectoryProfileBulkOperation';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of Directory Profiles updated. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type HospitalDirectoryProfileBulkOperationInput = {
  /** Directory Profile UIDs to operate on. */
  allUids: Array<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Op Type to perform. Can be `ACTIVATE` or `DEACTIVATE`. */
  opType: DirectoryProfileOperationType;
};

export type HospitalDirectoryProfileConnection = {
  __typename?: 'HospitalDirectoryProfileConnection';
  /** Get a list of all UIDs as part of this connection. **Note that the list will be truncated at 3000 for efficiency reasons.** */
  allUids?: Maybe<Array<Scalars['String']['output']>>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalDirectoryProfileEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Generate delayed Stitch link for downloading of exported CSV [DEPRECATED]. */
  exportedCsvUrl?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type HospitalDirectoryProfileConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `HospitalDirectoryProfile` and its cursor. */
export type HospitalDirectoryProfileEdge = {
  __typename?: 'HospitalDirectoryProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalDirectoryProfile>;
};

/** Divisions for this hospital. */
export type HospitalDivision = ScalpelNode & {
  __typename?: 'HospitalDivision';
  /** Einstein Admin who created this Favourite. */
  createdBy?: Maybe<EinsteinAdministrator>;
  createdOn: Scalars['DateTime']['output'];
  /** List of departments belonging to this division */
  departments?: Maybe<Array<HospitalDepartment>>;
  /** Number of Einstein documents with ACLs referencing this division */
  documentAclCount?: Maybe<Scalars['Int']['output']>;
  /** Number of Documents owned by this division */
  documentCount?: Maybe<Scalars['Int']['output']>;
  /** Number of favourites with ACLs referencing this division */
  favouriteCount?: Maybe<Scalars['Int']['output']>;
  /** This is the global ID constructed from the base64 encoding of `HospitalDivision:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Unique ID representing the Division. */
  uid: Scalars['String']['output'];
  updatedOn: Scalars['DateTime']['output'];
  /** Number of users in this division */
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type HospitalDivisionConnection = {
  __typename?: 'HospitalDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalDivisionEdge>>;
  /** Generate delayed Stitch link for downloading of document. */
  exportByUrl: Scalars['String']['output'];
  /** List of supported formats for export. */
  exportFormats?: Maybe<Array<HospitalExportableFormat>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type HospitalDivisionConnectionExportByUrlArgs = {
  exportKwargs?: InputMaybe<Scalars['GenericScalar']['input']>;
  outputFormat: EinsteinExportOutputFormat;
};

/** A Relay edge containing a `HospitalDivision` and its cursor. */
export type HospitalDivisionEdge = {
  __typename?: 'HospitalDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalDivision>;
};

/** This is a related model input type for `HospitalDivision`. */
export type HospitalDivisionRelatedModelInput = {
  /** Global ID for referencing `HospitalDivision`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `HospitalDivision`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Describes an exportable format. */
export type HospitalExportableFormat = ScalpelNode & {
  __typename?: 'HospitalExportableFormat';
  /** Is email allowed for the export of this document format. Defaults to `false`. */
  allowEmail: Scalars['Boolean']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Human readable label to display to the user. */
  label: Scalars['String']['output'];
  /** Output format key for use in `exportByUrl` field. */
  outputFormat: EinsteinExportOutputFormat;
};

/** Favourites for this hospital. */
export type HospitalFavourite = ScalpelNode & {
  __typename?: 'HospitalFavourite';
  /** List of ACLs in DNF format (OR of ANDs) that applies to this favourite. */
  aclDnf?: Maybe<Scalars['GenericScalar']['output']>;
  /** Content type of the Favourite. */
  contentType: Scalars['String']['output'];
  /** Einstein Admin who created this Favourite. */
  createdBy?: Maybe<EinsteinAdministrator>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital this favourite belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalFavourite:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Favourite key. */
  key: Scalars['String']['output'];
  /** Departments that own this resource */
  ownerDepartments: HospitalDepartmentConnection;
  /** Divisions that own this resource */
  ownerDivisions: HospitalDivisionConnection;
  /** Subtitle of the Favourite. */
  subtitle: Scalars['String']['output'];
  /** Title of the Favourite. */
  title: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** URL the favourite links to. */
  url: Scalars['String']['output'];
};

/** Favourites for this hospital. */
export type HospitalFavouriteOwnerDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Favourites for this hospital. */
export type HospitalFavouriteOwnerDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HospitalFavouriteConnection = {
  __typename?: 'HospitalFavouriteConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalFavouriteEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalFavourite` and its cursor. */
export type HospitalFavouriteEdge = {
  __typename?: 'HospitalFavouriteEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalFavourite>;
};

/** Find matching HospitalProfile by organization. */
export type HospitalFindHospital = ScalpelNode & {
  __typename?: 'HospitalFindHospital';
  /** The registered HospitalProfile and the associated identifiable information. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Find matching HospitalProfile by organization and phone number. */
export type HospitalFindProfiles = ScalpelNode & {
  __typename?: 'HospitalFindProfiles';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The registered HospitalProfile and the associated identifiable information. */
  profilesWithIi: Array<HospitalProfileWithIdentifiableInformation>;
};

/** Execute a Jarvis query flow. */
export type HospitalJarvisQuery = {
  __typename?: 'HospitalJarvisQuery';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of delivery objects that are created. This includes both `INCOMING` and `OUTGOING` deliveries. Only used when `createDelivery` is set. */
  deliveries?: Maybe<Array<Maybe<HospitalMessage>>>;
  /** Message content without variables substitution. */
  messages: Array<Scalars['GenericScalar']['output']>;
  /** Delivery metadata as part of the Jarvis response. */
  metadata: Scalars['GenericScalar']['output'];
};

export type HospitalJarvisQueryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create `INCOMING` and `OUTGOING` deliveries based on the Jarvis query and response. */
  createDelivery?: InputMaybe<JarvisQueryDeliveryInput>;
  /** Query for Jarvis. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** ModuleAnswerSet UID. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Login Provider linking organization to Heimdall Provider w/ info */
export type HospitalLoginProvider = ScalpelNode & {
  __typename?: 'HospitalLoginProvider';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Organization Key using this Login Provider */
  organizationKey: Scalars['String']['output'];
  /** Heimdall provider application this org uses for login */
  providerApplication: HeimdallProviderApplication;
  /** Heimdall provider application used to perform session exchange */
  sessionExchangeProviderApplication?: Maybe<HeimdallProviderApplication>;
};

/** List of organization UIDs and their respective login provider information */
export type HospitalLoginProviders = ScalpelNode & {
  __typename?: 'HospitalLoginProviders';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Public Login Providers */
  loginProviders?: Maybe<Array<HospitalLoginProvider>>;
};

/** Describe a hospital that a user can log in to. */
export type HospitalLoginableHospital = ScalpelNode & {
  __typename?: 'HospitalLoginableHospital';
  /** Active device associated with the session_token. */
  activeDevice?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** This is the user's current logged in hospital. */
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  /** This is a guest hospital. */
  isGuestHospital?: Maybe<Scalars['Boolean']['output']>;
  /** Last active of the profile */
  lastActiveOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Hospital name that the user can log in to. */
  name: Scalars['String']['output'];
  /** Hospital organization key */
  organizationKey: Scalars['String']['output'];
  /** Session token created previously for this hospital. */
  sessionToken?: Maybe<Scalars['String']['output']>;
  /** Hospital short name. */
  shortName: Scalars['String']['output'];
};

/** Find all hospitals that a user can log in to. */
export type HospitalLoginableHospitals = ScalpelNode & {
  __typename?: 'HospitalLoginableHospitals';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** All the hospitals that the user can log in to. */
  loginableHospitals: Array<HospitalLoginableHospital>;
};

/** Retrieve delivery associated with this HospitalProfile. */
export type HospitalMessage = ScalpelNode & {
  __typename?: 'HospitalMessage';
  /** Date/Time of delivery. */
  createdOn: Scalars['DateTime']['output'];
  /** Direction of the message. `incoming` means from user to Hippocrates, `outgoing` means otherwise. */
  direction: Scalars['String']['output'];
  /** Feedback associated with this message. */
  feedback?: Maybe<HospitalQueryFeedback>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Message content with variables substitution. */
  message: Scalars['GenericScalar']['output'];
  /** Message content without variables substitution. */
  messageContent: Scalars['GenericScalar']['output'];
  /** Delivery metadata. */
  metadata: Scalars['GenericScalar']['output'];
  /** Delivery object UID. */
  uid: Scalars['String']['output'];
};

export type HospitalMessagesConnection = {
  __typename?: 'HospitalMessagesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalMessagesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalMessages` and its cursor. */
export type HospitalMessagesEdge = {
  __typename?: 'HospitalMessagesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalMessage>;
};

/** Mood Logs for this user/hospital. */
export type HospitalMoodLog = ScalpelNode & {
  __typename?: 'HospitalMoodLog';
  /** The creator of this mood check-in */
  createdBy?: Maybe<HospitalProfile>;
  createdOn: Scalars['DateTime']['output'];
  /** Hospital this mood log belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalMoodLog:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The mood rating. 1 for unhappiest, 5 for happiest. */
  rating: Scalars['Int']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** A user's average mood log for a given day. */
export type HospitalMoodLogAverage = ScalpelNode & {
  __typename?: 'HospitalMoodLogAverage';
  /** Average Mood for this given day. Defaults to 0 if no mood check-ins for that day. */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** Day being measured */
  day?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Get a range of mood logs for a given day. If there are multiple entries, the average is returned. */
export type HospitalMoodLogAverages = ScalpelNode & {
  __typename?: 'HospitalMoodLogAverages';
  /** List of mood log averages by day */
  averages: Array<HospitalMoodLogAverage>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export type HospitalMoodLogConnection = {
  __typename?: 'HospitalMoodLogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalMoodLogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalMoodLog` and its cursor. */
export type HospitalMoodLogEdge = {
  __typename?: 'HospitalMoodLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalMoodLog>;
};

/** Mood Logs for this user/hospital. */
export type HospitalMoodLogReminder = ScalpelNode & {
  __typename?: 'HospitalMoodLogReminder';
  /** The creator of this mood check-in reminder */
  createdBy?: Maybe<HospitalProfile>;
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Reminder should only run before this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  endOn?: Maybe<Scalars['DateTime']['output']>;
  /** Hospital this mood log belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalMoodLogReminder:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Recurring frequencies this reminder is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. */
  recurringFrequencies?: Maybe<Scalars['GenericScalar']['output']>;
  /** Reminder should only run after this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  startOn?: Maybe<Scalars['DateTime']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

export type HospitalMoodLogReminderConnection = {
  __typename?: 'HospitalMoodLogReminderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalMoodLogReminderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalMoodLogReminder` and its cursor. */
export type HospitalMoodLogReminderEdge = {
  __typename?: 'HospitalMoodLogReminderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalMoodLogReminder>;
};

/** A notification setting. */
export type HospitalNotificationSetting = ScalpelNode & {
  __typename?: 'HospitalNotificationSetting';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the notification type is activated or not. */
  isActivated: Scalars['Boolean']['output'];
  /** Key for notification type. */
  key: Scalars['String']['output'];
  /** Name of the notification. */
  name: Scalars['String']['output'];
};

/** Send a message to the Hospital bot via GraphQL. */
export type HospitalPostMessage = {
  __typename?: 'HospitalPostMessage';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The device this message was posted from. */
  device?: Maybe<RatatoskrDevice>;
  /** The posted delivery/message. */
  message?: Maybe<HospitalMessage>;
};

export type HospitalPostMessageInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to only create the delivery and skip the Chatbot. Defaults to False. */
  createOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Message to post to the bot. It will be validated against [`ratatoskr/Message.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messageContent: Scalars['RatatoskrMessageSkeletonJSON']['input'];
  /** Metadata to add to the delivery object. It will be validated against [`ratatoskr/DeliveryMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['RatatoskrDeliveryMetadataSkeletonJSON']['input']>;
  /** UID for the delivery object. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Object type for `HospitalProfile`. */
export type HospitalProfile = ScalpelNode & {
  __typename?: 'HospitalProfile';
  /** ACL dnfs. */
  aclDnf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Profile's avatar. */
  avatar: Scalars['FileFieldType']['output'];
  /** Date/Time this profile was created. */
  createdOn: Scalars['DateTime']['output'];
  /** Profile department. */
  department: Scalars['String']['output'];
  /** Profile designation. */
  designation: Scalars['String']['output'];
  /** Profile first name. */
  firstName: Scalars['String']['output'];
  /** Full name of profile. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Hospital this user belongs to. */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalProfile:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of identifiable informations such phone number, email */
  identifiableInformations: Array<GovernessIdentifiableInformation>;
  /** Date/Time this profile was last active. */
  lastActiveOn: Scalars['DateTime']['output'];
  /** Profile last name. */
  lastName: Scalars['String']['output'];
  /** List of notification settings. */
  notificationSettings: Array<Maybe<HospitalNotificationSetting>>;
  /** Profile's profile picture. */
  picture: Scalars['FileFieldType']['output'];
  /** Settings for this object. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profilesettings-generated.html" target="_blank">hospital/ProfileSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Profile's superpower, e.g., General Practitioner, Specialist, etc */
  superpower: Scalars['String']['output'];
  /** Tags associated with this object. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profiletags-generated.html" target="_blank">hospital/ProfileTags.schema</a>. */
  tags?: Maybe<Scalars['GenericScalar']['output']>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this profile was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

export type HospitalProfileConnection = {
  __typename?: 'HospitalProfileConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalProfileEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/**
 * A way to keep track of devices associated with Hospital profile.
 *     Records in this table are never deleted.
 *     When a device loses its session, we still keep the record here.
 */
export type HospitalProfileDevice = ScalpelNode & {
  __typename?: 'HospitalProfileDevice';
  /** Date/Time the device was assigned to the profile. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This device associated with this profile. */
  device: RatatoskrDevice;
  /** `HospitalProfileDevice` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The registered Hospital profile. */
  profile: HospitalProfile;
};

export type HospitalProfileDeviceConnection = {
  __typename?: 'HospitalProfileDeviceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalProfileDeviceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalProfileDevice` and its cursor. */
export type HospitalProfileDeviceEdge = {
  __typename?: 'HospitalProfileDeviceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalProfileDevice>;
};

/** A Relay edge containing a `HospitalProfile` and its cursor. */
export type HospitalProfileEdge = {
  __typename?: 'HospitalProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalProfile>;
};

/** A profile with identifiable information. */
export type HospitalProfileWithIdentifiableInformation = ScalpelNode & {
  __typename?: 'HospitalProfileWithIdentifiableInformation';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The associated identifiable information for this profile. */
  identifiableInformation?: Maybe<GovernessIdentifiableInformation>;
  /** The hospital profile found. */
  profile: HospitalProfile;
};

/** Get public information related to hospitals. */
export type HospitalPublicInformation = ScalpelNode & {
  __typename?: 'HospitalPublicInformation';
  /** Hospital domain root (eg. botmd.io, botmd.sg). */
  domainRoot: Scalars['String']['output'];
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Login URL of the Hospital. */
  loginUrl?: Maybe<Scalars['String']['output']>;
  /** Logo of the Hospital. */
  logoUrl: Scalars['String']['output'];
  /** Full name of the hopsital. */
  name: Scalars['String']['output'];
  /** Hospital organization key. Convenience for `settings["organization_key"]`. */
  organizationKey: Scalars['String']['output'];
  /** Pusher URL of the Hospital. */
  pusherUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the hospital. */
  uid: Scalars['String']['output'];
  /** Viewer URL of the Hospital. */
  viewerUrl?: Maybe<Scalars['String']['output']>;
};

export type HospitalPublicInformationsConnection = {
  __typename?: 'HospitalPublicInformationsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HospitalPublicInformationsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HospitalPublicInformations` and its cursor. */
export type HospitalPublicInformationsEdge = {
  __typename?: 'HospitalPublicInformationsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HospitalPublicInformation>;
};

/** Feedback for a Query */
export type HospitalQueryFeedback = ScalpelNode & {
  __typename?: 'HospitalQueryFeedback';
  /** Time this feedback was created */
  createdOn: Scalars['DateTime']['output'];
  /** Hospital that made this feedback */
  hospital: Hospital;
  /** This is the global ID constructed from the base64 encoding of `HospitalQueryFeedback:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if positive, False if negative */
  isPositive: Scalars['Boolean']['output'];
  /** Profile that made this feedback */
  profile?: Maybe<HospitalProfile>;
  /** Unique ID representing the QueryFeedback. */
  uid: Scalars['String']['output'];
  /** Time this feedback was last updated */
  updatedOn: Scalars['DateTime']['output'];
  /** Text feedback written by user */
  userFeedback: Scalars['String']['output'];
};

/** Register a `Device` to an existing `HospitalProfile`. */
export type HospitalRegisterDevice = {
  __typename?: 'HospitalRegisterDevice';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Ratatoskr device created/obtained for this HospitalProfile. */
  device?: Maybe<RatatoskrDevice>;
  /** The HospitalProfile registered. */
  profile?: Maybe<HospitalProfile>;
};

export type HospitalRegisterDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device metadata to supplement the provider metadata. It will be validated against [`ratatoskr/DeviceMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  deviceMetadata?: InputMaybe<Scalars['RatatoskrDeviceMetadataSkeletonJSON']['input']>;
  /** Register/Create a FCM device to the `HospitalProfile`. This is used in conjunction with `smooch` and `pusher`. */
  fcm?: InputMaybe<RegisterDeviceFcmInput>;
  /** Ratatoskr Provider Application UID to register this device under. */
  providerApplication: Scalars['String']['input'];
  /** Register/Create a Pusher device to the `HospitalProfile`. */
  pusher?: InputMaybe<RegisterDevicePusherInput>;
  /** Register/Create a Smooch device to the `HospitalProfile`. */
  smooch?: InputMaybe<RegisterDeviceSmoochInput>;
};

/** Check if the existing device is registerable or not. */
export type HospitalRegisterableDevice = ScalpelNode & {
  __typename?: 'HospitalRegisterableDevice';
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Device is registerable or not */
  registerable: Scalars['Boolean']['output'];
};

/** Identifiable information (type, value) pair for use as inputs. */
export type IdentifiableInformationInput = {
  /** The identifiable information type. */
  type?: InputMaybe<IdentifiableInformationTypeWithUid>;
  /** The identifiable information value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentifiableInformationTypeWithUid {
  /** Email address. */
  Email = 'EMAIL',
  /** Governess user UID. */
  GovernessUserUid = 'GOVERNESS_USER_UID',
  /** Hospital profile UID. */
  HospitalProfileUid = 'HOSPITAL_PROFILE_UID',
  /** Phone number in E.164 format. */
  Phone = 'PHONE',
  /** WhatsApp phone number in E.164 format. */
  Whatsapp = 'WHATSAPP',
}

export type JarvisProfileGql = {
  /** The tenant of the profile. */
  tenant: Scalars['String']['input'];
};

export type JarvisQueryDeliveryInput = {
  /** Message to post to the bot. It will be validated against [`ratatoskr/Message.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messageContent?: InputMaybe<Scalars['RatatoskrMessageSkeletonJSON']['input']>;
  /** Metadata to add to the delivery object. It will be validated against [`ratatoskr/DeliveryMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['RatatoskrDeliveryMetadataSkeletonJSON']['input']>;
  /** UID for the delivery object. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** For BE developers to debug the Jarvis v2 query flow. */
export type JarvisQueryFlow = ScalpelNode & {
  __typename?: 'JarvisQueryFlow';
  /** The AsyncJob if `use_async` is `True`. */
  asyncJob?: Maybe<KronosAsyncJob>;
  /** Actual system prompt for LLM if `context_template` is given. If not, defaults to whatever is in the query engine settings. */
  contextTemplate?: Maybe<Scalars['String']['output']>;
  /** List of document IDs to restrict document search to. Comma-separated. */
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Search mode for LLM - either `retrieval` or `search_summarize` */
  llmSearchMode?: Maybe<Scalars['String']['output']>;
  /** Messages returned by query flow. */
  messages?: Maybe<Array<Scalars['RatatoskrMessageSkeletonJSON']['output']>>;
  /** Delivery metadata. It will be validated against [`ratatoskr/DeliveryMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: Maybe<Scalars['RatatoskrDeliveryMetadataSkeletonJSON']['output']>;
  /** Model name if `model` is given. If not, defaults to whatever is in the query engine settings. */
  model?: Maybe<Scalars['String']['output']>;
  /** Reranker cutoff: if non-zero, turns on the reranker, and removes nodes under this (reranker) score. Supersedes similarity_cutoff if nonzero. If not given, defaults to whatever is in the query engine settings */
  rerankerSimilarityCutoff?: Maybe<Scalars['Float']['output']>;
  /** Similarity cutoff: removes nodes under this cos-sim score. If not given, defaults to whatever is in the query engine settings. */
  similarityCutoff?: Maybe<Scalars['Float']['output']>;
  /** Top k to be retrieved if `similarity_top_k` is given. If not, defaults to whatever is in the query engine settings. */
  similarityTopK?: Maybe<Scalars['Int']['output']>;
  /** System prompt for LLM if `system_prompt` is given. If not, defaults to whatever is in the query engine settings. */
  systemPrompt?: Maybe<Scalars['String']['output']>;
  /** List of User ACLs to restrict document search to. Comma-separated. */
  userAclDnfs?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 *
 *     Note: Graphene will force uppercase for text choices
 *
 */
export enum KeyMetrics {
  DailyActive = 'DAILY_ACTIVE',
  DailyActiveByDepartment = 'DAILY_ACTIVE_BY_DEPARTMENT',
  DailyActiveByDesignation = 'DAILY_ACTIVE_BY_DESIGNATION',
  DailyQuerying = 'DAILY_QUERYING',
  DailyQueryingDepartment = 'DAILY_QUERYING_DEPARTMENT',
  DailyQueryingDesignation = 'DAILY_QUERYING_DESIGNATION',
  DailySignedIn = 'DAILY_SIGNED_IN',
  DailySignedInDepartment = 'DAILY_SIGNED_IN_DEPARTMENT',
  DailySignedInDesignation = 'DAILY_SIGNED_IN_DESIGNATION',
  DailyTotalQueries = 'DAILY_TOTAL_QUERIES',
  DailyTotalQueriesDepartment = 'DAILY_TOTAL_QUERIES_DEPARTMENT',
  DailyTotalQueriesDesignation = 'DAILY_TOTAL_QUERIES_DESIGNATION',
  Last_7DaysActiveDepartment = 'LAST_7_DAYS_ACTIVE_DEPARTMENT',
  Last_7DaysActiveDesignation = 'LAST_7_DAYS_ACTIVE_DESIGNATION',
  Last_7DaysDocumentsViewed = 'LAST_7_DAYS_DOCUMENTS_VIEWED',
  Last_7DaysDocumentsViewedDepartment = 'LAST_7_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  Last_7DaysDocumentsViewedDesignation = 'LAST_7_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  Last_7DaysQueryingDepartment = 'LAST_7_DAYS_QUERYING_DEPARTMENT',
  Last_7DaysQueryingDesignation = 'LAST_7_DAYS_QUERYING_DESIGNATION',
  Last_7DaysQueryContentType = 'LAST_7_DAYS_QUERY_CONTENT_TYPE',
  Last_7DaysQueryContentTypeDepartment = 'LAST_7_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  Last_7DaysQueryContentTypeDesignation = 'LAST_7_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  Last_7DaysSignedInDepartment = 'LAST_7_DAYS_SIGNED_IN_DEPARTMENT',
  Last_7DaysSignedInDesignation = 'LAST_7_DAYS_SIGNED_IN_DESIGNATION',
  Last_30DaysActiveDepartment = 'LAST_30_DAYS_ACTIVE_DEPARTMENT',
  Last_30DaysActiveDesignation = 'LAST_30_DAYS_ACTIVE_DESIGNATION',
  Last_30DaysDocumentsViewed = 'LAST_30_DAYS_DOCUMENTS_VIEWED',
  Last_30DaysDocumentsViewedDepartment = 'LAST_30_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  Last_30DaysDocumentsViewedDesignation = 'LAST_30_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  Last_30DaysQueryingDepartment = 'LAST_30_DAYS_QUERYING_DEPARTMENT',
  Last_30DaysQueryingDesignation = 'LAST_30_DAYS_QUERYING_DESIGNATION',
  Last_30DaysQueryContentType = 'LAST_30_DAYS_QUERY_CONTENT_TYPE',
  Last_30DaysQueryContentTypeDepartment = 'LAST_30_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  Last_30DaysQueryContentTypeDesignation = 'LAST_30_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  Last_30DaysSignedInDepartment = 'LAST_30_DAYS_SIGNED_IN_DEPARTMENT',
  Last_30DaysSignedInDesignation = 'LAST_30_DAYS_SIGNED_IN_DESIGNATION',
  Last_60DaysActiveDepartment = 'LAST_60_DAYS_ACTIVE_DEPARTMENT',
  Last_60DaysActiveDesignation = 'LAST_60_DAYS_ACTIVE_DESIGNATION',
  Last_60DaysDocumentsViewed = 'LAST_60_DAYS_DOCUMENTS_VIEWED',
  Last_60DaysDocumentsViewedDepartment = 'LAST_60_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  Last_60DaysDocumentsViewedDesignation = 'LAST_60_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  Last_60DaysQueryingDepartment = 'LAST_60_DAYS_QUERYING_DEPARTMENT',
  Last_60DaysQueryingDesignation = 'LAST_60_DAYS_QUERYING_DESIGNATION',
  Last_60DaysQueryContentType = 'LAST_60_DAYS_QUERY_CONTENT_TYPE',
  Last_60DaysQueryContentTypeDepartment = 'LAST_60_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  Last_60DaysQueryContentTypeDesignation = 'LAST_60_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  Last_60DaysSignedInDepartment = 'LAST_60_DAYS_SIGNED_IN_DEPARTMENT',
  Last_60DaysSignedInDesignation = 'LAST_60_DAYS_SIGNED_IN_DESIGNATION',
  Last_90DaysActiveDepartment = 'LAST_90_DAYS_ACTIVE_DEPARTMENT',
  Last_90DaysActiveDesignation = 'LAST_90_DAYS_ACTIVE_DESIGNATION',
  Last_90DaysDocumentsViewed = 'LAST_90_DAYS_DOCUMENTS_VIEWED',
  Last_90DaysDocumentsViewedDepartment = 'LAST_90_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  Last_90DaysDocumentsViewedDesignation = 'LAST_90_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  Last_90DaysQueryingDepartment = 'LAST_90_DAYS_QUERYING_DEPARTMENT',
  Last_90DaysQueryingDesignation = 'LAST_90_DAYS_QUERYING_DESIGNATION',
  Last_90DaysQueryContentType = 'LAST_90_DAYS_QUERY_CONTENT_TYPE',
  Last_90DaysQueryContentTypeDepartment = 'LAST_90_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  Last_90DaysQueryContentTypeDesignation = 'LAST_90_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  Last_90DaysSignedInDepartment = 'LAST_90_DAYS_SIGNED_IN_DEPARTMENT',
  Last_90DaysSignedInDesignation = 'LAST_90_DAYS_SIGNED_IN_DESIGNATION',
  Last_365DaysActiveDepartment = 'LAST_365_DAYS_ACTIVE_DEPARTMENT',
  Last_365DaysActiveDesignation = 'LAST_365_DAYS_ACTIVE_DESIGNATION',
  Last_365DaysDocumentsViewed = 'LAST_365_DAYS_DOCUMENTS_VIEWED',
  Last_365DaysDocumentsViewedDepartment = 'LAST_365_DAYS_DOCUMENTS_VIEWED_DEPARTMENT',
  Last_365DaysDocumentsViewedDesignation = 'LAST_365_DAYS_DOCUMENTS_VIEWED_DESIGNATION',
  Last_365DaysQueryingDepartment = 'LAST_365_DAYS_QUERYING_DEPARTMENT',
  Last_365DaysQueryingDesignation = 'LAST_365_DAYS_QUERYING_DESIGNATION',
  Last_365DaysQueryContentType = 'LAST_365_DAYS_QUERY_CONTENT_TYPE',
  Last_365DaysQueryContentTypeDepartment = 'LAST_365_DAYS_QUERY_CONTENT_TYPE_DEPARTMENT',
  Last_365DaysQueryContentTypeDesignation = 'LAST_365_DAYS_QUERY_CONTENT_TYPE_DESIGNATION',
  Last_365DaysSignedInDepartment = 'LAST_365_DAYS_SIGNED_IN_DEPARTMENT',
  Last_365DaysSignedInDesignation = 'LAST_365_DAYS_SIGNED_IN_DESIGNATION',
  WeeklyActive = 'WEEKLY_ACTIVE',
  WeeklyActiveByDepartment = 'WEEKLY_ACTIVE_BY_DEPARTMENT',
  WeeklyActiveByDesignation = 'WEEKLY_ACTIVE_BY_DESIGNATION',
  WeeklyQuerying = 'WEEKLY_QUERYING',
  WeeklyQueryingDepartment = 'WEEKLY_QUERYING_DEPARTMENT',
  WeeklyQueryingDesignation = 'WEEKLY_QUERYING_DESIGNATION',
  WeeklySignedIn = 'WEEKLY_SIGNED_IN',
  WeeklySignedInDepartment = 'WEEKLY_SIGNED_IN_DEPARTMENT',
  WeeklySignedInDesignation = 'WEEKLY_SIGNED_IN_DESIGNATION',
}

/** Starts a rendering async job for Kondo resources. */
export type KondoRenderResources = ScalpelNode & {
  __typename?: 'KondoRenderResources';
  /** The AsyncJob. */
  asyncJob: KronosAsyncJob;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Starts a validation async job for Kondo resources. */
export type KondoValidateResources = ScalpelNode & {
  __typename?: 'KondoValidateResources';
  /** The AsyncJob. */
  asyncJob: KronosAsyncJob;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Object type for `KronosAsyncJob`. */
export type KronosAsyncJob = ScalpelNode & {
  __typename?: 'KronosAsyncJob';
  /** When this job is created. */
  createdOn: Scalars['DateTime']['output'];
  /** When this job finished. */
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `KronosAsyncJob:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the AsyncJob is done and ready. */
  isReady: Scalars['Boolean']['output'];
  /** The results of the job. */
  results?: Maybe<Scalars['GenericScalar']['output']>;
  /** The task status. */
  status: KronosAsyncJobStatusChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum KronosAsyncJobStatusChoices {
  /** Failed ☠️ */
  Failed = 'FAILED',
  /** Running 🏃 */
  Running = 'RUNNING',
  /** Started 🏃 */
  Started = 'STARTED',
  /** Success 🚀 */
  Success = 'SUCCESS',
  /** Waiting ⏳ */
  Waiting = 'WAITING',
}

/** Object type for `KronosTask`. */
export type KronosTask = ScalpelNode & {
  __typename?: 'KronosTask';
  /** Task should only run before this. If `NULL`, it means this task can run anytime as determined by the schedules. */
  endOn?: Maybe<Scalars['DateTime']['output']>;
  /** `KronosTask` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for this task. This should be unique for the given provider. */
  key: Scalars['String']['output'];
  /** Date time for next occurance */
  nextOn?: Maybe<Scalars['DateTime']['output']>;
  /** Task should only run after this. If `NULL`, it means this task can run anytime as determined by the schedules. */
  startOn?: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration. */
export enum Language {
  Bn = 'BN',
  En = 'EN',
  Es = 'ES',
  Hi = 'HI',
  Id = 'ID',
  Ja = 'JA',
  Ms = 'MS',
  Ta = 'TA',
  Th = 'TH',
  Tl = 'TL',
  Zh = 'ZH',
}

/** Logo of the hospital to use in the app. */
export type LogoInput = {
  /** URL of the logo. */
  url: Scalars['String']['input'];
};

export enum MtsocFacilityCode {
  NuhsPolyclinic = 'NUHS_POLYCLINIC',
  SinghealthPolyclinic = 'SINGHEALTH_POLYCLINIC',
  Test = 'TEST',
}

export enum MtsocSchemaCode {
  Maf = 'maf',
  Soc = 'soc',
}

/** Object type for `MerlinAdministrator`. */
export type MerlinAdministrator = ScalpelNode & {
  __typename?: 'MerlinAdministrator';
  /** Account type of the staff */
  accountType: MerlinAdministratorAccountTypeChoices;
  /** ClinicGroups which administrator have access to. */
  clinicGroups: CleoClinicGroupConnection;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `MerlinAdministrator:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Full name of the user. */
  name: Scalars['String']['output'];
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone: Scalars['String']['output'];
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Object type for `MerlinAdministrator`. */
export type MerlinAdministratorClinicGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum MerlinAdministratorAccountTypeChoices {
  /** Admin */
  Admin = 'ADMIN',
  /** Super Admin */
  Superadmin = 'SUPERADMIN',
}

export type MerlinAdministratorConnection = {
  __typename?: 'MerlinAdministratorConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MerlinAdministratorEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MerlinAdministrator` and its cursor. */
export type MerlinAdministratorEdge = {
  __typename?: 'MerlinAdministratorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MerlinAdministrator>;
};

/** Mutation for Merlin's clinic creation flow. */
export type MerlinClinicImport = {
  __typename?: 'MerlinClinicImport';
  /** Alert rules to be created. */
  alertRules?: Maybe<Array<CleoAlertRule>>;
  /** Async job containing results of the async operation. */
  asyncJob?: Maybe<KronosAsyncJob>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Clinic to be created. */
  clinic?: Maybe<CleoClinic>;
  /** Clinic programs to be created. */
  clinicPrograms?: Maybe<Array<CleoClinicProgram>>;
  /** Clinical Paramters to be created. */
  clinicalParameters?: Maybe<Array<CleoClinicalParameter>>;
  /** Monitoring Formsets to be created. */
  monitoringFormsets?: Maybe<Array<CleoMonitoringFormset>>;
  /** Reminders to be created. */
  reminders?: Maybe<Array<CleoReminder>>;
};

export type MerlinClinicImportInput = {
  /** Async job UID for polling results. This should be the only input argument if used. */
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic programs to be import. */
  clinicPrograms?: InputMaybe<Array<ClinicProgramImport>>;
  /** UID of the clinic to be imported. */
  clinicUid?: InputMaybe<Scalars['String']['input']>;
  /** Preview the clinic creation. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Upload ID returned by `stitchCreateUploadUrl`. The file should have been uploaded when this mutation is called. */
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

/** Mutation to create WhatsAppTemplate. */
export type MerlinWhatsAppTemplateCreate = {
  __typename?: 'MerlinWhatsAppTemplateCreate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** WhatsAppTemplate that was created. */
  whatsappTemplate: RatatoskrWhatsAppTemplate;
};

export type MerlinWhatsAppTemplateCreateInput = {
  /** Category of the WhatsAppTemplate */
  category: Category;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the clinic */
  clinicUid: Scalars['String']['input'];
  /** WhatsApp component */
  components: Scalars['GenericScalar']['input'];
  /** Language of the WhatsAppTemplate */
  language: WhatsAppLanguage;
  /** MessageTemplateSet belong to the message_template */
  messageTemplateSetUid: Scalars['String']['input'];
  /** Name of the WhatsAppTemplate */
  name: Scalars['String']['input'];
};

/** Mutation to update WhatsAppTemplate. */
export type MerlinWhatsAppTemplateUpdate = {
  __typename?: 'MerlinWhatsAppTemplateUpdate';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** WhatsAppTemplate that was updated. */
  whatsappTemplate: RatatoskrWhatsAppTemplate;
};

export type MerlinWhatsAppTemplateUpdateInput = {
  /** Category of the WhatsAppTemplate */
  category?: InputMaybe<Category>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the clinic */
  clinicUid: Scalars['String']['input'];
  /** WhatsApp component */
  components?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** WhatsApp provided ID for the template. */
  whatsappTemplateId: Scalars['String']['input'];
};

/** An enumeration. */
export enum MessageTemplateError {
  DeliveryFailure = 'DELIVERY_FAILURE',
  WhatsappTemplateError = 'WHATSAPP_TEMPLATE_ERROR',
  WhatsappTemplateMissing = 'WHATSAPP_TEMPLATE_MISSING',
}

/** Object type for `MonetaPayment`. */
export type MonetaPayment = ScalpelNode & {
  __typename?: 'MonetaPayment';
  /** The decimal part of the amount. */
  amount: Scalars['Decimal']['output'];
  amountCurrency: MonetaPaymentAmountCurrencyChoices;
  /** Date/Time this payment was created. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `MonetaPayment:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this payment refundable? */
  isRefundable: Scalars['Boolean']['output'];
  /** Is this payment request cancelable? */
  isRequestCancelable: Scalars['Boolean']['output'];
  /** Payment method for this payment. */
  method: MonetaProviderApplicationPaymentMethod;
  /** Get the payment request URL associated with this payment. */
  paymentRequestUrl?: Maybe<Scalars['String']['output']>;
  /** Get the payment request URL associated with this payment. */
  prettyAmount: Scalars['String']['output'];
  /** ProviderApplication that requested this payment. */
  providerApplication: MonetaProviderApplication;
  /** Payment status. */
  status: MonetaPaymentStatusChoices;
  /** The list of transactions associated with this payment. */
  transactions: Array<MonetaTransaction>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
  /** Date/Time this payment was updated. */
  updatedOn: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum MonetaPaymentAmountCurrencyChoices {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR',
}

/** An enumeration. */
export enum MonetaPaymentStatusChoices {
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Received */
  Received = 'RECEIVED',
  /** Refunded */
  Refunded = 'REFUNDED',
  /** Requested */
  Requested = 'REQUESTED',
  /** Request Canceled */
  RequestCanceled = 'REQUEST_CANCELED',
}

/** Object type for `MonetaProviderApplication`. */
export type MonetaProviderApplication = ScalpelNode & {
  __typename?: 'MonetaProviderApplication';
  /** List of currencies supported by this provider application. */
  currencies: Array<MonetaProviderApplicationCurrency>;
  /** This is the global ID constructed from the base64 encoding of `MonetaProviderApplication:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name for uniquely identifying this model instance. */
  name: Scalars['String']['output'];
  /** List of payment methods supported by this provider application. */
  paymentMethods: Array<MonetaProviderApplicationPaymentMethod>;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** Object type for `MonetaProviderApplicationCurrency`. */
export type MonetaProviderApplicationCurrency = ScalpelNode & {
  __typename?: 'MonetaProviderApplicationCurrency';
  /** Currency supported by the provider-application */
  currency: MonetaProviderApplicationCurrencyCurrencyChoices;
  /** `MonetaProviderApplicationCurrency` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Full name of the currency name. */
  name: Scalars['String']['output'];
};

/** An enumeration. */
export enum MonetaProviderApplicationCurrencyCurrencyChoices {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR',
}

/** Object type for `MonetaProviderApplicationPaymentMethod`. */
export type MonetaProviderApplicationPaymentMethod = ScalpelNode & {
  __typename?: 'MonetaProviderApplicationPaymentMethod';
  /** `MonetaProviderApplicationPaymentMethod` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Pretty label for this payment method. */
  label: Scalars['String']['output'];
  /** Payment method supported by the provider-application. */
  method: MonetaProviderApplicationPaymentMethodMethodChoices;
};

/** An enumeration. */
export enum MonetaProviderApplicationPaymentMethodMethodChoices {
  /** PayNow (SG) */
  Paynow = 'PAYNOW',
}

/** Object type for `MonetaTransaction`. */
export type MonetaTransaction = ScalpelNode & {
  __typename?: 'MonetaTransaction';
  /** Date/Time this entry transaction was received and created by us. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `MonetaTransaction:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this transaction is considered successful. */
  isSuccessful: Scalars['Boolean']['output'];
  /** Metadata used by Moneta for processing of the transaction. It is validated against <a href="https://skeleton.staging.botmd.io/docs/moneta-transactionmetadata-generated.html" target="_blank">moneta/TransactionMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Transaction status. */
  status: MonetaTransactionStatusChoices;
  /** Transaction type. */
  type: MonetaTransactionTypeChoices;
  /** A unique ID for this object. */
  uid: Scalars['String']['output'];
};

/** An enumeration. */
export enum MonetaTransactionStatusChoices {
  /** Application Exception */
  ApplicationException = 'APPLICATION_EXCEPTION',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** Failed */
  Failed = 'FAILED',
  /** Success */
  Success = 'SUCCESS',
}

/** An enumeration. */
export enum MonetaTransactionTypeChoices {
  /** Cancel Payment Request */
  CancelPaymentRequest = 'CANCEL_PAYMENT_REQUEST',
  /** Payment Received */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** Payment Request */
  PaymentRequest = 'PAYMENT_REQUEST',
  /** Refund Payment */
  RefundPayment = 'REFUND_PAYMENT',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutation to create a `CleoAlertRule`. */
  cleoAlertRuleCreate?: Maybe<CreateCleoAlertRule>;
  /** Mutation to delete a `CleoAlertRule`. */
  cleoAlertRuleDelete?: Maybe<DeleteCleoAlertRule>;
  /** Mutation to update a `CleoAlertRule`. */
  cleoAlertRuleUpdate?: Maybe<UpdateCleoAlertRule>;
  /** Mutation to create a `CleoClinic`. */
  cleoClinicCreate?: Maybe<CreateCleoClinic>;
  /** Mutation to delete a `CleoClinic`. */
  cleoClinicDelete?: Maybe<DeleteCleoClinic>;
  /** Mutation to create a `CleoClinicFilter`. */
  cleoClinicFilterCreate?: Maybe<CreateCleoClinicFilter>;
  /** Mutation to delete a `CleoClinicFilter`. */
  cleoClinicFilterDelete?: Maybe<DeleteCleoClinicFilter>;
  /** Mutation to update a `CleoClinicFilter`. */
  cleoClinicFilterUpdate?: Maybe<UpdateCleoClinicFilter>;
  /** Mutation to create a `CleoClinicGroup`. */
  cleoClinicGroupCreate?: Maybe<CreateCleoClinicGroup>;
  /** Mutation to delete a `CleoClinicGroup`. */
  cleoClinicGroupDelete?: Maybe<DeleteCleoClinicGroup>;
  /** Mutation to update a `CleoClinicGroup`. */
  cleoClinicGroupUpdate?: Maybe<UpdateCleoClinicGroup>;
  /** Mutation to create a `CleoClinicProduct`. */
  cleoClinicProductCreate?: Maybe<CreateCleoClinicProduct>;
  /** Mutation to delete a `CleoClinicProduct`. */
  cleoClinicProductDelete?: Maybe<DeleteCleoClinicProduct>;
  /** Mutation to update a `CleoClinicProduct`. */
  cleoClinicProductUpdate?: Maybe<UpdateCleoClinicProduct>;
  /** Mutation to delete a `CleoClinicProgram`. */
  cleoClinicProgramDelete?: Maybe<DeleteCleoClinicProgram>;
  /** Mutation to delete a `CleoClinicProgramMonitoringFormset`. */
  cleoClinicProgramMonitoringFormsetDelete?: Maybe<DeleteCleoClinicProgramMonitoringFormset>;
  /** Mutation to update a `CleoClinicProgramMonitoringFormset`. */
  cleoClinicProgramMonitoringFormsetUpdate?: Maybe<UpdateCleoClinicProgramMonitoringFormset>;
  /** Mutation to update a `CleoClinicProgram`. */
  cleoClinicProgramUpdate?: Maybe<UpdateCleoClinicProgram>;
  /** Mutation to create a `CleoClinicRatatoskrProviderApplication`. */
  cleoClinicRatatoskrProviderApplicationCreate?: Maybe<CreateCleoClinicRatatoskrProviderApplication>;
  /** Mutation to delete a `CleoClinicRatatoskrProviderApplication`. */
  cleoClinicRatatoskrProviderApplicationDelete?: Maybe<DeleteCleoClinicRatatoskrProviderApplication>;
  /** Mutation to update a `CleoClinicRatatoskrProviderApplication`. */
  cleoClinicRatatoskrProviderApplicationUpdate?: Maybe<UpdateCleoClinicRatatoskrProviderApplication>;
  /** Mutation to update a `CleoClinic`. */
  cleoClinicUpdate?: Maybe<UpdateCleoClinic>;
  /** Mutation to create a `CleoClinicalParameter`. */
  cleoClinicalParameterCreate?: Maybe<CreateCleoClinicalParameter>;
  /** Mutation to delete a `CleoClinicalParameter`. */
  cleoClinicalParameterDelete?: Maybe<DeleteCleoClinicalParameter>;
  /** Mutation to update a `CleoClinicalParameter`. */
  cleoClinicalParameterUpdate?: Maybe<UpdateCleoClinicalParameter>;
  /** Mutation to create a `CleoClinician`. */
  cleoClinicianCreate?: Maybe<CreateCleoClinician>;
  /** Mutation to delete a `CleoClinician`. */
  cleoClinicianDelete?: Maybe<DeleteCleoClinician>;
  /** Set clinician-patientform relations in one go. (DEPRECATED) */
  cleoClinicianPatientFormRelationsUpdate?: Maybe<CleoClinicianPatientFormRelationsUpdate>;
  /** Set clinician-patient relations in one go. */
  cleoClinicianPatientRelationsUpdate?: Maybe<CleoClinicianPatientRelationsUpdate>;
  /** Reassign all of clinician A's patient-relations to clinician B. */
  cleoClinicianReassignment?: Maybe<CleoClinicianReassignment>;
  /** Mutation to update a `CleoClinician`. */
  cleoClinicianUpdate?: Maybe<UpdateCleoClinician>;
  /** Update or insert patient into clinic. */
  cleoExternalPatient?: Maybe<CleoExternalPatientMutation>;
  /** Mutation to create a `CleoMessageTemplate`. */
  cleoMessageTemplateCreate?: Maybe<CreateCleoMessageTemplate>;
  /** Mutation to delete a `CleoMessageTemplate`. */
  cleoMessageTemplateDelete?: Maybe<DeleteCleoMessageTemplate>;
  /** Deliver message template to patients. */
  cleoMessageTemplateDeliverToPatient?: Maybe<CleoMessageTemplateDeliverToPatient>;
  /** Asynchronously deliver message template to patients. */
  cleoMessageTemplateDeliverToPatientAsync?: Maybe<CleoMessageTemplateDeliverToPatientAsync>;
  /** Mutation to create a `CleoMessageTemplateSet`. */
  cleoMessageTemplateSetCreate?: Maybe<CreateCleoMessageTemplateSet>;
  /** Mutation to delete a `CleoMessageTemplateSet`. */
  cleoMessageTemplateSetDelete?: Maybe<DeleteCleoMessageTemplateSet>;
  /** Mutation to update a `CleoMessageTemplateSet`. */
  cleoMessageTemplateSetUpdate?: Maybe<UpdateCleoMessageTemplateSet>;
  /** Mutation to update a `CleoMessageTemplate`. */
  cleoMessageTemplateUpdate?: Maybe<UpdateCleoMessageTemplate>;
  /** Mutation to update a `CleoMonitoringFormset`. */
  cleoMonitoringFormsetUpdate?: Maybe<UpdateCleoMonitoringFormset>;
  /** Mutation to create a `CleoPatient`. */
  cleoPatientCreate?: Maybe<CreateCleoPatient>;
  /** Mutation to delete a `CleoPatient`. */
  cleoPatientDelete?: Maybe<DeleteCleoPatient>;
  /** Cancellation of patient events. */
  cleoPatientEventDelete?: Maybe<CleoPatientEventDelete>;
  /** Asynchronously cancel patient events. */
  cleoPatientEventDeleteAsync?: Maybe<CleoPatientEventDeleteAsync>;
  /** Mutation to create a `CleoPatientEventMetadataEntry`. */
  cleoPatientEventMetadataEntryCreate?: Maybe<CreateCleoPatientEventMetadataEntry>;
  /** Mutation to update a `CleoPatientEventMetadataEntry`. */
  cleoPatientEventMetadataEntryUpdate?: Maybe<UpdateCleoPatientEventMetadataEntry>;
  /** Update of patient events. */
  cleoPatientEventUpdate?: Maybe<CleoPatientEventUpdate>;
  /** Asynchronously update patient events. */
  cleoPatientEventUpdateAsync?: Maybe<CleoPatientEventUpdateAsync>;
  /** Enroll or discharge a patient-form. This operation will update the patient-form `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
  cleoPatientFormEnrollDischarge?: Maybe<CleoPatientFormEnrollDischarge>;
  /** Asynchronously enroll or discharge a patient-form. This operation will update the patient-form `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
  cleoPatientFormEnrollDischargeAsync?: Maybe<CleoPatientFormEnrollDischargeAsync>;
  /** Mutation to create a `CleoPatientFormMetadataEntry`. */
  cleoPatientFormMetadataEntryCreate?: Maybe<CreateCleoPatientFormMetadataEntry>;
  /** Mutation to update a `CleoPatientFormMetadataEntry`. */
  cleoPatientFormMetadataEntryUpdate?: Maybe<UpdateCleoPatientFormMetadataEntry>;
  /** Mutation to update a `CleoPatientForm`. */
  cleoPatientFormUpdate?: Maybe<UpdateCleoPatientForm>;
  /** Mutation to create a `CleoPatientGroup`. */
  cleoPatientGroupCreate?: Maybe<CreateCleoPatientGroup>;
  /** Mutation to delete a `CleoPatientGroup`. */
  cleoPatientGroupDelete?: Maybe<DeleteCleoPatientGroup>;
  /** Mutation to update a `CleoPatientGroup`. */
  cleoPatientGroupUpdate?: Maybe<UpdateCleoPatientGroup>;
  /** Synchronous import of patient forms via CSV or Excel. Do not use this when there are more than 500 entries. (DEPRECATED) */
  cleoPatientImport?: Maybe<CleoPatientImport>;
  /** Asynchronously import of patient forms via CSV or Excel. */
  cleoPatientImportAsync?: Maybe<CleoPatientImportAsync>;
  /** Mutation to create a `CleoPatientMetadataEntry`. */
  cleoPatientMetadataEntryCreate?: Maybe<CreateCleoPatientMetadataEntry>;
  /** Mutation to update a `CleoPatientMetadataEntry`. */
  cleoPatientMetadataEntryUpdate?: Maybe<UpdateCleoPatientMetadataEntry>;
  /** Cancel a patient payment. */
  cleoPatientPaymentCancelRequest?: Maybe<CleoPatientPaymentCancelRequest>;
  /** Create a patient payment. */
  cleoPatientPaymentCreate?: Maybe<CleoPatientPaymentCreate>;
  /** Refund a patient payment. */
  cleoPatientPaymentRefund?: Maybe<CleoPatientPaymentRefund>;
  /** Enroll or discharge a patient-program. This operation will update the patient-program `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
  cleoPatientProgramEnrollDischarge?: Maybe<CleoPatientProgramEnrollDischarge>;
  /** Asynchronously enroll or discharge a patient-program. This operation will update the patient-program `deactivatedOn` field and force delivery of enrollment/discharge messages. _This operation is idempotent._ */
  cleoPatientProgramEnrollDischargeAsync?: Maybe<CleoPatientProgramEnrollDischargeAsync>;
  /** Mutation to create a `CleoPatientProgramFormMetadataEntry`. */
  cleoPatientProgramFormMetadataEntryCreate?: Maybe<CreateCleoPatientProgramFormMetadataEntry>;
  /** Mutation to update a `CleoPatientProgramFormMetadataEntry`. */
  cleoPatientProgramFormMetadataEntryUpdate?: Maybe<UpdateCleoPatientProgramFormMetadataEntry>;
  /** Mutation to update a `CleoPatientProgramForm`. */
  cleoPatientProgramFormUpdate?: Maybe<UpdateCleoPatientProgramForm>;
  /** Mutation to create a `CleoPatientProgramMetadataEntry`. */
  cleoPatientProgramMetadataEntryCreate?: Maybe<CreateCleoPatientProgramMetadataEntry>;
  /** Mutation to update a `CleoPatientProgramMetadataEntry`. */
  cleoPatientProgramMetadataEntryUpdate?: Maybe<UpdateCleoPatientProgramMetadataEntry>;
  /** Mutation to update a `CleoPatientProgram`. */
  cleoPatientProgramUpdate?: Maybe<UpdateCleoPatientProgram>;
  /** Mutation to update a `CleoPatient`. */
  cleoPatientUpdate?: Maybe<UpdateCleoPatient>;
  /** Mutation to create a `CleoReminder`. */
  cleoReminderCreate?: Maybe<CreateCleoReminder>;
  /** Mutation to delete a `CleoReminder`. */
  cleoReminderDelete?: Maybe<DeleteCleoReminder>;
  /** Mutation to update a `CleoReminder`. */
  cleoReminderUpdate?: Maybe<UpdateCleoReminder>;
  /** Mutation to create a `CleoSubmissionComment`. */
  cleoSubmissionCommentCreate?: Maybe<CreateCleoSubmissionComment>;
  /** Mark the submission as hidden. */
  cleoSubmissionHide?: Maybe<CleoSubmissionHide>;
  /** Update the submission last seen status for current profile (i.e., clinician/patient). */
  cleoSubmissionLastSeenUpdate?: Maybe<CleoSubmissionLastSeenUpdate>;
  /** Update submission last seen status for all submissions accessible by the current profile (i.e., clinician/patient). */
  cleoSubmissionLastSeenUpdateAll?: Maybe<CleoSubmissionLastSeenUpdateAll>;
  /** Mark the submission value as hidden. */
  cleoSubmissionValueHide?: Maybe<CleoSubmissionValueHide>;
  /** Mutation to update a `CleoTriggeredAlert`. */
  cleoTriggeredAlertUpdate?: Maybe<UpdateCleoTriggeredAlert>;
  /** Create a resolving comment for all unresolved `TriggeredAlert`s where the active clinician is an IC. */
  cleoTriggeredAlertsResolveAll?: Maybe<CleoTriggeredAlertsResolveAll>;
  /** Perform bulk operation on Administrators. */
  einsteinAdministratorBulkOperation?: Maybe<EinsteinAdministratorBulkOperation>;
  /** Mutation to create a `EinsteinAdministrator`. */
  einsteinAdministratorCreate?: Maybe<CreateEinsteinAdministrator>;
  /** Mutation to update a `EinsteinAdministrator`. */
  einsteinAdministratorUpdate?: Maybe<UpdateEinsteinAdministrator>;
  /** Mutation to create a `EinsteinBroadcast`. */
  einsteinBroadcastCreate?: Maybe<CreateEinsteinBroadcast>;
  /** Mutation to delete a `EinsteinBroadcast`. */
  einsteinBroadcastDelete?: Maybe<DeleteEinsteinBroadcast>;
  /** Mutation to update a `EinsteinBroadcast`. */
  einsteinBroadcastUpdate?: Maybe<UpdateEinsteinBroadcast>;
  /** Mutation to create a `EinsteinChernobylEntry`. */
  einsteinChernobylEntryCreate?: Maybe<CreateEinsteinChernobylEntry>;
  /** Mutation to update a `EinsteinChernobylEntry`. */
  einsteinChernobylEntryUpdate?: Maybe<UpdateEinsteinChernobylEntry>;
  /** Mutation to update a `EinsteinDataSource`. */
  einsteinDataSourceUpdate?: Maybe<UpdateEinsteinDataSource>;
  /** Mutation to create a `EinsteinDialogueEntry`. */
  einsteinDialogueEntryCreate?: Maybe<CreateEinsteinDialogueEntry>;
  /** Mutation to update a `EinsteinDialogueEntry`. */
  einsteinDialogueEntryUpdate?: Maybe<UpdateEinsteinDialogueEntry>;
  /** Perform an update a set of documents filtered by the provided input filters */
  einsteinDocumentEntryBulkOperation?: Maybe<EinsteinDocumentEntryBulkOperation>;
  /** Mutation to create a `EinsteinDocumentEntry`. */
  einsteinDocumentEntryCreate?: Maybe<CreateEinsteinDocumentEntry>;
  /** Mutation to update a `EinsteinDocumentEntry`. */
  einsteinDocumentEntryUpdate?: Maybe<UpdateEinsteinDocumentEntry>;
  /** Does a full einstein module sync of data sources and jarvis sync. */
  einsteinJarvisSyncModule?: Maybe<EinsteinJarvisSyncModule>;
  /** Mutation to update a `EinsteinModule`. */
  einsteinModuleUpdate?: Maybe<UpdateEinsteinModule>;
  /** Mutation to create a `EinsteinProfilesGroup`. */
  einsteinProfilesGroupCreate?: Maybe<CreateEinsteinProfilesGroup>;
  /** Mutation to delete a `EinsteinProfilesGroup`. */
  einsteinProfilesGroupDelete?: Maybe<DeleteEinsteinProfilesGroup>;
  /** Mutation to update a `EinsteinProfilesGroup`. */
  einsteinProfilesGroupUpdate?: Maybe<UpdateEinsteinProfilesGroup>;
  /** Update Einstein and Hospital related settings. */
  einsteinSettingsUpdate?: Maybe<EinsteinSettingsUpdate>;
  /** Sync a tabular data to a chernobyl data source. */
  einsteinSyncChernobylDataSource?: Maybe<EinsteinSyncChernobylDataSource>;
  /** Sync a user data source excel template file. */
  einsteinSyncExcelUserDataSource?: Maybe<EinsteinSyncExcelUserDataSource>;
  /** Update `DataSourceEntry` related fields. */
  einsteinUpdateDataSourceEntry?: Maybe<EinsteinUpdateDataSourceEntry>;
  /** Upload resources to an `EinsteinModule` private storage. */
  einsteinUploadModuleResource?: Maybe<EinsteinUploadModuleResource>;
  /** Set admin-doctor relationships in one go. */
  faradayAdminDoctorRelationshipsUpdate?: Maybe<FaradayAdminDoctorRelationshipsUpdate>;
  /** Bulk create staff profiles. */
  faradayBulkCreateStaffProfile?: Maybe<FaradayBulkCreateStaffProfile>;
  /** Deliver message template to patients. */
  faradayMessageTemplateDeliverToPatient?: Maybe<FaradayMessageTemplateDeliverToPatient>;
  /** Mutation to create a `FaradayOrder`. */
  faradayOrderCreate?: Maybe<CreateFaradayOrder>;
  /** Mutation to delete a `FaradayOrder`. */
  faradayOrderDelete?: Maybe<DeleteFaradayOrder>;
  /** Mutation to create a `FaradayOrderDraft`. */
  faradayOrderDraftCreate?: Maybe<CreateFaradayOrderDraft>;
  /** Mutation to delete a `FaradayOrderDraft`. */
  faradayOrderDraftDelete?: Maybe<DeleteFaradayOrderDraft>;
  /** Mutation to update a `FaradayOrderDraft`. */
  faradayOrderDraftUpdate?: Maybe<UpdateFaradayOrderDraft>;
  /** Mutation to create a `FaradayOrderExam`. */
  faradayOrderExamCreate?: Maybe<CreateFaradayOrderExam>;
  /** Mutation to delete a `FaradayOrderExam`. */
  faradayOrderExamDelete?: Maybe<DeleteFaradayOrderExam>;
  /** Mutation to update a `FaradayOrderExam`. */
  faradayOrderExamUpdate?: Maybe<UpdateFaradayOrderExam>;
  /** Mutation to update a `FaradayOrder`. */
  faradayOrderUpdate?: Maybe<UpdateFaradayOrder>;
  /** Update patient doctor relationships. */
  faradayPatientDoctorRelationshipsUpdate?: Maybe<FaradayPatientDoctorRelationshipsUpdate>;
  /** Mutation to create a `FaradayPatientProfile`. */
  faradayPatientProfileCreate?: Maybe<CreateFaradayPatientProfile>;
  /** Mutation to delete a `FaradayPatientProfile`. */
  faradayPatientProfileDelete?: Maybe<DeleteFaradayPatientProfile>;
  /** Mutation to update a `FaradayPatientProfile`. */
  faradayPatientProfileUpdate?: Maybe<UpdateFaradayPatientProfile>;
  /** Register a `Device` to an existing `StaffProfile`. */
  faradayRegisterDevice?: Maybe<FaradayRegisterDevice>;
  /** Favorite an exam for staff. */
  faradayStaffFavoriteExamsUpdate?: Maybe<FaradayStaffFavoriteExamsUpdate>;
  /** Mutation to create a `FaradayStaffProfile`. */
  faradayStaffProfileCreate?: Maybe<CreateFaradayStaffProfile>;
  /** Mutation to delete a `FaradayStaffProfile`. */
  faradayStaffProfileDelete?: Maybe<DeleteFaradayStaffProfile>;
  /** Mutation to update a `FaradayStaffProfile`. */
  faradayStaffProfileUpdate?: Maybe<UpdateFaradayStaffProfile>;
  /** Send a Slack notification via Ford CI bot user. This GQL is only available in SG staging. */
  fordCiSlackNotification?: Maybe<FordCiSlackNotification>;
  /** Obtain a session and user instance through the Heimdall authorization flow. */
  heimdallAuthorizationFlow?: Maybe<HeimdallAuthorizationFlow>;
  /** Logout a session. */
  heimdallLogout?: Maybe<HeimdallLogout>;
  /** A single mutation for requesting OTP token and verifying it. */
  heimdallOtpFlow?: Maybe<HeimdallOtpFlow>;
  /** Get autocomplete queries via AirTable. (DEPRECATED) */
  hospitalAutoComplete?: Maybe<HospitalAutoComplete>;
  /** Mutation to create a `HospitalBanner`. */
  hospitalBannerCreate?: Maybe<CreateHospitalBanner>;
  /** Mutation to delete a `HospitalBanner`. */
  hospitalBannerDelete?: Maybe<DeleteHospitalBanner>;
  /** Mutation to update a `HospitalBanner`. */
  hospitalBannerUpdate?: Maybe<UpdateHospitalBanner>;
  /** Broadcast message to a list of users via Bot MD. */
  hospitalBroadcastMessages?: Maybe<HospitalBroadcastMessages>;
  /** Deliver message template to user. */
  hospitalChemocalcMessageTemplateDeliver?: Maybe<HospitalChemocalcMessageTemplateDeliver>;
  /** Deliver message template to user. */
  hospitalChemocalcReportDeliver?: Maybe<HospitalChemocalcReportDeliver>;
  /** To export chemocalc report. */
  hospitalChemocalcReportExport?: Maybe<HospitalChemocalcReportExport>;
  /** Mutation to create a `HospitalDepartment`. */
  hospitalDepartmentCreate?: Maybe<CreateHospitalDepartment>;
  /** Mutation to delete a `HospitalDepartment`. */
  hospitalDepartmentDelete?: Maybe<DeleteHospitalDepartment>;
  /** Mutation to update a `HospitalDepartment`. */
  hospitalDepartmentUpdate?: Maybe<UpdateHospitalDepartment>;
  /** Mutation to create a `HospitalDesignation`. */
  hospitalDesignationCreate?: Maybe<CreateHospitalDesignation>;
  /** Mutation to delete a `HospitalDesignation`. */
  hospitalDesignationDelete?: Maybe<DeleteHospitalDesignation>;
  /** Mutation to update a `HospitalDesignation`. */
  hospitalDesignationUpdate?: Maybe<UpdateHospitalDesignation>;
  /** Perform bulk operation on Directory Profiles. */
  hospitalDirectoryProfileBulkOperation?: Maybe<HospitalDirectoryProfileBulkOperation>;
  /** Mutation to create a `HospitalDirectoryProfile`. */
  hospitalDirectoryProfileCreate?: Maybe<CreateHospitalDirectoryProfile>;
  /** Mutation to delete a `HospitalDirectoryProfile`. */
  hospitalDirectoryProfileDelete?: Maybe<DeleteHospitalDirectoryProfile>;
  /** Mutation to update a `HospitalDirectoryProfile`. */
  hospitalDirectoryProfileUpdate?: Maybe<UpdateHospitalDirectoryProfile>;
  /** Mutation to create a `HospitalDivision`. */
  hospitalDivisionCreate?: Maybe<CreateHospitalDivision>;
  /** Mutation to delete a `HospitalDivision`. */
  hospitalDivisionDelete?: Maybe<DeleteHospitalDivision>;
  /** Mutation to update a `HospitalDivision`. */
  hospitalDivisionUpdate?: Maybe<UpdateHospitalDivision>;
  /** Mutation to create a `HospitalFavourite`. */
  hospitalFavouriteCreate?: Maybe<CreateHospitalFavourite>;
  /** Mutation to delete a `HospitalFavourite`. */
  hospitalFavouriteDelete?: Maybe<DeleteHospitalFavourite>;
  /** Mutation to update a `HospitalFavourite`. */
  hospitalFavouriteUpdate?: Maybe<UpdateHospitalFavourite>;
  /** Execute a Jarvis query flow. */
  hospitalJarvisQuery?: Maybe<HospitalJarvisQuery>;
  /** Mutation to create a `HospitalMoodLog`. */
  hospitalMoodLogCreate?: Maybe<CreateHospitalMoodLog>;
  /** Mutation to create a `HospitalMoodLogReminder`. */
  hospitalMoodLogReminderCreate?: Maybe<CreateHospitalMoodLogReminder>;
  /** Mutation to delete a `HospitalMoodLogReminder`. */
  hospitalMoodLogReminderDelete?: Maybe<DeleteHospitalMoodLogReminder>;
  /** Mutation to update a `HospitalMoodLogReminder`. */
  hospitalMoodLogReminderUpdate?: Maybe<UpdateHospitalMoodLogReminder>;
  /** Send a message to the Hospital bot via GraphQL. */
  hospitalPostMessage?: Maybe<HospitalPostMessage>;
  /** Mutation to create a `HospitalQueryFeedback`. */
  hospitalQueryFeedbackCreate?: Maybe<CreateHospitalQueryFeedback>;
  /** Register a `Device` to an existing `HospitalProfile`. */
  hospitalRegisterDevice?: Maybe<HospitalRegisterDevice>;
  /** Mutation to update a `HospitalProfile`. */
  hospitalUpdateHospitalProfile?: Maybe<UpdateHospitalProfile>;
  /** Mutation to delete a `MerlinAdministrator`. */
  merlinAdministratorDelete?: Maybe<DeleteMerlinAdministrator>;
  /** Mutation to update a `MerlinAdministrator`. */
  merlinAdministratorUpdate?: Maybe<UpdateMerlinAdministrator>;
  /** Mutation for Merlin's clinic creation flow. */
  merlinClinicImport?: Maybe<MerlinClinicImport>;
  /** Mutation to create WhatsAppTemplate. */
  merlinWhatsAppTemplateCreate?: Maybe<MerlinWhatsAppTemplateCreate>;
  /** Mutation to update WhatsAppTemplate. */
  merlinWhatsAppTemplateUpdate?: Maybe<MerlinWhatsAppTemplateUpdate>;
  /** Posts events to Amplitude via Shadowfax. */
  shadowfaxPostEvent?: Maybe<ShadowfaxPostEvent>;
  /** Create a Stitch Link using a Stitch Provider. Unconventional naming due to legacy reasons. */
  stitchCreateLink?: Maybe<StitchCreateLink>;
  /** Create a presigned post-URL for uploading temporary files. Note that the maximum supported file size is 10MB. */
  stitchCreateUploadUrl?: Maybe<StitchCreateUploadUrl>;
  /** Mutation to update a `StitchLink`. */
  stitchLinkUpdate?: Maybe<UpdateStitchLink>;
  /** Mutation to update a `HospitalProfile`. */
  updateHospitalProfile?: Maybe<UpdateHospitalProfile>;
};

export type MutationCleoAlertRuleCreateArgs = {
  input: CreateCleoAlertRuleInput;
};

export type MutationCleoAlertRuleDeleteArgs = {
  input: DeleteCleoAlertRuleInput;
};

export type MutationCleoAlertRuleUpdateArgs = {
  input: UpdateCleoAlertRuleInput;
};

export type MutationCleoClinicCreateArgs = {
  input: CreateCleoClinicInput;
};

export type MutationCleoClinicDeleteArgs = {
  input: DeleteCleoClinicInput;
};

export type MutationCleoClinicFilterCreateArgs = {
  input: CreateCleoClinicFilterInput;
};

export type MutationCleoClinicFilterDeleteArgs = {
  input: DeleteCleoClinicFilterInput;
};

export type MutationCleoClinicFilterUpdateArgs = {
  input: UpdateCleoClinicFilterInput;
};

export type MutationCleoClinicGroupCreateArgs = {
  input: CreateCleoClinicGroupInput;
};

export type MutationCleoClinicGroupDeleteArgs = {
  input: DeleteCleoClinicGroupInput;
};

export type MutationCleoClinicGroupUpdateArgs = {
  input: UpdateCleoClinicGroupInput;
};

export type MutationCleoClinicProductCreateArgs = {
  input: CreateCleoClinicProductInput;
};

export type MutationCleoClinicProductDeleteArgs = {
  input: DeleteCleoClinicProductInput;
};

export type MutationCleoClinicProductUpdateArgs = {
  input: UpdateCleoClinicProductInput;
};

export type MutationCleoClinicProgramDeleteArgs = {
  input: DeleteCleoClinicProgramInput;
};

export type MutationCleoClinicProgramMonitoringFormsetDeleteArgs = {
  input: DeleteCleoClinicProgramMonitoringFormsetInput;
};

export type MutationCleoClinicProgramMonitoringFormsetUpdateArgs = {
  input: UpdateCleoClinicProgramMonitoringFormsetInput;
};

export type MutationCleoClinicProgramUpdateArgs = {
  input: UpdateCleoClinicProgramInput;
};

export type MutationCleoClinicRatatoskrProviderApplicationCreateArgs = {
  input: CreateCleoClinicRatatoskrProviderApplicationInput;
};

export type MutationCleoClinicRatatoskrProviderApplicationDeleteArgs = {
  input: DeleteCleoClinicRatatoskrProviderApplicationInput;
};

export type MutationCleoClinicRatatoskrProviderApplicationUpdateArgs = {
  input: UpdateCleoClinicRatatoskrProviderApplicationInput;
};

export type MutationCleoClinicUpdateArgs = {
  input: UpdateCleoClinicInput;
};

export type MutationCleoClinicalParameterCreateArgs = {
  input: CreateCleoClinicalParameterInput;
};

export type MutationCleoClinicalParameterDeleteArgs = {
  input: DeleteCleoClinicalParameterInput;
};

export type MutationCleoClinicalParameterUpdateArgs = {
  input: UpdateCleoClinicalParameterInput;
};

export type MutationCleoClinicianCreateArgs = {
  input: CreateCleoClinicianInput;
};

export type MutationCleoClinicianDeleteArgs = {
  input: DeleteCleoClinicianInput;
};

export type MutationCleoClinicianPatientFormRelationsUpdateArgs = {
  input: CleoClinicianPatientFormRelationsUpdateInput;
};

export type MutationCleoClinicianPatientRelationsUpdateArgs = {
  input: CleoClinicianPatientRelationsUpdateInput;
};

export type MutationCleoClinicianReassignmentArgs = {
  input: CleoClinicianReassignmentInput;
};

export type MutationCleoClinicianUpdateArgs = {
  input: UpdateCleoClinicianInput;
};

export type MutationCleoExternalPatientArgs = {
  input: CleoExternalPatientMutationInput;
};

export type MutationCleoMessageTemplateCreateArgs = {
  input: CreateCleoMessageTemplateInput;
};

export type MutationCleoMessageTemplateDeleteArgs = {
  input: DeleteCleoMessageTemplateInput;
};

export type MutationCleoMessageTemplateDeliverToPatientArgs = {
  input: CleoMessageTemplateDeliverToPatientInput;
};

export type MutationCleoMessageTemplateDeliverToPatientAsyncArgs = {
  input: CleoMessageTemplateDeliverToPatientAsyncInput;
};

export type MutationCleoMessageTemplateSetCreateArgs = {
  input: CreateCleoMessageTemplateSetInput;
};

export type MutationCleoMessageTemplateSetDeleteArgs = {
  input: DeleteCleoMessageTemplateSetInput;
};

export type MutationCleoMessageTemplateSetUpdateArgs = {
  input: UpdateCleoMessageTemplateSetInput;
};

export type MutationCleoMessageTemplateUpdateArgs = {
  input: UpdateCleoMessageTemplateInput;
};

export type MutationCleoMonitoringFormsetUpdateArgs = {
  input: UpdateCleoMonitoringFormsetInput;
};

export type MutationCleoPatientCreateArgs = {
  input: CreateCleoPatientInput;
};

export type MutationCleoPatientDeleteArgs = {
  input: DeleteCleoPatientInput;
};

export type MutationCleoPatientEventDeleteArgs = {
  input: CleoPatientEventDeleteInput;
};

export type MutationCleoPatientEventDeleteAsyncArgs = {
  input: CleoPatientEventDeleteAsyncInput;
};

export type MutationCleoPatientEventMetadataEntryCreateArgs = {
  input: CreateCleoPatientEventMetadataEntryInput;
};

export type MutationCleoPatientEventMetadataEntryUpdateArgs = {
  input: UpdateCleoPatientEventMetadataEntryInput;
};

export type MutationCleoPatientEventUpdateArgs = {
  input: CleoPatientEventUpdateInput;
};

export type MutationCleoPatientEventUpdateAsyncArgs = {
  input: CleoPatientEventUpdateAsyncInput;
};

export type MutationCleoPatientFormEnrollDischargeArgs = {
  input: CleoPatientFormEnrollDischargeInput;
};

export type MutationCleoPatientFormEnrollDischargeAsyncArgs = {
  input: CleoPatientFormEnrollDischargeAsyncInput;
};

export type MutationCleoPatientFormMetadataEntryCreateArgs = {
  input: CreateCleoPatientFormMetadataEntryInput;
};

export type MutationCleoPatientFormMetadataEntryUpdateArgs = {
  input: UpdateCleoPatientFormMetadataEntryInput;
};

export type MutationCleoPatientFormUpdateArgs = {
  input: UpdateCleoPatientFormInput;
};

export type MutationCleoPatientGroupCreateArgs = {
  input: CreateCleoPatientGroupInput;
};

export type MutationCleoPatientGroupDeleteArgs = {
  input: DeleteCleoPatientGroupInput;
};

export type MutationCleoPatientGroupUpdateArgs = {
  input: UpdateCleoPatientGroupInput;
};

export type MutationCleoPatientImportArgs = {
  input: CleoPatientImportInput;
};

export type MutationCleoPatientImportAsyncArgs = {
  input: CleoPatientImportAsyncInput;
};

export type MutationCleoPatientMetadataEntryCreateArgs = {
  input: CreateCleoPatientMetadataEntryInput;
};

export type MutationCleoPatientMetadataEntryUpdateArgs = {
  input: UpdateCleoPatientMetadataEntryInput;
};

export type MutationCleoPatientPaymentCancelRequestArgs = {
  input: CleoPatientPaymentCancelRequestInput;
};

export type MutationCleoPatientPaymentCreateArgs = {
  input: CleoPatientPaymentCreateInput;
};

export type MutationCleoPatientPaymentRefundArgs = {
  input: CleoPatientPaymentRefundInput;
};

export type MutationCleoPatientProgramEnrollDischargeArgs = {
  input: CleoPatientProgramEnrollDischargeInput;
};

export type MutationCleoPatientProgramEnrollDischargeAsyncArgs = {
  input: CleoPatientProgramEnrollDischargeAsyncInput;
};

export type MutationCleoPatientProgramFormMetadataEntryCreateArgs = {
  input: CreateCleoPatientProgramFormMetadataEntryInput;
};

export type MutationCleoPatientProgramFormMetadataEntryUpdateArgs = {
  input: UpdateCleoPatientProgramFormMetadataEntryInput;
};

export type MutationCleoPatientProgramFormUpdateArgs = {
  input: UpdateCleoPatientProgramFormInput;
};

export type MutationCleoPatientProgramMetadataEntryCreateArgs = {
  input: CreateCleoPatientProgramMetadataEntryInput;
};

export type MutationCleoPatientProgramMetadataEntryUpdateArgs = {
  input: UpdateCleoPatientProgramMetadataEntryInput;
};

export type MutationCleoPatientProgramUpdateArgs = {
  input: UpdateCleoPatientProgramInput;
};

export type MutationCleoPatientUpdateArgs = {
  input: UpdateCleoPatientInput;
};

export type MutationCleoReminderCreateArgs = {
  input: CreateCleoReminderInput;
};

export type MutationCleoReminderDeleteArgs = {
  input: DeleteCleoReminderInput;
};

export type MutationCleoReminderUpdateArgs = {
  input: UpdateCleoReminderInput;
};

export type MutationCleoSubmissionCommentCreateArgs = {
  input: CreateCleoSubmissionCommentInput;
};

export type MutationCleoSubmissionHideArgs = {
  input: CleoSubmissionHideInput;
};

export type MutationCleoSubmissionLastSeenUpdateArgs = {
  input: CleoSubmissionLastSeenUpdateInput;
};

export type MutationCleoSubmissionLastSeenUpdateAllArgs = {
  input: CleoSubmissionLastSeenUpdateAllInput;
};

export type MutationCleoSubmissionValueHideArgs = {
  input: CleoSubmissionValueHideInput;
};

export type MutationCleoTriggeredAlertUpdateArgs = {
  input: UpdateCleoTriggeredAlertInput;
};

export type MutationCleoTriggeredAlertsResolveAllArgs = {
  input: CleoTriggeredAlertsResolveAllInput;
};

export type MutationEinsteinAdministratorBulkOperationArgs = {
  input: EinsteinAdministratorBulkOperationInput;
};

export type MutationEinsteinAdministratorCreateArgs = {
  input: CreateEinsteinAdministratorInput;
};

export type MutationEinsteinAdministratorUpdateArgs = {
  input: UpdateEinsteinAdministratorInput;
};

export type MutationEinsteinBroadcastCreateArgs = {
  input: CreateEinsteinBroadcastInput;
};

export type MutationEinsteinBroadcastDeleteArgs = {
  input: DeleteEinsteinBroadcastInput;
};

export type MutationEinsteinBroadcastUpdateArgs = {
  input: UpdateEinsteinBroadcastInput;
};

export type MutationEinsteinChernobylEntryCreateArgs = {
  input: CreateEinsteinChernobylEntryInput;
};

export type MutationEinsteinChernobylEntryUpdateArgs = {
  input: UpdateEinsteinChernobylEntryInput;
};

export type MutationEinsteinDataSourceUpdateArgs = {
  input: UpdateEinsteinDataSourceInput;
};

export type MutationEinsteinDialogueEntryCreateArgs = {
  input: CreateEinsteinDialogueEntryInput;
};

export type MutationEinsteinDialogueEntryUpdateArgs = {
  input: UpdateEinsteinDialogueEntryInput;
};

export type MutationEinsteinDocumentEntryBulkOperationArgs = {
  input: EinsteinDocumentEntryBulkOperationInput;
};

export type MutationEinsteinDocumentEntryCreateArgs = {
  input: CreateEinsteinDocumentEntryInput;
};

export type MutationEinsteinDocumentEntryUpdateArgs = {
  input: UpdateEinsteinDocumentEntryInput;
};

export type MutationEinsteinJarvisSyncModuleArgs = {
  input: EinsteinJarvisSyncModuleInput;
};

export type MutationEinsteinModuleUpdateArgs = {
  input: UpdateEinsteinModuleInput;
};

export type MutationEinsteinProfilesGroupCreateArgs = {
  input: CreateEinsteinProfilesGroupInput;
};

export type MutationEinsteinProfilesGroupDeleteArgs = {
  input: DeleteEinsteinProfilesGroupInput;
};

export type MutationEinsteinProfilesGroupUpdateArgs = {
  input: UpdateEinsteinProfilesGroupInput;
};

export type MutationEinsteinSettingsUpdateArgs = {
  input: EinsteinSettingsUpdateInput;
};

export type MutationEinsteinSyncChernobylDataSourceArgs = {
  input: EinsteinSyncChernobylDataSourceInput;
};

export type MutationEinsteinSyncExcelUserDataSourceArgs = {
  input: EinsteinSyncExcelUserDataSourceInput;
};

export type MutationEinsteinUpdateDataSourceEntryArgs = {
  input: EinsteinUpdateDataSourceEntryInput;
};

export type MutationEinsteinUploadModuleResourceArgs = {
  input: EinsteinUploadModuleResourceInput;
};

export type MutationFaradayAdminDoctorRelationshipsUpdateArgs = {
  input: FaradayAdminDoctorRelationshipsUpdateInput;
};

export type MutationFaradayBulkCreateStaffProfileArgs = {
  input: FaradayBulkCreateStaffProfileInput;
};

export type MutationFaradayMessageTemplateDeliverToPatientArgs = {
  input: FaradayMessageTemplateDeliverToPatientInput;
};

export type MutationFaradayOrderCreateArgs = {
  input: CreateFaradayOrderInput;
};

export type MutationFaradayOrderDeleteArgs = {
  input: DeleteFaradayOrderInput;
};

export type MutationFaradayOrderDraftCreateArgs = {
  input: CreateFaradayOrderDraftInput;
};

export type MutationFaradayOrderDraftDeleteArgs = {
  input: DeleteFaradayOrderDraftInput;
};

export type MutationFaradayOrderDraftUpdateArgs = {
  input: UpdateFaradayOrderDraftInput;
};

export type MutationFaradayOrderExamCreateArgs = {
  input: CreateFaradayOrderExamInput;
};

export type MutationFaradayOrderExamDeleteArgs = {
  input: DeleteFaradayOrderExamInput;
};

export type MutationFaradayOrderExamUpdateArgs = {
  input: UpdateFaradayOrderExamInput;
};

export type MutationFaradayOrderUpdateArgs = {
  input: UpdateFaradayOrderInput;
};

export type MutationFaradayPatientDoctorRelationshipsUpdateArgs = {
  input: FaradayPatientDoctorRelationshipsUpdateInput;
};

export type MutationFaradayPatientProfileCreateArgs = {
  input: CreateFaradayPatientProfileInput;
};

export type MutationFaradayPatientProfileDeleteArgs = {
  input: DeleteFaradayPatientProfileInput;
};

export type MutationFaradayPatientProfileUpdateArgs = {
  input: UpdateFaradayPatientProfileInput;
};

export type MutationFaradayRegisterDeviceArgs = {
  input: FaradayRegisterDeviceInput;
};

export type MutationFaradayStaffFavoriteExamsUpdateArgs = {
  input: FaradayStaffFavoriteExamsUpdateInput;
};

export type MutationFaradayStaffProfileCreateArgs = {
  input: CreateFaradayStaffProfileInput;
};

export type MutationFaradayStaffProfileDeleteArgs = {
  input: DeleteFaradayStaffProfileInput;
};

export type MutationFaradayStaffProfileUpdateArgs = {
  input: UpdateFaradayStaffProfileInput;
};

export type MutationFordCiSlackNotificationArgs = {
  input: FordCiSlackNotificationInput;
};

export type MutationHeimdallAuthorizationFlowArgs = {
  input: HeimdallAuthorizationFlowInput;
};

export type MutationHeimdallLogoutArgs = {
  input: HeimdallLogoutInput;
};

export type MutationHeimdallOtpFlowArgs = {
  input: HeimdallOtpFlowInput;
};

export type MutationHospitalAutoCompleteArgs = {
  input: HospitalAutoCompleteInput;
};

export type MutationHospitalBannerCreateArgs = {
  input: CreateHospitalBannerInput;
};

export type MutationHospitalBannerDeleteArgs = {
  input: DeleteHospitalBannerInput;
};

export type MutationHospitalBannerUpdateArgs = {
  input: UpdateHospitalBannerInput;
};

export type MutationHospitalBroadcastMessagesArgs = {
  input: HospitalBroadcastMessagesInput;
};

export type MutationHospitalChemocalcMessageTemplateDeliverArgs = {
  input: HospitalChemocalcMessageTemplateDeliverInput;
};

export type MutationHospitalChemocalcReportDeliverArgs = {
  input: HospitalChemocalcReportDeliverInput;
};

export type MutationHospitalChemocalcReportExportArgs = {
  input: HospitalChemocalcReportExportInput;
};

export type MutationHospitalDepartmentCreateArgs = {
  input: CreateHospitalDepartmentInput;
};

export type MutationHospitalDepartmentDeleteArgs = {
  input: DeleteHospitalDepartmentInput;
};

export type MutationHospitalDepartmentUpdateArgs = {
  input: UpdateHospitalDepartmentInput;
};

export type MutationHospitalDesignationCreateArgs = {
  input: CreateHospitalDesignationInput;
};

export type MutationHospitalDesignationDeleteArgs = {
  input: DeleteHospitalDesignationInput;
};

export type MutationHospitalDesignationUpdateArgs = {
  input: UpdateHospitalDesignationInput;
};

export type MutationHospitalDirectoryProfileBulkOperationArgs = {
  input: HospitalDirectoryProfileBulkOperationInput;
};

export type MutationHospitalDirectoryProfileCreateArgs = {
  input: CreateHospitalDirectoryProfileInput;
};

export type MutationHospitalDirectoryProfileDeleteArgs = {
  input: DeleteHospitalDirectoryProfileInput;
};

export type MutationHospitalDirectoryProfileUpdateArgs = {
  input: UpdateHospitalDirectoryProfileInput;
};

export type MutationHospitalDivisionCreateArgs = {
  input: CreateHospitalDivisionInput;
};

export type MutationHospitalDivisionDeleteArgs = {
  input: DeleteHospitalDivisionInput;
};

export type MutationHospitalDivisionUpdateArgs = {
  input: UpdateHospitalDivisionInput;
};

export type MutationHospitalFavouriteCreateArgs = {
  input: CreateHospitalFavouriteInput;
};

export type MutationHospitalFavouriteDeleteArgs = {
  input: DeleteHospitalFavouriteInput;
};

export type MutationHospitalFavouriteUpdateArgs = {
  input: UpdateHospitalFavouriteInput;
};

export type MutationHospitalJarvisQueryArgs = {
  input: HospitalJarvisQueryInput;
};

export type MutationHospitalMoodLogCreateArgs = {
  input: CreateHospitalMoodLogInput;
};

export type MutationHospitalMoodLogReminderCreateArgs = {
  input: CreateHospitalMoodLogReminderInput;
};

export type MutationHospitalMoodLogReminderDeleteArgs = {
  input: DeleteHospitalMoodLogReminderInput;
};

export type MutationHospitalMoodLogReminderUpdateArgs = {
  input: UpdateHospitalMoodLogReminderInput;
};

export type MutationHospitalPostMessageArgs = {
  input: HospitalPostMessageInput;
};

export type MutationHospitalQueryFeedbackCreateArgs = {
  input: CreateHospitalQueryFeedbackInput;
};

export type MutationHospitalRegisterDeviceArgs = {
  input: HospitalRegisterDeviceInput;
};

export type MutationHospitalUpdateHospitalProfileArgs = {
  input: UpdateHospitalProfileInput;
};

export type MutationMerlinAdministratorDeleteArgs = {
  input: DeleteMerlinAdministratorInput;
};

export type MutationMerlinAdministratorUpdateArgs = {
  input: UpdateMerlinAdministratorInput;
};

export type MutationMerlinClinicImportArgs = {
  input: MerlinClinicImportInput;
};

export type MutationMerlinWhatsAppTemplateCreateArgs = {
  input: MerlinWhatsAppTemplateCreateInput;
};

export type MutationMerlinWhatsAppTemplateUpdateArgs = {
  input: MerlinWhatsAppTemplateUpdateInput;
};

export type MutationShadowfaxPostEventArgs = {
  input: ShadowfaxPostEventInput;
};

export type MutationStitchCreateLinkArgs = {
  input: StitchCreateLinkInput;
};

export type MutationStitchCreateUploadUrlArgs = {
  input: StitchCreateUploadUrlInput;
};

export type MutationStitchLinkUpdateArgs = {
  input: UpdateStitchLinkInput;
};

export type MutationUpdateHospitalProfileArgs = {
  input: UpdateHospitalProfileInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type OrderExamInput = {
  /** UID of the exam to schedule. */
  examUid: Scalars['String']['input'];
  /** OrderExam metadata. */
  metadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** UID of the room to schedule. */
  roomUid: Scalars['String']['input'];
  /** DateTime of the schedule */
  scheduledFor: Scalars['DateTime']['input'];
};

export enum OrderOrderBy {
  CreatedBy = 'CREATED_BY',
  CreatedOn = 'CREATED_ON',
  Exams = 'EXAMS',
  Patient = 'PATIENT',
  ScheduledFor = 'SCHEDULED_FOR',
  Status = 'STATUS',
  UpdatedOn = 'UPDATED_ON',
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** This field may not return the results as expected. Refer to the [GraphQL Guide: Connections section](https://gitlab.com/fivehealth/engineering/-/blob/master/rfcs/0006-graphql-guide.md#connections) for details. */
  hasNextPage: Scalars['Boolean']['output'];
  /** This field may not return the results as expected. Refer to the [GraphQL Guide: Connections section](https://gitlab.com/fivehealth/engineering/-/blob/master/rfcs/0006-graphql-guide.md#connections) for details. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PatientEventFilter = {
  /** Filter based on patient event's calendar. */
  calendar_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on patient event's event type. */
  event_EventType_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If `true`, returns upcoming events (including events that are in-progress), else if `false`, returns events that have ended. If `null`, returns all events. */
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter patient events based on status. */
  statusIn?: InputMaybe<Array<PatientEventStatus>>;
};

export enum PatientEventOrderBy {
  CreatedOn = 'CREATED_ON',
  EventName = 'EVENT_NAME',
  EventStartOn = 'EVENT_START_ON',
  PatientName = 'PATIENT_NAME',
}

export enum PatientEventStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  NotConfirmed = 'NOT_CONFIRMED',
  Past = 'PAST',
  PatientNotShowed = 'PATIENT_NOT_SHOWED',
  PatientReminderSent = 'PATIENT_REMINDER_SENT',
  PatientShowed = 'PATIENT_SHOWED',
  Pending = 'PENDING',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED',
}

export type PatientFilter = {
  /** Filter based on patient's communication method. */
  communicationMethod_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter patients enrolled after this date/time. */
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter patients enrolled before this date/time. */
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter based on patient's deactivated on. */
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter patients who have enrolled monitoring forms in this list of UIDs. Monitoring formset UIDs can be used here as well. */
  enrolledMonitoringForm_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on patient's gender. */
  gender_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter patient's device cration status */
  isDeviceCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter patient's device subscription */
  isDeviceSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter patient by follower */
  isFollower?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on patient's clnician in-charge. */
  patientForms_ClinicianRelations_Clinician_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on patient's monitoring programs. */
  patientForms_MonitoringForm_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter based on patient's clinic programs. */
  patientPrograms_ClinicProgram_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PatientFormOperation {
  Discharge = 'DISCHARGE',
  Enroll = 'ENROLL',
}

export enum PatientFormOrderBy {
  DischargedDate = 'DISCHARGED_DATE',
  EnrollmentDate = 'ENROLLMENT_DATE',
  IcClinicianName = 'IC_CLINICIAN_NAME',
  LastSubmittedDate = 'LAST_SUBMITTED_DATE',
  MonitoringFormEffectiveName = 'MONITORING_FORM_EFFECTIVE_NAME',
  Name = 'NAME',
}

export enum PatientGroupOrderBy {
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
}

/** Used to override specific fields during import. These values will be applied to all patients. Common options are: `monitoring_form`, `communication_method`, `language`, `icsUids`. */
export type PatientImportAdditionalInput = {
  /** Alert rules names/UIDs. */
  alertRules?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinic program names/UIDs. */
  clinicPrograms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician alertees names/UIDs. */
  clinicianAlertees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician caregivers names/UIDs. */
  clinicianCaregivers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Clinician ICs names/UIDs. */
  clinicianIcs?: InputMaybe<Array<Scalars['String']['input']>>;
  communicationMethod?: InputMaybe<CommunicationMethod>;
  /** Gender of the patient. Can be left empty. */
  gender?: InputMaybe<CleoPatientGenderChoices>;
  /** Language of patient. */
  language?: InputMaybe<Language>;
  /** Monitoring form/formset names/UIDs. */
  monitoringForms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reminder names/UIDs. */
  reminders?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PatientOrderBy {
  CreatedOn = 'CREATED_ON',
  EnrollmentDate = 'ENROLLMENT_DATE',
  IcClinicianName = 'IC_CLINICIAN_NAME',
  Name = 'NAME',
}

export enum PatientPaymentOrderBy {
  ClinicProductName = 'CLINIC_PRODUCT_NAME',
  PatientName = 'PATIENT_NAME',
  PaymentCreatedOn = 'PAYMENT_CREATED_ON',
}

export enum PatientProfileOrderBy {
  DoctorInCharge = 'DOCTOR_IN_CHARGE',
  FullName = 'FULL_NAME',
  LastOrderDate = 'LAST_ORDER_DATE',
}

export enum PatientProgramFormOrderBy {
  ClinicProgramName = 'CLINIC_PROGRAM_NAME',
  DischargedDate = 'DISCHARGED_DATE',
  EnrollmentDate = 'ENROLLMENT_DATE',
  IcClinicianName = 'IC_CLINICIAN_NAME',
  LastSubmittedDate = 'LAST_SUBMITTED_DATE',
  Name = 'NAME',
}

export enum PatientProgramOperation {
  Discharge = 'DISCHARGE',
  Enroll = 'ENROLL',
}

export enum PatientProgramOrderBy {
  DischargedDate = 'DISCHARGED_DATE',
  EnrollmentDate = 'ENROLLMENT_DATE',
  Name = 'NAME',
  ProgramName = 'PROGRAM_NAME',
}

export enum PatientReminderTaskOrderBy {
  NextReminderDate = 'NEXT_REMINDER_DATE',
  ProgramName = 'PROGRAM_NAME',
  ReminderName = 'REMINDER_NAME',
}

export type PaymentAmountInput = {
  /** Amount of payment requested. */
  amount: Scalars['Decimal']['input'];
  /** The 3 letter currency code. */
  currency: Scalars['String']['input'];
};

/** An enumeration. */
export enum PaymentMethod {
  Paynow = 'PAYNOW',
}

/** An enumeration. */
export enum ProfileActivationStatus {
  ActivatedWithoutSession = 'ACTIVATED_WITHOUT_SESSION',
  ActivatedWithSession = 'ACTIVATED_WITH_SESSION',
  AwaitingActivation = 'AWAITING_ACTIVATION',
  AwaitingActivationError = 'AWAITING_ACTIVATION_ERROR',
  Deactivated = 'DEACTIVATED',
}

export enum ProfilesGroupOrderBy {
  CreatedOn = 'CREATED_ON',
  Name = 'NAME',
}

export type Query = {
  __typename?: 'Query';
  /** Get a single `CleoAlertRule`. At least one of the `id` or `uid` arguments must be specified. */
  cleoAlertRule?: Maybe<CleoAlertRule>;
  /** Get a paginable and filterable list of `CleoAlertRule` via Relay connection. */
  cleoAlertRules?: Maybe<CleoAlertRuleConnection>;
  /** Get a single `CleoClinic`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinic?: Maybe<CleoClinic>;
  /** Get a single `CleoClinicCalendar`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicCalendar?: Maybe<CleoClinicCalendar>;
  /** Get a single `CleoClinicCalendarEventType`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicCalendarEventType?: Maybe<CleoClinicCalendarEventType>;
  /** Get a paginable and filterable list of `CleoClinicCalendarEventType` via Relay connection. */
  cleoClinicCalendarEventTypes?: Maybe<CleoClinicCalendarEventTypeConnection>;
  /** Get a paginable and filterable list of `CleoClinicCalendar` via Relay connection. */
  cleoClinicCalendars?: Maybe<CleoClinicCalendarConnection>;
  /** Get a single `CleoClinicFilter`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicFilter?: Maybe<CleoClinicFilter>;
  /** Get a paginable and filterable list of `CleoClinicFilter` via Relay connection. */
  cleoClinicFilters?: Maybe<CleoClinicFilterConnection>;
  /** Get a single `CleoClinicGroup`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicGroup?: Maybe<CleoClinicGroup>;
  /** Get a paginable and filterable list of `CleoClinicGroup` via Relay connection. */
  cleoClinicGroups?: Maybe<CleoClinicGroupConnection>;
  /** Get a single `CleoClinicProduct`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicProduct?: Maybe<CleoClinicProduct>;
  /** Get a paginable and filterable list of `CleoClinicProduct` via Relay connection. */
  cleoClinicProducts?: Maybe<CleoClinicProductConnection>;
  /** Get a single `CleoClinicProgram`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicProgram?: Maybe<CleoClinicProgram>;
  /** Get a single `CleoClinicProgramMonitoringFormset`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicProgramMonitoringFormset?: Maybe<CleoClinicProgramMonitoringFormset>;
  /** Get a paginable and filterable list of `CleoClinicProgramMonitoringFormset` via Relay connection. */
  cleoClinicProgramMonitoringFormsets?: Maybe<CleoClinicProgramMonitoringFormsetConnection>;
  /** Get a paginable and filterable list of `CleoClinicProgram` via Relay connection. */
  cleoClinicPrograms?: Maybe<CleoClinicProgramConnection>;
  /** Publicly accessible endpoint to get various publicly available settings for the clinic. */
  cleoClinicPublicSettings?: Maybe<CleoClinicPublicSettings>;
  /** Get a single `CleoClinicRatatoskrProviderApplication`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicRatatoskrProviderApplication?: Maybe<CleoClinicRatatoskrProviderApplication>;
  /** Get a paginable and filterable list of `CleoClinicRatatoskrProviderApplication` via Relay connection. */
  cleoClinicRatatoskrProviderApplications?: Maybe<CleoClinicRatatoskrProviderApplicationConnection>;
  /** Get a single `CleoClinicalParameter`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinicalParameter?: Maybe<CleoClinicalParameter>;
  /** Get a paginable and filterable list of `CleoClinicalParameter` via Relay connection. */
  cleoClinicalParameters?: Maybe<CleoClinicalParameterConnection>;
  /** Get a single `CleoClinician`. At least one of the `id` or `uid` arguments must be specified. */
  cleoClinician?: Maybe<CleoClinician>;
  /** Returns a list of clinician designations for user's clinic. */
  cleoClinicianDesignations: Array<Maybe<CleoClinicianDesignation>>;
  /** Get a paginable and filterable list of `CleoClinician` via Relay connection. */
  cleoClinicians?: Maybe<CleoClinicianConnection>;
  /** Get a paginable and filterable list of `CleoClinic` via Relay connection. */
  cleoClinics?: Maybe<CleoClinicConnection>;
  /** Get a paginable list of `CleoDelivery` via Relay connection. */
  cleoDeliveries?: Maybe<CleoDeliveriesConnection>;
  cleoDeliveryCount?: Maybe<CleoDeliveryCount>;
  cleoExternalApi?: Maybe<CleoExternalApi>;
  /** Returns a list of parameters in clinic for third party integration. */
  cleoExternalClinicalParameters?: Maybe<CleoExternalClinicalParametersConnection>;
  /** Returns a list of patients in clinic for third party integration. */
  cleoExternalPatients?: Maybe<CleoExternalPatientsConnection>;
  cleoLoginableClinics?: Maybe<CleoLoginableClinics>;
  cleoMaxicare?: Maybe<CleoMaxicare>;
  /** Get a single `CleoMessageTemplate`. At least one of the `id` or `uid` arguments must be specified. */
  cleoMessageTemplate?: Maybe<CleoMessageTemplate>;
  /** Get a single `CleoMessageTemplateSet`. At least one of the `id` or `uid` arguments must be specified. */
  cleoMessageTemplateSet?: Maybe<CleoMessageTemplateSet>;
  /** Get a paginable and filterable list of `CleoMessageTemplateSet` via Relay connection. */
  cleoMessageTemplateSets?: Maybe<CleoMessageTemplateSetConnection>;
  /** Get a paginable and filterable list of `CleoMessageTemplate` via Relay connection. */
  cleoMessageTemplates?: Maybe<CleoMessageTemplateConnection>;
  /** Get a single `CleoMonitoringFormset`. At least one of the `id` or `uid` arguments must be specified. */
  cleoMonitoringFormset?: Maybe<CleoMonitoringFormset>;
  /** Get a paginable and filterable list of `CleoMonitoringFormset` via Relay connection. */
  cleoMonitoringFormsets?: Maybe<CleoMonitoringFormsetConnection>;
  /** Get a single `CleoPatient`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatient?: Maybe<CleoPatient>;
  cleoPatientChart?: Maybe<CleoPatientChart>;
  cleoPatientCount?: Maybe<CleoPatientCount>;
  /** Get a single `CleoPatientEvent`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientEvent?: Maybe<CleoPatientEvent>;
  cleoPatientEventCount?: Maybe<CleoPatientEventCount>;
  /** Get a paginable and filterable list of `CleoPatientEvent` via Relay connection. */
  cleoPatientEvents?: Maybe<CleoPatientEventConnection>;
  /** Get a single `CleoPatientForm`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientForm?: Maybe<CleoPatientForm>;
  cleoPatientFormCount?: Maybe<CleoPatientFormCount>;
  /** Get a paginable and filterable list of `CleoPatientForm` via Relay connection. */
  cleoPatientForms?: Maybe<CleoPatientFormConnection>;
  /** Get a single `CleoPatientGroup`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientGroup?: Maybe<CleoPatientGroup>;
  /** Get a paginable and filterable list of `CleoPatientGroup` via Relay connection. */
  cleoPatientGroups?: Maybe<CleoPatientGroupConnection>;
  /** Get a single `CleoPatientPayment`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientPayment?: Maybe<CleoPatientPayment>;
  /** Get a paginable and filterable list of `CleoPatientPayment` via Relay connection. */
  cleoPatientPayments?: Maybe<CleoPatientPaymentConnection>;
  /** Get a single `CleoPatientProgram`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientProgram?: Maybe<CleoPatientProgram>;
  /** Get a single `CleoPatientProgramForm`. At least one of the `id` or `uid` arguments must be specified. */
  cleoPatientProgramForm?: Maybe<CleoPatientProgramForm>;
  /** Get a paginable and filterable list of `CleoPatientProgramForm` via Relay connection. */
  cleoPatientProgramForms?: Maybe<CleoPatientProgramFormConnection>;
  /** Get a paginable and filterable list of `CleoPatientProgram` via Relay connection. */
  cleoPatientPrograms?: Maybe<CleoPatientProgramConnection>;
  /** Get a paginable list of `CleoPatientReminderTask` via Relay connection. */
  cleoPatientReminderTasks?: Maybe<CleoPatientReminderTasksConnection>;
  /** Get a paginable and filterable list of `CleoPatient` via Relay connection. */
  cleoPatients?: Maybe<CleoPatientConnection>;
  cleoPermanentSession?: Maybe<CleoPermanentSession>;
  /** Get a single `CleoReminder`. At least one of the `id` or `uid` arguments must be specified. */
  cleoReminder?: Maybe<CleoReminder>;
  /** Get a paginable and filterable list of `CleoReminder` via Relay connection. */
  cleoReminders?: Maybe<CleoReminderConnection>;
  /** Get a single `CleoRole`. At least one of the `id` or `uid` arguments must be specified. */
  cleoRole?: Maybe<CleoRole>;
  /** Get a paginable and filterable list of `CleoRole` via Relay connection. */
  cleoRoles?: Maybe<CleoRoleConnection>;
  /** Get a single `CleoSubmission`. At least one of the `id` or `uid` arguments must be specified. */
  cleoSubmission?: Maybe<CleoSubmission>;
  /** Get a single `CleoSubmissionComment`. At least one of the `id` or `uid` arguments must be specified. */
  cleoSubmissionComment?: Maybe<CleoSubmissionComment>;
  /** Get a paginable and filterable list of `CleoSubmissionComment` via Relay connection. */
  cleoSubmissionComments?: Maybe<CleoSubmissionCommentConnection>;
  cleoSubmissionCount?: Maybe<CleoSubmissionCount>;
  /** Get a paginable and filterable list of `CleoSubmission` via Relay connection. */
  cleoSubmissions?: Maybe<CleoSubmissionConnection>;
  /** Get the `EinsteinAdministrator` specified by `id` or `uid`. If both are unspecified, we will use the `EinsteinAdministrator` from the current session token. */
  einsteinAdministrator?: Maybe<EinsteinAdministrator>;
  /** Get a paginable and filterable list of `EinsteinAdministrator` via Relay connection. */
  einsteinAdministrators?: Maybe<EinsteinAdministratorConnection>;
  /** Get Einstein broadcasts based on Administrator. */
  einsteinBroadcast?: Maybe<EinsteinBroadcast>;
  /** Get a paginable and filterable list of `EinsteinBroadcast` via Relay connection. */
  einsteinBroadcasts?: Maybe<EinsteinBroadcastConnection>;
  /** Get a single `EinsteinChernobylEntry`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinChernobylEntry?: Maybe<EinsteinChernobylEntry>;
  /** Get a paginable and filterable list of `EinsteinChernobylEntry` via Relay connection. */
  einsteinChernobylEntrys?: Maybe<EinsteinChernobylEntryConnection>;
  /** Get a single `EinsteinDataSource`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinDataSource?: Maybe<EinsteinDataSource>;
  /** Get a paginable and filterable list of `EinsteinDataSource` via Relay connection. */
  einsteinDataSources?: Maybe<EinsteinDataSourceConnection>;
  /** Get a single `EinsteinDialogueEntry`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinDialogueEntry?: Maybe<EinsteinDialogueEntry>;
  /** Get a paginable and filterable list of `EinsteinDialogueEntry` via Relay connection. */
  einsteinDialogueEntrys?: Maybe<EinsteinDialogueEntryConnection>;
  /** Get a single `EinsteinDocumentEntry`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinDocumentEntry?: Maybe<EinsteinDocumentEntry>;
  /** Get a paginable and filterable list of `EinsteinDocumentEntry` via Relay connection. */
  einsteinDocumentEntrys?: Maybe<EinsteinDocumentEntryConnection>;
  /** Export User Chat Messages. */
  einsteinExportChatMessages?: Maybe<EinsteinExportChatMessages>;
  /** Get a paginable list of `EinsteinExportChatMessages` via Relay connection. */
  einsteinExportChatMessagess?: Maybe<EinsteinExportChatMessagessConnection>;
  /** Get a single `EinsteinMetricSnapshot`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinMetricSnapshot?: Maybe<EinsteinMetricSnapshot>;
  /** Get Einstein Analytics Metric Snapshots */
  einsteinMetricSnapshots?: Maybe<EinsteinMetricSnapshotConnection>;
  /** Get a single `EinsteinModule`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinModule?: Maybe<EinsteinModule>;
  /** Get a paginable and filterable list of `EinsteinModule` via Relay connection. */
  einsteinModules?: Maybe<EinsteinModuleConnection>;
  /** Get a single `EinsteinProfilesGroup`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinProfilesGroup?: Maybe<EinsteinProfilesGroup>;
  /** Get a paginable and filterable list of `EinsteinProfilesGroup` via Relay connection. */
  einsteinProfilesGroups?: Maybe<EinsteinProfilesGroupConnection>;
  /** Get Einstein sent broadcast logs based on Administrator. */
  einsteinSentBroadcast?: Maybe<EinsteinSentBroadcast>;
  /** Get a paginable and filterable list of `EinsteinSentBroadcast` via Relay connection. */
  einsteinSentBroadcasts?: Maybe<EinsteinSentBroadcastConnection>;
  /** Get Einstein specific settings for the current Administrator's hospital. */
  einsteinSettings?: Maybe<EinsteinSettings>;
  /** Get a single `EinsteinUserDataSource`. At least one of the `id` or `uid` arguments must be specified. */
  einsteinUserDataSource?: Maybe<EinsteinUserDataSource>;
  /** Get a paginable and filterable list of `EinsteinUserDataSource` via Relay connection. */
  einsteinUserDataSources?: Maybe<EinsteinUserDataSourceConnection>;
  /** Get a single `FaradayAdminDoctorRelationship`. At least one of the `id` or `uid` arguments must be specified. */
  faradayAdminDoctorRelationship?: Maybe<FaradayAdminDoctorRelationship>;
  /** Get a paginable and filterable list of `FaradayAdminDoctorRelationship` via Relay connection. */
  faradayAdminDoctorRelationships?: Maybe<FaradayAdminDoctorRelationshipConnection>;
  faradayAvailability?: Maybe<FaradayAvailability>;
  faradayAvailabilityAsync?: Maybe<FaradayAvailabilityAsync>;
  /** Get a paginable list of `FaradayCatalogue` via Relay connection. */
  faradayCatalogues?: Maybe<FaradayCataloguesConnection>;
  /** Get a single `FaradayClinic`. At least one of the `id` or `uid` arguments must be specified. */
  faradayClinic?: Maybe<FaradayClinic>;
  /** Get a paginable and filterable list of `FaradayClinic` via Relay connection. */
  faradayClinics?: Maybe<FaradayClinicConnection>;
  /** Get a single `FaradayExam`. At least one of the `id` or `uid` arguments must be specified. */
  faradayExam?: Maybe<FaradayExam>;
  faradayExamAvailability?: Maybe<Array<Maybe<FaradayExamAvailability>>>;
  /** Get a paginable and filterable list of `FaradayExam` via Relay connection. */
  faradayExams?: Maybe<FaradayExamConnection>;
  /** Get a paginable and filterable list of `FaradayFacility` via Relay connection. */
  faradayFacilities?: Maybe<FaradayFacilityConnection>;
  /** Get a single `FaradayFacility`. At least one of the `id` or `uid` arguments must be specified. */
  faradayFacility?: Maybe<FaradayFacility>;
  faradayFacilityAvailability?: Maybe<Array<Maybe<FaradayFacilityAvailability>>>;
  /** Get a single `FaradayMessageTemplate`. At least one of the `id` or `uid` arguments must be specified. */
  faradayMessageTemplate?: Maybe<FaradayMessageTemplate>;
  /** Get a paginable and filterable list of `FaradayMessageTemplate` via Relay connection. */
  faradayMessageTemplates?: Maybe<FaradayMessageTemplateConnection>;
  /** Get a paginable and filterable list of `FaradayModality` via Relay connection. */
  faradayModalities?: Maybe<FaradayModalityConnection>;
  /** Get a single `FaradayModality`. At least one of the `id` or `uid` arguments must be specified. */
  faradayModality?: Maybe<FaradayModality>;
  /** Get a single `FaradayOrder`. At least one of the `id` or `uid` arguments must be specified. */
  faradayOrder?: Maybe<FaradayOrder>;
  /** Get a single `FaradayOrderDraft`. At least one of the `id` or `uid` arguments must be specified. */
  faradayOrderDraft?: Maybe<FaradayOrderDraft>;
  /** Get a paginable and filterable list of `FaradayOrderDraft` via Relay connection. */
  faradayOrderDrafts?: Maybe<FaradayOrderDraftConnection>;
  /** Get a single `FaradayOrderExam`. At least one of the `id` or `uid` arguments must be specified. */
  faradayOrderExam?: Maybe<FaradayOrderExam>;
  /** Get a paginable and filterable list of `FaradayOrderExam` via Relay connection. */
  faradayOrderExams?: Maybe<FaradayOrderExamConnection>;
  /** Get a single `FaradayOrderPDF`. At least one of the `id` or `uid` arguments must be specified. */
  faradayOrderPdf?: Maybe<FaradayOrderPdf>;
  /** Get a paginable and filterable list of `FaradayOrderPDF` via Relay connection. */
  faradayOrderPdfs?: Maybe<FaradayOrderPdfConnection>;
  /** Get a paginable and filterable list of `FaradayOrder` via Relay connection. */
  faradayOrders?: Maybe<FaradayOrderConnection>;
  /** Get a single `FaradayParkwayOrder`. At least one of the `id` or `uid` arguments must be specified. */
  faradayParkwayOrder?: Maybe<FaradayParkwayOrder>;
  /** Get a paginable and filterable list of `FaradayParkwayOrder` via Relay connection. */
  faradayParkwayOrders?: Maybe<FaradayParkwayOrderConnection>;
  /** Get a single `FaradayParkwayStaff`. At least one of the `id` or `uid` arguments must be specified. */
  faradayParkwayStaff?: Maybe<FaradayParkwayStaff>;
  /** Get a paginable and filterable list of `FaradayParkwayStaff` via Relay connection. */
  faradayParkwayStaffs?: Maybe<FaradayParkwayStaffConnection>;
  /** Get a single `FaradayPatientProfile`. At least one of the `id` or `uid` arguments must be specified. */
  faradayPatientProfile?: Maybe<FaradayPatientProfile>;
  /** Get a paginable and filterable list of `FaradayPatientProfile` via Relay connection. */
  faradayPatientProfiles?: Maybe<FaradayPatientProfileConnection>;
  /** Get a paginable list of `FaradayPriceList` via Relay connection. */
  faradayPriceLists?: Maybe<FaradayPriceListsConnection>;
  /** Get a single `FaradayRoom`. At least one of the `id` or `uid` arguments must be specified. */
  faradayRoom?: Maybe<FaradayRoom>;
  /** Get a paginable and filterable list of `FaradayRoom` via Relay connection. */
  faradayRooms?: Maybe<FaradayRoomConnection>;
  /** Get a single `FaradayStaffProfile`. At least one of the `id` or `uid` arguments must be specified. */
  faradayStaffProfile?: Maybe<FaradayStaffProfile>;
  /** Get a paginable and filterable list of `FaradayStaffProfile` via Relay connection. */
  faradayStaffProfiles?: Maybe<FaradayStaffProfileConnection>;
  /** Get a single `FaradayStaffProfileRatatoskrDevice`. At least one of the `id` or `uid` arguments must be specified. */
  faradayStassProfileRatatoskrDevice?: Maybe<FaradayStaffProfileRatatoskrDevice>;
  /** Get a paginable and filterable list of `FaradayStaffProfileRatatoskrDevice` via Relay connection. */
  faradayStassProfileRatatoskrDevices?: Maybe<FaradayStaffProfileRatatoskrDeviceConnection>;
  /** Get a single `GovernessOrganization`. At least one of the `id` or `uid` arguments must be specified. */
  governessOrganization?: Maybe<GovernessOrganization>;
  heimdallDiscovery?: Maybe<HeimdallDiscovery>;
  /** Get a single `HeimdallProviderApplication`. At least one of the `id` or `uid` arguments must be specified. */
  heimdallProviderApplication?: Maybe<HeimdallProviderApplication>;
  heimdallRequestLog?: Maybe<HeimdallRequestLog>;
  /** Get the `Session` specified by `id` or `uid`. If both are unspecified, we will use the `Session` from the current session token. */
  heimdallSession?: Maybe<HeimdallSession>;
  heimdallSgidUserInfo?: Maybe<HeimdallSgidUserInfo>;
  /** Get the active banner for this hospital. */
  hospitalActiveBanner?: Maybe<HospitalActiveBanner>;
  /** Get a single `HospitalAutoCompleteEntry`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalAutoCompleteEntry?: Maybe<HospitalAutoCompleteEntry>;
  hospitalAutocompleteEntries?: Maybe<Array<Maybe<HospitalAutoCompleteEntry>>>;
  /** Get a paginable and filterable list of `HospitalBanner` via Relay connection. */
  hospitalBanners?: Maybe<HospitalBannerConnection>;
  /** Get chemocalc related data */
  hospitalChemocalc?: Maybe<HospitalChemocalc>;
  /** Get a single `HospitalDepartment`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalDepartment?: Maybe<HospitalDepartment>;
  /** Get a paginable and filterable list of `HospitalDepartment` via Relay connection. */
  hospitalDepartments?: Maybe<HospitalDepartmentConnection>;
  /** Get a single `HospitalDesignation`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalDesignation?: Maybe<HospitalDesignation>;
  /** Get a paginable and filterable list of `HospitalDesignation` via Relay connection. */
  hospitalDesignations?: Maybe<HospitalDesignationConnection>;
  /** Get `Directory Profiles` by specified `id`, `uid` or `hospital_uid`. If all are unspecified, it will return all the `Directory Profile`. */
  hospitalDirectoryProfiles?: Maybe<HospitalDirectoryProfileConnection>;
  /** Get a single `HospitalDivision`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalDivision?: Maybe<HospitalDivision>;
  /** Get a paginable and filterable list of `HospitalDivision` via Relay connection. */
  hospitalDivisions?: Maybe<HospitalDivisionConnection>;
  /** Get a single `HospitalFavourite`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalFavourite?: Maybe<HospitalFavourite>;
  /** Get a paginable and filterable list of `HospitalFavourite` via Relay connection. */
  hospitalFavourites?: Maybe<HospitalFavouriteConnection>;
  hospitalFindHospital?: Maybe<HospitalFindHospital>;
  hospitalFindProfiles?: Maybe<HospitalFindProfiles>;
  /** Get a single `Hospital`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalHospital?: Maybe<Hospital>;
  /** Get public Login Providers per Organization key */
  hospitalLoginProviders?: Maybe<HospitalLoginProviders>;
  /** Get all the `Hospitals` available for login on BotMD. */
  hospitalLoginableHospitals?: Maybe<HospitalLoginableHospitals>;
  /** Get a single `HospitalMessage`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalMessage?: Maybe<HospitalMessage>;
  /** Retrieve a connection of deliveries/messages associated with the current HospitalProfile. */
  hospitalMessages?: Maybe<HospitalMessagesConnection>;
  /** Get a single `HospitalMoodLog`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalMoodLog?: Maybe<HospitalMoodLog>;
  /** Get the average mood logs for this profile user. */
  hospitalMoodLogAverages?: Maybe<HospitalMoodLogAverages>;
  /** Get a single `HospitalMoodLogReminder`. At least one of the `id` or `uid` arguments must be specified. */
  hospitalMoodLogReminder?: Maybe<HospitalMoodLogReminder>;
  /** Get a paginable and filterable list of `HospitalMoodLogReminder` via Relay connection. */
  hospitalMoodLogReminders?: Maybe<HospitalMoodLogReminderConnection>;
  /** Get a paginable and filterable list of `HospitalMoodLog` via Relay connection. */
  hospitalMoodLogs?: Maybe<HospitalMoodLogConnection>;
  /** Get the `HospitalProfile` specified by `id` or `uid`. If both are unspecified, we will use the `HospitalProfile` from the current session token. */
  hospitalProfile?: Maybe<HospitalProfile>;
  hospitalPublicInformation?: Maybe<HospitalPublicInformation>;
  /** Get public information related to hospitals. */
  hospitalPublicInformations?: Maybe<HospitalPublicInformationsConnection>;
  /** Check whether the `device` is registerable. */
  hospitalRegisterableDevice?: Maybe<HospitalRegisterableDevice>;
  /** This GQL takes a few arguments. It is used by BE developers and JTF to debug the Jarvis v2 query flow. */
  jarvisQueryFlow?: Maybe<JarvisQueryFlow>;
  /** Starts a rendering async job for Kondo resources. */
  kondoRenderResources?: Maybe<KondoRenderResources>;
  /** Starts a validation async job for Kondo resources. */
  kondoValidateResources?: Maybe<KondoValidateResources>;
  /** Get a single `KronosAsyncJob`. At least one of the `id` or `uid` arguments must be specified. */
  kronosAsyncJob?: Maybe<KronosAsyncJob>;
  /** Get a single `KronosTask`. At least one of the `id` or `uid` arguments must be specified. */
  kronosTask?: Maybe<KronosTask>;
  /** Get a single `MerlinAdministrator`. At least one of the `id` or `uid` arguments must be specified. */
  merlinAdministrator?: Maybe<MerlinAdministrator>;
  /** Get a paginable and filterable list of `MerlinAdministrator` via Relay connection. */
  merlinAdministrators?: Maybe<MerlinAdministratorConnection>;
  /** Get a single `RatatoskrDevice`. At least one of the `id` or `uid` arguments must be specified. */
  ratatoskrDevice?: Maybe<RatatoskrDevice>;
  /** Get a single `RatatoskrProviderApplication`. At least one of the `id` or `uid` arguments must be specified. */
  ratatoskrProviderApplication?: Maybe<RatatoskrProviderApplication>;
  /** Get a paginable list of `RatatoskrProvider` via Relay connection. */
  ratatoskrProviders?: Maybe<RatatoskrProvidersConnection>;
  /** Get a single `RatatoskrWhatsAppTemplate`. At least one of the `id` or `uid` arguments must be specified. */
  ratatoskrWhatsAppTemplate?: Maybe<RatatoskrWhatsAppTemplate>;
  /** Get a paginable and filterable list of `RatatoskrWhatsAppTemplate` via Relay connection. */
  ratatoskrWhatsAppTemplates?: Maybe<RatatoskrWhatsAppTemplateConnection>;
  /** Get a single `StitchLink`. At least one of the `id` or `uid` arguments must be specified. */
  stitchLink?: Maybe<StitchLink>;
};

export type QueryCleoAlertRuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoAlertRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isForClinic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<CleoAlertRuleLevelChoices>;
  level_In?: InputMaybe<Array<InputMaybe<CleoAlertRuleLevelChoices>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicCalendarArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicCalendarEventTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCleoClinicCalendarEventTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicCalendar_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_DeactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  eventType_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicFilterArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ClinicGroupOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoClinicProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicProgramArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicProgramMonitoringFormsetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicProgramMonitoringFormsetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinic_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicPublicSettingsArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCleoClinicRatatoskrProviderApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicRatatoskrProviderApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinic_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communicationMethod_In?: InputMaybe<
    Array<InputMaybe<CleoClinicRatatoskrProviderApplicationCommunicationMethodChoices>>
  >;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicalParameterArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoClinicalParametersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isUsedForPatientEventMetadataEntry?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedForPatientFormMetadataEntry?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedForPatientMetadataEntry?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedForPatientProgramFormMetadataEntry?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedForPatientProgramMetadataEntry?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoClinicianArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoCliniciansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communicationMethod?: InputMaybe<CleoClinicianCommunicationMethodChoices>;
  communicationMethod_In?: InputMaybe<Array<InputMaybe<CleoClinicianCommunicationMethodChoices>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  designation_Icontains?: InputMaybe<Scalars['String']['input']>;
  designation_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCaregiver?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role_Name?: InputMaybe<Scalars['String']['input']>;
  role_Uid?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ClinicianOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoClinicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  beforeDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  clinicianUid?: InputMaybe<Scalars['String']['input']>;
  communicationMethods?: InputMaybe<Array<CommunicationMethod>>;
  direction?: InputMaybe<Direction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientGroupUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DeliveryOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCleoDeliveryCountArgs = {
  afterDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  beforeDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  clinicianUid?: InputMaybe<Scalars['String']['input']>;
  communicationMethods?: InputMaybe<Array<CommunicationMethod>>;
  direction?: InputMaybe<Direction>;
  patientGroupUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCleoExternalClinicalParametersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicUids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoExternalPatientsArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicUids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uniquePatient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoLoginableClinicsArgs = {
  providerApplicationUid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type QueryCleoMessageTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoMessageTemplateSetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoMessageTemplateSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinic_Uid?: InputMaybe<Scalars['String']['input']>;
  communicationMethods?: InputMaybe<Array<CommunicationMethod>>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  languages?: InputMaybe<Array<Language>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  purpose_In?: InputMaybe<Array<InputMaybe<CleoMessageTemplateSetPurposeChoices>>>;
  requirePatientEvent?: InputMaybe<Scalars['Boolean']['input']>;
  requirePatientForm?: InputMaybe<Scalars['Boolean']['input']>;
  requirePatientProgram?: InputMaybe<Scalars['Boolean']['input']>;
  requirePatientProgramForm?: InputMaybe<Scalars['Boolean']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCleoMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communicationMethod_In?: InputMaybe<Array<InputMaybe<CleoMessageTemplateCommunicationMethodChoices>>>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  errorIn?: InputMaybe<Array<MessageTemplateError>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasErrors?: InputMaybe<Scalars['Boolean']['input']>;
  language_In?: InputMaybe<Array<InputMaybe<CleoMessageTemplateLanguageChoices>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageTemplateSet_Clinic_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  messageTemplateSet_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  messageTemplateSet_Purpose_In?: InputMaybe<Array<InputMaybe<CleoMessageTemplateSetPurposeChoices>>>;
  messageTemplateSet_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoMonitoringFormsetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoMonitoringFormsetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinic_Uid?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isEnrollmentForm?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoPatientArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientChartArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  parameterIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientFormUid?: InputMaybe<Scalars['String']['input']>;
  patientFormUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientProgramFormUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientUid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientCountArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientEventArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientEventCountArgs = {
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  isCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  patientUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  statusIn?: InputMaybe<Array<PatientEventStatus>>;
};

export type QueryCleoPatientEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendar_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_EndOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_EventType_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_PendingOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_PendingOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  event_StartOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  patientShowed?: InputMaybe<Scalars['Boolean']['input']>;
  patientShowedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<PatientEventOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  statusIn?: InputMaybe<Array<PatientEventStatus>>;
};

export type QueryCleoPatientFormArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientFormCountArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentPatientForms?: InputMaybe<Scalars['Boolean']['input']>;
  nonCompliantSince?: InputMaybe<Scalars['DateTime']['input']>;
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCleoPatientFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alerteeUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentPatientForms?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  icUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSubmissionAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSubmissionAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSubmittedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  monitoringForm_MonitoringFormset_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  monitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonCompliantSince?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientGroupUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<PatientFormOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAllPatients?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemGroup?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  monitoringFormsets_MonitoringForms_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  monitoringFormsets_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PatientGroupOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCleoPatientPaymentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicProduct_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payment_Method_Method_In?: InputMaybe<
    Array<InputMaybe<MonetaProviderApplicationPaymentMethodMethodChoices>>
  >;
  payment_Status_In?: InputMaybe<Array<InputMaybe<MonetaPaymentStatusChoices>>>;
  sortBy?: InputMaybe<PatientPaymentOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientProgramArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientProgramFormArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoPatientProgramFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alerteeUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  icUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSubmissionAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSubmissionAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSubmittedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  monitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonCompliantSince?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientProgram_Patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PatientProgramFormOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  clinicProgram_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientGroupUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<PatientProgramOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientReminderTasksArgs = {
  activatedPatient?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicProgramUids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPatientEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientForm?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientProgramForm?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<PatientReminderTaskOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  upcomingTask?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCleoPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  communicationMethod_In?: InputMaybe<Array<InputMaybe<CleoPatientCommunicationMethodChoices>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  dischargedMonitoringFormIn?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolledAfter?: InputMaybe<Scalars['DateTime']['input']>;
  enrolledBefore?: InputMaybe<Scalars['DateTime']['input']>;
  enrolledMonitoringFormIn?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeGroupsUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender_In?: InputMaybe<Array<InputMaybe<CleoPatientGenderChoices>>>;
  groupsUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  hasEnrolledMonitoringForms?: InputMaybe<Scalars['Boolean']['input']>;
  isDeviceCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeviceSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  isFollower?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientForms_ClinicianRelations_Clinician_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientForms_MonitoringForm_MonitoringFormset_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  patientForms_MonitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientProgramsClinicProgramUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientPrograms_PatientProgramForms_ClinicianRelations_Clinician_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PatientOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCleoReminderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoRemindersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicPrograms_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clinic_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isForClinic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  programMonitoringFormsets_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCleoRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCleoSubmissionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoSubmissionCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCleoSubmissionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  icAndAlerteeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isUnread?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  submissionUids?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleTo?: InputMaybe<SubmissionCommentVisibleToEnum>;
};

export type QueryCleoSubmissionCountArgs = {
  enrollmentSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommentVisibleTo?: InputMaybe<SubmissionCommentVisibleToEnum>;
  hasUnseenComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnseenCommentsAndVisibleToEverybody?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  patientFormUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCleoSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  alerteeUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  beforeDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  clinicFilterUid?: InputMaybe<Scalars['String']['input']>;
  enrollmentSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['GenericScalar']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCommentVisibleTo?: InputMaybe<SubmissionCommentVisibleToEnum>;
  hasUnseenComments?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnseenCommentsAndVisibleToEverybody?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  icUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  isAlertsTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientForm_DeactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  patientForm_MonitoringForm_MonitoringFormset_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  patientForm_MonitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientForm_Patient_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  patientForm_Patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientGroupUidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  patientProgramForm_DeactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  patientProgramForm_MonitoringForm_MonitoringFormset_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  patientProgramForm_MonitoringForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientProgramForm_PatientProgram_ClinicProgram_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  patientProgramForm_PatientProgram_Patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientProgramForm_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SubmissionOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortParameterUid?: InputMaybe<Scalars['String']['input']>;
  triggeredAlerts_Rule_Level?: InputMaybe<CleoAlertRuleLevelChoices>;
  triggeredAlerts_Rule_Level_In?: InputMaybe<Array<InputMaybe<CleoAlertRuleLevelChoices>>>;
};

export type QueryEinsteinAdministratorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinAdministratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  department_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  designation_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  designation_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isSuper?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AdminOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEinsteinBroadcastArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinBroadcastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerDepartments_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ownerDivisions_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<BroadcastOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EinsteinBroadcastStatusChoices>;
  status_In?: InputMaybe<Array<InputMaybe<EinsteinBroadcastStatusChoices>>>;
};

export type QueryEinsteinChernobylEntryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinChernobylEntrysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dataSource_Key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Modules_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<DataSourceEntrySyncStatus>;
};

export type QueryEinsteinDataSourceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinDataSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modules_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEinsteinDialogueEntryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinDialogueEntrysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Modules_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DialogueEntryOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEinsteinDocumentEntryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinDocumentEntrysArgs = {
  aclDnfOr?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dataSource_Key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Modules_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSource_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mimeType_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mimeType_Startswith?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerDepartments_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ownerDepartments_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerDivisions_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  ownerDivisions_Uid_In?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<DataSourceEntrySyncStatus>;
  syncedOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryEinsteinExportChatMessagesArgs = {
  chatMessageTypeIn?: InputMaybe<Array<ChatMessageType>>;
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  designationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  endOn: Scalars['DateTime']['input'];
  startOn: Scalars['DateTime']['input'];
};

export type QueryEinsteinExportChatMessagessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEinsteinMetricSnapshotArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEinsteinMetricSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<KeyMetrics>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  startOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryEinsteinModuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinModulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEinsteinProfilesGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinProfilesGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerDepartments_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ownerDivisions_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<ProfilesGroupOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEinsteinSentBroadcastArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinSentBroadcastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerDepartments_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ownerDivisions_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy?: InputMaybe<SentBroadcastOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EinsteinSentBroadcastStatusChoices>;
  status_In?: InputMaybe<Array<InputMaybe<EinsteinSentBroadcastStatusChoices>>>;
};

export type QueryEinsteinUserDataSourceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEinsteinUserDataSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryFaradayAdminDoctorRelationshipArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFaradayAdminDoctorRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayAvailabilityArgs = {
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  examUid: Scalars['String']['input'];
  facilityUid?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryFaradayAvailabilityAsyncArgs = {
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  examUid?: InputMaybe<Scalars['String']['input']>;
  facilityUid?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryFaradayCataloguesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogueSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modalityUids?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayClinicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayClinicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hciCode_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayExamArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayExamAvailabilityArgs = {
  examSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayExamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  examSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modalities?: InputMaybe<Array<Scalars['String']['input']>>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  procedureCode_Icontains?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ExamOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFaradayFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shortCode_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryFaradayFacilityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayFacilityAvailabilityArgs = {
  examUids: Array<Scalars['String']['input']>;
};

export type QueryFaradayMessageTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayModalitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shortName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryFaradayModalityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderDraftArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderExamArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderExamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayOrderPdfArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrderPdfsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdFor_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  exams_Exam_Modality_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exams_Status_In?: InputMaybe<Array<InputMaybe<FaradayOrderExamStatusChoices>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderSearch?: InputMaybe<Scalars['String']['input']>;
  patient_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<OrderOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryFaradayParkwayOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayParkwayOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facility_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modality_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parkwayOrderSearch?: InputMaybe<Scalars['String']['input']>;
  procedureCode?: InputMaybe<Scalars['String']['input']>;
  referringDoctor_McrNo_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<OrderOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  status_In?: InputMaybe<Array<InputMaybe<FaradayParkwayOrderStatusChoices>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayParkwayStaffArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayParkwayStaffsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mcrNo?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  physicianId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayPatientProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayPatientProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  doctors_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PatientProfileOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFaradayPriceListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityUids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modalityUids?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priceListSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayRoomArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayRoomsArgs = {
  aeTitle_Icontains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  modalities?: InputMaybe<Array<Scalars['String']['input']>>;
  modality_ShortName_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFaradayStaffProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayStaffProfilesArgs = {
  accountType_In?: InputMaybe<Array<InputMaybe<FaradayStaffProfileAccountTypeChoices>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<StaffProfileOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  staffSearch?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayStassProfileRatatoskrDeviceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaradayStassProfileRatatoskrDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGovernessOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHeimdallDiscoveryArgs = {
  url: Scalars['String']['input'];
};

export type QueryHeimdallProviderApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHeimdallSessionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalAutoCompleteEntryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHospitalChemocalcArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  cancerType: CancerType;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  drugIndications?: InputMaybe<Scalars['GenericScalar']['input']>;
  healthcareFacility: MtsocFacilityCode;
  height?: InputMaybe<Scalars['Int']['input']>;
  regimens: Array<InputMaybe<RegimenItemInput>>;
  schemaCodes: Array<InputMaybe<MtsocSchemaCode>>;
  subsidyStatus: SubsidyStatus;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHospitalDepartmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  division_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DepartmentOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  viewAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHospitalDesignationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalDesignationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DesignationOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHospitalDirectoryProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  departmentFk_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  departmentFk_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  designationFk_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  designationFk_Name_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileActivationStatus?: InputMaybe<ProfileActivationStatus>;
  profileActivationStatusIn?: InputMaybe<Array<ProfileActivationStatus>>;
  profileGroupUid?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DirectoryProfileOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryHospitalDivisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DivisionOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  viewAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHospitalFavouriteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalFavouritesArgs = {
  aclDnfOr?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<FavouriteOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHospitalFindHospitalArgs = {
  organizationKey: Scalars['String']['input'];
};

export type QueryHospitalFindProfilesArgs = {
  hospitalUid: Scalars['String']['input'];
  identifiableInformations?: InputMaybe<Array<IdentifiableInformationInput>>;
};

export type QueryHospitalHospitalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalMessagesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHospitalMoodLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalMoodLogAveragesArgs = {
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryHospitalMoodLogReminderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalMoodLogRemindersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalMoodLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid?: InputMaybe<Scalars['String']['input']>;
  createdBy_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHospitalProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalPublicInformationArgs = {
  organizationKey: Scalars['String']['input'];
};

export type QueryHospitalPublicInformationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryHospitalRegisterableDeviceArgs = {
  deviceUid: Scalars['String']['input'];
};

export type QueryJarvisQueryFlowArgs = {
  contextTemplate?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  indexName?: InputMaybe<Scalars['String']['input']>;
  llmSearchMode?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  overrideNow?: InputMaybe<Scalars['DateTime']['input']>;
  profile: JarvisProfileGql;
  query: Scalars['String']['input'];
  queryEngine: Scalars['String']['input'];
  rerankerSimilarityCutoff?: InputMaybe<Scalars['Float']['input']>;
  similarityCutoff?: InputMaybe<Scalars['Float']['input']>;
  similarityTopK?: InputMaybe<Scalars['Int']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  useAsync?: InputMaybe<Scalars['Boolean']['input']>;
  userAclDnfs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryKondoRenderResourcesArgs = {
  uid: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type QueryKondoValidateResourcesArgs = {
  uid: Scalars['String']['input'];
};

export type QueryKronosAsyncJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryKronosTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMerlinAdministratorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMerlinAdministratorsArgs = {
  accountType?: InputMaybe<MerlinAdministratorAccountTypeChoices>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AdministratorOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRatatoskrDeviceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRatatoskrProviderApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRatatoskrProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deviceChannelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRatatoskrWhatsAppTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryRatatoskrWhatsAppTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerApplication_Uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryStitchLinkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linkId?: InputMaybe<Scalars['String']['input']>;
};

/** Ratatoskr `Device`s are a logical representation of a single client device used for chat. Think of it as a chat session. */
export type RatatoskrDevice = ScalpelNode & {
  __typename?: 'RatatoskrDevice';
  /** Date/Time device is created. */
  createdOn: Scalars['DateTime']['output'];
  /** This is the global ID constructed from the base64 encoding of `RatatoskrDevice:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the device is subscribed to receive notifications. */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** Date/Time when device is last active. */
  lastActiveOn: Scalars['DateTime']['output'];
  /** Device specific metadata (e.g., device type, browser information). It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-devicemetadata-generated.html" target="_blank">ratatoskr/DeviceMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** Phone number associated with the device. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Session attached to this device. */
  session?: Maybe<HeimdallSession>;
  /** Frontend should use this field to retrieve required device information. */
  uid: Scalars['String']['output'];
};

/** GQL type representation for ratatoskr providers. */
export type RatatoskrProvider = ScalpelNode & {
  __typename?: 'RatatoskrProvider';
  /** Device channel. */
  deviceChannel?: Maybe<Scalars['String']['output']>;
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Import path of the provider. */
  importPath: Scalars['String']['output'];
  /** Name of the provider. */
  name: Scalars['String']['output'];
};

/** Ratatoskr `ProviderApplication`s are used by user/client to integrate with the chat services. */
export type RatatoskrProviderApplication = ScalpelNode & {
  __typename?: 'RatatoskrProviderApplication';
  /** This is the global ID constructed from the base64 encoding of `RatatoskrProviderApplication:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Provider-Application specific settings that are accessible by frontend. *Secret settings should not be stored here!* It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-providerapplicationsettings-generated.html" target="_blank">ratatoskr/ProviderApplicationSettings.schema</a>. */
  settings?: Maybe<Scalars['GenericScalar']['output']>;
  /** Frontend should use this field to retrieve required information. */
  uid: Scalars['String']['output'];
};

/** This is a related model input type for `RatatoskrProviderApplication`. */
export type RatatoskrProviderApplicationRelatedModelInput = {
  /** Global ID for referencing `RatatoskrProviderApplication`. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** UID for `RatatoskrProviderApplication`. */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type RatatoskrProvidersConnection = {
  __typename?: 'RatatoskrProvidersConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RatatoskrProvidersEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RatatoskrProviders` and its cursor. */
export type RatatoskrProvidersEdge = {
  __typename?: 'RatatoskrProvidersEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RatatoskrProvider>;
};

/** Object type for `RatatoskrWhatsAppTemplate`. */
export type RatatoskrWhatsAppTemplate = ScalpelNode & {
  __typename?: 'RatatoskrWhatsAppTemplate';
  /** WhatsApp template category. */
  category: RatatoskrWhatsAppTemplateCategoryChoices;
  /** WhatsApp template components. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-whatsapptemplatecomponents-generated.html" target="_blank">ratatoskr/WhatsAppTemplateComponents.schema</a>. */
  components?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time this object is created. */
  createdOn: Scalars['DateTime']['output'];
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** `RatatoskrWhatsAppTemplate` model does not define a UID field and hence the ID field is not applicable here. */
  id?: Maybe<Scalars['ID']['output']>;
  /** WhatsApp template language. */
  language: RatatoskrWhatsAppTemplateLanguageChoices;
  /** Whatsapp template specific metadata (e.g., error). It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-whatsapptemplatemetadata-generated.html" target="_blank">ratatoskr/WhatsAppTemplateMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** WhatsApp template name. */
  name: Scalars['String']['output'];
  /** ProviderApplication for the associated WhatsApp business account. */
  providerApplication: RatatoskrProviderApplication;
  /** WhatsApp template status. */
  status?: Maybe<RatatoskrWhatsAppTemplateStatusChoices>;
  /** WhatsApp provided ID for the template. */
  templateId: Scalars['String']['output'];
};

/** An enumeration. */
export enum RatatoskrWhatsAppTemplateCategoryChoices {
  /** Account Update */
  AccountUpdate = 'ACCOUNT_UPDATE',
  /** Alert Update */
  AlertUpdate = 'ALERT_UPDATE',
  /** Appointment Update */
  AppointmentUpdate = 'APPOINTMENT_UPDATE',
  /** Auto Reply */
  AutoReply = 'AUTO_REPLY',
  /** Issue Resolution */
  IssueResolution = 'ISSUE_RESOLUTION',
  /** Marketing */
  Marketing = 'MARKETING',
  /** OTP */
  Otp = 'OTP',
  /** Payment Update */
  PaymentUpdate = 'PAYMENT_UPDATE',
  /** Personal Finance Update */
  PersonalFinanceUpdate = 'PERSONAL_FINANCE_UPDATE',
  /** Reservation Update */
  ReservationUpdate = 'RESERVATION_UPDATE',
  /** Shipping Update */
  ShippingUpdate = 'SHIPPING_UPDATE',
  /** Ticket Update */
  TicketUpdate = 'TICKET_UPDATE',
  /** Transactional */
  Transactional = 'TRANSACTIONAL',
  /** Transportation Update */
  TransportationUpdate = 'TRANSPORTATION_UPDATE',
  /** Utility */
  Utility = 'UTILITY',
}

export type RatatoskrWhatsAppTemplateConnection = {
  __typename?: 'RatatoskrWhatsAppTemplateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RatatoskrWhatsAppTemplateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items returned in this query. Note that this is not necessarily equal to the total number of items available. */
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RatatoskrWhatsAppTemplate` and its cursor. */
export type RatatoskrWhatsAppTemplateEdge = {
  __typename?: 'RatatoskrWhatsAppTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RatatoskrWhatsAppTemplate>;
};

/** An enumeration. */
export enum RatatoskrWhatsAppTemplateLanguageChoices {
  /** Afrikaans */
  Af = 'AF',
  /** Arabic */
  Ar = 'AR',
  /** Azerbaijani */
  Az = 'AZ',
  /** Bulgarian */
  Bg = 'BG',
  /** Bengali */
  Bn = 'BN',
  /** Catalan */
  Ca = 'CA',
  /** Czech */
  Cs = 'CS',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** Greek */
  El = 'EL',
  /** English */
  En = 'EN',
  /** English (UK) */
  EnGb = 'EN_GB',
  /** English (US) */
  EnUs = 'EN_US',
  /** Spanish */
  Es = 'ES',
  /** Spanish (ARG) */
  EsAr = 'ES_AR',
  /** Spanish (SPA) */
  EsEs = 'ES_ES',
  /** Spanish (MEX) */
  EsMx = 'ES_MX',
  /** Estonian */
  Et = 'ET',
  /** Persian */
  Fa = 'FA',
  /** Finnish */
  Fi = 'FI',
  /** Filipino */
  Fil = 'FIL',
  /** French */
  Fr = 'FR',
  /** Irish */
  Ga = 'GA',
  /** Gujarati */
  Gu = 'GU',
  /** Hausa */
  Ha = 'HA',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Croatian */
  Hr = 'HR',
  /** Hungarian */
  Hu = 'HU',
  /** Indonesian */
  Id = 'ID',
  /** Italian */
  It = 'IT',
  /** Japanese */
  Ja = 'JA',
  /** Georgian */
  Ka = 'KA',
  /** Kazakh */
  Kk = 'KK',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Kyrgyz (Kyrgyzstan) */
  KyKg = 'KY_KG',
  /** Lao */
  Lo = 'LO',
  /** Lithuanian */
  Lt = 'LT',
  /** Latvian */
  Lv = 'LV',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Marathi */
  Mr = 'MR',
  /** Malay */
  Ms = 'MS',
  /** Norwegian */
  Nb = 'NB',
  /** Dutch */
  Nl = 'NL',
  /** Punjabi */
  Pa = 'PA',
  /** Polish */
  Pl = 'PL',
  /** Portuguese (BR) */
  PtBr = 'PT_BR',
  /** Portuguese (POR) */
  PtPt = 'PT_PT',
  /** Romanian */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Kinyarwanda */
  RwRw = 'RW_RW',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Telugu */
  Te = 'TE',
  /** Thai */
  Th = 'TH',
  /** Turkish */
  Tr = 'TR',
  /** Ukrainian */
  Uk = 'UK',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Vietnamese */
  Vi = 'VI',
  /** Chinese (CHN) */
  ZhCn = 'ZH_CN',
  /** Chinese (HKG) */
  ZhHk = 'ZH_HK',
  /** Chinese (TAI) */
  ZhTw = 'ZH_TW',
  /** Zulu */
  Zu = 'ZU',
}

/** An enumeration. */
export enum RatatoskrWhatsAppTemplateStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** Deleted */
  Deleted = 'DELETED',
  /** Disabled */
  Disabled = 'DISABLED',
  /** Error */
  Error = 'ERROR',
  /** In Appeal */
  InAppeal = 'IN_APPEAL',
  /** LIMIT_EXCEEDED */
  LimitExceeded = 'LIMIT_EXCEEDED',
  /** Locked */
  Locked = 'LOCKED',
  /** Not synced */
  NotSynced = 'NOT_SYNCED',
  /** PAUSED */
  Paused = 'PAUSED',
  /** Pending */
  Pending = 'PENDING',
  /** Pending Deletion */
  PendingDeletion = 'PENDING_DELETION',
  /** Rejected */
  Rejected = 'REJECTED',
}

/** A chosen formulary item of a drug used in a regimen. */
export type RegimenItemInput = {
  /** Number of cycles of the regimen. */
  numCycles: Scalars['Int']['input'];
  /** Formulary item name. */
  regimen: Scalars['String']['input'];
};

export type RegisterDeviceFcmInput = {
  /** The operating system for FCM, either `ios` or `android`. */
  os: Scalars['String']['input'];
  /** The FCM device token. */
  token: Scalars['String']['input'];
};

export type RegisterDevicePusherInput = {
  /** Pusher channel name. It should conform to `private-encrypted-<32 char uid>` format. If `null`, a new pusher device will be created. If specified but the corresponding device is not found, a new device with the specific UID will be created. */
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterDeviceSmoochInput = {
  /** Smooch conversation ID that should already exist on Smooch side. */
  conversationId: Scalars['String']['input'];
};

export type ScalpelNode = {
  /** This is the global ID constructed from the base64 encoding of `Type:<uid>`. */
  id?: Maybe<Scalars['ID']['output']>;
};

export enum SentBroadcastOrderBy {
  CreatedBy = 'CREATED_BY',
  Name = 'NAME',
  SentOn = 'SENT_ON',
  Status = 'STATUS',
}

/** Posts events to Amplitude via Shadowfax. */
export type ShadowfaxPostEvent = {
  __typename?: 'ShadowfaxPostEvent';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True if the event was handled (i.e., sent to the task queue). */
  isHandled: Scalars['Boolean']['output'];
};

export type ShadowfaxPostEventInput = {
  /** An application label, e.g., hospital. (DEPRECATED; Use `provider` instead). */
  appLabel?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Ratatoskr `Device` UID to tie the event to, if available. */
  deviceUid?: InputMaybe<Scalars['String']['input']>;
  /** Standard Amplitude events payload. */
  events: Array<Scalars['GenericScalar']['input']>;
  /** Application-specific profile UID to tie the event to, if available. */
  profileUid?: InputMaybe<Scalars['String']['input']>;
  /** The provider key for handling the Shadowfax event. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Heimdall `Session` UID to tie the event to. Defaults to session in request header. */
  sessionUid?: InputMaybe<Scalars['String']['input']>;
};

export type StaffDevicePusherInput = {
  /** Pusher channel name. It should conform to `private-encrypted-<32 char uid>` format. If `null`, a new pusher device will be created. If specified but the corresponding device is not found, a new device with the specific UID will be created. */
  channel?: InputMaybe<Scalars['String']['input']>;
};

export enum StaffProfileAccountTypeInput {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Superadmin = 'SUPERADMIN',
}

export type StaffProfileInput = {
  /** Staff's account type. */
  accountType: StaffProfileAccountTypeInput;
  /** Staff's designation. */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs for AdminDoctorRelationship. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Staff's email. */
  email: Scalars['String']['input'];
  /** Staff's first name. */
  firstName: Scalars['String']['input'];
  /** Staff's last name. */
  lastName: Scalars['String']['input'];
  /** Staff's MCR NO. */
  mcrNo?: InputMaybe<Scalars['String']['input']>;
  /** Staff's phone. */
  phone: Scalars['String']['input'];
  /** Staff's Physician ID. */
  physicianId?: InputMaybe<Scalars['String']['input']>;
};

export enum StaffProfileOrderBy {
  AccountType = 'ACCOUNT_TYPE',
  Designation = 'DESIGNATION',
  FullName = 'FULL_NAME',
}

/** Create a Stitch Link using a Stitch Provider. Unconventional naming due to legacy reasons. */
export type StitchCreateLink = {
  __typename?: 'StitchCreateLink';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the link was actually created. */
  isCreated: Scalars['Boolean']['output'];
  /** The created link object. (Planned deprecation; Use `stitchLink` instead.) */
  link: StitchLink;
  /** The created link object. */
  stitchLink: StitchLink;
};

export type StitchCreateLinkInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional event properties to complement the default Stitch event. It will be validated against [`skeleton/Any.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  eventProperties?: InputMaybe<Scalars['SkeletonAnySkeletonJSON']['input']>;
  /** Date/Time when the link expires. If not set, it will never expire. */
  expiresOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Stitch provider key to create the link. */
  key: Scalars['String']['input'];
  /** Link identifier. Will be auto-generated if not specified. */
  linkId?: InputMaybe<Scalars['String']['input']>;
  /** Link metadata used for features such as delayed creation. It will be validated against [`stitch/LinkMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['StitchLinkMetadataSkeletonJSON']['input']>;
  /** MIME type of this link's content. Defaults to `application/octet-stream`. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Permission object specific to the provider (i.e. `key`). See `stitch/LinkPermissions.schema` for details. */
  permission: Scalars['GenericScalar']['input'];
  /** These additional settings will be used with HTTPS source URLs in the request. It will be validated against [`stitch/RequestSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  requestSettings?: InputMaybe<Scalars['StitchRequestSettingsSkeletonJSON']['input']>;
  /** These additional headers will be added to the response when link is used. It will be validated against [`stitch/ResponseHeaders.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  responseHeaders?: InputMaybe<Scalars['StitchResponseHeadersSkeletonJSON']['input']>;
  /** Whether to generate short link (8 characters) or regular link (16 characters). */
  shortLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source URL for the link. */
  sourceUrl: Scalars['String']['input'];
};

/** Create a presigned post-URL for uploading temporary files. Note that the maximum supported file size is 10MB. */
export type StitchCreateUploadUrl = {
  __typename?: 'StitchCreateUploadUrl';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** cURL command for POST-ing to `url`. Note that this field is only available when `GQL_INTROSPECTION_KEY` is valid. */
  curlCommand?: Maybe<Scalars['String']['output']>;
  /** Fields for use in a multipart POST request. See [AWS S3 Reference](https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html) or [GCP Cloud Storage Docs](https://cloud.google.com/storage/docs/xml-api/post-object-forms#python). */
  fields: Scalars['GenericScalar']['output'];
  /** A unique upload ID for this temporary upload. This is also the `path` stored in the storage returned by `stitch.utils.get_temporary_storage`. */
  uploadId: Scalars['String']['output'];
  /** URL to use for multipart POST request. */
  url: Scalars['String']['output'];
};

export type StitchCreateUploadUrlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Stitch provider key to create the temporary file upload. */
  key: Scalars['String']['input'];
  /** MIME type for file being uploaded. */
  mimeType: Scalars['String']['input'];
};

/** Object type for `StitchLink`. */
export type StitchLink = ScalpelNode & {
  __typename?: 'StitchLink';
  /** Date/Time link is created. */
  createdOn: Scalars['DateTime']['output'];
  /** The status of a delay link. This is `null` if not a delay link. */
  delayedStatus?: Maybe<DelayedStatus>;
  /** Additional event properties to complement the default Stitch event. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. */
  eventProperties?: Maybe<Scalars['GenericScalar']['output']>;
  /** Date/Time when the link expires. If not set, it will never expire. */
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  /** This is the global ID constructed from the base64 encoding of `StitchLink:<link_id>`. */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if this is a delayed link. */
  isDelayedLink: Scalars['Boolean']['output'];
  /** Link identifier. Will be auto-generated if not specified. */
  linkId: Scalars['String']['output'];
  /** Link metadata used for features such as delayed creation. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-linkmetadata-generated.html" target="_blank">stitch/LinkMetadata.schema</a>. */
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  /** The MIME type is useful for frontend to decide what to do with the link. */
  mimeType: Scalars['String']['output'];
  /** Link permission used to validate a request. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-linkpermission-generated.html" target="_blank">stitch/LinkPermission.schema</a>. */
  permission?: Maybe<Scalars['GenericScalar']['output']>;
  /** The link's redirect URL. Triggers a download event on the stitch provider. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** The link's redirect URL (no download event reporting). */
  redirectUrlWithoutEventReporting?: Maybe<Scalars['String']['output']>;
  /** These additional settings will be used with HTTPS source URLs in the request. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-requestsettings-generated.html" target="_blank">stitch/RequestSettings.schema</a>. */
  requestSettings?: Maybe<Scalars['GenericScalar']['output']>;
  /** These additional headers will be added to the response when link is used. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-responseheaders-generated.html" target="_blank">stitch/ResponseHeaders.schema</a>. */
  responseHeaders?: Maybe<Scalars['GenericScalar']['output']>;
  /** Source URL for the link. */
  sourceUrl: Scalars['String']['output'];
  /** The link URL. */
  url: Scalars['String']['output'];
};

export enum SubmissionCommentVisibleToEnum {
  Everybody = 'EVERYBODY',
  IcsAndAlertees = 'ICS_AND_ALERTEES',
}

export enum SubmissionOrderBy {
  PatientName = 'PATIENT_NAME',
  SubmissionValue = 'SUBMISSION_VALUE',
  SubmittedOn = 'SUBMITTED_ON',
}

export enum SubsidyStatus {
  NonResident = 'NON_RESIDENT',
  Private = 'PRIVATE',
  Subsidies = 'SUBSIDIES',
}

export enum SyncMode {
  Add = 'ADD',
  Sync = 'SYNC',
}

/** Result of update mutation. */
export type UpdateCleoAlertRule = {
  __typename?: 'UpdateCleoAlertRule';
  /** Return the updated `CleoAlertRule` after mutation. */
  cleoAlertRule: CleoAlertRule;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoAlertRuleInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This alert rule applies to all patient-form in the clinic by default. (Required if creating new `CleoAlertRule`) */
  isForClinic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The level determines the response to the alert. */
  level?: InputMaybe<CleoAlertRuleLevelForMutation>;
  /** Alert name (Required if creating new `CleoAlertRule`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The import path for this instantiable object. (Required if creating new `CleoAlertRule`) */
  parserImportPath?: InputMaybe<CleoAlertRuleParserImportPathForMutation>;
  /** Settings for parser. It will be validated against `cleo/RuleParserSettings.schema`. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-ruleparsersettings-generated.html" target="_blank">cleo/RuleParserSettings.schema</a>. It will be validated against [`cleo/RuleParserSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  parserSettings?: InputMaybe<Scalars['CleoRuleParserSettingsSkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinic = {
  __typename?: 'UpdateCleoClinic';
  /** Return the updated `CleoClinic` after mutation. */
  cleoClinic: CleoClinic;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicFilter = {
  __typename?: 'UpdateCleoClinicFilter';
  /** Return the updated `CleoClinicFilter` after mutation. */
  cleoClinicFilter: CleoClinicFilter;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicFilterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the filter. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter name. (Required if creating new `CleoClinicFilter`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter settings including its schedule and options. It is validated against <a href="https://skeleton.staging.botmd.io/docs/scalpel-filtersettings-generated.html" target="_blank">scalpel/FilterSettings.schema</a>. (Required if creating new `CleoClinicFilter`) It will be validated against [`scalpel/FilterSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  settings?: InputMaybe<Scalars['ScalpelFilterSettingsSkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicGroup = {
  __typename?: 'UpdateCleoClinicGroup';
  /** Return the updated `CleoClinicGroup` after mutation. */
  cleoClinicGroup: CleoClinicGroup;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clinic group domain/sub-domain. (Required if creating new `CleoClinicGroup`) */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Clinic group logo which will be displayed on dashboard. (Required if creating new `CleoClinicGroup`) (Supports either S3 or data URI) */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Clinic group name. (Required if creating new `CleoClinicGroup`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default timezone of this clinic group. (Required if creating new `CleoClinicGroup`) */
  timezone?: InputMaybe<CleoClinicGroupTimezoneForMutation>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCleoClinicInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicGroup`. */
  clinicGroup?: InputMaybe<CleoClinicGroupRelatedModelInput>;
  /** Default phone country code of this clinic. (Required if creating new `CleoClinic`) */
  countryCode?: InputMaybe<CleoClinicCountryCodeForMutation>;
  /** Clinic domain/sub-domain when accessing via the web. (Required if creating new `CleoClinic`) */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Default language of this clinic. (Required if creating new `CleoClinic`) */
  language?: InputMaybe<CleoClinicLanguageForMutation>;
  /** Clinic logo which will be displayed on dashboard. Defaults to clinic group logo if not set. (Supports either S3 or data URI) */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Clinic name. (Required if creating new `CleoClinic`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Default timezone of this clinic. (Required if creating new `CleoClinic`) */
  timezone?: InputMaybe<CleoClinicTimezoneForMutation>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicProduct = {
  __typename?: 'UpdateCleoClinicProduct';
  /** Return the updated `CleoClinicProduct` after mutation. */
  cleoClinicProduct: CleoClinicProduct;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicProductInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cost of the product. (Required if creating new `CleoClinicProduct`) */
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  /**  (Required if creating new `CleoClinicProduct`) */
  costCurrency?: InputMaybe<CleoClinicProductCostCurrencyForMutation>;
  /** The name of this product. (Required if creating new `CleoClinicProduct`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicProgram = {
  __typename?: 'UpdateCleoClinicProgram';
  /** Return the updated `CleoClinicProgram` after mutation. */
  cleoClinicProgram: CleoClinicProgram;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicProgramInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Program name. (Required if creating new `CleoClinicProgram`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicProgramMonitoringFormset = {
  __typename?: 'UpdateCleoClinicProgramMonitoringFormset';
  /** Return the updated `CleoClinicProgramMonitoringFormset` after mutation. */
  cleoClinicProgramMonitoringFormset: CleoClinicProgramMonitoringFormset;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicProgramMonitoringFormsetInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicRatatoskrProviderApplication = {
  __typename?: 'UpdateCleoClinicRatatoskrProviderApplication';
  /** Return the updated `CleoClinicRatatoskrProviderApplication` after mutation. */
  cleoClinicRatatoskrProviderApplication: CleoClinicRatatoskrProviderApplication;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicRatatoskrProviderApplicationInput = {
  /** Application's settings to setup ratatoskr provider application. */
  applicationSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** Use this Ratatoskr provider application for communication. (Required if creating new `CleoClinicRatatoskrProviderApplication`) */
  communicationMethod?: InputMaybe<CleoClinicRatatoskrProviderApplicationCommunicationMethodForMutation>;
  /** Order of fallback Ratatoskr provider applications. Lower number means higher priority. */
  fallbackOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Set the value for `ForeignKey` to `RatatoskrProviderApplication`. */
  providerApplication?: InputMaybe<RatatoskrProviderApplicationRelatedModelInput>;
  /** Import path of the provider. */
  providerImportPath?: InputMaybe<Scalars['String']['input']>;
  /** Provider's settings to setup ratatoskr provider application. */
  providerSettings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Settings for this Ratatoskr provider application. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicratatoskrproviderapplicationsettings-generated.html" target="_blank">cleo/ClinicRatatoskrProviderApplicationSettings.schema</a>. It will be validated against [`cleo/ClinicRatatoskrProviderApplicationSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  settings?: InputMaybe<Scalars['CleoClinicRatatoskrProviderApplicationSettingsSkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoClinicalParameter = {
  __typename?: 'UpdateCleoClinicalParameter';
  /** Return the updated `CleoClinicalParameter` after mutation. */
  cleoClinicalParameter: CleoClinicalParameter;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicalParameterInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This is used for grouping parameters together, e.g., "Blood Pressure" is a group for Systolic/Diastolic. Defaults to the parameter name. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter name. (Required if creating new `CleoClinicalParameter`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Type of the clinical parameter. (Required if creating new `CleoClinicalParameter`) */
  valueType?: InputMaybe<CleoClinicalParameterValueTypeForMutation>;
};

/** Result of update mutation. */
export type UpdateCleoClinician = {
  __typename?: 'UpdateCleoClinician';
  /** Return the updated `CleoClinician` after mutation. */
  cleoClinician: CleoClinician;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoClinicianInput = {
  /** Avatar for clinicians. */
  avatar?: InputMaybe<ClinicianAvartar>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Method of contacting the clinician/patient. (Required if creating new `CleoClinician`) */
  communicationMethod?: InputMaybe<CleoClinicianCommunicationMethodForMutation>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Designation. (Required if creating new `CleoClinician`) */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Supplementary information about the clinician/Patient. (Deprecated for Patient, use `metadata_entries` instead) It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-profilemetadata-generated.html" target="_blank">cleo/ProfileMetadata.schema</a>. It will be validated against [`cleo/ProfileMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['CleoProfileMetadataSkeletonJSON']['input']>;
  /** Full name of the user. (Required if creating new `CleoClinician`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoClinician`) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Profile photo. (Supports either S3 or data URI) */
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoRole`. */
  role?: InputMaybe<CleoRoleRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoMessageTemplate = {
  __typename?: 'UpdateCleoMessageTemplate';
  /** Return the updated `CleoMessageTemplate` after mutation. */
  cleoMessageTemplate: CleoMessageTemplate;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoMessageTemplateInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Communication method this message template is for. (Required if creating new `CleoMessageTemplate`) */
  communicationMethod?: InputMaybe<CleoMessageTemplateCommunicationMethodForMutation>;
  /** Language of this message template. */
  language?: InputMaybe<CleoMessageTemplateLanguageForMutation>;
  /** Set the value for `ForeignKey` to `CleoMessageTemplateSet`. */
  messageTemplateSet?: InputMaybe<CleoMessageTemplateSetRelatedModelInput>;
  /** The message template to use for delivery. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `CleoMessageTemplate`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  template?: InputMaybe<Scalars['RatatoskrMessageTemplateSkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoMessageTemplateSet = {
  __typename?: 'UpdateCleoMessageTemplateSet';
  /** Return the updated `CleoMessageTemplateSet` after mutation. */
  cleoMessageTemplateSet: CleoMessageTemplateSet;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoMessageTemplateSetInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** Descriptive name of this message template set. Should be unique within the clinic. (Required if creating new `CleoMessageTemplateSet`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of this message template set. (Required if creating new `CleoMessageTemplateSet`) */
  purpose?: InputMaybe<CleoMessageTemplateSetPurposeForMutation>;
  /** Whether message templates in this set require access to patient-event. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether message templates in this set require access to patient-forms. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether message templates in this set require access to patient-programs. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientProgram?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether message templates in this set require access to patient-program-forms. (Required if creating new `CleoMessageTemplateSet`) */
  requirePatientProgramForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoMonitoringFormset = {
  __typename?: 'UpdateCleoMonitoringFormset';
  /** Return the updated `CleoMonitoringFormset` after mutation. */
  cleoMonitoringFormset: CleoMonitoringFormset;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoMonitoringFormsetInput = {
  /** Set the values for `ManyToManyField` to `CleoAlertRule`. */
  alertRules?: InputMaybe<Array<InputMaybe<CleoAlertRuleRelatedModelInput>>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Monitoring formset name. (Required if creating new `CleoMonitoringFormset`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatient = {
  __typename?: 'UpdateCleoPatient';
  /** Return the updated `CleoPatient` after mutation. */
  cleoPatient: CleoPatient;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientEventMetadataEntry = {
  __typename?: 'UpdateCleoPatientEventMetadataEntry';
  /** Return the updated `CleoPatientEventMetadataEntry` after mutation. */
  cleoPatientEventMetadataEntry: CleoPatientEventMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientEventMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientEvent`. */
  patientEvent?: InputMaybe<CleoPatientEventRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientForm = {
  __typename?: 'UpdateCleoPatientForm';
  /** Return the updated `CleoPatientForm` after mutation. */
  cleoPatientForm: CleoPatientForm;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientFormInput = {
  /** Set the values for `ManyToManyField` to `CleoAlertRule`. */
  alertRules?: InputMaybe<Array<InputMaybe<CleoAlertRuleRelatedModelInput>>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Do not alert this patient regardless. (Required if creating new `CleoPatientForm`) */
  doNotAlert?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not remind this patient regardless. (Required if creating new `CleoPatientForm`) */
  doNotRemind?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientFormMetadataEntry = {
  __typename?: 'UpdateCleoPatientFormMetadataEntry';
  /** Return the updated `CleoPatientFormMetadataEntry` after mutation. */
  cleoPatientFormMetadataEntry: CleoPatientFormMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientFormMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientForm`. */
  patientForm?: InputMaybe<CleoPatientFormRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientGroup = {
  __typename?: 'UpdateCleoPatientGroup';
  /** Return the updated `CleoPatientGroup` after mutation. */
  cleoPatientGroup: CleoPatientGroup;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientGroupInput = {
  /** List of patient group UIDs to add patients from. */
  addFromPatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of patient UIDs to add to this patient group. */
  addPatients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicFilter`. */
  clinicFilter?: InputMaybe<CleoClinicFilterRelatedModelInput>;
  /** Description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Patient UIDs to be excluded from adding into patient group. Only applicable for mutation with patient_filter. */
  excludePatientUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter patients fulfill conditin of this filter. It is validated against <a href="https://skeleton.staging.botmd.io/docs/scalpel-filtersettings-generated.html" target="_blank">scalpel/FilterSettings.schema</a>. It will be validated against [`scalpel/FilterSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  filterSettings?: InputMaybe<Scalars['ScalpelFilterSettingsSkeletonJSON']['input']>;
  /** Set the values for `ManyToManyField` to `CleoMonitoringFormset`. */
  monitoringFormsets?: InputMaybe<Array<InputMaybe<CleoMonitoringFormsetRelatedModelInput>>>;
  /** Name of the group. (Required if creating new `CleoPatientGroup`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter for patients in clinic. This will apply to all patients in clinic regardless of pagination. */
  patientFilter?: InputMaybe<PatientFilter>;
  /** Set the values for `ManyToManyField` to `CleoPatient`. */
  patients?: InputMaybe<Array<InputMaybe<CleoPatientRelatedModelInput>>>;
  /** Remove patient from group based on patient filter. This flag only applicable in update operation. */
  removeByPatientFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of patient UIDs to remove from this patient group. */
  removePatients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCleoPatientInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Method of contacting the clinician/patient. (Required if creating new `CleoPatient`) */
  communicationMethod?: InputMaybe<CleoPatientCommunicationMethodForMutation>;
  /** Date of birth of the patient. Can be left empty. If time is not available, we assume it is 12:00 (noon) local time of the patient. This field is always stored in UTC. */
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the patient. Can be left empty. */
  gender?: InputMaybe<CleoPatientGenderForMutation>;
  /** Unique identifier for the user within the clinic. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoPatient`) */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the user. (Required if creating new `CleoPatient`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `CleoPatient`) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientMetadataEntry = {
  __typename?: 'UpdateCleoPatientMetadataEntry';
  /** Return the updated `CleoPatientMetadataEntry` after mutation. */
  cleoPatientMetadataEntry: CleoPatientMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatient`. */
  patient?: InputMaybe<CleoPatientRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientProgram = {
  __typename?: 'UpdateCleoPatientProgram';
  /** Return the updated `CleoPatientProgram` after mutation. */
  cleoPatientProgram: CleoPatientProgram;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientProgramForm = {
  __typename?: 'UpdateCleoPatientProgramForm';
  /** Return the updated `CleoPatientProgramForm` after mutation. */
  cleoPatientProgramForm: CleoPatientProgramForm;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientProgramFormInput = {
  /** Set the values for `ManyToManyField` to `CleoAlertRule`. */
  alertRules?: InputMaybe<Array<InputMaybe<CleoAlertRuleRelatedModelInput>>>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Do not alert this patient regardless. (Required if creating new `CleoPatientProgramForm`) */
  doNotAlert?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not remind this patient regardless. (Required if creating new `CleoPatientProgramForm`) */
  doNotRemind?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientProgramFormMetadataEntry = {
  __typename?: 'UpdateCleoPatientProgramFormMetadataEntry';
  /** Return the updated `CleoPatientProgramFormMetadataEntry` after mutation. */
  cleoPatientProgramFormMetadataEntry: CleoPatientProgramFormMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientProgramFormMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientProgramForm`. */
  patientProgramForm?: InputMaybe<CleoPatientProgramFormRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

export type UpdateCleoPatientProgramInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Do not remind this patient regardless. (Required if creating new `CleoPatientProgram`) */
  doNotRemind?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the values for `ManyToManyField` to `CleoReminder`. */
  reminders?: InputMaybe<Array<InputMaybe<CleoReminderRelatedModelInput>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoPatientProgramMetadataEntry = {
  __typename?: 'UpdateCleoPatientProgramMetadataEntry';
  /** Return the updated `CleoPatientProgramMetadataEntry` after mutation. */
  cleoPatientProgramMetadataEntry: CleoPatientProgramMetadataEntry;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoPatientProgramMetadataEntryInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinicalParameter`. */
  parameter?: InputMaybe<CleoClinicalParameterRelatedModelInput>;
  /** Set the value for `ForeignKey` to `CleoPatientProgram`. */
  patientProgram?: InputMaybe<CleoPatientProgramRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Clinical parameter value. It is validated against <a href="https://skeleton.staging.botmd.io/docs/cleo-clinicalparametervalue-generated.html" target="_blank">cleo/ClinicalParameterValue.schema</a>. It will be validated against [`cleo/ClinicalParameterValue.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  value?: InputMaybe<Scalars['CleoClinicalParameterValueSkeletonJSON']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoReminder = {
  __typename?: 'UpdateCleoReminder';
  /** Return the updated `CleoReminder` after mutation. */
  cleoReminder: CleoReminder;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoClinic`. */
  clinic?: InputMaybe<CleoClinicRelatedModelInput>;
  /** This reminder applies to all patient-form in the clinic by default. (Required if creating new `CleoReminder`) */
  isForClinic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reminder name. (Required if creating new `CleoReminder`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Reminder settings including its schedule and options. This field is overriden to be nullable. */
  settings?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateCleoTriggeredAlert = {
  __typename?: 'UpdateCleoTriggeredAlert';
  /** Return the updated `CleoTriggeredAlert` after mutation. */
  cleoTriggeredAlert: CleoTriggeredAlert;
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCleoTriggeredAlertInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `CleoSubmissionComment`. */
  resolvingComment?: InputMaybe<CleoSubmissionCommentRelatedModelInput>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinAdministrator = {
  __typename?: 'UpdateEinsteinAdministrator';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinAdministrator` after mutation. */
  einsteinAdministrator: EinsteinAdministrator;
};

export type UpdateEinsteinAdministratorInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Department UID of the administrator. */
  departmentUid?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  departments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Designation UID of the administrator. */
  designationUid?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  divisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Email of the administrator. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Administrator first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** True if the admin is a super-admin. False for department admins, or other cases as to be defined. */
  isSuper?: InputMaybe<Scalars['Boolean']['input']>;
  /** Administrator last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the administrator. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinBroadcast = {
  __typename?: 'UpdateEinsteinBroadcast';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinBroadcast` after mutation. */
  einsteinBroadcast: EinsteinBroadcast;
};

export type UpdateEinsteinBroadcastInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Broadcast should only run before this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Messages to be broadcasted. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `EinsteinBroadcast`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messages?: InputMaybe<Scalars['RatatoskrMessageTemplateSkeletonJSON']['input']>;
  /** Broadcast name. (Required if creating new `EinsteinBroadcast`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Rulesets to select profiles to send the messages to. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-profilesgrouprulesetarray-generated.html" target="_blank">einstein/ProfilesGroupRulesetArray.schema</a>. It will be validated against [`einstein/ProfilesGroupRulesetArray.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  profilesGroupRulesets?: InputMaybe<Scalars['EinsteinProfilesGroupRulesetArraySkeletonJSON']['input']>;
  /** Recurring frequencies this broadcast is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. It will be validated against [`einstein/RecurringFrequencies.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  recurringFrequencies?: InputMaybe<Scalars['EinsteinRecurringFrequenciesSkeletonJSON']['input']>;
  /** Date/Time this broadcast is scheduled to be sent. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  /** Broadcast should only run after this. If `NULL`, it means this broadcast can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Status of the broadcast. (Required if creating new `EinsteinBroadcast`) */
  status?: InputMaybe<EinsteinBroadcastStatusForMutation>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of update mutation. */
export type UpdateEinsteinChernobylEntry = {
  __typename?: 'UpdateEinsteinChernobylEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinChernobylEntry` after mutation. */
  einsteinChernobylEntry: EinsteinChernobylEntry;
};

export type UpdateEinsteinChernobylEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the Einstein Chernobyl DataSource to create the entry. */
  dataSourceUid?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** For convenient CUD of the data source entry variables. This is a _set_ operation meaning any variables not in this set will be deleted from the entry. If `null`, no changes will be done to the existing variables. */
  variablesSet?: InputMaybe<Array<ChernobylVariableInput>>;
};

/** Result of update mutation. */
export type UpdateEinsteinDataSource = {
  __typename?: 'UpdateEinsteinDataSource';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinDataSource` after mutation. */
  einsteinDataSource: EinsteinDataSource;
};

export type UpdateEinsteinDataSourceInput = {
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Athena will set this to `synced_version` with it does a successful sync. */
  athenaSyncedVersion?: InputMaybe<Scalars['String']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinDialogueEntry = {
  __typename?: 'UpdateEinsteinDialogueEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinDialogueEntry` after mutation. */
  einsteinDialogueEntry: EinsteinDialogueEntry;
};

export type UpdateEinsteinDialogueEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Messages that will be returned as a response. It is validated against <a href="https://skeleton.staging.botmd.io/docs/ratatoskr-messagetemplate-generated.html" target="_blank">ratatoskr/MessageTemplate.schema</a>. (Required if creating new `EinsteinDialogueEntry`) It will be validated against [`ratatoskr/MessageTemplate.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  messages?: InputMaybe<Scalars['RatatoskrMessageTemplateSkeletonJSON']['input']>;
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Title of this dialogue. (Required if creating new `EinsteinDialogueEntry`) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Array of trigger entities. */
  triggersSet?: InputMaybe<Array<InputMaybe<Array<EntityInput>>>>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinDocumentEntry = {
  __typename?: 'UpdateEinsteinDocumentEntry';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinDocumentEntry` after mutation. */
  einsteinDocumentEntry: EinsteinDocumentEntry;
};

export type UpdateEinsteinDocumentEntryInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this entry. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Date/Time this entry was synced to Athena. `None` means this entry hasn't been synced yet. */
  athenaSyncedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `EinsteinDataSource`. */
  dataSource?: InputMaybe<EinsteinDataSourceRelatedModelInput>;
  /** DataSource UID when creating a DocumentEntry. */
  dataSourceUid?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** (DEPRECATED) Department UID when creating or updating a DocumentEntry */
  departmentUid?: InputMaybe<Scalars['String']['input']>;
  /** An identifier which uniquely identifies this file in the source. (Required if creating new `EinsteinDocumentEntry`) */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** The name/path of this file for display. Depending on the nature of the data source, this may be a hierarchical path. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of this file. Defaults to `application/octet-stream` if unable to guess from `filename`. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Syncs Jarvis if True */
  syncJarvis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Title of this document. This is usually provided by the user (or automatically inferred). */
  title?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** For convenient CUD of the data source entry variables. This is a _set_ operation meaning any variables not in this set will be deleted from the entry. If `null`, no changes will be done to the existing variables. */
  variablesSet?: InputMaybe<Array<DocumentVariableInput>>;
  /** The URL to web version of the file on the data source if available. */
  webUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinModule = {
  __typename?: 'UpdateEinsteinModule';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinModule` after mutation. */
  einsteinModule: EinsteinModule;
};

export type UpdateEinsteinModuleInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** All departments have access to this module */
  ownerDepartmentsAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** All divisions have access to this module */
  ownerDivisionsAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating if this module should be viewable by default to Einstein admins. (Required if creating new `EinsteinModule`) */
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of update mutation. */
export type UpdateEinsteinProfilesGroup = {
  __typename?: 'UpdateEinsteinProfilesGroup';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `EinsteinProfilesGroup` after mutation. */
  einsteinProfilesGroup: EinsteinProfilesGroup;
};

export type UpdateEinsteinProfilesGroupInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Group description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Group name. (Required if creating new `EinsteinProfilesGroup`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Ruleset for profiles to send the message to. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-profilesgroupruleset-generated.html" target="_blank">einstein/ProfilesGroupRuleset.schema</a>. It will be validated against [`einstein/ProfilesGroupRuleset.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  ruleset?: InputMaybe<Scalars['EinsteinProfilesGroupRulesetSkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** To upsert DirectoryProfile UIDs into the Broadcast's ruleset */
  upsertDirectoryprofileUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Result of update mutation. */
export type UpdateFaradayOrder = {
  __typename?: 'UpdateFaradayOrder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `FaradayOrder` after mutation. */
  faradayOrder: FaradayOrder;
};

/** Result of update mutation. */
export type UpdateFaradayOrderDraft = {
  __typename?: 'UpdateFaradayOrderDraft';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `FaradayOrderDraft` after mutation. */
  faradayOrderDraft: FaradayOrderDraft;
};

export type UpdateFaradayOrderDraftInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Draft detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. It will be validated against [`skeleton/Any.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  draft?: InputMaybe<Scalars['SkeletonAnySkeletonJSON']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateFaradayOrderExam = {
  __typename?: 'UpdateFaradayOrderExam';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `FaradayOrderExam` after mutation. */
  faradayOrderExam: FaradayOrderExam;
};

export type UpdateFaradayOrderExamInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the value for `ForeignKey` to `FaradayExam`. */
  exam?: InputMaybe<FaradayExamRelatedModelInput>;
  /** exam comments, attention radiologist etc. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. It will be validated against [`faraday/OrderMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayOrderMetadataSkeletonJSON']['input']>;
  /** Set the value for `ForeignKey` to `FaradayOrder`. */
  order?: InputMaybe<FaradayOrderRelatedModelInput>;
  /** Metadata for order. This will overwrite existing order metadata. */
  orderMetadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Set the value for `ForeignKey` to `FaradayRoom`. */
  room?: InputMaybe<FaradayRoomRelatedModelInput>;
  /** Time this exam order is scheduled for. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFaradayOrderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UID of the doctor to create an order for. */
  doctorUid?: InputMaybe<Scalars['String']['input']>;
  /** Order detail. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-ordermetadata-generated.html" target="_blank">faraday/OrderMetadata.schema</a>. It will be validated against [`faraday/OrderMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayOrderMetadataSkeletonJSON']['input']>;
  /** List of OrderExams to bulk create during object creation. */
  orderExams?: InputMaybe<Array<OrderExamInput>>;
  /** UID of the patient to create an order for. */
  patientUid?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateFaradayPatientProfile = {
  __typename?: 'UpdateFaradayPatientProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `FaradayPatientProfile` after mutation. */
  faradayPatientProfile: FaradayPatientProfile;
};

export type UpdateFaradayPatientProfileInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comments for this patient. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Patient date of birth */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** UIDs for doctor who in-charge of this patient. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User's first name. (Required if creating new `FaradayPatientProfile`) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Patient gender. */
  gender?: InputMaybe<FaradayPatientProfileGenderForMutation>;
  /** Is this patient claustrophobic? (Required if creating new `FaradayPatientProfile`) */
  isClaustrophobic?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Patient metadata. It is validated against <a href="https://skeleton.staging.botmd.io/docs/faraday-patientmetadata-generated.html" target="_blank">faraday/PatientMetadata.schema</a>. It will be validated against [`faraday/PatientMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['FaradayPatientMetadataSkeletonJSON']['input']>;
  /** Patient MRN in Parkway UCMI. */
  mrnNo?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted patient national ID (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  nationalId?: InputMaybe<Scalars['String']['input']>;
  /** Nationality for this patient. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateFaradayStaffProfile = {
  __typename?: 'UpdateFaradayStaffProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `FaradayStaffProfile` after mutation. */
  faradayStaffProfile: FaradayStaffProfile;
};

export type UpdateFaradayStaffProfileInput = {
  /** Account type of the staff (Required if creating new `FaradayStaffProfile`) */
  accountType?: InputMaybe<FaradayStaffProfileAccountTypeForMutation>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Staff designation */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** List of doctor UIDs for AdminDoctorRelationship. */
  doctorUids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Encrypted and HMAC email for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User's first name. (Required if creating new `FaradayStaffProfile`) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Staff's MCR No. */
  mcrNo?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted and HMAC phone number for profile. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Staff's Physician ID. */
  physicianId?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalBanner = {
  __typename?: 'UpdateHospitalBanner';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalBanner` after mutation. */
  hospitalBanner: HospitalBanner;
};

export type UpdateHospitalBannerInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Banner should only run before this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Banner should only run after this. If `NULL`, it means this banner can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** The HTML content of the banner. Max 60 characters (exclude the HTML tags). (Required if creating new `HospitalBanner`) */
  text?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalDepartment = {
  __typename?: 'UpdateHospitalDepartment';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalDepartment` after mutation. */
  hospitalDepartment: HospitalDepartment;
};

export type UpdateHospitalDepartmentInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**  (Required if creating new `HospitalDepartment`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name of Department to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalDesignation = {
  __typename?: 'UpdateHospitalDesignation';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalDesignation` after mutation. */
  hospitalDesignation: HospitalDesignation;
};

export type UpdateHospitalDesignationInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**  (Required if creating new `HospitalDesignation`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name of Designation to move displaced users to on deletion */
  replaceName?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID representing the Designation. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalDirectoryProfile = {
  __typename?: 'UpdateHospitalDirectoryProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalDirectoryProfile` after mutation. */
  hospitalDirectoryProfile: HospitalDirectoryProfile;
};

export type UpdateHospitalDirectoryProfileInput = {
  /** If specified, this profile will be activated after the set date. */
  activateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If specified, this profile will be deactivated after the set date. Mechanics of deactivation follow that of `deactivated_on`. */
  deactivateAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** If specified, this profile will be deactivated. However, the user will still be able to log in if they are present in the hospital's API. Note that this option should be left blank if user `is_blacklisted`. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** User Department UID */
  department?: InputMaybe<Scalars['String']['input']>;
  /** User Designation UID */
  designation?: InputMaybe<Scalars['String']['input']>;
  /** Email of user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Profile first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Profile last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalDivision = {
  __typename?: 'UpdateHospitalDivision';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalDivision` after mutation. */
  hospitalDivision: HospitalDivision;
};

export type UpdateHospitalDivisionInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToOneRel` to `HospitalDepartment`. */
  departments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /**  (Required if creating new `HospitalDivision`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UID of Division to move displaced admins and departments to on deletion. */
  replaceUid?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID representing the Division. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalFavourite = {
  __typename?: 'UpdateHospitalFavourite';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalFavourite` after mutation. */
  hospitalFavourite: HospitalFavourite;
};

export type UpdateHospitalFavouriteInput = {
  /** List of ACLs in DNF format (OR of ANDs) that applies to this favourite. */
  aclDnf?: InputMaybe<Scalars['GenericScalar']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Content type of the Favourite. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Favourite key. (Required if creating new `HospitalFavourite`) */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Set the values for `ManyToManyField` to `HospitalDepartment`. */
  ownerDepartments?: InputMaybe<Array<InputMaybe<HospitalDepartmentRelatedModelInput>>>;
  /** Set the values for `ManyToManyField` to `HospitalDivision`. */
  ownerDivisions?: InputMaybe<Array<InputMaybe<HospitalDivisionRelatedModelInput>>>;
  /** Subtitle of the Favourite. */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Title of the Favourite. (Required if creating new `HospitalFavourite`) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
  /** URL the favourite links to. (Required if creating new `HospitalFavourite`) */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalMoodLogReminder = {
  __typename?: 'UpdateHospitalMoodLogReminder';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalMoodLogReminder` after mutation. */
  hospitalMoodLogReminder: HospitalMoodLogReminder;
};

export type UpdateHospitalMoodLogReminderInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time the instance was deactivated. */
  deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Reminder should only run before this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  endOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Recurring frequencies this reminder is scheduled to be sent. It is validated against <a href="https://skeleton.staging.botmd.io/docs/einstein-recurringfrequencies-generated.html" target="_blank">einstein/RecurringFrequencies.schema</a>. It will be validated against [`einstein/RecurringFrequencies.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  recurringFrequencies?: InputMaybe<Scalars['EinsteinRecurringFrequenciesSkeletonJSON']['input']>;
  /** Reminder should only run after this. If `NULL`, it means this reminder can run anytime as determined by the schedules. */
  startOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateHospitalProfile = {
  __typename?: 'UpdateHospitalProfile';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `HospitalProfile` after mutation. */
  hospitalProfile: HospitalProfile;
};

export type UpdateHospitalProfileInput = {
  /** Profile's avatar. (Supports either S3 or data URI) */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Profile's profile picture. (Supports either S3 or data URI) */
  picture?: InputMaybe<Scalars['String']['input']>;
  /** Settings for this object. It is validated against <a href="https://skeleton.staging.botmd.io/docs/hospital-profilesettings-generated.html" target="_blank">hospital/ProfileSettings.schema</a>. It will be validated against [`hospital/ProfileSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  settings?: InputMaybe<Scalars['HospitalProfileSettingsSkeletonJSON']['input']>;
  /** Profile's superpower, e.g., General Practitioner, Specialist, etc */
  superpower?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateMerlinAdministrator = {
  __typename?: 'UpdateMerlinAdministrator';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `MerlinAdministrator` after mutation. */
  merlinAdministrator: MerlinAdministrator;
};

export type UpdateMerlinAdministratorInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the user. (Required if creating new `MerlinAdministrator`) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for the user. (Value is encrypted with AES-256 and separately hashed with HMAC (sha3-512).) (Required if creating new `MerlinAdministrator`) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique ID for this object. (Required) */
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Result of update mutation. */
export type UpdateStitchLink = {
  __typename?: 'UpdateStitchLink';
  /** Used by Relay client for mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated `StitchLink` after mutation. */
  stitchLink: StitchLink;
};

export type UpdateStitchLinkInput = {
  /** Used by Relay client for mutations. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional event properties to complement the default Stitch event. It is validated against <a href="https://skeleton.staging.botmd.io/docs/skeleton-any-generated.html" target="_blank">skeleton/Any.schema</a>. It will be validated against [`skeleton/Any.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  eventProperties?: InputMaybe<Scalars['SkeletonAnySkeletonJSON']['input']>;
  /** Date/Time when the link expires. If not set, it will never expire. */
  expiresOn?: InputMaybe<Scalars['DateTime']['input']>;
  /** Link identifier. Will be auto-generated if not specified. */
  linkId?: InputMaybe<Scalars['String']['input']>;
  /** Link metadata used for features such as delayed creation. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-linkmetadata-generated.html" target="_blank">stitch/LinkMetadata.schema</a>. It will be validated against [`stitch/LinkMetadata.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  metadata?: InputMaybe<Scalars['StitchLinkMetadataSkeletonJSON']['input']>;
  /** The MIME type is useful for frontend to decide what to do with the link. */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Link permission used to validate a request. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-linkpermission-generated.html" target="_blank">stitch/LinkPermission.schema</a>. (Required if creating new `StitchLink`) It will be validated against [`stitch/LinkPermission.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  permission?: InputMaybe<Scalars['StitchLinkPermissionSkeletonJSON']['input']>;
  /** These additional settings will be used with HTTPS source URLs in the request. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-requestsettings-generated.html" target="_blank">stitch/RequestSettings.schema</a>. It will be validated against [`stitch/RequestSettings.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  requestSettings?: InputMaybe<Scalars['StitchRequestSettingsSkeletonJSON']['input']>;
  /** These additional headers will be added to the response when link is used. It is validated against <a href="https://skeleton.staging.botmd.io/docs/stitch-responseheaders-generated.html" target="_blank">stitch/ResponseHeaders.schema</a>. It will be validated against [`stitch/ResponseHeaders.schema`](https://skeleton.staging.botmd.io/docs/index.html) */
  responseHeaders?: InputMaybe<Scalars['StitchResponseHeadersSkeletonJSON']['input']>;
  /** Source URL for the link. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserVariableInput = {
  /** Variable name. */
  name: Scalars['String']['input'];
  /** Variable value. For `file` types, this can be either a Stitch `upload_id` or HTTPS URL. */
  value: Scalars['String']['input'];
};

/** Welcome menu to display to the user. */
export type WelcomeMessageInput = {
  /** Buttons of the welcome menu. */
  buttons: Array<Scalars['String']['input']>;
  /** Text of the welcome menu. */
  text: Scalars['String']['input'];
};

/** An enumeration. */
export enum WhatsAppLanguage {
  Af = 'AF',
  Ar = 'AR',
  Az = 'AZ',
  Bg = 'BG',
  Bn = 'BN',
  Ca = 'CA',
  Cs = 'CS',
  Da = 'DA',
  De = 'DE',
  El = 'EL',
  En = 'EN',
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  Es = 'ES',
  EsAr = 'ES_AR',
  EsEs = 'ES_ES',
  EsMx = 'ES_MX',
  Et = 'ET',
  Fa = 'FA',
  Fi = 'FI',
  Fil = 'FIL',
  Fr = 'FR',
  Ga = 'GA',
  Gu = 'GU',
  Ha = 'HA',
  He = 'HE',
  Hi = 'HI',
  Hr = 'HR',
  Hu = 'HU',
  Id = 'ID',
  It = 'IT',
  Ja = 'JA',
  Ka = 'KA',
  Kk = 'KK',
  Kn = 'KN',
  Ko = 'KO',
  KyKg = 'KY_KG',
  Lo = 'LO',
  Lt = 'LT',
  Lv = 'LV',
  Mk = 'MK',
  Ml = 'ML',
  Mr = 'MR',
  Ms = 'MS',
  Nb = 'NB',
  Nl = 'NL',
  Pa = 'PA',
  Pl = 'PL',
  PtBr = 'PT_BR',
  PtPt = 'PT_PT',
  Ro = 'RO',
  Ru = 'RU',
  RwRw = 'RW_RW',
  Sk = 'SK',
  Sl = 'SL',
  Sq = 'SQ',
  Sr = 'SR',
  Sv = 'SV',
  Sw = 'SW',
  Ta = 'TA',
  Te = 'TE',
  Th = 'TH',
  Tr = 'TR',
  Uk = 'UK',
  Ur = 'UR',
  Uz = 'UZ',
  Vi = 'VI',
  ZhCn = 'ZH_CN',
  ZhHk = 'ZH_HK',
  ZhTw = 'ZH_TW',
  Zu = 'ZU',
}

export type AvailabilityRoom_Fragment = {
  __typename?: 'FaradayRoom';
  uid: string;
  name: string;
  metadata?: any | null;
  aeTitle: string;
  modality: { __typename?: 'FaradayModality' } & {
    ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
  };
  facility: { __typename?: 'FaradayFacility' } & {
    ' $fragmentRefs'?: { Facility_Fragment: Facility_Fragment };
  };
} & { ' $fragmentName'?: 'AvailabilityRoom_Fragment' };

export type AvailabilitySlots_Fragment = {
  __typename?: 'FaradayAvailabilitySlot';
  id?: string | null;
  date: any;
  times: Array<Array<string> | null>;
} & { ' $fragmentName'?: 'AvailabilitySlots_Fragment' };

export type AvalibilityQueryVariables = Exact<{
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  examUid: Scalars['String']['input'];
  facilityUid?: InputMaybe<Scalars['String']['input']>;
}>;

export type AvalibilityQuery = {
  __typename?: 'Query';
  faradayAvailability?: {
    __typename?: 'FaradayAvailability';
    results?: Array<{
      __typename?: 'FaradayAvailabilityResult';
      exam: {
        __typename?: 'FaradayExam';
        duration: number;
        uid: string;
        name: string;
        disclaimerMessages?: Array<string> | null;
        metadata?: any | null;
      };
      room: {
        __typename?: 'FaradayRoom';
        uid: string;
        name: string;
        metadata?: any | null;
        aeTitle: string;
        facility: { __typename?: 'FaradayFacility'; uid: string; name: string };
      };
      slots?: Array<
        { __typename?: 'FaradayAvailabilitySlot' } & {
          ' $fragmentRefs'?: { AvailabilitySlots_Fragment: AvailabilitySlots_Fragment };
        }
      > | null;
    }> | null;
  } | null;
};

export type AsyncJob_Fragment = {
  __typename?: 'KronosAsyncJob';
  uid: string;
  status: KronosAsyncJobStatusChoices;
  createdOn: any;
  results?: any | null;
  isReady: boolean;
} & { ' $fragmentName'?: 'AsyncJob_Fragment' };

export type AvalibilityAsyncQueryVariables = Exact<{
  asyncJobUid?: InputMaybe<Scalars['String']['input']>;
  examUid?: InputMaybe<Scalars['String']['input']>;
  facilityUid?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type AvalibilityAsyncQuery = {
  __typename?: 'Query';
  faradayAvailabilityAsync?: {
    __typename?: 'FaradayAvailabilityAsync';
    asyncJob?:
      | ({ __typename?: 'KronosAsyncJob' } & { ' $fragmentRefs'?: { AsyncJob_Fragment: AsyncJob_Fragment } })
      | null;
    results?: Array<{
      __typename?: 'FaradayAvailabilityResult';
      exam: { __typename?: 'FaradayExam'; uid: string; duration: number };
      room: { __typename?: 'FaradayRoom' } & {
        ' $fragmentRefs'?: { AvailabilityRoom_Fragment: AvailabilityRoom_Fragment };
      };
      slots?: Array<
        { __typename?: 'FaradayAvailabilitySlot' } & {
          ' $fragmentRefs'?: { AvailabilitySlots_Fragment: AvailabilitySlots_Fragment };
        }
      > | null;
    }> | null;
  } | null;
};

export type FacilityAvailabilityQueryVariables = Exact<{
  examUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type FacilityAvailabilityQuery = {
  __typename?: 'Query';
  faradayFacilityAvailability?: Array<{
    __typename?: 'FaradayFacilityAvailability';
    exams: Array<{
      __typename?: 'FaradayExam';
      uid: string;
      name: string;
      disclaimerMessages?: Array<string> | null;
      modality: { __typename?: 'FaradayModality'; shortName: string; name: string };
    }>;
    facility: { __typename?: 'FaradayFacility' } & {
      ' $fragmentRefs'?: { Facility_Fragment: Facility_Fragment };
    };
  } | null> | null;
};

export type ExamAvailabilityQueryVariables = Exact<{
  examSearch?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExamAvailabilityQuery = {
  __typename?: 'Query';
  faradayExamAvailability?: Array<{
    __typename?: 'FaradayExamAvailability';
    exam: {
      __typename?: 'FaradayExam';
      modality: { __typename?: 'FaradayModality' } & {
        ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
      };
    } & { ' $fragmentRefs'?: { Exam_Fragment: Exam_Fragment } };
  } | null> | null;
};

export type Clinic_Fragment = {
  __typename?: 'FaradayClinic';
  uid: string;
  domain: string;
  address: string;
  name: string;
  hciCode: string;
  phone: string;
} & { ' $fragmentName'?: 'Clinic_Fragment' };

export type Staffs_Fragment = {
  __typename?: 'FaradayClinic';
  staffs: Array<
    {
      __typename?: 'FaradayStaffProfile';
      uid: string;
      accountType: FaradayStaffProfileAccountTypeChoices;
      createdOn: any;
      deactivatedOn?: any | null;
      email?: string | null;
    } & { ' $fragmentRefs'?: { FavoriteExams_Fragment: FavoriteExams_Fragment } }
  >;
} & { ' $fragmentName'?: 'Staffs_Fragment' };

export type ClinicsConnection_Fragment = {
  __typename?: 'FaradayClinicConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
} & { ' $fragmentName'?: 'ClinicsConnection_Fragment' };

export type ClinicsQueryVariables = Exact<{ [key: string]: never }>;

export type ClinicsQuery = {
  __typename?: 'Query';
  faradayClinics?:
    | ({
        __typename?: 'FaradayClinicConnection';
        edges: Array<{
          __typename?: 'FaradayClinicEdge';
          node?:
            | ({ __typename?: 'FaradayClinic' } & {
                ' $fragmentRefs'?: { Clinic_Fragment: Clinic_Fragment; Staffs_Fragment: Staffs_Fragment };
              })
            | null;
        } | null>;
      } & { ' $fragmentRefs'?: { ClinicsConnection_Fragment: ClinicsConnection_Fragment } })
    | null;
};

export type ClinicQueryVariables = Exact<{ [key: string]: never }>;

export type ClinicQuery = {
  __typename?: 'Query';
  faradayClinic?:
    | ({ __typename?: 'FaradayClinic' } & {
        ' $fragmentRefs'?: { Clinic_Fragment: Clinic_Fragment; Staffs_Fragment: Staffs_Fragment };
      })
    | null;
};

export type RegisterDeviceMutationVariables = Exact<{
  input: FaradayRegisterDeviceInput;
}>;

export type RegisterDeviceMutation = {
  __typename?: 'Mutation';
  faradayRegisterDevice?: {
    __typename?: 'FaradayRegisterDevice';
    device?: {
      __typename?: 'RatatoskrDevice';
      uid: string;
      createdOn: any;
      metadata?: any | null;
      id?: string | null;
      lastActiveOn: any;
      session?: { __typename?: 'HeimdallSession'; uid: string } | null;
    } | null;
    staffProfile?: { __typename?: 'FaradayStaffProfile'; uid: string } | null;
  } | null;
};

export type Exam_Fragment = {
  __typename?: 'FaradayExam';
  uid: string;
  name: string;
  duration: number;
  isRetired: boolean;
  disclaimerMessages?: Array<string> | null;
  modality: { __typename?: 'FaradayModality'; uid: string; shortName: string };
  additionalFieldTemplates?: Array<
    { __typename?: 'FaradayAdditionalFieldTemplate' } & {
      ' $fragmentRefs'?: { AdditionalFieldTemplates_Fragment: AdditionalFieldTemplates_Fragment };
    }
  > | null;
} & { ' $fragmentName'?: 'Exam_Fragment' };

export type AdditionalFieldTemplates_Fragment = {
  __typename?: 'FaradayAdditionalFieldTemplate';
  id?: string | null;
  key: string;
  name: string;
  description?: string | null;
  categories: Array<{
    __typename?: 'FaradayAditionalFieldCategory';
    id?: string | null;
    key: string;
    name: string;
    description?: string | null;
    fields: Array<{
      __typename?: 'FaradayAdditionalField';
      key: string;
      id?: string | null;
      name: string;
      type: string;
      default?: string | null;
    }>;
  }>;
} & { ' $fragmentName'?: 'AdditionalFieldTemplates_Fragment' };

export type ExamsQueryVariables = Exact<{
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  modalities?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExamsQuery = {
  __typename?: 'Query';
  faradayExams?: {
    __typename?: 'FaradayExamConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'FaradayExamEdge';
      node?:
        | ({
            __typename?: 'FaradayExam';
            modality: { __typename?: 'FaradayModality' } & {
              ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
            };
          } & { ' $fragmentRefs'?: { Exam_Fragment: Exam_Fragment } })
        | null;
    } | null>;
  } | null;
};

export type ExamByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type ExamByUidQuery = {
  __typename?: 'Query';
  faradayExam?:
    | ({
        __typename?: 'FaradayExam';
        modality: { __typename?: 'FaradayModality' } & {
          ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
        };
      } & { ' $fragmentRefs'?: { Exam_Fragment: Exam_Fragment } })
    | null;
};

export type Facility_Fragment = {
  __typename?: 'FaradayFacility';
  uid: string;
  name: string;
  metadata?: any | null;
  shortCode: string;
  disclaimerMessages?: Array<string> | null;
  rooms: Array<{
    __typename?: 'FaradayRoom';
    uid: string;
    name: string;
    metadata?: any | null;
    modality: { __typename?: 'FaradayModality' } & {
      ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
    };
  }>;
} & { ' $fragmentName'?: 'Facility_Fragment' };

export type FacilitiesQueryVariables = Exact<{ [key: string]: never }>;

export type FacilitiesQuery = {
  __typename?: 'Query';
  faradayFacilities?: {
    __typename?: 'FaradayFacilityConnection';
    edges: Array<{
      __typename?: 'FaradayFacilityEdge';
      node?:
        | ({ __typename?: 'FaradayFacility' } & {
            ' $fragmentRefs'?: { Facility_Fragment: Facility_Fragment };
          })
        | null;
    } | null>;
  } | null;
};

export type FacilityByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type FacilityByUidQuery = {
  __typename?: 'Query';
  faradayFacility?:
    | ({ __typename?: 'FaradayFacility' } & { ' $fragmentRefs'?: { Facility_Fragment: Facility_Fragment } })
    | null;
};

export type HeimdallWithSessionQueryVariables = Exact<{ [key: string]: never }>;

export type HeimdallWithSessionQuery = {
  __typename?: 'Query';
  heimdallSession?: {
    __typename?: 'HeimdallSession';
    id?: string | null;
    uid: string;
    scopes?: any | null;
    expiresOn: any;
    user?: { __typename?: 'GovernessUser'; uid: string } | null;
  } | null;
};

export type HeimdallWithSessionByIdQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type HeimdallWithSessionByIdQuery = {
  __typename?: 'Query';
  heimdallSession?: { __typename?: 'HeimdallSession'; id?: string | null; uid: string } | null;
};

export type HeimdallAuthorizationFlowJwtMutationVariables = Exact<{
  input: HeimdallAuthorizationFlowInput;
}>;

export type HeimdallAuthorizationFlowJwtMutation = {
  __typename?: 'Mutation';
  heimdallAuthorizationFlow?: {
    __typename?: 'HeimdallAuthorizationFlow';
    redirectTo?: string | null;
    session?: {
      __typename?: 'HeimdallSession';
      uid: string;
      scopes?: any | null;
      expiresOn: any;
      user?: { __typename?: 'GovernessUser'; uid: string } | null;
    } | null;
  } | null;
};

export type HeimdallAuthorizationFlowExchangeMutationVariables = Exact<{
  heimdallAuthorizationFlowInput: HeimdallAuthorizationFlowInput;
}>;

export type HeimdallAuthorizationFlowExchangeMutation = {
  __typename?: 'Mutation';
  heimdallAuthorizationFlow?: {
    __typename?: 'HeimdallAuthorizationFlow';
    session?: { __typename?: 'HeimdallSession'; uid: string; scopes?: any | null; expiresOn: any } | null;
  } | null;
};

export type LogoutSessionMutationVariables = Exact<{
  input: HeimdallLogoutInput;
}>;

export type LogoutSessionMutation = {
  __typename?: 'Mutation';
  heimdallLogout?: { __typename?: 'HeimdallLogout'; success?: boolean | null } | null;
};

export type MessageTemplate_Fragment = {
  __typename?: 'FaradayMessageTemplate';
  uid: string;
  name: string;
  template?: any | null;
} & { ' $fragmentName'?: 'MessageTemplate_Fragment' };

export type MessageTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type MessageTemplatesQuery = {
  __typename?: 'Query';
  faradayMessageTemplates?: {
    __typename?: 'FaradayMessageTemplateConnection';
    edges: Array<{
      __typename?: 'FaradayMessageTemplateEdge';
      node?:
        | ({ __typename?: 'FaradayMessageTemplate' } & {
            ' $fragmentRefs'?: { MessageTemplate_Fragment: MessageTemplate_Fragment };
          })
        | null;
    } | null>;
  } | null;
};

export type MessageTemplateByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type MessageTemplateByUidQuery = {
  __typename?: 'Query';
  faradayMessageTemplate?:
    | ({ __typename?: 'FaradayMessageTemplate' } & {
        ' $fragmentRefs'?: { MessageTemplate_Fragment: MessageTemplate_Fragment };
      })
    | null;
};

export type MessageTemplateDeliverToPatientMutationVariables = Exact<{
  input: FaradayMessageTemplateDeliverToPatientInput;
}>;

export type MessageTemplateDeliverToPatientMutation = {
  __typename?: 'Mutation';
  faradayMessageTemplateDeliverToPatient?: {
    __typename?: 'FaradayMessageTemplateDeliverToPatient';
    results: Array<{
      __typename?: 'FaradayMessageTemplateDeliveryResult';
      isDelivered: boolean;
      patientProfile: { __typename?: 'FaradayPatientProfile'; uid: string };
      messageTemplate?:
        | ({ __typename?: 'FaradayMessageTemplate' } & {
            ' $fragmentRefs'?: { MessageTemplate_Fragment: MessageTemplate_Fragment };
          })
        | null;
    }>;
  } | null;
};

export type ModalitiesAllQueryVariables = Exact<{ [key: string]: never }>;

export type ModalitiesAllQuery = {
  __typename?: 'Query';
  faradayModalities?: {
    __typename?: 'FaradayModalityConnection';
    edges: Array<{
      __typename?: 'FaradayModalityEdge';
      node?: { __typename?: 'FaradayModality'; uid: string; name: string; shortName: string } | null;
    } | null>;
  } | null;
};

export type ModalitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  shortName_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type ModalitiesQuery = {
  __typename?: 'Query';
  faradayModalities?: {
    __typename?: 'FaradayModalityConnection';
    edges: Array<{
      __typename?: 'FaradayModalityEdge';
      node?: { __typename?: 'FaradayModality'; uid: string; name: string; shortName: string } | null;
    } | null>;
  } | null;
};

export type ModalityDetails_Fragment = { __typename?: 'FaradayModality'; name: string; shortName: string } & {
  ' $fragmentName'?: 'ModalityDetails_Fragment';
};

export type ModalityQueryVariables = Exact<{ [key: string]: never }>;

export type ModalityQuery = {
  __typename?: 'Query';
  faradayModality?:
    | ({ __typename?: 'FaradayModality' } & {
        ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
      })
    | null;
};

export type ModalityByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type ModalityByUidQuery = {
  __typename?: 'Query';
  faradayModality?: { __typename?: 'FaradayModality'; uid: string; name: string; shortName: string } | null;
};

export type OrdersExams_Fragment = ({
  __typename?: 'FaradayOrderExam';
  room: {
    __typename?: 'FaradayRoom';
    uid: string;
    name: string;
    metadata?: any | null;
    modality: { __typename?: 'FaradayModality'; name: string; uid: string; shortName: string };
    facility: { __typename?: 'FaradayFacility'; uid: string; name: string; metadata?: any | null };
  };
} & { ' $fragmentRefs'?: { OrderExam_Fragment: OrderExam_Fragment } }) & {
  ' $fragmentName'?: 'OrdersExams_Fragment';
};

export type OrderPdfForms_Fragment = {
  __typename?: 'FaradayOrderPDF';
  uid: string;
  pdfForm: any;
  pdfFormMasked: any;
  createdOn: any;
  createdBy: {
    __typename?: 'FaradayStaffProfile';
    uid: string;
    fullName: string;
    accountType: FaradayStaffProfileAccountTypeChoices;
  };
} & { ' $fragmentName'?: 'OrderPdfForms_Fragment' };

export type OrderCreatedBy_Fragment = {
  __typename?: 'FaradayStaffProfile';
  uid: string;
  fullName: string;
  accountType: FaradayStaffProfileAccountTypeChoices;
  designation: string;
  clinic: { __typename?: 'FaradayClinic'; uid: string; name: string };
} & { ' $fragmentName'?: 'OrderCreatedBy_Fragment' };

export type OrderCreatedFor_Fragment = {
  __typename?: 'FaradayStaffProfile';
  uid: string;
  fullName: string;
  accountType: FaradayStaffProfileAccountTypeChoices;
  designation: string;
  clinic: { __typename?: 'FaradayClinic'; uid: string; name: string };
} & { ' $fragmentName'?: 'OrderCreatedFor_Fragment' };

export type OrdersConnection_Fragment = {
  __typename?: 'FaradayOrderConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
} & { ' $fragmentName'?: 'OrdersConnection_Fragment' };

export type OrdersPatient_Fragment = {
  __typename?: 'FaradayPatientProfile';
  uid: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phone?: string | null;
  gender?: string | null;
  isClaustrophobic: boolean;
  dateOfBirth?: any | null;
  nationalId: string;
  deactivatedOn?: any | null;
  comments: string;
  doctors: Array<{
    __typename?: 'FaradayStaffProfile';
    uid: string;
    designation: string;
    accountType: FaradayStaffProfileAccountTypeChoices;
  }>;
} & { ' $fragmentName'?: 'OrdersPatient_Fragment' };

export type OrderDetails_Fragment = {
  __typename?: 'FaradayOrder';
  uid: string;
  createdOn: any;
  updatedOn: any;
  metadata?: any | null;
  orderExams: Array<
    { __typename?: 'FaradayOrderExam' } & { ' $fragmentRefs'?: { OrdersExams_Fragment: OrdersExams_Fragment } }
  >;
  pdfForms: Array<
    { __typename?: 'FaradayOrderPDF' } & {
      ' $fragmentRefs'?: { OrderPdfForms_Fragment: OrderPdfForms_Fragment };
    }
  >;
  createdBy: { __typename?: 'FaradayStaffProfile' } & {
    ' $fragmentRefs'?: { OrderCreatedBy_Fragment: OrderCreatedBy_Fragment };
  };
  createdFor: { __typename?: 'FaradayStaffProfile' } & {
    ' $fragmentRefs'?: { OrderCreatedFor_Fragment: OrderCreatedFor_Fragment };
  };
  patient: { __typename?: 'FaradayPatientProfile' } & {
    ' $fragmentRefs'?: { PatientProfile_Fragment: PatientProfile_Fragment };
  };
} & { ' $fragmentName'?: 'OrderDetails_Fragment' };

export type OrdersQueryVariables = Exact<{
  sortBy?: InputMaybe<OrderOrderBy>;
  orderSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  exams_Status_In?: InputMaybe<
    Array<InputMaybe<FaradayOrderExamStatusChoices>> | InputMaybe<FaradayOrderExamStatusChoices>
  >;
  exams_Exam_Modality_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  createdFor_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  createdBy_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  patient_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  createdOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_Lte?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type OrdersQuery = {
  __typename?: 'Query';
  faradayOrders?:
    | ({
        __typename?: 'FaradayOrderConnection';
        edges: Array<{
          __typename?: 'FaradayOrderEdge';
          node?:
            | ({ __typename?: 'FaradayOrder' } & {
                ' $fragmentRefs'?: { OrderDetails_Fragment: OrderDetails_Fragment };
              })
            | null;
        } | null>;
      } & { ' $fragmentRefs'?: { OrdersConnection_Fragment: OrdersConnection_Fragment } })
    | null;
};

export type OrderByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type OrderByUidQuery = {
  __typename?: 'Query';
  faradayOrder?: {
    __typename?: 'FaradayOrder';
    uid: string;
    lastPdfForm?: { __typename?: 'FaradayOrderPDF'; uid: string; pdfForm: any } | null;
    pdfForms: Array<{
      __typename?: 'FaradayOrderPDF';
      uid: string;
      pdfForm: any;
      pdfFormMasked: any;
      createdOn: any;
      createdBy: {
        __typename?: 'FaradayStaffProfile';
        uid: string;
        fullName: string;
        accountType: FaradayStaffProfileAccountTypeChoices;
      };
    }>;
    orderExams: Array<{ __typename?: 'FaradayOrderExam'; uid: string; status: FaradayOrderExamStatusChoices }>;
  } | null;
};

export type CreateOrderMutationVariables = Exact<{
  createInput: CreateFaradayOrderInput;
}>;

export type CreateOrderMutation = {
  __typename?: 'Mutation';
  faradayOrderCreate?: {
    __typename?: 'CreateFaradayOrder';
    faradayOrder: { __typename?: 'FaradayOrder' } & {
      ' $fragmentRefs'?: { OrderDetails_Fragment: OrderDetails_Fragment };
    };
  } | null;
};

export type UpdateOrderMutationVariables = Exact<{
  updateInput: UpdateFaradayOrderInput;
}>;

export type UpdateOrderMutation = {
  __typename?: 'Mutation';
  faradayOrderUpdate?: {
    __typename?: 'UpdateFaradayOrder';
    faradayOrder: {
      __typename?: 'FaradayOrder';
      uid: string;
      metadata?: any | null;
      patient: { __typename?: 'FaradayPatientProfile'; firstName: string; lastName: string };
      orderExams: Array<{
        __typename?: 'FaradayOrderExam';
        uid: string;
        status: FaradayOrderExamStatusChoices;
        metadata?: any | null;
      }>;
      createdBy: { __typename?: 'FaradayStaffProfile'; uid: string };
    };
  } | null;
};

export type DeleteOrderMutationVariables = Exact<{
  deleteInput: DeleteFaradayOrderInput;
}>;

export type DeleteOrderMutation = {
  __typename?: 'Mutation';
  faradayOrderDelete?: {
    __typename?: 'DeleteFaradayOrder';
    deleteMutationResult: { __typename?: 'DeleteMutationResult'; uid?: string | null; count: number };
  } | null;
};

export type OrderDraft_Fragment = {
  __typename?: 'FaradayOrderDraft';
  uid: string;
  deactivatedOn?: any | null;
  draft?: any | null;
  createdOn: any;
  updatedOn: any;
  createdBy: { __typename?: 'FaradayStaffProfile'; uid: string; fullName: string };
} & { ' $fragmentName'?: 'OrderDraft_Fragment' };

export type OrderDraftsQueryVariables = Exact<{ [key: string]: never }>;

export type OrderDraftsQuery = {
  __typename?: 'Query';
  faradayOrderDrafts?: {
    __typename?: 'FaradayOrderDraftConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'FaradayOrderDraftEdge';
      node?:
        | ({ __typename?: 'FaradayOrderDraft' } & {
            ' $fragmentRefs'?: { OrderDraft_Fragment: OrderDraft_Fragment };
          })
        | null;
    } | null>;
  } | null;
};

export type OrderDraftByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type OrderDraftByUidQuery = {
  __typename?: 'Query';
  faradayOrderDraft?:
    | ({ __typename?: 'FaradayOrderDraft' } & {
        ' $fragmentRefs'?: { OrderDraft_Fragment: OrderDraft_Fragment };
      })
    | null;
};

export type UpdateOrderDraftMutationVariables = Exact<{
  updateInput: UpdateFaradayOrderDraftInput;
}>;

export type UpdateOrderDraftMutation = {
  __typename?: 'Mutation';
  faradayOrderDraftUpdate?: {
    __typename?: 'UpdateFaradayOrderDraft';
    faradayOrderDraft: {
      __typename?: 'FaradayOrderDraft';
      uid: string;
      deactivatedOn?: any | null;
      createdBy: { __typename?: 'FaradayStaffProfile'; uid: string };
    };
  } | null;
};

export type CreateOrderDraftMutationVariables = Exact<{
  createInput: CreateFaradayOrderDraftInput;
}>;

export type CreateOrderDraftMutation = {
  __typename?: 'Mutation';
  faradayOrderDraftCreate?: {
    __typename?: 'CreateFaradayOrderDraft';
    faradayOrderDraft: {
      __typename?: 'FaradayOrderDraft';
      uid: string;
      deactivatedOn?: any | null;
      createdBy: { __typename?: 'FaradayStaffProfile'; uid: string };
    };
  } | null;
};

export type DeleteOrderDraftMutationVariables = Exact<{
  deleteInput: DeleteFaradayOrderDraftInput;
}>;

export type DeleteOrderDraftMutation = {
  __typename?: 'Mutation';
  faradayOrderDraftDelete?: {
    __typename?: 'DeleteFaradayOrderDraft';
    deleteMutationResult: { __typename?: 'DeleteMutationResult'; uid?: string | null; count: number };
  } | null;
};

export type OrderExamsConnection_Fragment = {
  __typename?: 'FaradayOrderExamConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
} & { ' $fragmentName'?: 'OrderExamsConnection_Fragment' };

export type OrderExam_Fragment = {
  __typename?: 'FaradayOrderExam';
  uid: string;
  accessionNo: string;
  vueMotionUrl?: string | null;
  imageReadyOn?: any | null;
  reportReadyOn?: any | null;
  lastRemindedOn?: any | null;
  status: FaradayOrderExamStatusChoices;
  updatedOn: any;
  createdOn: any;
  deactivatedOn?: any | null;
  scheduledFor?: any | null;
  duration?: number | null;
  metadata?: any | null;
  exam: {
    __typename?: 'FaradayExam';
    uid: string;
    duration: number;
    name: string;
    metadata?: any | null;
    disclaimerMessages?: Array<string> | null;
    procedureCode: string;
    additionalFieldTemplates?: Array<
      { __typename?: 'FaradayAdditionalFieldTemplate' } & {
        ' $fragmentRefs'?: { AdditionalFieldTemplates_Fragment: AdditionalFieldTemplates_Fragment };
      }
    > | null;
    modality: { __typename?: 'FaradayModality'; shortName: string; name: string };
  };
} & { ' $fragmentName'?: 'OrderExam_Fragment' };

export type OrderExamsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrderExamsQuery = {
  __typename?: 'Query';
  faradayOrderExams?:
    | ({
        __typename?: 'FaradayOrderExamConnection';
        edges: Array<{
          __typename?: 'FaradayOrderExamEdge';
          node?:
            | ({
                __typename?: 'FaradayOrderExam';
                order: {
                  __typename?: 'FaradayOrder';
                  pdfForms: Array<
                    { __typename?: 'FaradayOrderPDF' } & {
                      ' $fragmentRefs'?: { OrderPdfForms_Fragment: OrderPdfForms_Fragment };
                    }
                  >;
                  createdBy: { __typename?: 'FaradayStaffProfile' } & {
                    ' $fragmentRefs'?: { OrderCreatedBy_Fragment: OrderCreatedBy_Fragment };
                  };
                };
              } & { ' $fragmentRefs'?: { OrderExam_Fragment: OrderExam_Fragment } })
            | null;
        } | null>;
      } & { ' $fragmentRefs'?: { OrderExamsConnection_Fragment: OrderExamsConnection_Fragment } })
    | null;
};

export type OrderExamQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;

export type OrderExamQuery = {
  __typename?: 'Query';
  faradayOrderExam?: {
    __typename?: 'FaradayOrderExam';
    uid: string;
    order: {
      __typename?: 'FaradayOrder';
      createdBy: { __typename?: 'FaradayStaffProfile' } & {
        ' $fragmentRefs'?: { OrderCreatedBy_Fragment: OrderCreatedBy_Fragment };
      };
    };
  } | null;
};

export type OrderExamCreateMutationVariables = Exact<{
  createInput: CreateFaradayOrderExamInput;
}>;

export type OrderExamCreateMutation = {
  __typename?: 'Mutation';
  faradayOrderExamCreate?: {
    __typename?: 'CreateFaradayOrderExam';
    faradayOrderExam: {
      __typename?: 'FaradayOrderExam';
      uid: string;
      status: FaradayOrderExamStatusChoices;
      metadata?: any | null;
      order: {
        __typename?: 'FaradayOrder';
        createdBy: { __typename?: 'FaradayStaffProfile' } & {
          ' $fragmentRefs'?: { OrderCreatedBy_Fragment: OrderCreatedBy_Fragment };
        };
      };
      exam: { __typename?: 'FaradayExam'; uid: string };
    };
  } | null;
};

export type OrderExamUpdateMutationVariables = Exact<{
  updateInput: UpdateFaradayOrderExamInput;
}>;

export type OrderExamUpdateMutation = {
  __typename?: 'Mutation';
  faradayOrderExamUpdate?: {
    __typename?: 'UpdateFaradayOrderExam';
    faradayOrderExam: {
      __typename?: 'FaradayOrderExam';
      uid: string;
      status: FaradayOrderExamStatusChoices;
      metadata?: any | null;
      order: {
        __typename?: 'FaradayOrder';
        createdBy: { __typename?: 'FaradayStaffProfile' } & {
          ' $fragmentRefs'?: { OrderCreatedBy_Fragment: OrderCreatedBy_Fragment };
        };
      };
      exam: { __typename?: 'FaradayExam'; uid: string };
    };
  } | null;
};

export type OrderExamDeleteMutationVariables = Exact<{
  deleteInput: DeleteFaradayOrderExamInput;
}>;

export type OrderExamDeleteMutation = {
  __typename?: 'Mutation';
  faradayOrderExamDelete?: {
    __typename?: 'DeleteFaradayOrderExam';
    deleteMutationResult: { __typename?: 'DeleteMutationResult'; count: number };
  } | null;
};

export type ReferringDoctor_Fragment = {
  __typename?: 'FaradayParkwayStaff';
  uid: string;
  fullName: string;
  mcrNo: string;
  physicianId: string;
  metadata?: any | null;
} & { ' $fragmentName'?: 'ReferringDoctor_Fragment' };

export type ParkwayOrderDetails_Fragment = {
  __typename?: 'FaradayParkwayOrder';
  uid: string;
  accessionNo: string;
  exam: string;
  patientFullName: string;
  scheduledFor?: any | null;
  status: FaradayParkwayOrderStatusChoices;
  room: string;
  procedureCode: string;
  patientMrnNo: string;
  vueMotionUrl?: string | null;
} & { ' $fragmentName'?: 'ParkwayOrderDetails_Fragment' };

export type ParkwayOrdersQueryVariables = Exact<{
  parkwayOrderSearch?: InputMaybe<Scalars['String']['input']>;
  procedureCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  facility_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  modality_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  referringDoctor_McrNo_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  sortBy?: InputMaybe<OrderOrderBy>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  status_In?: InputMaybe<
    Array<InputMaybe<FaradayParkwayOrderStatusChoices>> | InputMaybe<FaradayParkwayOrderStatusChoices>
  >;
}>;

export type ParkwayOrdersQuery = {
  __typename?: 'Query';
  faradayParkwayOrders?: {
    __typename?: 'FaradayParkwayOrderConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'FaradayParkwayOrderEdge';
      node?:
        | ({
            __typename?: 'FaradayParkwayOrder';
            modality: { __typename?: 'FaradayModality'; shortName: string; uid: string; name: string };
            facility?: {
              __typename?: 'FaradayFacility';
              uid: string;
              shortCode: string;
              name: string;
              metadata?: any | null;
            } | null;
            referringDoctor?:
              | ({ __typename?: 'FaradayParkwayStaff' } & {
                  ' $fragmentRefs'?: { ReferringDoctor_Fragment: ReferringDoctor_Fragment };
                })
              | null;
          } & { ' $fragmentRefs'?: { ParkwayOrderDetails_Fragment: ParkwayOrderDetails_Fragment } })
        | null;
    } | null>;
  } | null;
};

export type ParkwayOrdersCountQueryVariables = Exact<{
  parkwayOrderSearch?: InputMaybe<Scalars['String']['input']>;
  procedureCode?: InputMaybe<Scalars['String']['input']>;
  facility_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  modality_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  referringDoctor_McrNo_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type ParkwayOrdersCountQuery = {
  __typename?: 'Query';
  faradayParkwayOrders?: { __typename?: 'FaradayParkwayOrderConnection'; totalCount: number } | null;
};

export type ParkwayOrderByUidQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;

export type ParkwayOrderByUidQuery = {
  __typename?: 'Query';
  faradayParkwayOrders?: {
    __typename?: 'FaradayParkwayOrderConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'FaradayParkwayOrderEdge';
      node?:
        | ({
            __typename?: 'FaradayParkwayOrder';
            modality: { __typename?: 'FaradayModality'; shortName: string; uid: string; name: string };
            facility?: {
              __typename?: 'FaradayFacility';
              uid: string;
              shortCode: string;
              name: string;
              metadata?: any | null;
            } | null;
            referringDoctor?:
              | ({ __typename?: 'FaradayParkwayStaff' } & {
                  ' $fragmentRefs'?: { ReferringDoctor_Fragment: ReferringDoctor_Fragment };
                })
              | null;
          } & { ' $fragmentRefs'?: { ParkwayOrderDetails_Fragment: ParkwayOrderDetails_Fragment } })
        | null;
    } | null>;
  } | null;
};

export type PatientProfilesConnection_Fragment = {
  __typename?: 'FaradayPatientProfileConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
} & { ' $fragmentName'?: 'PatientProfilesConnection_Fragment' };

export type PatientProfileDoctors_Fragment = {
  __typename?: 'FaradayPatientProfile';
  doctors: Array<{
    __typename?: 'FaradayStaffProfile';
    uid: string;
    fullName: string;
    createdOn: any;
    mcrNo?: string | null;
    phone?: string | null;
    email?: string | null;
    designation: string;
    accountType: FaradayStaffProfileAccountTypeChoices;
    deactivatedOn?: any | null;
    favoriteExams: Array<{
      __typename?: 'FaradayExam';
      uid: string;
      name: string;
      procedureCode: string;
      modality: { __typename?: 'FaradayModality'; shortName: string; name: string };
    }>;
  }>;
} & { ' $fragmentName'?: 'PatientProfileDoctors_Fragment' };

export type PatientProfile_Fragment = ({
  __typename?: 'FaradayPatientProfile';
  uid: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phone?: string | null;
  gender?: string | null;
  isClaustrophobic: boolean;
  dateOfBirth?: any | null;
  nationalId: string;
  nationality?: string | null;
  deactivatedOn?: any | null;
  comments: string;
  metadata?: any | null;
} & { ' $fragmentRefs'?: { PatientProfileDoctors_Fragment: PatientProfileDoctors_Fragment } }) & {
  ' $fragmentName'?: 'PatientProfile_Fragment';
};

export type PatientProfileLastOrder_Fragment = {
  __typename?: 'FaradayOrder';
  uid: string;
  createdOn: any;
  updatedOn: any;
  metadata?: any | null;
  patient: { __typename?: 'FaradayPatientProfile'; uid: string; fullName: string };
  pdfForms: Array<{
    __typename?: 'FaradayOrderPDF';
    uid: string;
    createdOn: any;
    pdfForm: any;
    pdfFormMasked: any;
    createdBy: { __typename?: 'FaradayStaffProfile'; uid: string; fullName: string };
  }>;
  createdBy: {
    __typename?: 'FaradayStaffProfile';
    uid: string;
    fullName: string;
    accountType: FaradayStaffProfileAccountTypeChoices;
    designation: string;
  };
  orderExams: Array<{ __typename?: 'FaradayOrderExam'; uid: string }>;
} & { ' $fragmentName'?: 'PatientProfileLastOrder_Fragment' };

export type PatientProfilesQueryVariables = Exact<{
  sortBy?: InputMaybe<PatientProfileOrderBy>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  doctors_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  gender_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type PatientProfilesQuery = {
  __typename?: 'Query';
  faradayPatientProfiles?:
    | ({
        __typename?: 'FaradayPatientProfileConnection';
        edges: Array<{
          __typename?: 'FaradayPatientProfileEdge';
          node?:
            | ({
                __typename?: 'FaradayPatientProfile';
                lastOrder?:
                  | ({ __typename?: 'FaradayOrder' } & {
                      ' $fragmentRefs'?: {
                        PatientProfileLastOrder_Fragment: PatientProfileLastOrder_Fragment;
                      };
                    })
                  | null;
              } & { ' $fragmentRefs'?: { PatientProfile_Fragment: PatientProfile_Fragment } })
            | null;
        } | null>;
      } & { ' $fragmentRefs'?: { PatientProfilesConnection_Fragment: PatientProfilesConnection_Fragment } })
    | null;
};

export type PatientProfilesExportDataQueryVariables = Exact<{
  sortBy?: InputMaybe<PatientProfileOrderBy>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  doctors_Uid_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  gender_In?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
  email?: InputMaybe<Scalars['String']['input']>;
}>;

export type PatientProfilesExportDataQuery = {
  __typename?: 'Query';
  faradayPatientProfiles?: { __typename?: 'FaradayPatientProfileConnection'; export?: string | null } | null;
};

export type PatientProfileQueryVariables = Exact<{ [key: string]: never }>;

export type PatientProfileQuery = {
  __typename?: 'Query';
  faradayPatientProfile?:
    | ({
        __typename?: 'FaradayPatientProfile';
        lastOrder?:
          | ({ __typename?: 'FaradayOrder' } & {
              ' $fragmentRefs'?: { PatientProfileLastOrder_Fragment: PatientProfileLastOrder_Fragment };
            })
          | null;
      } & { ' $fragmentRefs'?: { PatientProfile_Fragment: PatientProfile_Fragment } })
    | null;
};

export type PatientProfileByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type PatientProfileByUidQuery = {
  __typename?: 'Query';
  faradayPatientProfile?:
    | ({
        __typename?: 'FaradayPatientProfile';
        lastOrder?:
          | ({ __typename?: 'FaradayOrder' } & {
              ' $fragmentRefs'?: { PatientProfileLastOrder_Fragment: PatientProfileLastOrder_Fragment };
            })
          | null;
      } & { ' $fragmentRefs'?: { PatientProfile_Fragment: PatientProfile_Fragment } })
    | null;
};

export type CreatePatientProfileMutationVariables = Exact<{
  createInput: CreateFaradayPatientProfileInput;
}>;

export type CreatePatientProfileMutation = {
  __typename?: 'Mutation';
  faradayPatientProfileCreate?: {
    __typename?: 'CreateFaradayPatientProfile';
    faradayPatientProfile: {
      __typename?: 'FaradayPatientProfile';
      uid: string;
      fullName: string;
      firstName: string;
      lastName: string;
      phone?: string | null;
      gender?: string | null;
      isClaustrophobic: boolean;
      comments: string;
    } & { ' $fragmentRefs'?: { PatientProfileDoctors_Fragment: PatientProfileDoctors_Fragment } };
  } | null;
};

export type UpdatePatientProfileMutationVariables = Exact<{
  updateInput: UpdateFaradayPatientProfileInput;
}>;

export type UpdatePatientProfileMutation = {
  __typename?: 'Mutation';
  faradayPatientProfileUpdate?: {
    __typename?: 'UpdateFaradayPatientProfile';
    faradayPatientProfile: { __typename?: 'FaradayPatientProfile' } & {
      ' $fragmentRefs'?: { PatientProfile_Fragment: PatientProfile_Fragment };
    };
  } | null;
};

export type DeletePatientProfileMutationVariables = Exact<{
  deleteInput: DeleteFaradayPatientProfileInput;
}>;

export type DeletePatientProfileMutation = {
  __typename?: 'Mutation';
  faradayPatientProfileDelete?: {
    __typename?: 'DeleteFaradayPatientProfile';
    deleteMutationResult: { __typename?: 'DeleteMutationResult'; uid?: string | null; count: number };
  } | null;
};

export type UpdatePatientDoctorRelationshipMutationVariables = Exact<{
  updateRelationsInput: FaradayPatientDoctorRelationshipsUpdateInput;
}>;

export type UpdatePatientDoctorRelationshipMutation = {
  __typename?: 'Mutation';
  faradayPatientDoctorRelationshipsUpdate?: {
    __typename?: 'FaradayPatientDoctorRelationshipsUpdate';
    patient: {
      __typename?: 'FaradayPatientProfile';
      doctors: Array<{ __typename?: 'FaradayStaffProfile'; uid: string }>;
    };
  } | null;
};

export type PriceListPageInfoConnection_Fragment = {
  __typename?: 'FaradayPriceListsConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    endCursor?: string | null;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
  };
} & { ' $fragmentName'?: 'PriceListPageInfoConnection_Fragment' };

export type CataloguesPageInfoConnection_Fragment = {
  __typename?: 'FaradayCataloguesConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    endCursor?: string | null;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
  };
} & { ' $fragmentName'?: 'CataloguesPageInfoConnection_Fragment' };

export type PriceListQueryVariables = Exact<{
  priceListSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  modalityUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  facilityUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type PriceListQuery = {
  __typename?: 'Query';
  faradayPriceLists?:
    | ({
        __typename?: 'FaradayPriceListsConnection';
        edges: Array<{
          __typename?: 'FaradayPriceListsEdge';
          node?: {
            __typename?: 'FaradayPriceList';
            id?: string | null;
            entry: {
              __typename?: 'EinsteinChernobylEntry';
              uid: string;
              variables: any;
              deactivatedOn?: any | null;
              createdOn: any;
              tags?: any | null;
              aclDnf?: any | null;
              syncStatus: DataSourceEntrySyncStatus;
              isActivated: boolean;
            };
          } | null;
        } | null>;
      } & {
        ' $fragmentRefs'?: { PriceListPageInfoConnection_Fragment: PriceListPageInfoConnection_Fragment };
      })
    | null;
};

export type CatalogueListQueryVariables = Exact<{
  catalogueSearch?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  modalityUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type CatalogueListQuery = {
  __typename?: 'Query';
  faradayCatalogues?:
    | ({
        __typename?: 'FaradayCataloguesConnection';
        edges: Array<{
          __typename?: 'FaradayCataloguesEdge';
          node?: {
            __typename?: 'FaradayCatalogue';
            document: {
              __typename?: 'EinsteinDocumentEntry';
              uid: string;
              title: string;
              variables: any;
              pdfFile: any;
              mimeType: string;
              createdOn: any;
              syncStatus: DataSourceEntrySyncStatus;
              filename: string;
              tags?: any | null;
              aclDnf?: any | null;
            };
          } | null;
        } | null>;
      } & {
        ' $fragmentRefs'?: { CataloguesPageInfoConnection_Fragment: CataloguesPageInfoConnection_Fragment };
      })
    | null;
};

export type CatalogueListCountQueryVariables = Exact<{ [key: string]: never }>;

export type CatalogueListCountQuery = {
  __typename?: 'Query';
  faradayCatalogues?: { __typename?: 'FaradayCataloguesConnection'; totalCount: number } | null;
};

export type StaffProfile_Fragment = ({
  __typename?: 'FaradayStaffProfile';
  uid: string;
  fullName: string;
  firstName: string;
  lastName: string;
  designation: string;
  accountType: FaradayStaffProfileAccountTypeChoices;
  mcrNo?: string | null;
  physicianId?: string | null;
  phone?: string | null;
  email?: string | null;
  createdOn: any;
  deactivatedOn?: any | null;
  adminDoctorRelationships: Array<
    { __typename?: 'FaradayAdminDoctorRelationship' } & {
      ' $fragmentRefs'?: { AdminDoctorRelationship_Fragment: AdminDoctorRelationship_Fragment };
    }
  >;
} & { ' $fragmentRefs'?: { FavoriteExams_Fragment: FavoriteExams_Fragment } }) & {
  ' $fragmentName'?: 'StaffProfile_Fragment';
};

export type AdminDoctorRelationship_Fragment = {
  __typename?: 'FaradayAdminDoctorRelationship';
  id?: string | null;
  admin: { __typename?: 'FaradayStaffProfile'; uid: string; fullName: string };
  doctor: { __typename?: 'FaradayStaffProfile'; uid: string; fullName: string };
} & { ' $fragmentName'?: 'AdminDoctorRelationship_Fragment' };

export type FavoriteExams_Fragment = {
  __typename?: 'FaradayStaffProfile';
  favoriteExams: Array<{
    __typename?: 'FaradayExam';
    uid: string;
    name: string;
    duration: number;
    isRetired: boolean;
    metadata?: any | null;
    disclaimerMessages?: Array<string> | null;
    modality: { __typename?: 'FaradayModality' } & {
      ' $fragmentRefs'?: { ModalityDetails_Fragment: ModalityDetails_Fragment };
    };
    additionalFieldTemplates?: Array<
      { __typename?: 'FaradayAdditionalFieldTemplate' } & {
        ' $fragmentRefs'?: { AdditionalFieldTemplates_Fragment: AdditionalFieldTemplates_Fragment };
      }
    > | null;
  }>;
} & { ' $fragmentName'?: 'FavoriteExams_Fragment' };

export type StaffProfileConnection_Fragment = {
  __typename?: 'FaradayStaffProfileConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
} & { ' $fragmentName'?: 'StaffProfileConnection_Fragment' };

export type StaffProfileQueryVariables = Exact<{ [key: string]: never }>;

export type StaffProfileQuery = {
  __typename?: 'Query';
  faradayStaffProfile?:
    | ({
        __typename?: 'FaradayStaffProfile';
        clinic: { __typename?: 'FaradayClinic' } & { ' $fragmentRefs'?: { Clinic_Fragment: Clinic_Fragment } };
      } & { ' $fragmentRefs'?: { StaffProfile_Fragment: StaffProfile_Fragment } })
    | null;
};

export type StaffProfileByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;

export type StaffProfileByUidQuery = {
  __typename?: 'Query';
  faradayStaffProfile?:
    | ({
        __typename?: 'FaradayStaffProfile';
        clinic: { __typename?: 'FaradayClinic' } & { ' $fragmentRefs'?: { Clinic_Fragment: Clinic_Fragment } };
      } & { ' $fragmentRefs'?: { StaffProfile_Fragment: StaffProfile_Fragment } })
    | null;
};

export type StaffProfilesQueryVariables = Exact<{
  sortBy?: InputMaybe<StaffProfileOrderBy>;
  staffSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  accountType_In?: InputMaybe<
    | Array<InputMaybe<FaradayStaffProfileAccountTypeChoices>>
    | InputMaybe<FaradayStaffProfileAccountTypeChoices>
  >;
  deactivatedOn_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type StaffProfilesQuery = {
  __typename?: 'Query';
  faradayStaffProfiles?:
    | ({
        __typename?: 'FaradayStaffProfileConnection';
        edges: Array<{
          __typename?: 'FaradayStaffProfileEdge';
          node?:
            | ({
                __typename?: 'FaradayStaffProfile';
                clinic: { __typename?: 'FaradayClinic' } & {
                  ' $fragmentRefs'?: { Clinic_Fragment: Clinic_Fragment };
                };
              } & { ' $fragmentRefs'?: { StaffProfile_Fragment: StaffProfile_Fragment } })
            | null;
        } | null>;
      } & { ' $fragmentRefs'?: { StaffProfileConnection_Fragment: StaffProfileConnection_Fragment } })
    | null;
};

export type StaffProfilesUsersCountQueryVariables = Exact<{
  sortBy?: InputMaybe<StaffProfileOrderBy>;
  staffSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffProfilesUsersCountQuery = {
  __typename?: 'Query';
  faradayStaffProfiles?: { __typename?: 'FaradayStaffProfileConnection'; totalCount: number } | null;
};

export type StaffProfilesPendingRequestCountQueryVariables = Exact<{
  sortBy?: InputMaybe<StaffProfileOrderBy>;
  staffSearch?: InputMaybe<Scalars['String']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffProfilesPendingRequestCountQuery = {
  __typename?: 'Query';
  faradayStaffProfiles?: { __typename?: 'FaradayStaffProfileConnection'; totalCount: number } | null;
};

export type CreateStaffProfileMutationVariables = Exact<{
  createInput: CreateFaradayStaffProfileInput;
}>;

export type CreateStaffProfileMutation = {
  __typename?: 'Mutation';
  faradayStaffProfileCreate?: {
    __typename?: 'CreateFaradayStaffProfile';
    faradayStaffProfile: {
      __typename?: 'FaradayStaffProfile';
      uid: string;
      fullName: string;
      firstName: string;
      lastName: string;
      designation: string;
      accountType: FaradayStaffProfileAccountTypeChoices;
      mcrNo?: string | null;
      physicianId?: string | null;
      phone?: string | null;
      email?: string | null;
    };
  } | null;
};

export type BulkCreateStaffProfileMutationVariables = Exact<{
  bulkCreateStaffProfiles: FaradayBulkCreateStaffProfileInput;
}>;

export type BulkCreateStaffProfileMutation = {
  __typename?: 'Mutation';
  faradayBulkCreateStaffProfile?: {
    __typename?: 'FaradayBulkCreateStaffProfile';
    status: CreationStatus;
    totalCount: number;
    errorCount: number;
    creationStatus: Array<{
      __typename?: 'FaradayStaffProfileCreationStatus';
      status: CreationStatus;
      info?: string | null;
    }>;
  } | null;
};

export type UpdateStaffProfileMutationVariables = Exact<{
  updateInput: UpdateFaradayStaffProfileInput;
}>;

export type UpdateStaffProfileMutation = {
  __typename?: 'Mutation';
  faradayStaffProfileUpdate?: {
    __typename?: 'UpdateFaradayStaffProfile';
    faradayStaffProfile: { __typename?: 'FaradayStaffProfile' } & {
      ' $fragmentRefs'?: { StaffProfile_Fragment: StaffProfile_Fragment };
    };
  } | null;
};

export type DeleteStaffProfileMutationVariables = Exact<{
  deleteInput: DeleteFaradayStaffProfileInput;
}>;

export type DeleteStaffProfileMutation = {
  __typename?: 'Mutation';
  faradayStaffProfileDelete?: {
    __typename?: 'DeleteFaradayStaffProfile';
    deleteMutationResult: { __typename?: 'DeleteMutationResult'; uid?: string | null; count: number };
  } | null;
};

export type UpdateAdminDoctorRelationshipsMutationVariables = Exact<{
  updateRelationshipsInput: FaradayAdminDoctorRelationshipsUpdateInput;
}>;

export type UpdateAdminDoctorRelationshipsMutation = {
  __typename?: 'Mutation';
  faradayAdminDoctorRelationshipsUpdate?: {
    __typename?: 'FaradayAdminDoctorRelationshipsUpdate';
    adminDoctorRelationships: Array<{
      __typename?: 'FaradayAdminDoctorRelationship';
      admin: {
        __typename?: 'FaradayStaffProfile';
        uid: string;
        fullName: string;
        accountType: FaradayStaffProfileAccountTypeChoices;
      };
      doctor: {
        __typename?: 'FaradayStaffProfile';
        uid: string;
        fullName: string;
        accountType: FaradayStaffProfileAccountTypeChoices;
      };
    }>;
  } | null;
};

export type UpdateFavoriteExamsUpdateMutationVariables = Exact<{
  input: FaradayStaffFavoriteExamsUpdateInput;
}>;

export type UpdateFavoriteExamsUpdateMutation = {
  __typename?: 'Mutation';
  faradayStaffFavoriteExamsUpdate?: {
    __typename?: 'FaradayStaffFavoriteExamsUpdate';
    favoriteExams: Array<{
      __typename?: 'FaradayStaffFavoriteExam';
      id?: string | null;
      exam: { __typename?: 'FaradayExam'; uid: string; name: string };
    }>;
  } | null;
};

export const ModalityDetails_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModalityDetails_Fragment, unknown>;
export const Facility_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Facility_Fragment, unknown>;
export const AvailabilityRoom_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'availabilityRoom_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aeTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'facility_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilityRoom_Fragment, unknown>;
export const AvailabilitySlots_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'availabilitySlots_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAvailabilitySlot' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'times' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailabilitySlots_Fragment, unknown>;
export const AsyncJob_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'asyncJob_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KronosAsyncJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'results' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReady' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AsyncJob_Fragment, unknown>;
export const Clinic_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Clinic_Fragment, unknown>;
export const AdditionalFieldTemplates_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdditionalFieldTemplates_Fragment, unknown>;
export const FavoriteExams_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FavoriteExams_Fragment, unknown>;
export const Staffs_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffs_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Staffs_Fragment, unknown>;
export const ClinicsConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinicsConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinicConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClinicsConnection_Fragment, unknown>;
export const Exam_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'exam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalFieldTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Exam_Fragment, unknown>;
export const MessageTemplate_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageTemplate_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayMessageTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageTemplate_Fragment, unknown>;
export const OrdersConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersConnection_Fragment, unknown>;
export const OrdersPatient_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersPatient_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersPatient_Fragment, unknown>;
export const OrderExam_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExam_Fragment, unknown>;
export const OrdersExams_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExam_' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'room' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facility' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersExams_Fragment, unknown>;
export const OrderPdfForms_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderPdfForms_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderPDF' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderPdfForms_Fragment, unknown>;
export const OrderCreatedBy_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderCreatedBy_Fragment, unknown>;
export const OrderCreatedFor_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedFor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderCreatedFor_Fragment, unknown>;
export const PatientProfileDoctors_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfileDoctors_Fragment, unknown>;
export const PatientProfile_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfile_Fragment, unknown>;
export const OrderDetails_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ordersExams_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderPdfForms_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedFor_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExam_' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'room' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facility' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderPdfForms_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderPDF' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedFor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDetails_Fragment, unknown>;
export const OrderDraft_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDraft_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDraft_Fragment, unknown>;
export const OrderExamsConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExamsConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExamConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamsConnection_Fragment, unknown>;
export const ReferringDoctor_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'referringDoctor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayStaff' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReferringDoctor_Fragment, unknown>;
export const ParkwayOrderDetails_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'parkwayOrderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'exam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientFullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientMrnNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParkwayOrderDetails_Fragment, unknown>;
export const PatientProfilesConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfilesConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfileConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfilesConnection_Fragment, unknown>;
export const PatientProfileLastOrder_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileLastOrder_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfileLastOrder_Fragment, unknown>;
export const PriceListPageInfoConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceListPageInfoConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPriceListsConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceListPageInfoConnection_Fragment, unknown>;
export const CataloguesPageInfoConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cataloguesPageInfoConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayCataloguesConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CataloguesPageInfoConnection_Fragment, unknown>;
export const AdminDoctorRelationship_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminDoctorRelationship_Fragment, unknown>;
export const StaffProfile_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminDoctorRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'adminDoctorRelationship_' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfile_Fragment, unknown>;
export const StaffProfileConnection_FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfileConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfileConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfileConnection_Fragment, unknown>;
export const AvalibilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Avalibility' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDatetime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDatetime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'examUid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'examUid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'examUid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'facilityUid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDatetime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDatetime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDatetime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDatetime' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'room' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aeTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facility' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slots' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'availabilitySlots_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'availabilitySlots_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAvailabilitySlot' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'times' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvalibilityQuery, AvalibilityQueryVariables>;
export const AvalibilityAsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'avalibilityAsync' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobUid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'examUid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDatetime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDatetime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayAvailabilityAsync' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asyncJobUid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobUid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'examUid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'examUid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'facilityUid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDatetime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDatetime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDatetime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDatetime' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asyncJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'asyncJob_' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'room' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'availabilityRoom_' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slots' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'availabilitySlots_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'asyncJob_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KronosAsyncJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'results' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReady' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'availabilityRoom_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aeTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facility' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'facility_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'availabilitySlots_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAvailabilitySlot' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'times' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvalibilityAsyncQuery, AvalibilityAsyncQueryVariables>;
export const FacilityAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FacilityAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'examUids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayFacilityAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'examUids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'examUids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facility' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'facility_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityAvailabilityQuery, FacilityAvailabilityQueryVariables>;
export const ExamAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExamAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'examSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayExamAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'examSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'examSearch' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'exam_' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'exam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalFieldTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExamAvailabilityQuery, ExamAvailabilityQueryVariables>;
export const ClinicsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'clinics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayClinics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinicsConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinic_' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffs_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinicsConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinicConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffs_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClinicsQuery, ClinicsQueryVariables>;
export const ClinicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'clinic' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayClinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinic_' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffs_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffs_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClinicQuery, ClinicQueryVariables>;
export const RegisterDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'registerDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayRegisterDeviceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayRegisterDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'session' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActiveOn' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterDeviceMutation, RegisterDeviceMutationVariables>;
export const ExamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Exams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name_Icontains' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modalities' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayExams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name_Icontains' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name_Icontains' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modalities' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'modalities' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deactivatedOn_Isnull' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'exam_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modality' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'modalityDetails_' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'exam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalFieldTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExamsQuery, ExamsQueryVariables>;
export const ExamByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExamByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayExam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'exam_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'exam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalFieldTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExamByUidQuery, ExamByUidQueryVariables>;
export const FacilitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'facilities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayFacilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'facility_' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilitiesQuery, FacilitiesQueryVariables>;
export const FacilityByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FacilityByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayFacility' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'facility_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'facility_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayFacility' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityByUidQuery, FacilityByUidQueryVariables>;
export const HeimdallWithSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeimdallWithSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heimdallSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scopes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresOn' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeimdallWithSessionQuery, HeimdallWithSessionQueryVariables>;
export const HeimdallWithSessionByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeimdallWithSessionById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heimdallSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeimdallWithSessionByIdQuery, HeimdallWithSessionByIdQueryVariables>;
export const HeimdallAuthorizationFlowJwtDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HeimdallAuthorizationFlowJWT' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'HeimdallAuthorizationFlowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heimdallAuthorizationFlow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'session' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scopes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresOn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HeimdallAuthorizationFlowJwtMutation,
  HeimdallAuthorizationFlowJwtMutationVariables
>;
export const HeimdallAuthorizationFlowExchangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HeimdallAuthorizationFlowExchange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'heimdallAuthorizationFlowInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'HeimdallAuthorizationFlowInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heimdallAuthorizationFlow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'heimdallAuthorizationFlowInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'session' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scopes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresOn' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HeimdallAuthorizationFlowExchangeMutation,
  HeimdallAuthorizationFlowExchangeMutationVariables
>;
export const LogoutSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LogoutSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'HeimdallLogoutInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heimdallLogout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoutSessionMutation, LogoutSessionMutationVariables>;
export const MessageTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayMessageTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageTemplate_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageTemplate_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayMessageTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageTemplatesQuery, MessageTemplatesQueryVariables>;
export const MessageTemplateByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageTemplateByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayMessageTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageTemplate_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageTemplate_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayMessageTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageTemplateByUidQuery, MessageTemplateByUidQueryVariables>;
export const MessageTemplateDeliverToPatientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MessageTemplateDeliverToPatient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FaradayMessageTemplateDeliverToPatientInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayMessageTemplateDeliverToPatient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isDelivered' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'patientProfile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageTemplate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageTemplate_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageTemplate_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayMessageTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MessageTemplateDeliverToPatientMutation,
  MessageTemplateDeliverToPatientMutationVariables
>;
export const ModalitiesAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'modalitiesAll' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayModalities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModalitiesAllQuery, ModalitiesAllQueryVariables>;
export const ModalitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'modalities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shortName_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayModalities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shortName_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shortName_In' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModalitiesQuery, ModalitiesQueryVariables>;
export const ModalityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'modality' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayModality' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModalityQuery, ModalityQueryVariables>;
export const ModalityByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'modalityByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayModality' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModalityByUidQuery, ModalityByUidQueryVariables>;
export const OrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Orders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exams_Status_In' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExamStatusChoices' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exams_Exam_Modality_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdFor_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdBy_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patient_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Gt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Gte' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Lt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Lte' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Gt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Gte' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Lt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Lte' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exams_Status_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exams_Status_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deactivatedOn_Isnull' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exams_Exam_Modality_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exams_Exam_Modality_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdFor_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdFor_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdBy_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdBy_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdOn_Gt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Gt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdOn_Gte' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Gte' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdOn_Lt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Lt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdOn_Lte' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdOn_Lte' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedOn_Gt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Gt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedOn_Gte' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Gte' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedOn_Lt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Lt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedOn_Lte' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedOn_Lte' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'patient_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'patient_Uid_In' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ordersConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderDetails_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExam_' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'room' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facility' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderPdfForms_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderPDF' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedFor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ordersExams_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderPdfForms_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedFor_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const OrderByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastPdfForm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pdfForms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderByUidQuery, OrderByUidQueryVariables>;
export const CreateOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFaradayOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderDetails_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ordersExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExam_' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'room' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facility' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderPdfForms_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderPDF' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedFor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ordersExams_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderPdfForms_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedFor_' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFaradayOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'patient' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderExams' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFaradayOrderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deleteMutationResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const OrderDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderDrafts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDrafts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderDraft_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDraft_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDraftsQuery, OrderDraftsQueryVariables>;
export const OrderDraftByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderDraftByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderDraft_' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderDraft_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderDraftByUidQuery, OrderDraftByUidQueryVariables>;
export const UpdateOrderDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrderDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFaradayOrderDraftInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDraftUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrderDraft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrderDraftMutation, UpdateOrderDraftMutationVariables>;
export const CreateOrderDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOrderDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFaradayOrderDraftInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDraftCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrderDraft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOrderDraftMutation, CreateOrderDraftMutationVariables>;
export const DeleteOrderDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOrderDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFaradayOrderDraftInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderDraftDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deleteMutationResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOrderDraftMutation, DeleteOrderDraftMutationVariables>;
export const OrderExamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderExams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderExams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExamsConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderExam_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pdfForms' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'orderPdfForms_' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'orderCreatedBy_' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExamsConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExamConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderExam_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderExam' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportReadyOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRemindedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderPdfForms_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrderPDF' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamsQuery, OrderExamsQueryVariables>;
export const OrderExamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrderExam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderExam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamQuery, OrderExamQueryVariables>;
export const OrderExamCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'orderExamCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFaradayOrderExamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderExamCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrderExam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamCreateMutation, OrderExamCreateMutationVariables>;
export const OrderExamUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OrderExamUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFaradayOrderExamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderExamUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayOrderExam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'orderCreatedBy_' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'orderCreatedBy_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clinic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamUpdateMutation, OrderExamUpdateMutationVariables>;
export const OrderExamDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OrderExamDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFaradayOrderExamInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayOrderExamDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deleteMutationResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderExamDeleteMutation, OrderExamDeleteMutationVariables>;
export const ParkwayOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'parkwayOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkwayOrderSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'procedureCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'facility_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modality_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referringDoctor_McrNo_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status_In' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayOrderStatusChoices' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayParkwayOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parkwayOrderSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkwayOrderSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'procedureCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'procedureCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'facility_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'facility_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modality_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'modality_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referringDoctor_McrNo_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referringDoctor_McrNo_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'parkwayOrderDetails_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modality' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facility' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'referringDoctor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'referringDoctor_' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'parkwayOrderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'exam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientFullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientMrnNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'referringDoctor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayStaff' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParkwayOrdersQuery, ParkwayOrdersQueryVariables>;
export const ParkwayOrdersCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'parkwayOrdersCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parkwayOrderSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'procedureCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'facility_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modality_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referringDoctor_McrNo_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayParkwayOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parkwayOrderSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parkwayOrderSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'procedureCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'procedureCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'facility_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'facility_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modality_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'modality_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referringDoctor_McrNo_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referringDoctor_McrNo_In' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParkwayOrdersCountQuery, ParkwayOrdersCountQueryVariables>;
export const ParkwayOrderByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'parkwayOrderByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayParkwayOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'parkwayOrderDetails_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modality' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facility' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'referringDoctor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'referringDoctor_' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'parkwayOrderDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessionNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'exam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientFullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduledFor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'patientMrnNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vueMotionUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'referringDoctor_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayParkwayStaff' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParkwayOrderByUidQuery, ParkwayOrderByUidQueryVariables>;
export const PatientProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PatientProfileOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patientSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'doctors_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gender_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'patientSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'patientSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deactivatedOn_Isnull' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'doctors_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'doctors_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gender_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'gender_In' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfilesConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastOrder' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'patientProfileLastOrder_' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfilesConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfileConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileLastOrder_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfilesQuery, PatientProfilesQueryVariables>;
export const PatientProfilesExportDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientProfilesExportData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PatientProfileOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patientSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'doctors_Uid_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gender_In' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'patientSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'patientSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deactivatedOn_Isnull' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'doctors_Uid_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'doctors_Uid_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'gender_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'gender_In' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'export' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfilesExportDataQuery, PatientProfilesExportDataQueryVariables>;
export const PatientProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileLastOrder_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileLastOrder_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfileQuery, PatientProfileQueryVariables>;
export const PatientProfileByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PatientProfileByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileLastOrder_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileLastOrder_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'patient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdfForms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdfFormMasked' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientProfileByUidQuery, PatientProfileByUidQueryVariables>;
export const CreatePatientProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPatientProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFaradayPatientProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfileCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayPatientProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePatientProfileMutation, CreatePatientProfileMutationVariables>;
export const UpdatePatientProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePatientProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFaradayPatientProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfileUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayPatientProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfile_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfileDoctors_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'procedureCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modality' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'patientProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPatientProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClaustrophobic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'patientProfileDoctors_' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>;
export const DeletePatientProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePatientProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFaradayPatientProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientProfileDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deleteMutationResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePatientProfileMutation, DeletePatientProfileMutationVariables>;
export const UpdatePatientDoctorRelationshipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePatientDoctorRelationship' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateRelationsInput' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FaradayPatientDoctorRelationshipsUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPatientDoctorRelationshipsUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateRelationsInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'patient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doctors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uid' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePatientDoctorRelationshipMutation,
  UpdatePatientDoctorRelationshipMutationVariables
>;
export const PriceListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PriceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'priceListSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modalityUids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayPriceLists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'priceListSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'priceListSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'facilityUids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'facilityUids' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modalityUids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'modalityUids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceListPageInfoConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entry' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'variables' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'aclDnf' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'syncStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isActivated' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceListPageInfoConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayPriceListsConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceListQuery, PriceListQueryVariables>;
export const CatalogueListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CatalogueList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'catalogueSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modalityUids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayCatalogues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'catalogueSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'catalogueSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'modalityUids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'modalityUids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cataloguesPageInfoConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'variables' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pdfFile' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'syncStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'aclDnf' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'syncStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cataloguesPageInfoConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayCataloguesConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CatalogueListQuery, CatalogueListQueryVariables>;
export const CatalogueListCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CatalogueListCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayCatalogues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CatalogueListCountQuery, CatalogueListCountQueryVariables>;
export const StaffProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffProfile_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clinic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinic_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminDoctorRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'adminDoctorRelationship_' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfileQuery, StaffProfileQueryVariables>;
export const StaffProfileByUidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfileByUid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffProfile_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clinic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinic_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminDoctorRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'adminDoctorRelationship_' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfileByUidQuery, StaffProfileByUidQueryVariables>;
export const StaffProfilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffProfileOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accountType_In' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FaradayStaffProfileAccountTypeChoices' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staffSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountType_In' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accountType_In' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deactivatedOn_Isnull' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deactivatedOn_Isnull' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffProfileConnection_' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffProfile_' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'clinic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'clinic_' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfileConnection_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfileConnection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminDoctorRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'adminDoctorRelationship_' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'clinic_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayClinic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hciCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfilesQuery, StaffProfilesQueryVariables>;
export const StaffProfilesUsersCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfilesUsersCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffProfileOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staffSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffProfilesUsersCountQuery, StaffProfilesUsersCountQueryVariables>;
export const StaffProfilesPendingRequestCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfilesPendingRequestCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffProfileOrderBy' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'staffSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'staffSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDesc' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortDesc' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffProfilesPendingRequestCountQuery,
  StaffProfilesPendingRequestCountQueryVariables
>;
export const CreateStaffProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createStaffProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFaradayStaffProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfileCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayStaffProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateStaffProfileMutation, CreateStaffProfileMutationVariables>;
export const BulkCreateStaffProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'bulkCreateStaffProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bulkCreateStaffProfiles' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayBulkCreateStaffProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayBulkCreateStaffProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'bulkCreateStaffProfiles' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creationStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'info' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkCreateStaffProfileMutation, BulkCreateStaffProfileMutationVariables>;
export const UpdateStaffProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStaffProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFaradayStaffProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfileUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'faradayStaffProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'staffProfile_' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'adminDoctorRelationship_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdminDoctorRelationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'admin' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'doctor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'modalityDetails_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayModality' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'additionalFieldTemplates_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayAdditionalFieldTemplate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'favoriteExams_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favoriteExams' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRetired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disclaimerMessages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'modalityDetails_' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalFieldTemplates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'additionalFieldTemplates_' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'staffProfile_' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mcrNo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicianId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deactivatedOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminDoctorRelationships' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'adminDoctorRelationship_' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'favoriteExams_' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStaffProfileMutation, UpdateStaffProfileMutationVariables>;
export const DeleteStaffProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteStaffProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFaradayStaffProfileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffProfileDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deleteMutationResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteStaffProfileMutation, DeleteStaffProfileMutationVariables>;
export const UpdateAdminDoctorRelationshipsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAdminDoctorRelationships' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateRelationshipsInput' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FaradayAdminDoctorRelationshipsUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayAdminDoctorRelationshipsUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateRelationshipsInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adminDoctorRelationships' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'admin' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doctor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAdminDoctorRelationshipsMutation,
  UpdateAdminDoctorRelationshipsMutationVariables
>;
export const UpdateFavoriteExamsUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFavoriteExamsUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FaradayStaffFavoriteExamsUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faradayStaffFavoriteExamsUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'favoriteExams' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exam' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFavoriteExamsUpdateMutation, UpdateFavoriteExamsUpdateMutationVariables>;
